{
  "level": "mt02c",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02c",
    "objects": "AREAS.E3:mt02c.e3",
    "mesh": "TREES.E3:mt02c.e3"
  },
  "spawn_point": {
    "position": [
      -1703.997255504915,
      -3787.240560323925,
      840.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1703.997255504915,
      -3687.240560323925,
      840.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1878.9119873046875,
      -3958.111083984375,
      816.0
    ],
    "bbox_max": [
      -1518.5,
      -3622.827880859375,
      1035.5
    ],
    "vertex_count": 1901,
    "vertices": [
      [
        -1544.0,
        -3625.5,
        954.5
      ],
      [
        -1537.7037353515625,
        -3626.666748046875,
        954.5
      ],
      [
        -1537.7037353515625,
        -3626.666748046875,
        954.5
      ],
      [
        -1520.7037353515625,
        -3629.666748046875,
        954.5
      ],
      [
        -1550.2962646484375,
        -3626.666748046875,
        954.5
      ],
      [
        -1544.0,
        -3625.5,
        954.5
      ],
      [
        -1567.2962646484375,
        -3629.666748046875,
        954.5
      ],
      [
        -1550.2962646484375,
        -3626.666748046875,
        954.5
      ],
      [
        -1544.0,
        -3624.0,
        956.0
      ],
      [
        -1518.5,
        -3628.5,
        956.0
      ],
      [
        -1569.5,
        -3628.5,
        956.0
      ],
      [
        -1544.0,
        -3624.0,
        956.0
      ],
      [
        -1544.1524658203125,
        -3625.5283203125,
        954.5
      ],
      [
        -1578.0,
        -3642.0,
        956.0
      ],
      [
        -1569.5,
        -3628.5,
        956.0
      ],
      [
        -1548.546142578125,
        -3685.21728515625,
        956.0
      ],
      [
        -1550.358642578125,
        -3686.5185546875,
        956.0
      ],
      [
        -1546.733642578125,
        -3686.5185546875,
        956.0
      ],
      [
        -1548.546142578125,
        -3685.21728515625,
        956.0
      ],
      [
        -1539.7125244140625,
        -3624.756591796875,
        983.35693359375
      ],
      [
        -1546.873779296875,
        -3623.492919921875,
        983.1091918945312
      ],
      [
        -1536.4239501953125,
        -3625.337158203125,
        986.3760375976562
      ],
      [
        -1536.6015625,
        -3625.3056640625,
        986.208740234375
      ],
      [
        -1536.6015625,
        -3625.3056640625,
        986.208740234375
      ],
      [
        -1539.7125244140625,
        -3624.756591796875,
        983.35693359375
      ],
      [
        -1550.6424560546875,
        -3622.827880859375,
        986.1759033203125
      ],
      [
        -1550.57421875,
        -3622.83984375,
        986.1188354492188
      ],
      [
        -1546.873779296875,
        -3623.492919921875,
        983.1091918945312
      ],
      [
        -1550.57421875,
        -3622.83984375,
        986.1188354492188
      ],
      [
        -1565.908203125,
        -3627.8662109375,
        1001.0
      ],
      [
        -1560.5831298828125,
        -3626.926513671875,
        985.0
      ],
      [
        -1550.0721435546875,
        -3625.07177734375,
        986.3548583984375
      ],
      [
        -1549.9072265625,
        -3625.042724609375,
        986.1990966796875
      ],
      [
        -1546.756103515625,
        -3624.486328125,
        983.303955078125
      ],
      [
        -1549.9072265625,
        -3625.042724609375,
        986.1990966796875
      ],
      [
        -1544.0001220703125,
        -3624.0,
        983.2086181640625
      ],
      [
        -1546.756103515625,
        -3624.486328125,
        983.303955078125
      ],
      [
        -1556.2061767578125,
        -3626.154296875,
        989.2205810546875
      ],
      [
        -1558.06591796875,
        -3626.482177734375,
        985.0
      ],
      [
        -1555.5428466796875,
        -3626.484375,
        991.6578369140625
      ],
      [
        -1557.1864013671875,
        -3629.746337890625,
        994.119384765625
      ],
      [
        -1557.1864013671875,
        -3629.746337890625,
        994.119384765625
      ],
      [
        -1562.528076171875,
        -3631.36181640625,
        999.369384765625
      ],
      [
        -1557.2144775390625,
        -3629.682861328125,
        993.9132080078125
      ],
      [
        -1562.46728515625,
        -3631.224365234375,
        998.9226684570312
      ],
      [
        -1555.576416015625,
        -3626.4677734375,
        991.534423828125
      ],
      [
        -1557.2144775390625,
        -3629.682861328125,
        993.9132080078125
      ],
      [
        -1560.124755859375,
        -3638.397216796875,
        980.7122192382812
      ],
      [
        -1558.8641357421875,
        -3638.397216796875,
        980.7122192382812
      ],
      [
        -1557.3966064453125,
        -3635.28515625,
        977.2122192382812
      ],
      [
        -1556.614013671875,
        -3635.659912109375,
        979.0113525390625
      ],
      [
        -1555.874267578125,
        -3636.01416015625,
        980.7122192382812
      ],
      [
        -1556.614013671875,
        -3635.659912109375,
        979.0113525390625
      ],
      [
        -1553.3067626953125,
        -3658.357666015625,
        963.3132934570312
      ],
      [
        -1553.316162109375,
        -3665.7685546875,
        963.3158569335938
      ],
      [
        -1552.064208984375,
        -3658.576904296875,
        962.9705200195312
      ],
      [
        -1553.316162109375,
        -3665.7685546875,
        963.3158569335938
      ],
      [
        -1543.64111328125,
        -3659.936767578125,
        963.3530883789062
      ],
      [
        -1543.776123046875,
        -3665.7685546875,
        963.3158569335938
      ],
      [
        -1544.6392822265625,
        -3660.81103515625,
        963.0777587890625
      ],
      [
        -1543.776123046875,
        -3665.7685546875,
        963.3158569335938
      ],
      [
        -1544.80517578125,
        -3659.85791015625,
        963.031982421875
      ],
      [
        -1544.6392822265625,
        -3660.81103515625,
        963.0777587890625
      ],
      [
        -1546.2908935546875,
        -3659.595703125,
        962.6221313476562
      ],
      [
        -1545.8765869140625,
        -3665.7685546875,
        962.7363891601562
      ],
      [
        -1544.1962890625,
        -3663.35546875,
        963.199951171875
      ],
      [
        -1545.876708984375,
        -3665.7685546875,
        962.7363891601562
      ],
      [
        -1556.3553466796875,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1542.6947021484375,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1542.6947021484375,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1541.7158203125,
        -3697.7685546875,
        951.8101196289062
      ],
      [
        -1540.7369384765625,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1541.7158203125,
        -3697.7685546875,
        951.8101196289062
      ],
      [
        -1556.3553466796875,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1540.7369384765625,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      [
        -1556.39404296875,
        -3697.7685546875,
        961.5885620117188
      ],
      [
        -1556.39404296875,
        -3697.7685546875,
        961.5885620117188
      ],
      [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      [
        -1541.065673828125,
        -3697.7685546875,
        962.5009765625
      ],
      [
        -1540.6982421875,
        -3697.7685546875,
        961.5885620117188
      ],
      [
        -1540.6982421875,
        -3697.7685546875,
        961.5885620117188
      ],
      [
        -1541.065673828125,
        -3697.7685546875,
        962.5009765625
      ],
      [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      [
        -1548.5999755859375,
        -3720.14990234375,
        948.4600830078125
      ],
      [
        -1539.9739990234375,
        -3728.5185546875,
        948.0535888671875
      ],
      [
        -1539.2103271484375,
        -3728.5185546875,
        949.39453125
      ],
      [
        -1548.4471435546875,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1541.58984375,
        -3700.238525390625,
        951.0
      ],
      [
        -1548.5999755859375,
        -3698.197509765625,
        951.892578125
      ],
      [
        -1548.5999755859375,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1541.58984375,
        -3700.238525390625,
        951.0
      ],
      [
        -1540.2091064453125,
        -3700.556884765625,
        950.967041015625
      ],
      [
        -1548.5369873046875,
        -3699.88427734375,
        963.899658203125
      ],
      [
        -1540.711669921875,
        -3697.7685546875,
        961.6217651367188
      ],
      [
        -1548.5369873046875,
        -3699.88427734375,
        963.899658203125
      ],
      [
        -1548.5999755859375,
        -3697.787841796875,
        963.8597412109375
      ],
      [
        -1548.5999755859375,
        -3699.851318359375,
        963.8812255859375
      ],
      [
        -1548.5999755859375,
        -3697.787841796875,
        963.8597412109375
      ],
      [
        -1548.5999755859375,
        -3697.7685546875,
        963.8651123046875
      ],
      [
        -1548.5421142578125,
        -3717.8564453125,
        961.4943237304688
      ],
      [
        -1548.5999755859375,
        -3708.592529296875,
        963.9571533203125
      ],
      [
        -1548.5999755859375,
        -3717.760009765625,
        961.5095825195312
      ],
      [
        -1548.5421142578125,
        -3717.8564453125,
        961.4943237304688
      ],
      [
        -1548.5999755859375,
        -3708.402099609375,
        963.9703369140625
      ],
      [
        -1548.5999755859375,
        -3708.402099609375,
        963.9703369140625
      ],
      [
        -1548.5999755859375,
        -3708.592529296875,
        963.9571533203125
      ],
      [
        -1548.545654296875,
        -3718.646484375,
        961.28271484375
      ],
      [
        -1548.5999755859375,
        -3718.589111328125,
        961.2882080078125
      ],
      [
        -1548.545654296875,
        -3718.646484375,
        961.28271484375
      ],
      [
        -1548.5999755859375,
        -3700.238525390625,
        951.0
      ],
      [
        -1548.5999755859375,
        -3716.478515625,
        949.3200073242188
      ],
      [
        -1548.5999755859375,
        -3716.478515625,
        949.3200073242188
      ],
      [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      [
        -1548.5999755859375,
        -3718.8369140625,
        961.209716796875
      ],
      [
        -1548.5999755859375,
        -3718.751708984375,
        961.2447509765625
      ],
      [
        -1548.5999755859375,
        -3718.8369140625,
        961.209716796875
      ],
      [
        -1539.1971435546875,
        -3721.56494140625,
        950.0297241210938
      ],
      [
        -1539.1971435546875,
        -3721.56494140625,
        950.0297241210938
      ],
      [
        -1539.557861328125,
        -3722.03955078125,
        949.3544311523438
      ],
      [
        -1548.5999755859375,
        -3718.751708984375,
        961.2447509765625
      ],
      [
        -1548.5999755859375,
        -3700.238525390625,
        951.0
      ],
      [
        -1548.5999755859375,
        -3720.10546875,
        948.4705200195312
      ],
      [
        -1557.1182861328125,
        -3728.5185546875,
        948.0535888671875
      ],
      [
        -1557.8819580078125,
        -3728.5185546875,
        949.39453125
      ],
      [
        -1548.5999755859375,
        -3699.884765625,
        963.881591796875
      ],
      [
        -1548.5999755859375,
        -3717.8388671875,
        961.4884643554688
      ],
      [
        -1548.5999755859375,
        -3718.6298828125,
        961.2772827148438
      ],
      [
        -1548.644287109375,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1555.5009765625,
        -3700.238525390625,
        951.0
      ],
      [
        -1548.5999755859375,
        -3698.2294921875,
        951.8785400390625
      ],
      [
        -1556.8831787109375,
        -3700.55712890625,
        950.967041015625
      ],
      [
        -1555.5009765625,
        -3700.238525390625,
        951.0
      ],
      [
        -1557.8951416015625,
        -3721.565185546875,
        950.02978515625
      ],
      [
        -1557.534423828125,
        -3722.039794921875,
        949.3544311523438
      ],
      [
        -1557.8951416015625,
        -3721.565185546875,
        950.02978515625
      ],
      [
        -1531.9283447265625,
        -3740.70263671875,
        942.53466796875
      ],
      [
        -1531.43115234375,
        -3750.979248046875,
        941.5712890625
      ],
      [
        -1531.9283447265625,
        -3740.70263671875,
        942.53466796875
      ],
      [
        -1531.9283447265625,
        -3740.70263671875,
        952.0046997070312
      ],
      [
        -1531.3936767578125,
        -3751.753173828125,
        951.0257568359375
      ],
      [
        -1531.43115234375,
        -3750.979248046875,
        951.0269775390625
      ],
      [
        -1531.9283447265625,
        -3740.70263671875,
        952.0046997070312
      ],
      [
        -1531.43115234375,
        -3750.979248046875,
        951.0269775390625
      ],
      [
        -1531.3936767578125,
        -3751.753173828125,
        941.5729370117188
      ],
      [
        -1531.43115234375,
        -3750.979248046875,
        941.5712890625
      ],
      [
        -1531.3936767578125,
        -3751.753173828125,
        951.0257568359375
      ],
      [
        -1531.3936767578125,
        -3751.753173828125,
        941.5729370117188
      ],
      [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      [
        -1548.5999755859375,
        -3740.238525390625,
        942.5399780273438
      ],
      [
        -1548.5999755859375,
        -3740.238525390625,
        942.5399780273438
      ],
      [
        -1548.5999755859375,
        -3752.158447265625,
        941.4199829101562
      ],
      [
        -1548.5999755859375,
        -3752.158447265625,
        941.4199829101562
      ],
      [
        -1548.5999755859375,
        -3760.5185546875,
        939.5
      ],
      [
        -1537.7735595703125,
        -3760.5185546875,
        940.634521484375
      ],
      [
        -1531.7142333984375,
        -3745.128173828125,
        942.1198120117188
      ],
      [
        -1531.5609130859375,
        -3748.29736328125,
        951.2821044921875
      ],
      [
        -1531.4893798828125,
        -3749.77490234375,
        951.1415405273438
      ],
      [
        -1531.3922119140625,
        -3751.78271484375,
        950.9506225585938
      ],
      [
        -1531.389892578125,
        -3751.830322265625,
        950.828857421875
      ],
      [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      [
        -1548.5999755859375,
        -3739.20458984375,
        954.0750732421875
      ],
      [
        -1548.5999755859375,
        -3739.385986328125,
        954.025634765625
      ],
      [
        -1548.5999755859375,
        -3739.521484375,
        953.9931640625
      ],
      [
        -1548.5999755859375,
        -3746.2919921875,
        953.02587890625
      ],
      [
        -1548.5999755859375,
        -3739.44140625,
        954.010498046875
      ],
      [
        -1548.5999755859375,
        -3739.521484375,
        953.9931640625
      ],
      [
        -1548.5999755859375,
        -3739.44140625,
        954.010498046875
      ],
      [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      [
        -1548.5999755859375,
        -3752.690185546875,
        952.1936645507812
      ],
      [
        -1548.5999755859375,
        -3752.51708984375,
        952.2457275390625
      ],
      [
        -1548.5999755859375,
        -3746.540283203125,
        952.9928588867188
      ],
      [
        -1548.5999755859375,
        -3746.493896484375,
        952.9970703125
      ],
      [
        -1548.5999755859375,
        -3746.493896484375,
        952.9970703125
      ],
      [
        -1548.5999755859375,
        -3746.540283203125,
        952.9928588867188
      ],
      [
        -1548.5999755859375,
        -3752.56201171875,
        952.2296752929688
      ],
      [
        -1548.5999755859375,
        -3752.51708984375,
        952.2457275390625
      ],
      [
        -1548.5999755859375,
        -3752.56201171875,
        952.2296752929688
      ],
      [
        -1548.5999755859375,
        -3753.242431640625,
        941.1710205078125
      ],
      [
        -1559.2916259765625,
        -3760.5185546875,
        940.5975952148438
      ],
      [
        -1559.8170166015625,
        -3760.5185546875,
        941.3113403320312
      ],
      [
        -1549.8890380859375,
        -3753.599609375,
        951.7432250976562
      ],
      [
        -1548.5999755859375,
        -3754.233154296875,
        951.7596435546875
      ],
      [
        -1549.889404296875,
        -3753.60009765625,
        951.7431030273438
      ],
      [
        -1557.3013916015625,
        -3728.5185546875,
        953.625
      ],
      [
        -1587.5714111328125,
        -3749.7197265625,
        949.9112548828125
      ],
      [
        -1590.2265625,
        -3749.416015625,
        949.7849731445312
      ],
      [
        -1590.2265625,
        -3749.416015625,
        949.7849731445312
      ],
      [
        -1587.5714111328125,
        -3749.7197265625,
        949.9112548828125
      ],
      [
        -1559.749755859375,
        -3735.429931640625,
        944.1647338867188
      ],
      [
        -1559.749755859375,
        -3735.429931640625,
        944.1647338867188
      ],
      [
        -1548.5999755859375,
        -3733.876953125,
        944.689453125
      ],
      [
        -1548.5999755859375,
        -3738.198486328125,
        943.2293090820312
      ],
      [
        -1560.529541015625,
        -3756.31884765625,
        949.8262329101562
      ],
      [
        -1548.5999755859375,
        -3758.17578125,
        950.6508178710938
      ],
      [
        -1554.3497314453125,
        -3757.190673828125,
        950.0599975585938
      ],
      [
        -1560.529541015625,
        -3756.31884765625,
        949.8262329101562
      ],
      [
        -1554.349853515625,
        -3757.190673828125,
        950.0598754882812
      ],
      [
        -1548.5501708984375,
        -3782.516357421875,
        947.0
      ],
      [
        -1538.14208984375,
        -3783.316650390625,
        945.8993530273438
      ],
      [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      [
        -1548.5999755859375,
        -3768.142333984375,
        947.8477172851562
      ],
      [
        -1548.5999755859375,
        -3768.6298828125,
        947.7294311523438
      ],
      [
        -1548.5999755859375,
        -3774.419677734375,
        947.0057373046875
      ],
      [
        -1537.1878662109375,
        -3760.5185546875,
        946.5698852539062
      ],
      [
        -1548.5999755859375,
        -3768.47509765625,
        947.7540893554688
      ],
      [
        -1548.5999755859375,
        -3768.52001953125,
        947.7431640625
      ],
      [
        -1548.5999755859375,
        -3768.47509765625,
        947.7540893554688
      ],
      [
        -1548.5999755859375,
        -3768.52001953125,
        947.7431640625
      ],
      [
        -1537.0772705078125,
        -3760.5185546875,
        946.4196166992188
      ],
      [
        -1548.5501708984375,
        -3782.516357421875,
        947.0
      ],
      [
        -1548.5999755859375,
        -3781.299560546875,
        946.9923095703125
      ],
      [
        -1548.5999755859375,
        -3782.512451171875,
        946.9924926757812
      ],
      [
        -1548.5999755859375,
        -3781.261474609375,
        946.99462890625
      ],
      [
        -1548.5999755859375,
        -3781.299560546875,
        946.9923095703125
      ],
      [
        -1548.5999755859375,
        -3781.261474609375,
        946.99462890625
      ],
      [
        -1548.5999755859375,
        -3774.541259765625,
        946.9943237304688
      ],
      [
        -1548.5999755859375,
        -3774.495361328125,
        946.9962768554688
      ],
      [
        -1548.5999755859375,
        -3774.541259765625,
        946.9943237304688
      ],
      [
        -1548.5999755859375,
        -3774.495361328125,
        946.9962768554688
      ],
      [
        -1538.14208984375,
        -3783.316650390625,
        945.8993530273438
      ],
      [
        -1535.9979248046875,
        -3783.481689453125,
        945.6007690429688
      ],
      [
        -1535.9979248046875,
        -3783.481689453125,
        945.6007690429688
      ],
      [
        -1535.9462890625,
        -3783.485595703125,
        945.53125
      ],
      [
        -1536.8560791015625,
        -3760.5185546875,
        946.1192016601562
      ],
      [
        -1548.5999755859375,
        -3781.261474609375,
        935.0035400390625
      ],
      [
        -1548.5999755859375,
        -3781.218017578125,
        935.00537109375
      ],
      [
        -1548.5999755859375,
        -3781.218017578125,
        935.00537109375
      ],
      [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      [
        -1538.14208984375,
        -3783.316650390625,
        935.7178344726562
      ],
      [
        -1548.5501708984375,
        -3782.516357421875,
        935.0
      ],
      [
        -1537.785888671875,
        -3783.343994140625,
        935.7640380859375
      ],
      [
        -1538.14208984375,
        -3783.316650390625,
        935.7178344726562
      ],
      [
        -1548.5501708984375,
        -3782.516357421875,
        935.0
      ],
      [
        -1548.5999755859375,
        -3782.512451171875,
        935.0075073242188
      ],
      [
        -1548.5999755859375,
        -3781.299560546875,
        935.0076904296875
      ],
      [
        -1548.5999755859375,
        -3781.261474609375,
        935.0035400390625
      ],
      [
        -1548.5999755859375,
        -3781.299560546875,
        935.0076904296875
      ],
      [
        -1535.171630859375,
        -3781.4951171875,
        936.382080078125
      ],
      [
        -1535.9979248046875,
        -3783.481689453125,
        935.99609375
      ],
      [
        -1535.9979248046875,
        -3783.481689453125,
        935.99609375
      ],
      [
        -1535.171630859375,
        -3781.4951171875,
        936.382080078125
      ],
      [
        -1535.692138671875,
        -3783.505126953125,
        936.3787841796875
      ],
      [
        -1548.5999755859375,
        -3760.5185546875,
        939.5
      ],
      [
        -1536.958251953125,
        -3764.951416015625,
        937.8456420898438
      ],
      [
        -1548.5999755859375,
        -3763.375244140625,
        938.4338989257812
      ],
      [
        -1536.958251953125,
        -3764.951416015625,
        937.8456420898438
      ],
      [
        -1548.5999755859375,
        -3766.478271484375,
        937.2758178710938
      ],
      [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      [
        -1548.5999755859375,
        -3771.328369140625,
        936.1071166992188
      ],
      [
        -1550.2620849609375,
        -3782.384521484375,
        935.25830078125
      ],
      [
        -1557.4801025390625,
        -3781.829345703125,
        935.7698364257812
      ],
      [
        -1550.2620849609375,
        -3782.384521484375,
        935.25830078125
      ],
      [
        -1560.986328125,
        -3781.5595703125,
        936.018310546875
      ],
      [
        -1560.986328125,
        -3781.5595703125,
        936.018310546875
      ],
      [
        -1560.986328125,
        -3781.5595703125,
        945.5963134765625
      ],
      [
        -1550.2620849609375,
        -3782.384521484375,
        946.74169921875
      ],
      [
        -1548.7537841796875,
        -3781.39990234375,
        946.9691162109375
      ],
      [
        -1548.7537841796875,
        -3781.39990234375,
        946.9691162109375
      ],
      [
        -1550.2620849609375,
        -3782.384521484375,
        946.74169921875
      ],
      [
        -1548.5999755859375,
        -3781.413818359375,
        946.9923095703125
      ],
      [
        -1561.645751953125,
        -3781.509033203125,
        944.5693969726562
      ],
      [
        -1561.645751953125,
        -3781.509033203125,
        944.5693969726562
      ],
      [
        -1560.986328125,
        -3781.5595703125,
        945.5963134765625
      ],
      [
        -1559.8748779296875,
        -3760.5185546875,
        946.610107421875
      ],
      [
        -1559.9766845703125,
        -3760.5185546875,
        946.4718017578125
      ],
      [
        -1580.589599609375,
        -3777.34912109375,
        945.5909423828125
      ],
      [
        -1560.134033203125,
        -3764.951171875,
        937.845703125
      ],
      [
        -1548.5999755859375,
        -3763.3896484375,
        938.4285278320312
      ],
      [
        -1560.134033203125,
        -3764.951171875,
        937.845703125
      ],
      [
        -1548.5999755859375,
        -3766.498291015625,
        937.2683715820312
      ],
      [
        -1574.5142822265625,
        -3818.942138671875,
        935.751220703125
      ],
      [
        -1587.0760498046875,
        -3813.6298828125,
        935.0321655273438
      ],
      [
        -1574.513427734375,
        -3818.942138671875,
        946.2487182617188
      ],
      [
        -1587.076416015625,
        -3813.627685546875,
        946.9678344726562
      ],
      [
        -1587.1258544921875,
        -3813.35400390625,
        935.0337524414062
      ],
      [
        -1587.1258544921875,
        -3813.354248046875,
        946.9662475585938
      ],
      [
        -1590.1395263671875,
        -3796.664306640625,
        945.5
      ],
      [
        -1590.133056640625,
        -3796.699951171875,
        945.5057373046875
      ],
      [
        -1588.803466796875,
        -3804.0634765625,
        947.0
      ],
      [
        -1590.133056640625,
        -3796.699951171875,
        945.5057373046875
      ],
      [
        -1588.803466796875,
        -3804.0634765625,
        947.0
      ],
      [
        -1588.7762451171875,
        -3804.214111328125,
        946.99072265625
      ],
      [
        -1590.1395263671875,
        -3796.664306640625,
        945.5
      ],
      [
        -1590.14111328125,
        -3796.6552734375,
        945.4871215820312
      ],
      [
        -1565.7232666015625,
        -3793.491455078125,
        945.3919677734375
      ],
      [
        -1548.2073974609375,
        -3797.84375,
        946.67626953125
      ],
      [
        -1559.34423828125,
        -3787.439208984375,
        944.3470458984375
      ],
      [
        -1542.1624755859375,
        -3793.923095703125,
        946.0346069335938
      ],
      [
        -1548.2073974609375,
        -3797.84375,
        946.67626953125
      ],
      [
        -1590.0263671875,
        -3796.68212890625,
        945.4535522460938
      ],
      [
        -1589.806640625,
        -3796.659423828125,
        945.4542236328125
      ],
      [
        -1589.8067626953125,
        -3796.659423828125,
        945.4542236328125
      ],
      [
        -1559.3577880859375,
        -3787.43408203125,
        944.3286743164062
      ],
      [
        -1590.0263671875,
        -3796.68212890625,
        945.45361328125
      ],
      [
        -1590.1461181640625,
        -3796.628173828125,
        945.4398803710938
      ],
      [
        -1590.1424560546875,
        -3796.648193359375,
        945.476806640625
      ],
      [
        -1590.1424560546875,
        -3796.648193359375,
        945.476806640625
      ],
      [
        -1590.1395263671875,
        -3796.664306640625,
        936.5
      ],
      [
        -1590.133056640625,
        -3796.699951171875,
        936.4942626953125
      ],
      [
        -1588.803466796875,
        -3804.0634765625,
        935.0
      ],
      [
        -1590.133056640625,
        -3796.699951171875,
        936.4942626953125
      ],
      [
        -1588.803466796875,
        -3804.0634765625,
        935.0
      ],
      [
        -1588.7762451171875,
        -3804.213623046875,
        935.00927734375
      ],
      [
        -1590.1395263671875,
        -3796.664306640625,
        936.5
      ],
      [
        -1590.14111328125,
        -3796.655517578125,
        936.5128173828125
      ],
      [
        -1565.722900390625,
        -3793.490966796875,
        936.6080932617188
      ],
      [
        -1548.2073974609375,
        -3797.843505859375,
        935.3236694335938
      ],
      [
        -1559.34423828125,
        -3787.439208984375,
        937.65283203125
      ],
      [
        -1548.2073974609375,
        -3797.843505859375,
        935.3236694335938
      ],
      [
        -1542.16259765625,
        -3793.9228515625,
        935.96533203125
      ],
      [
        -1590.0262451171875,
        -3796.682373046875,
        936.5462646484375
      ],
      [
        -1589.8074951171875,
        -3796.65966796875,
        936.5455932617188
      ],
      [
        -1589.8074951171875,
        -3796.65966796875,
        936.5455932617188
      ],
      [
        -1559.3577880859375,
        -3787.43408203125,
        937.6712646484375
      ],
      [
        -1590.0262451171875,
        -3796.682373046875,
        936.5462646484375
      ],
      [
        -1590.1424560546875,
        -3796.648193359375,
        936.523193359375
      ],
      [
        -1590.1461181640625,
        -3796.628173828125,
        936.56005859375
      ],
      [
        -1590.1424560546875,
        -3796.648193359375,
        936.523193359375
      ],
      [
        -1564.0093994140625,
        -3790.170166015625,
        943.1653442382812
      ],
      [
        -1561.041259765625,
        -3789.03564453125,
        944.609375
      ],
      [
        -1564.0093994140625,
        -3790.170166015625,
        943.1653442382812
      ],
      [
        -1588.7708740234375,
        -3804.24365234375,
        935.0111083984375
      ],
      [
        -1588.7708740234375,
        -3804.24365234375,
        935.0111083984375
      ],
      [
        -1587.2120361328125,
        -3812.876220703125,
        935.0138549804688
      ],
      [
        -1588.7708740234375,
        -3804.24365234375,
        946.9888916015625
      ],
      [
        -1587.2120361328125,
        -3812.876220703125,
        946.9861450195312
      ],
      [
        -1588.7708740234375,
        -3804.24365234375,
        946.9888916015625
      ],
      [
        -1587.168701171875,
        -3813.11669921875,
        946.9649047851562
      ],
      [
        -1587.2120361328125,
        -3812.876220703125,
        946.9861450195312
      ],
      [
        -1587.168701171875,
        -3813.11669921875,
        946.9649047851562
      ],
      [
        -1587.168701171875,
        -3813.11669921875,
        935.0350952148438
      ],
      [
        -1587.2120361328125,
        -3812.876220703125,
        935.0138549804688
      ],
      [
        -1587.168701171875,
        -3813.11669921875,
        935.0350952148438
      ],
      [
        -1584.50048828125,
        -3827.895263671875,
        936.1749877929688
      ],
      [
        -1584.50048828125,
        -3827.895263671875,
        947.8250122070312
      ],
      [
        -1612.0,
        -3817.651611328125,
        936.4095458984375
      ],
      [
        -1612.0,
        -3809.320068359375,
        935.6153564453125
      ],
      [
        -1612.0,
        -3809.320068359375,
        946.3846435546875
      ],
      [
        -1612.0,
        -3817.651611328125,
        945.5904541015625
      ],
      [
        -1612.0,
        -3796.937255859375,
        935.0
      ],
      [
        -1612.0,
        -3806.129150390625,
        935.5999755859375
      ],
      [
        -1612.0,
        -3806.129150390625,
        935.5999755859375
      ],
      [
        -1612.0,
        -3809.320068359375,
        935.6153564453125
      ],
      [
        -1612.0,
        -3806.129150390625,
        946.4000244140625
      ],
      [
        -1612.0,
        -3796.937255859375,
        947.0
      ],
      [
        -1612.0,
        -3809.320068359375,
        946.3846435546875
      ],
      [
        -1612.0,
        -3806.129150390625,
        946.4000244140625
      ],
      [
        -1612.0,
        -3788.646728515625,
        945.5
      ],
      [
        -1612.0,
        -3785.941162109375,
        941.3213500976562
      ],
      [
        -1612.0,
        -3788.646728515625,
        936.5
      ],
      [
        -1612.0,
        -3785.941162109375,
        940.6786499023438
      ],
      [
        -1612.0,
        -3785.778564453125,
        941.0
      ],
      [
        -1612.0,
        -3785.941162109375,
        941.3213500976562
      ],
      [
        -1612.0,
        -3785.778564453125,
        941.0
      ],
      [
        -1612.0,
        -3785.941162109375,
        940.6786499023438
      ],
      [
        -1612.0,
        -3796.937255859375,
        947.0
      ],
      [
        -1612.0,
        -3795.149658203125,
        946.6159057617188
      ],
      [
        -1612.0,
        -3788.646728515625,
        945.5
      ],
      [
        -1612.0,
        -3795.149658203125,
        946.6159057617188
      ],
      [
        -1612.0,
        -3796.937255859375,
        935.0
      ],
      [
        -1612.0,
        -3795.149658203125,
        935.3840942382812
      ],
      [
        -1612.0,
        -3788.646728515625,
        936.5
      ],
      [
        -1612.0,
        -3795.149658203125,
        935.3840942382812
      ],
      [
        -1612.0,
        -3819.80419921875,
        943.8273315429688
      ],
      [
        -1612.0,
        -3817.651611328125,
        945.5904541015625
      ],
      [
        -1612.0,
        -3817.651611328125,
        936.4095458984375
      ],
      [
        -1612.0,
        -3819.80419921875,
        938.1726684570312
      ],
      [
        -1612.0,
        -3822.512939453125,
        941.296875
      ],
      [
        -1612.0,
        -3819.80419921875,
        938.1726684570312
      ],
      [
        -1612.0,
        -3819.80419921875,
        943.8273315429688
      ],
      [
        -1612.0,
        -3822.512939453125,
        941.296875
      ],
      [
        -1598.629638671875,
        -3828.572509765625,
        939.6521606445312
      ],
      [
        -1572.6624755859375,
        -3827.327880859375,
        940.0089111328125
      ],
      [
        -1595.2296142578125,
        -3833.740966796875,
        946.020263671875
      ],
      [
        -1598.9222412109375,
        -3828.58642578125,
        943.9910278320312
      ],
      [
        -1595.2296142578125,
        -3833.740966796875,
        946.020263671875
      ],
      [
        -1575.7442626953125,
        -3832.119873046875,
        946.0619506835938
      ],
      [
        -1575.7442626953125,
        -3832.119873046875,
        946.0619506835938
      ],
      [
        -1572.955078125,
        -3827.342041015625,
        944.347900390625
      ],
      [
        -1588.3648681640625,
        -3853.06396484375,
        944.1610717773438
      ],
      [
        -1586.9556884765625,
        -3854.140869140625,
        943.2225952148438
      ],
      [
        -1586.9556884765625,
        -3854.140869140625,
        943.2225952148438
      ],
      [
        -1584.5699462890625,
        -3858.7724609375,
        943.5479736328125
      ],
      [
        -1584.5699462890625,
        -3858.7724609375,
        943.5479736328125
      ],
      [
        -1585.519287109375,
        -3858.489501953125,
        944.4815673828125
      ],
      [
        -1587.2640380859375,
        -3857.969482421875,
        946.197509765625
      ],
      [
        -1588.3648681640625,
        -3853.06396484375,
        944.1610717773438
      ],
      [
        -1587.2640380859375,
        -3857.969482421875,
        946.197509765625
      ],
      [
        -1590.4613037109375,
        -3843.88623046875,
        949.2310180664062
      ],
      [
        -1594.858154296875,
        -3837.39013671875,
        941.1856079101562
      ],
      [
        -1590.3251953125,
        -3844.332763671875,
        940.5376586914062
      ],
      [
        -1574.744384765625,
        -3830.406982421875,
        945.4474487304688
      ],
      [
        -1579.5677490234375,
        -3842.706298828125,
        949.2118530273438
      ],
      [
        -1590.623779296875,
        -3844.795166015625,
        941.9959716796875
      ],
      [
        -1588.9244384765625,
        -3850.31787109375,
        942.9537963867188
      ],
      [
        -1590.623779296875,
        -3844.795166015625,
        941.9959716796875
      ],
      [
        -1590.7894287109375,
        -3844.521484375,
        941.9890747070312
      ],
      [
        -1711.697998046875,
        -3690.043212890625,
        936.0477905273438
      ],
      [
        -1711.764404296875,
        -3690.041748046875,
        936.064453125
      ],
      [
        -1722.1947021484375,
        -3689.809326171875,
        936.9876708984375
      ],
      [
        -1711.764404296875,
        -3690.041748046875,
        936.064453125
      ],
      [
        -1722.1947021484375,
        -3689.809326171875,
        936.9876708984375
      ],
      [
        -1724.149658203125,
        -3689.765625,
        939.162353515625
      ],
      [
        -1711.697998046875,
        -3690.043212890625,
        947.0
      ],
      [
        -1711.764404296875,
        -3690.041748046875,
        946.98388671875
      ],
      [
        -1722.1947021484375,
        -3689.809326171875,
        946.1038818359375
      ],
      [
        -1711.764404296875,
        -3690.041748046875,
        946.98388671875
      ],
      [
        -1724.0389404296875,
        -3689.76806640625,
        944.0107421875
      ],
      [
        -1722.1947021484375,
        -3689.809326171875,
        946.1038818359375
      ],
      [
        -1711.697998046875,
        -3690.043212890625,
        936.0477905273438
      ],
      [
        -1711.6328125,
        -3690.044677734375,
        936.0630493164062
      ],
      [
        -1700.165771484375,
        -3690.300048828125,
        936.9534301757812
      ],
      [
        -1711.6328125,
        -3690.044677734375,
        936.0630493164062
      ],
      [
        -1700.165771484375,
        -3690.300048828125,
        936.9534301757812
      ],
      [
        -1702.3560791015625,
        -3683.877685546875,
        939.3380737304688
      ],
      [
        -1699.9915771484375,
        -3690.3037109375,
        937.324462890625
      ],
      [
        -1699.9915771484375,
        -3690.3037109375,
        937.324462890625
      ],
      [
        -1702.3560791015625,
        -3683.877685546875,
        939.3380737304688
      ],
      [
        -1697.8070068359375,
        -3690.352294921875,
        939.302734375
      ],
      [
        -1711.697998046875,
        -3690.043212890625,
        947.0
      ],
      [
        -1711.6328125,
        -3690.044677734375,
        946.9842529296875
      ],
      [
        -1700.165771484375,
        -3690.300048828125,
        946.1050415039062
      ],
      [
        -1711.6328125,
        -3690.044677734375,
        946.9842529296875
      ],
      [
        -1699.9915771484375,
        -3690.3037109375,
        945.732666015625
      ],
      [
        -1702.4593505859375,
        -3683.596923828125,
        944.7207641601562
      ],
      [
        -1700.165771484375,
        -3690.300048828125,
        946.1050415039062
      ],
      [
        -1702.4593505859375,
        -3683.596923828125,
        944.7207641601562
      ],
      [
        -1699.9915771484375,
        -3690.3037109375,
        945.732666015625
      ],
      [
        -1697.6708984375,
        -3690.35546875,
        943.6024780273438
      ],
      [
        -1708.50732421875,
        -3672.238037109375,
        946.1156005859375
      ],
      [
        -1703.0645751953125,
        -3682.4228515625,
        939.4207153320312
      ],
      [
        -1708.5096435546875,
        -3672.238037109375,
        939.8837890625
      ],
      [
        -1716.3983154296875,
        -3672.43701171875,
        940.2635498046875
      ],
      [
        -1718.921875,
        -3678.255859375,
        939.7186279296875
      ],
      [
        -1717.2364501953125,
        -3674.095947265625,
        940.1442260742188
      ],
      [
        -1716.3983154296875,
        -3672.43701171875,
        940.2635498046875
      ],
      [
        -1717.2364501953125,
        -3674.095947265625,
        940.1442260742188
      ],
      [
        -1719.731689453125,
        -3678.42041015625,
        944.4415283203125
      ],
      [
        -1720.8251953125,
        -3682.590576171875,
        944.8344116210938
      ],
      [
        -1719.7318115234375,
        -3678.42041015625,
        944.4414672851562
      ],
      [
        -1715.8052978515625,
        -3672.422119140625,
        946.114501953125
      ],
      [
        -1727.9119873046875,
        -3706.206298828125,
        935.0
      ],
      [
        -1755.0,
        -3714.480712890625,
        935.0
      ],
      [
        -1755.0,
        -3709.578857421875,
        935.6702270507812
      ],
      [
        -1755.0,
        -3714.480712890625,
        935.0
      ],
      [
        -1727.9119873046875,
        -3706.206298828125,
        935.0
      ],
      [
        -1755.0,
        -3716.8330078125,
        935.4457397460938
      ],
      [
        -1668.1134033203125,
        -3710.934326171875,
        935.69287109375
      ],
      [
        -1673.1185302734375,
        -3720.25048828125,
        937.3679809570312
      ],
      [
        -1668.9794921875,
        -3721.3271484375,
        937.5496826171875
      ],
      [
        -1673.1185302734375,
        -3720.25048828125,
        937.3679809570312
      ],
      [
        -1755.0,
        -3722.10302734375,
        937.9052124023438
      ],
      [
        -1755.0,
        -3721.42333984375,
        936.5
      ],
      [
        -1755.0,
        -3721.42333984375,
        936.5
      ],
      [
        -1755.0,
        -3716.8330078125,
        935.4457397460938
      ],
      [
        -1755.0,
        -3723.683349609375,
        941.0
      ],
      [
        -1755.0,
        -3723.237060546875,
        940.2492065429688
      ],
      [
        -1729.636474609375,
        -3714.65478515625,
        936.5279541015625
      ],
      [
        -1729.636474609375,
        -3714.65478515625,
        936.5279541015625
      ],
      [
        -1755.0,
        -3723.237060546875,
        940.2492065429688
      ],
      [
        -1729.6275634765625,
        -3714.643798828125,
        936.510009765625
      ],
      [
        -1668.9439697265625,
        -3720.900390625,
        945.3038330078125
      ],
      [
        -1742.2239990234375,
        -3718.9140625,
        943.625244140625
      ],
      [
        -1755.0,
        -3723.237060546875,
        941.7507934570312
      ],
      [
        -1755.0,
        -3723.683349609375,
        941.0
      ],
      [
        -1749.62744140625,
        -3719.98681640625,
        945.5
      ],
      [
        -1755.0,
        -3721.42333984375,
        945.5
      ],
      [
        -1755.0,
        -3723.237060546875,
        941.7507934570312
      ],
      [
        -1742.2239990234375,
        -3718.9140625,
        943.625244140625
      ],
      [
        -1755.0,
        -3721.42333984375,
        945.5
      ],
      [
        -1749.62744140625,
        -3719.98681640625,
        945.5
      ],
      [
        -1751.3043212890625,
        -3720.024169921875,
        945.5944213867188
      ],
      [
        -1755.0,
        -3720.94287109375,
        945.6103515625
      ],
      [
        -1755.0,
        -3720.106201171875,
        945.802490234375
      ],
      [
        -1751.5352783203125,
        -3713.42236328125,
        947.0
      ],
      [
        -1755.0,
        -3714.480712890625,
        947.0
      ],
      [
        -1755.0,
        -3716.8330078125,
        946.5542602539062
      ],
      [
        -1729.840087890625,
        -3714.625,
        945.5162353515625
      ],
      [
        -1729.6236572265625,
        -3714.6376953125,
        945.5
      ],
      [
        -1729.840087890625,
        -3714.625,
        945.5162353515625
      ],
      [
        -1755.0,
        -3716.8330078125,
        946.5542602539062
      ],
      [
        -1729.6236572265625,
        -3714.6376953125,
        945.5
      ],
      [
        -1729.6375732421875,
        -3714.655029296875,
        945.471923828125
      ],
      [
        -1729.6375732421875,
        -3714.655029296875,
        945.471923828125
      ],
      [
        -1755.0,
        -3714.480712890625,
        947.0
      ],
      [
        -1751.5352783203125,
        -3713.42236328125,
        947.0
      ],
      [
        -1755.0,
        -3713.415283203125,
        946.9400024414062
      ],
      [
        -1668.41552734375,
        -3714.559326171875,
        946.8872680664062
      ],
      [
        -1751.23583984375,
        -3713.330810546875,
        947.0
      ],
      [
        -1751.23583984375,
        -3713.330810546875,
        947.0
      ],
      [
        -1755.0,
        -3713.319580078125,
        946.9346313476562
      ],
      [
        -1668.113525390625,
        -3710.9345703125,
        946.3071899414062
      ],
      [
        -1727.9130859375,
        -3706.20654296875,
        947.0
      ],
      [
        -1731.5299072265625,
        -3706.4326171875,
        946.9505004882812
      ],
      [
        -1755.0,
        -3708.571044921875,
        946.6672973632812
      ],
      [
        -1727.9130859375,
        -3706.20654296875,
        947.0
      ],
      [
        -1755.0,
        -3707.93896484375,
        946.6224975585938
      ],
      [
        -1755.0,
        -3708.571044921875,
        946.6672973632812
      ],
      [
        -1731.5299072265625,
        -3706.4326171875,
        946.9505004882812
      ],
      [
        -1755.0,
        -3707.76904296875,
        946.6104736328125
      ],
      [
        -1755.0,
        -3709.463134765625,
        935.68603515625
      ],
      [
        -1704.687744140625,
        -3690.199462890625,
        936.602294921875
      ],
      [
        -1705.375732421875,
        -3690.18408203125,
        946.5045166015625
      ],
      [
        -1723.052490234375,
        -3692.4951171875,
        946.1246948242188
      ],
      [
        -1723.081298828125,
        -3692.41259765625,
        946.1194458007812
      ],
      [
        -1723.052490234375,
        -3692.4951171875,
        946.1246948242188
      ],
      [
        -1711.6658935546875,
        -3690.0439453125,
        946.9922485351562
      ],
      [
        -1723.081298828125,
        -3692.41259765625,
        946.1194458007812
      ],
      [
        -1722.3291015625,
        -3689.806396484375,
        945.9512939453125
      ],
      [
        -1711.5985107421875,
        -3690.04541015625,
        946.9816284179688
      ],
      [
        -1755.0,
        -3703.6845703125,
        946.3211669921875
      ],
      [
        -1755.0,
        -3702.145751953125,
        944.484619140625
      ],
      [
        -1722.9755859375,
        -3692.48046875,
        936.5137329101562
      ],
      [
        -1711.7288818359375,
        -3690.04248046875,
        936.0555419921875
      ],
      [
        -1722.9755859375,
        -3692.48046875,
        936.5137329101562
      ],
      [
        -1720.193115234375,
        -3689.85400390625,
        936.8104858398438
      ],
      [
        -1755.0,
        -3703.6845703125,
        936.41943359375
      ],
      [
        -1755.0,
        -3708.571044921875,
        935.8079833984375
      ],
      [
        -1755.0,
        -3708.571044921875,
        935.8079833984375
      ],
      [
        -1755.0,
        -3703.6845703125,
        946.3211669921875
      ],
      [
        -1755.0,
        -3702.145751953125,
        938.3945922851562
      ],
      [
        -1755.0,
        -3703.6845703125,
        936.41943359375
      ],
      [
        -1722.9429931640625,
        -3692.44970703125,
        936.5172119140625
      ],
      [
        -1755.0,
        -3700.1103515625,
        941.5791015625
      ],
      [
        -1755.0,
        -3702.145751953125,
        938.3945922851562
      ],
      [
        -1755.0,
        -3702.145751953125,
        944.484619140625
      ],
      [
        -1755.0,
        -3700.1103515625,
        941.5791015625
      ],
      [
        -1639.661376953125,
        -3725.0,
        942.6796264648438
      ],
      [
        -1642.075927734375,
        -3725.0,
        945.257568359375
      ],
      [
        -1642.075927734375,
        -3725.0,
        945.257568359375
      ],
      [
        -1642.2611083984375,
        -3725.0,
        945.5
      ],
      [
        -1642.2611083984375,
        -3725.0,
        945.5
      ],
      [
        -1667.853515625,
        -3707.8154296875,
        945.6140747070312
      ],
      [
        -1642.3095703125,
        -3725.0,
        945.507080078125
      ],
      [
        -1642.075927734375,
        -3725.0,
        936.742431640625
      ],
      [
        -1639.661376953125,
        -3725.0,
        939.3203735351562
      ],
      [
        -1642.2611083984375,
        -3725.0,
        936.5
      ],
      [
        -1642.075927734375,
        -3725.0,
        936.742431640625
      ],
      [
        -1667.8536376953125,
        -3707.81591796875,
        936.3858642578125
      ],
      [
        -1642.2611083984375,
        -3725.0,
        936.5
      ],
      [
        -1642.3095703125,
        -3725.0,
        936.492919921875
      ],
      [
        -1643.2301025390625,
        -3725.0,
        945.6409912109375
      ],
      [
        -1643.2301025390625,
        -3725.0,
        936.3590087890625
      ],
      [
        -1643.2301025390625,
        -3725.0,
        945.6409912109375
      ],
      [
        -1653.9031982421875,
        -3725.0,
        947.0
      ],
      [
        -1653.9031982421875,
        -3725.0,
        935.0
      ],
      [
        -1643.2301025390625,
        -3725.0,
        936.3590087890625
      ],
      [
        -1653.9031982421875,
        -3725.0,
        947.0
      ],
      [
        -1659.6912841796875,
        -3725.0,
        946.0845947265625
      ],
      [
        -1663.982177734375,
        -3725.0,
        945.5
      ],
      [
        -1659.6912841796875,
        -3725.0,
        946.0845947265625
      ],
      [
        -1663.982177734375,
        -3725.0,
        945.5
      ],
      [
        -1664.0701904296875,
        -3725.0,
        945.39208984375
      ],
      [
        -1653.9031982421875,
        -3725.0,
        935.0
      ],
      [
        -1659.6912841796875,
        -3725.0,
        935.9154052734375
      ],
      [
        -1663.982177734375,
        -3725.0,
        936.5
      ],
      [
        -1659.6912841796875,
        -3725.0,
        935.9154052734375
      ],
      [
        -1663.982177734375,
        -3725.0,
        936.5
      ],
      [
        -1664.0701904296875,
        -3725.0,
        936.6079711914062
      ],
      [
        -1666.927001953125,
        -3725.0,
        941.0
      ],
      [
        -1664.837158203125,
        -3725.0,
        937.5482177734375
      ],
      [
        -1666.927001953125,
        -3725.0,
        941.0
      ],
      [
        -1664.837158203125,
        -3725.0,
        944.4517822265625
      ],
      [
        -1664.837158203125,
        -3725.0,
        944.4517822265625
      ],
      [
        -1664.837158203125,
        -3725.0,
        937.5482177734375
      ],
      [
        -1638.80712890625,
        -3725.0,
        941.0
      ],
      [
        -1639.661376953125,
        -3725.0,
        942.6796264648438
      ],
      [
        -1639.661376953125,
        -3725.0,
        939.3203735351562
      ],
      [
        -1638.80712890625,
        -3725.0,
        941.0
      ],
      [
        -1653.421630859375,
        -3725.0,
        935.0613403320312
      ],
      [
        -1653.42138671875,
        -3725.0,
        946.9386596679688
      ],
      [
        -1702.318603515625,
        -3738.620849609375,
        949.5
      ],
      [
        -1694.623779296875,
        -3740.8671875,
        949.5
      ],
      [
        -1701.1209716796875,
        -3778.039794921875,
        938.0225830078125
      ],
      [
        -1701.0919189453125,
        -3778.023193359375,
        938.0220947265625
      ],
      [
        -1700.9921875,
        -3777.95947265625,
        938.0223388671875
      ],
      [
        -1701.0919189453125,
        -3778.023193359375,
        938.0220947265625
      ],
      [
        -1700.97705078125,
        -3778.16259765625,
        937.9686279296875
      ],
      [
        -1700.9921875,
        -3777.95947265625,
        938.0223388671875
      ],
      [
        -1694.623779296875,
        -3740.8671875,
        949.5
      ],
      [
        -1685.7935791015625,
        -3743.613525390625,
        949.5
      ],
      [
        -1675.23828125,
        -3754.430419921875,
        949.5
      ],
      [
        -1669.96826171875,
        -3760.87353515625,
        946.2261962890625
      ],
      [
        -1669.7672119140625,
        -3760.635498046875,
        945.7706298828125
      ],
      [
        -1678.515380859375,
        -3747.443115234375,
        949.5
      ],
      [
        -1669.96826171875,
        -3760.87353515625,
        945.2925415039062
      ],
      [
        -1671.449951171875,
        -3762.627197265625,
        941.6052856445312
      ],
      [
        -1669.7672119140625,
        -3760.635498046875,
        945.7706298828125
      ],
      [
        -1669.96826171875,
        -3760.87353515625,
        945.2925415039062
      ],
      [
        -1677.7918701171875,
        -3746.93798828125,
        948.1014404296875
      ],
      [
        -1677.9205322265625,
        -3746.827392578125,
        948.0337524414062
      ],
      [
        -1718.5859375,
        -3746.98193359375,
        949.5
      ],
      [
        -1714.742919921875,
        -3743.8330078125,
        949.5
      ],
      [
        -1711.5450439453125,
        -3739.49853515625,
        949.5
      ],
      [
        -1714.742919921875,
        -3743.8330078125,
        949.5
      ],
      [
        -1711.5450439453125,
        -3739.49853515625,
        949.5
      ],
      [
        -1709.17724609375,
        -3739.273193359375,
        949.5
      ],
      [
        -1691.4439697265625,
        -3786.293701171875,
        937.2744140625
      ],
      [
        -1685.6278076171875,
        -3779.409423828125,
        938.0
      ],
      [
        -1682.2763671875,
        -3775.4423828125,
        938.34375
      ],
      [
        -1685.6278076171875,
        -3779.409423828125,
        938.0
      ],
      [
        -1682.2763671875,
        -3775.4423828125,
        938.34375
      ],
      [
        -1681.8201904296875,
        -3774.90234375,
        938.4747924804688
      ],
      [
        -1687.7828369140625,
        -3777.701171875,
        949.5
      ],
      [
        -1691.4439697265625,
        -3786.293701171875,
        947.7255859375
      ],
      [
        -1685.6278076171875,
        -3779.4091796875,
        949.0221557617188
      ],
      [
        -1684.982177734375,
        -3777.1611328125,
        949.5
      ],
      [
        -1671.521484375,
        -3762.635986328125,
        949.5
      ],
      [
        -1671.449951171875,
        -3762.627197265625,
        949.3949584960938
      ],
      [
        -1669.96826171875,
        -3760.87353515625,
        946.2261962890625
      ],
      [
        -1675.23828125,
        -3754.430419921875,
        949.5
      ],
      [
        -1678.515380859375,
        -3747.443115234375,
        949.5
      ],
      [
        -1685.7935791015625,
        -3743.613525390625,
        949.5
      ],
      [
        -1678.252197265625,
        -3770.678955078125,
        939.5
      ],
      [
        -1678.252197265625,
        -3770.678955078125,
        939.5
      ],
      [
        -1672.0089111328125,
        -3763.2890625,
        940.9384765625
      ],
      [
        -1672.0089111328125,
        -3763.2890625,
        940.9384765625
      ],
      [
        -1671.880126953125,
        -3763.136474609375,
        941.0870361328125
      ],
      [
        -1671.569091796875,
        -3762.641845703125,
        941.43017578125
      ],
      [
        -1671.6143798828125,
        -3762.82177734375,
        941.4071655273438
      ],
      [
        -1671.880126953125,
        -3763.136474609375,
        941.0870361328125
      ],
      [
        -1702.318603515625,
        -3738.620849609375,
        949.5
      ],
      [
        -1690.8162841796875,
        -3765.99072265625,
        940.959228515625
      ],
      [
        -1691.0933837890625,
        -3766.4990234375,
        940.939697265625
      ],
      [
        -1693.9775390625,
        -3771.78955078125,
        940.7367553710938
      ],
      [
        -1698.45556640625,
        -3774.364013671875,
        941.1912841796875
      ],
      [
        -1693.9775390625,
        -3771.78955078125,
        940.7367553710938
      ],
      [
        -1702.8487548828125,
        -3776.56591796875,
        941.6814575195312
      ],
      [
        -1698.45556640625,
        -3774.364013671875,
        941.1912841796875
      ],
      [
        -1683.1024169921875,
        -3776.419921875,
        949.5
      ],
      [
        -1684.982177734375,
        -3777.1611328125,
        949.5
      ],
      [
        -1685.6278076171875,
        -3779.4091796875,
        949.0221557617188
      ],
      [
        -1718.5859375,
        -3746.98193359375,
        949.5
      ],
      [
        -1717.133056640625,
        -3748.904296875,
        949.5
      ],
      [
        -1691.29638671875,
        -3765.057373046875,
        942.5570068359375
      ],
      [
        -1695.7110595703125,
        -3771.24853515625,
        943.3782958984375
      ],
      [
        -1694.4488525390625,
        -3769.362548828125,
        943.148193359375
      ],
      [
        -1697.3370361328125,
        -3771.99658203125,
        943.7432861328125
      ],
      [
        -1702.189697265625,
        -3777.128173828125,
        944.7142944335938
      ],
      [
        -1697.3369140625,
        -3771.99658203125,
        943.7432861328125
      ],
      [
        -1696.491455078125,
        -3771.637939453125,
        943.55224609375
      ],
      [
        -1695.7110595703125,
        -3771.24853515625,
        943.3782958984375
      ],
      [
        -1696.4915771484375,
        -3771.63818359375,
        943.5521850585938
      ],
      [
        -1691.29638671875,
        -3765.057373046875,
        942.5570068359375
      ],
      [
        -1694.4488525390625,
        -3769.362548828125,
        943.148193359375
      ],
      [
        -1711.44287109375,
        -3754.021240234375,
        949.5
      ],
      [
        -1706.6829833984375,
        -3754.43701171875,
        949.5
      ],
      [
        -1690.5771484375,
        -3764.969482421875,
        949.5
      ],
      [
        -1691.437255859375,
        -3764.0322265625,
        949.5
      ],
      [
        -1687.7828369140625,
        -3777.701171875,
        949.5
      ],
      [
        -1687.2596435546875,
        -3773.88671875,
        949.5
      ],
      [
        -1691.213134765625,
        -3767.299560546875,
        949.5
      ],
      [
        -1687.2596435546875,
        -3773.88671875,
        949.5
      ],
      [
        -1691.213134765625,
        -3767.299560546875,
        949.5
      ],
      [
        -1690.5771484375,
        -3764.969482421875,
        949.5
      ],
      [
        -1691.1400146484375,
        -3765.038330078125,
        948.6729125976562
      ],
      [
        -1693.157470703125,
        -3767.58642578125,
        942.918701171875
      ],
      [
        -1693.15673828125,
        -3767.597900390625,
        942.9058837890625
      ],
      [
        -1716.35009765625,
        -3749.940185546875,
        949.5
      ],
      [
        -1715.5347900390625,
        -3748.607177734375,
        949.1234130859375
      ],
      [
        -1711.44287109375,
        -3754.021240234375,
        949.5
      ],
      [
        -1716.35009765625,
        -3749.940185546875,
        949.5
      ],
      [
        -1699.876953125,
        -3758.613525390625,
        949.5
      ],
      [
        -1706.4853515625,
        -3754.454345703125,
        949.5
      ],
      [
        -1691.6697998046875,
        -3763.77880859375,
        949.5
      ],
      [
        -1706.4853515625,
        -3754.454345703125,
        949.5
      ],
      [
        -1691.7686767578125,
        -3763.671142578125,
        949.5
      ],
      [
        -1699.876953125,
        -3758.613525390625,
        949.5
      ],
      [
        -1695.752685546875,
        -3759.3310546875,
        949.5
      ],
      [
        -1695.58837890625,
        -3759.359619140625,
        949.5
      ],
      [
        -1691.7686767578125,
        -3763.671142578125,
        949.5
      ],
      [
        -1695.58837890625,
        -3759.359619140625,
        949.5
      ],
      [
        -1671.449951171875,
        -3762.627197265625,
        941.6052856445312
      ],
      [
        -1671.449951171875,
        -3762.627197265625,
        949.3949584960938
      ],
      [
        -1671.521484375,
        -3762.635986328125,
        949.5
      ],
      [
        -1671.5579833984375,
        -3762.755126953125,
        949.5
      ],
      [
        -1681.3533935546875,
        -3775.73046875,
        949.5
      ],
      [
        -1673.056884765625,
        -3767.643310546875,
        949.5
      ],
      [
        -1673.056884765625,
        -3767.643310546875,
        949.5
      ],
      [
        -1677.3145751953125,
        -3772.983642578125,
        949.5
      ],
      [
        -1677.3145751953125,
        -3772.983642578125,
        949.5
      ],
      [
        -1681.3533935546875,
        -3775.73046875,
        949.5
      ],
      [
        -1629.9923095703125,
        -3806.3291015625,
        938.7177734375
      ],
      [
        -1627.5323486328125,
        -3810.47607421875,
        941.0
      ],
      [
        -1627.5323486328125,
        -3810.47607421875,
        941.0
      ],
      [
        -1629.9923095703125,
        -3806.3291015625,
        938.7177734375
      ],
      [
        -1636.08349609375,
        -3748.56103515625,
        935.4556884765625
      ],
      [
        -1643.1871337890625,
        -3729.17333984375,
        935.662109375
      ],
      [
        -1636.08349609375,
        -3748.56103515625,
        935.4556884765625
      ],
      [
        -1636.0836181640625,
        -3748.56103515625,
        946.5443115234375
      ],
      [
        -1643.1871337890625,
        -3729.17333984375,
        946.337890625
      ],
      [
        -1636.082763671875,
        -3748.5625,
        946.5442504882812
      ],
      [
        -1612.6240234375,
        -3795.10546875,
        946.6475830078125
      ],
      [
        -1612.063720703125,
        -3796.917724609375,
        947.0
      ],
      [
        -1612.6240234375,
        -3795.10546875,
        946.6475830078125
      ],
      [
        -1612.0,
        -3797.060791015625,
        946.991943359375
      ],
      [
        -1612.063720703125,
        -3796.917724609375,
        947.0
      ],
      [
        -1612.0,
        -3786.872802734375,
        939.23974609375
      ],
      [
        -1612.0,
        -3786.922607421875,
        939.162841796875
      ],
      [
        -1612.6234130859375,
        -3795.10546875,
        935.3524169921875
      ],
      [
        -1612.063720703125,
        -3796.917724609375,
        935.0
      ],
      [
        -1612.6234130859375,
        -3795.10546875,
        935.3524169921875
      ],
      [
        -1612.063720703125,
        -3796.917724609375,
        935.0
      ],
      [
        -1612.0,
        -3797.060791015625,
        935.008056640625
      ],
      [
        -1618.9774169921875,
        -3794.7939453125,
        935.0
      ],
      [
        -1612.0,
        -3805.474365234375,
        935.5572509765625
      ],
      [
        -1618.8709716796875,
        -3794.66259765625,
        935.0352172851562
      ],
      [
        -1618.9775390625,
        -3794.793701171875,
        935.0
      ],
      [
        -1618.8709716796875,
        -3794.66259765625,
        935.0352172851562
      ],
      [
        -1612.0,
        -3805.47412109375,
        946.4427490234375
      ],
      [
        -1618.9776611328125,
        -3794.793701171875,
        947.0
      ],
      [
        -1618.8712158203125,
        -3794.66259765625,
        946.9647827148438
      ],
      [
        -1618.9776611328125,
        -3794.793701171875,
        947.0
      ],
      [
        -1618.8712158203125,
        -3794.66259765625,
        946.9647827148438
      ],
      [
        -1612.0,
        -3806.07080078125,
        946.40380859375
      ],
      [
        -1612.0,
        -3806.0703125,
        935.5961303710938
      ],
      [
        -1616.5992431640625,
        -3813.0,
        945.859375
      ],
      [
        -1612.0,
        -3813.0,
        946.0338745117188
      ],
      [
        -1612.0,
        -3813.0,
        935.9661254882812
      ],
      [
        -1616.59765625,
        -3813.0,
        936.1405639648438
      ],
      [
        -1618.371826171875,
        -3813.0,
        936.2078857421875
      ],
      [
        -1618.371826171875,
        -3813.0,
        945.7921142578125
      ],
      [
        -1621.9622802734375,
        -3813.0,
        943.7589111328125
      ],
      [
        -1618.371826171875,
        -3813.0,
        945.7921142578125
      ],
      [
        -1618.371826171875,
        -3813.0,
        936.2078857421875
      ],
      [
        -1621.9622802734375,
        -3813.0,
        938.2410888671875
      ],
      [
        -1624.6712646484375,
        -3813.0,
        941.0
      ],
      [
        -1621.9622802734375,
        -3813.0,
        943.7589111328125
      ],
      [
        -1621.9622802734375,
        -3813.0,
        938.2410888671875
      ],
      [
        -1624.6712646484375,
        -3813.0,
        941.0
      ],
      [
        -1755.0,
        -3762.584228515625,
        941.0
      ],
      [
        -1755.0,
        -3763.111083984375,
        940.1726684570312
      ],
      [
        -1755.0,
        -3765.23681640625,
        936.5
      ],
      [
        -1755.0,
        -3763.111083984375,
        940.1726684570312
      ],
      [
        -1755.0,
        -3765.23681640625,
        936.5
      ],
      [
        -1755.0,
        -3765.4765625,
        936.4584350585938
      ],
      [
        -1755.0,
        -3765.23681640625,
        945.5
      ],
      [
        -1755.0,
        -3763.111083984375,
        941.8273315429688
      ],
      [
        -1755.0,
        -3762.584228515625,
        941.0
      ],
      [
        -1755.0,
        -3763.111083984375,
        941.8273315429688
      ],
      [
        -1755.0,
        -3767.986328125,
        945.9766235351562
      ],
      [
        -1755.0,
        -3765.23681640625,
        945.5
      ],
      [
        -1755.0,
        -3773.460693359375,
        947.0
      ],
      [
        -1755.0,
        -3767.986328125,
        945.9766235351562
      ],
      [
        -1755.0,
        -3773.460693359375,
        947.0
      ],
      [
        -1755.0,
        -3773.6767578125,
        946.963134765625
      ],
      [
        -1755.0,
        -3767.986328125,
        936.0233764648438
      ],
      [
        -1755.0,
        -3767.986328125,
        936.0233764648438
      ],
      [
        -1755.0,
        -3773.460693359375,
        935.0
      ],
      [
        -1755.0,
        -3773.460693359375,
        935.0
      ],
      [
        -1755.0,
        -3773.6767578125,
        935.0368041992188
      ],
      [
        -1755.0,
        -3778.674560546875,
        935.8887329101562
      ],
      [
        -1755.0,
        -3778.674560546875,
        946.1112670898438
      ],
      [
        -1755.0,
        -3782.01806640625,
        945.5
      ],
      [
        -1755.0,
        -3778.674560546875,
        946.1112670898438
      ],
      [
        -1755.0,
        -3782.01806640625,
        936.5
      ],
      [
        -1755.0,
        -3778.674560546875,
        935.8887329101562
      ],
      [
        -1755.0,
        -3784.180908203125,
        942.2288208007812
      ],
      [
        -1755.0,
        -3782.01806640625,
        945.5
      ],
      [
        -1755.0,
        -3782.01806640625,
        936.5
      ],
      [
        -1755.0,
        -3784.180908203125,
        939.7711791992188
      ],
      [
        -1755.0,
        -3784.9326171875,
        941.0
      ],
      [
        -1755.0,
        -3784.180908203125,
        942.2288208007812
      ],
      [
        -1755.0,
        -3784.180908203125,
        939.7711791992188
      ],
      [
        -1755.0,
        -3784.9326171875,
        941.0
      ],
      [
        -1724.56005859375,
        -3797.994140625,
        936.0242919921875
      ],
      [
        -1724.56005859375,
        -3797.994140625,
        945.9757080078125
      ],
      [
        -1721.1881103515625,
        -3789.229248046875,
        947.0
      ],
      [
        -1721.4622802734375,
        -3789.942138671875,
        946.9208984375
      ],
      [
        -1724.56005859375,
        -3797.994140625,
        945.9757080078125
      ],
      [
        -1721.4622802734375,
        -3789.942138671875,
        946.9208984375
      ],
      [
        -1742.4561767578125,
        -3778.22216796875,
        946.5968017578125
      ],
      [
        -1721.4622802734375,
        -3789.942138671875,
        935.0791015625
      ],
      [
        -1721.1881103515625,
        -3789.229248046875,
        935.0
      ],
      [
        -1721.4622802734375,
        -3789.942138671875,
        935.0791015625
      ],
      [
        -1724.56005859375,
        -3797.994140625,
        936.0242919921875
      ],
      [
        -1742.456298828125,
        -3778.222412109375,
        935.4031372070312
      ],
      [
        -1717.8287353515625,
        -3780.49755859375,
        936.235595703125
      ],
      [
        -1720.862060546875,
        -3788.3818359375,
        935.1098022460938
      ],
      [
        -1720.862060546875,
        -3788.3818359375,
        946.9341430664062
      ],
      [
        -1717.8287353515625,
        -3780.49755859375,
        946.1875610351562
      ],
      [
        -1717.8287353515625,
        -3780.49755859375,
        936.235595703125
      ],
      [
        -1717.8287353515625,
        -3780.49755859375,
        946.1875610351562
      ],
      [
        -1721.1881103515625,
        -3789.229248046875,
        935.0
      ],
      [
        -1720.862060546875,
        -3788.3818359375,
        935.1098022460938
      ],
      [
        -1720.862060546875,
        -3788.3818359375,
        946.9341430664062
      ],
      [
        -1721.1881103515625,
        -3789.229248046875,
        947.0
      ],
      [
        -1701.2791748046875,
        -3801.0,
        942.7822875976562
      ],
      [
        -1699.894287109375,
        -3801.0,
        941.5701904296875
      ],
      [
        -1701.279296875,
        -3801.0,
        942.7822875976562
      ],
      [
        -1703.93310546875,
        -3801.0,
        946.2156982421875
      ],
      [
        -1703.93310546875,
        -3801.0,
        946.2156982421875
      ],
      [
        -1705.3992919921875,
        -3801.0,
        946.3880004882812
      ],
      [
        -1699.73779296875,
        -3801.0,
        941.420654296875
      ],
      [
        -1699.894287109375,
        -3801.0,
        941.5701904296875
      ],
      [
        -1711.670166015625,
        -3799.554443359375,
        947.0
      ],
      [
        -1711.625,
        -3801.0,
        947.0
      ],
      [
        -1707.2210693359375,
        -3801.0,
        946.60205078125
      ],
      [
        -1707.2210693359375,
        -3801.0,
        946.60205078125
      ],
      [
        -1713.0892333984375,
        -3801.0,
        946.8565063476562
      ],
      [
        -1711.625,
        -3801.0,
        947.0
      ],
      [
        -1711.670166015625,
        -3799.554443359375,
        947.0
      ],
      [
        -1707.2210693359375,
        -3801.0,
        935.6632690429688
      ],
      [
        -1707.861328125,
        -3801.0,
        935.5668334960938
      ],
      [
        -1707.2210693359375,
        -3801.0,
        935.6632690429688
      ],
      [
        -1703.93310546875,
        -3801.0,
        936.2247314453125
      ],
      [
        -1703.93310546875,
        -3801.0,
        936.2247314453125
      ],
      [
        -1703.9208984375,
        -3801.0,
        936.24169921875
      ],
      [
        -1701.279296875,
        -3801.0,
        939.8902587890625
      ],
      [
        -1699.894287109375,
        -3801.0,
        941.2578735351562
      ],
      [
        -1701.2791748046875,
        -3801.0,
        939.8902587890625
      ],
      [
        -1699.73779296875,
        -3801.0,
        941.420654296875
      ],
      [
        -1699.894287109375,
        -3801.0,
        941.2578735351562
      ],
      [
        -1697.3681640625,
        -3788.31787109375,
        936.4118041992188
      ],
      [
        -1718.2552490234375,
        -3781.60595703125,
        936.0773315429688
      ],
      [
        -1718.4296875,
        -3782.0595703125,
        946.3355102539062
      ],
      [
        -1718.6058349609375,
        -3782.517333984375,
        946.3788452148438
      ],
      [
        -1716.302490234375,
        -3801.0,
        946.5415649414062
      ],
      [
        -1708.2095947265625,
        -3799.71337890625,
        946.687744140625
      ],
      [
        -1716.302490234375,
        -3801.0,
        946.5415649414062
      ],
      [
        -1720.9139404296875,
        -3801.0,
        945.9814453125
      ],
      [
        -1720.9139404296875,
        -3801.0,
        945.9814453125
      ],
      [
        -1720.961669921875,
        -3801.0,
        945.9314575195312
      ],
      [
        -1721.1302490234375,
        -3789.078857421875,
        946.98828125
      ],
      [
        -1712.3045654296875,
        -3792.355712890625,
        946.8894653320312
      ],
      [
        -1712.3045654296875,
        -3792.355712890625,
        946.8894653320312
      ],
      [
        -1721.7252197265625,
        -3799.626708984375,
        945.73046875
      ],
      [
        -1724.5958251953125,
        -3798.087158203125,
        945.8182983398438
      ],
      [
        -1721.7252197265625,
        -3799.626708984375,
        945.73046875
      ],
      [
        -1721.2935791015625,
        -3801.0,
        945.583251953125
      ],
      [
        -1714.3831787109375,
        -3791.583984375,
        946.9127197265625
      ],
      [
        -1721.4630126953125,
        -3791.9599609375,
        935.2642822265625
      ],
      [
        -1721.4630126953125,
        -3791.9599609375,
        935.2642822265625
      ],
      [
        -1722.149658203125,
        -3791.72900390625,
        935.288818359375
      ],
      [
        -1711.625,
        -3801.0,
        935.0
      ],
      [
        -1711.625,
        -3801.0,
        935.0
      ],
      [
        -1716.302490234375,
        -3801.0,
        935.4584350585938
      ],
      [
        -1720.9139404296875,
        -3801.0,
        936.0185546875
      ],
      [
        -1716.302490234375,
        -3801.0,
        935.4584350585938
      ],
      [
        -1720.9139404296875,
        -3801.0,
        936.0185546875
      ],
      [
        -1720.961669921875,
        -3801.0,
        936.068603515625
      ],
      [
        -1725.6402587890625,
        -3801.0,
        940.9754028320312
      ],
      [
        -1725.6402587890625,
        -3801.0,
        941.0245971679688
      ],
      [
        -1725.649169921875,
        -3801.0,
        941.0
      ],
      [
        -1725.6402587890625,
        -3801.0,
        941.0245971679688
      ],
      [
        -1725.649169921875,
        -3801.0,
        941.0
      ],
      [
        -1725.6402587890625,
        -3801.0,
        940.9754028320312
      ],
      [
        -1699.9974365234375,
        -3801.0,
        941.6605224609375
      ],
      [
        -1709.38427734375,
        -3813.0,
        946.3489990234375
      ],
      [
        -1709.3843994140625,
        -3813.0,
        935.6509399414062
      ],
      [
        -1687.4248046875,
        -3775.0908203125,
        949.5
      ],
      [
        -1686.0582275390625,
        -3777.36865234375,
        949.5
      ],
      [
        -1685.261962890625,
        -3777.215087890625,
        949.5
      ],
      [
        -1686.2467041015625,
        -3743.47265625,
        949.5
      ],
      [
        -1701.7689208984375,
        -3749.519287109375,
        956.9758911132812
      ],
      [
        -1701.7689208984375,
        -3749.519287109375,
        956.9758911132812
      ],
      [
        -1705.3699951171875,
        -3750.216064453125,
        957.7255859375
      ],
      [
        -1727.3189697265625,
        -3739.666015625,
        961.12841796875
      ],
      [
        -1711.69189453125,
        -3739.697509765625,
        949.5
      ],
      [
        -1720.07958984375,
        -3755.53271484375,
        959.5333862304688
      ],
      [
        -1717.816650390625,
        -3747.999755859375,
        949.5
      ],
      [
        -1727.2740478515625,
        -3739.764404296875,
        961.1481323242188
      ],
      [
        -1741.64697265625,
        -3778.40478515625,
        952.0032958984375
      ],
      [
        -1741.637451171875,
        -3778.370361328125,
        952.0032348632812
      ],
      [
        -1741.637451171875,
        -3778.370361328125,
        952.0032348632812
      ],
      [
        -1741.6474609375,
        -3778.40478515625,
        963.996826171875
      ],
      [
        -1741.63818359375,
        -3778.37109375,
        963.996826171875
      ],
      [
        -1741.63818359375,
        -3778.37109375,
        963.996826171875
      ],
      [
        -1728.6856689453125,
        -3813.0,
        962.5
      ],
      [
        -1729.2105712890625,
        -3813.0,
        962.6077270507812
      ],
      [
        -1729.2105712890625,
        -3813.0,
        962.6077270507812
      ],
      [
        -1735.7744140625,
        -3813.0,
        964.0
      ],
      [
        -1735.7744140625,
        -3813.0,
        964.0
      ],
      [
        -1735.8841552734375,
        -3813.0,
        963.9776000976562
      ],
      [
        -1728.6856689453125,
        -3813.0,
        962.5
      ],
      [
        -1727.4683837890625,
        -3813.0,
        960.1439208984375
      ],
      [
        -1727.4683837890625,
        -3813.0,
        955.8560791015625
      ],
      [
        -1728.6856689453125,
        -3813.0,
        953.5
      ],
      [
        -1735.7744140625,
        -3813.0,
        952.0
      ],
      [
        -1729.2105712890625,
        -3813.0,
        953.3922729492188
      ],
      [
        -1729.2105712890625,
        -3813.0,
        953.3922729492188
      ],
      [
        -1728.6856689453125,
        -3813.0,
        953.5
      ],
      [
        -1735.7744140625,
        -3813.0,
        952.0
      ],
      [
        -1738.56640625,
        -3813.0,
        952.5704956054688
      ],
      [
        -1738.56640625,
        -3813.0,
        963.4295043945312
      ],
      [
        -1742.9892578125,
        -3813.0,
        962.5
      ],
      [
        -1738.56640625,
        -3813.0,
        963.4295043945312
      ],
      [
        -1742.9892578125,
        -3813.0,
        953.5
      ],
      [
        -1738.56640625,
        -3813.0,
        952.5704956054688
      ],
      [
        -1742.9892578125,
        -3813.0,
        962.5
      ],
      [
        -1744.332275390625,
        -3813.0,
        960.0376586914062
      ],
      [
        -1744.332275390625,
        -3813.0,
        955.9623413085938
      ],
      [
        -1742.9892578125,
        -3813.0,
        953.5
      ],
      [
        -1744.332275390625,
        -3813.0,
        960.0376586914062
      ],
      [
        -1745.4122314453125,
        -3813.0,
        958.0
      ],
      [
        -1745.4122314453125,
        -3813.0,
        958.0
      ],
      [
        -1744.332275390625,
        -3813.0,
        955.9623413085938
      ],
      [
        -1726.16796875,
        -3813.0,
        958.0
      ],
      [
        -1727.4683837890625,
        -3813.0,
        960.1439208984375
      ],
      [
        -1727.4683837890625,
        -3813.0,
        955.8560791015625
      ],
      [
        -1726.16796875,
        -3813.0,
        958.0
      ],
      [
        -1755.0,
        -3825.0,
        943.8333129882812
      ],
      [
        -1755.0,
        -3826.052734375,
        938.7732543945312
      ],
      [
        -1755.0,
        -3831.5,
        935.0
      ],
      [
        -1755.0,
        -3833.464599609375,
        935.6044921875
      ],
      [
        -1755.0,
        -3828.342041015625,
        936.659912109375
      ],
      [
        -1755.0,
        -3826.625,
        937.188232421875
      ],
      [
        -1755.0,
        -3831.5,
        935.0
      ],
      [
        -1755.0,
        -3828.342041015625,
        936.659912109375
      ],
      [
        -1755.0,
        -3826.052734375,
        938.7732543945312
      ],
      [
        -1755.0,
        -3826.625,
        937.188232421875
      ],
      [
        -1755.0,
        -3836.375,
        937.0882568359375
      ],
      [
        -1755.0,
        -3837.100341796875,
        939.0968627929688
      ],
      [
        -1755.0,
        -3838.0,
        943.2973022460938
      ],
      [
        -1755.0,
        -3837.100341796875,
        939.0968627929688
      ],
      [
        -1755.0,
        -3836.375,
        937.0882568359375
      ],
      [
        -1755.0,
        -3833.464599609375,
        935.6044921875
      ],
      [
        -1755.0,
        -3837.25341796875,
        945.3648681640625
      ],
      [
        -1754.428466796875,
        -3836.375,
        949.5
      ],
      [
        -1755.0,
        -3836.3994140625,
        949.5
      ],
      [
        -1755.0,
        -3838.0,
        943.2973022460938
      ],
      [
        -1755.0,
        -3837.25341796875,
        945.3648681640625
      ],
      [
        -1755.0,
        -3825.0,
        943.8333129882812
      ],
      [
        -1755.0,
        -3825.541748046875,
        945.3333129882812
      ],
      [
        -1751.6051025390625,
        -3826.625,
        949.5
      ],
      [
        -1755.0,
        -3825.541748046875,
        945.3333129882812
      ],
      [
        -1755.0,
        -3826.447265625,
        949.5
      ],
      [
        -1751.6051025390625,
        -3826.625,
        949.5
      ],
      [
        -1750.791748046875,
        -3827.26171875,
        949.5
      ],
      [
        -1754.428466796875,
        -3836.375,
        949.5
      ],
      [
        -1748.4000244140625,
        -3834.425048828125,
        949.5
      ],
      [
        -1748.0001220703125,
        -3829.447265625,
        949.5
      ],
      [
        -1748.0001220703125,
        -3829.447265625,
        949.5
      ],
      [
        -1744.8529052734375,
        -3831.5,
        949.5
      ],
      [
        -1744.8529052734375,
        -3831.5,
        949.5
      ],
      [
        -1745.1087646484375,
        -3831.7109375,
        949.5
      ],
      [
        -1748.4000244140625,
        -3834.425048828125,
        949.5
      ],
      [
        -1670.2294921875,
        -3835.551025390625,
        937.0
      ],
      [
        -1668.3404541015625,
        -3836.337158203125,
        937.0
      ],
      [
        -1685.0157470703125,
        -3829.178466796875,
        937.0
      ],
      [
        -1670.2294921875,
        -3835.551025390625,
        937.0
      ],
      [
        -1688.9046630859375,
        -3838.511962890625,
        937.0
      ],
      [
        -1687.3419189453125,
        -3839.38134765625,
        937.0
      ],
      [
        -1674.5140380859375,
        -3846.253662109375,
        937.0
      ],
      [
        -1687.3419189453125,
        -3839.38134765625,
        937.0
      ],
      [
        -1702.2369384765625,
        -3824.1748046875,
        937.0
      ],
      [
        -1686.7274169921875,
        -3828.608154296875,
        937.0
      ],
      [
        -1706.4444580078125,
        -3813.0,
        937.0
      ],
      [
        -1705.8739013671875,
        -3814.0791015625,
        937.0
      ],
      [
        -1702.2369384765625,
        -3824.1748046875,
        937.0
      ],
      [
        -1705.8739013671875,
        -3814.0791015625,
        937.0
      ],
      [
        -1685.0157470703125,
        -3829.178466796875,
        937.0
      ],
      [
        -1686.7274169921875,
        -3828.608154296875,
        937.0
      ],
      [
        -1702.9710693359375,
        -3840.555908203125,
        937.0
      ],
      [
        -1706.0128173828125,
        -3853.634521484375,
        937.0
      ],
      [
        -1702.9710693359375,
        -3840.555908203125,
        937.0
      ],
      [
        -1690.1995849609375,
        -3838.830322265625,
        937.0
      ],
      [
        -1688.9046630859375,
        -3838.511962890625,
        937.0
      ],
      [
        -1690.1995849609375,
        -3838.830322265625,
        937.0
      ],
      [
        -1706.4444580078125,
        -3855.0,
        937.0
      ],
      [
        -1706.0128173828125,
        -3853.634521484375,
        937.0
      ],
      [
        -1687.0848388671875,
        -3834.144287109375,
        935.0997314453125
      ],
      [
        -1711.0533447265625,
        -3822.651611328125,
        935.137451171875
      ],
      [
        -1711.5,
        -3822.597412109375,
        935.0
      ],
      [
        -1711.0533447265625,
        -3822.651611328125,
        935.137451171875
      ],
      [
        -1711.5,
        -3827.428466796875,
        935.0
      ],
      [
        -1687.6103515625,
        -3835.405517578125,
        935.5200805664062
      ],
      [
        -1704.825927734375,
        -3848.531494140625,
        937.0
      ],
      [
        -1705.0,
        -3849.27978515625,
        937.0
      ],
      [
        -1711.5,
        -3835.8095703125,
        935.0
      ],
      [
        -1720.2103271484375,
        -3840.210205078125,
        937.0
      ],
      [
        -1733.5833740234375,
        -3837.02783203125,
        937.0
      ],
      [
        -1720.2103271484375,
        -3840.210205078125,
        937.0
      ],
      [
        -1717.02783203125,
        -3853.583251953125,
        937.0
      ],
      [
        -1716.5555419921875,
        -3855.0,
        937.0
      ],
      [
        -1717.02783203125,
        -3853.583251953125,
        937.0
      ],
      [
        -1720.2103271484375,
        -3823.6826171875,
        937.0
      ],
      [
        -1733.5833740234375,
        -3826.111083984375,
        937.0
      ],
      [
        -1720.2103271484375,
        -3823.6826171875,
        937.0
      ],
      [
        -1717.02783203125,
        -3814.0,
        937.0
      ],
      [
        -1716.5555419921875,
        -3813.0,
        937.0
      ],
      [
        -1717.02783203125,
        -3814.0,
        937.0
      ],
      [
        -1735.0,
        -3836.5556640625,
        937.0
      ],
      [
        -1733.5833740234375,
        -3837.02783203125,
        937.0
      ],
      [
        -1735.0,
        -3826.4443359375,
        937.0
      ],
      [
        -1733.5833740234375,
        -3826.111083984375,
        937.0
      ],
      [
        -1717.57763671875,
        -3815.672607421875,
        937.0
      ],
      [
        -1711.5,
        -3827.66943359375,
        935.0
      ],
      [
        -1727.463623046875,
        -3824.999755859375,
        937.0
      ],
      [
        -1728.78369140625,
        -3838.170166015625,
        937.0
      ],
      [
        -1729.4984130859375,
        -3838.0,
        937.0
      ],
      [
        -1716.051025390625,
        -3831.5,
        935.0
      ],
      [
        -1718.0,
        -3849.498291015625,
        937.0
      ],
      [
        -1705.186279296875,
        -3824.80859375,
        949.358154296875
      ],
      [
        -1704.3330078125,
        -3825.595458984375,
        949.3621826171875
      ],
      [
        -1704.5230712890625,
        -3825.6083984375,
        949.5
      ],
      [
        -1704.3330078125,
        -3825.595458984375,
        949.3621826171875
      ],
      [
        -1705.2613525390625,
        -3824.88671875,
        949.5
      ],
      [
        -1705.186279296875,
        -3824.80859375,
        949.358154296875
      ],
      [
        -1711.5,
        -3823.28369140625,
        949.5
      ],
      [
        -1711.5,
        -3821.626220703125,
        947.6852416992188
      ],
      [
        -1711.5,
        -3821.22998046875,
        947.5552978515625
      ],
      [
        -1711.5,
        -3821.62060546875,
        947.6791381835938
      ],
      [
        -1711.5,
        -3821.22998046875,
        947.5552978515625
      ],
      [
        -1711.5,
        -3821.54931640625,
        947.6013793945312
      ],
      [
        -1711.5,
        -3821.56640625,
        947.6038208007812
      ],
      [
        -1711.5,
        -3821.62060546875,
        947.6791381835938
      ],
      [
        -1711.5,
        -3821.56640625,
        947.6038208007812
      ],
      [
        -1704.5010986328125,
        -3837.0703125,
        949.5
      ],
      [
        -1705.128173828125,
        -3838.38818359375,
        949.426025390625
      ],
      [
        -1705.154052734375,
        -3838.309814453125,
        949.5
      ],
      [
        -1705.128173828125,
        -3838.38818359375,
        949.426025390625
      ],
      [
        -1711.5,
        -3840.3994140625,
        949.5
      ],
      [
        -1711.5,
        -3842.806884765625,
        947.657958984375
      ],
      [
        -1711.5,
        -3843.765625,
        947.5501708984375
      ],
      [
        -1711.5,
        -3842.806884765625,
        947.657958984375
      ],
      [
        -1711.5,
        -3842.811767578125,
        947.6508178710938
      ],
      [
        -1711.5,
        -3843.13427734375,
        947.5811157226562
      ],
      [
        -1711.5,
        -3842.838623046875,
        947.6117553710938
      ],
      [
        -1711.5,
        -3843.13427734375,
        947.5811157226562
      ],
      [
        -1711.5,
        -3842.838623046875,
        947.6117553710938
      ],
      [
        -1717.5906982421875,
        -3838.045166015625,
        949.3778076171875
      ],
      [
        -1717.3890380859375,
        -3838.015625,
        949.5
      ],
      [
        -1717.5906982421875,
        -3838.045166015625,
        949.3778076171875
      ],
      [
        -1716.813232421875,
        -3825.20361328125,
        949.4200439453125
      ],
      [
        -1716.6385498046875,
        -3825.211181640625,
        949.5
      ],
      [
        -1716.813232421875,
        -3825.20361328125,
        949.4200439453125
      ],
      [
        -1717.705322265625,
        -3836.968994140625,
        949.5
      ],
      [
        -1735.0,
        -3832.75732421875,
        946.6131591796875
      ],
      [
        -1717.6497802734375,
        -3838.093017578125,
        949.280029296875
      ],
      [
        -1745.4940185546875,
        -3831.5,
        949.6626586914062
      ],
      [
        -1755.0,
        -3831.5,
        952.0746459960938
      ],
      [
        -1755.0,
        -3833.464599609375,
        951.4701538085938
      ],
      [
        -1748.1156005859375,
        -3834.1904296875,
        949.5
      ],
      [
        -1755.0,
        -3836.375,
        949.61767578125
      ],
      [
        -1755.0,
        -3833.464599609375,
        951.4701538085938
      ],
      [
        -1755.0,
        -3826.625,
        950.3178100585938
      ],
      [
        -1755.0,
        -3828.342041015625,
        950.8461303710938
      ],
      [
        -1755.0,
        -3828.342041015625,
        950.8461303710938
      ],
      [
        -1755.0,
        -3831.5,
        952.0746459960938
      ],
      [
        -1745.4940185546875,
        -3831.5,
        949.6626586914062
      ],
      [
        -1745.244873046875,
        -3831.244384765625,
        949.5
      ],
      [
        -1755.0,
        -3826.625,
        950.3178100585938
      ],
      [
        -1755.0,
        -3836.375,
        949.61767578125
      ],
      [
        -1701.0096435546875,
        -3831.66162109375,
        952.8571166992188
      ],
      [
        -1701.0054931640625,
        -3831.6533203125,
        952.8705444335938
      ],
      [
        -1701.0096435546875,
        -3831.661865234375,
        952.8572998046875
      ],
      [
        -1701.0205078125,
        -3831.69580078125,
        952.8576049804688
      ],
      [
        -1701.020751953125,
        -3831.696044921875,
        952.8574829101562
      ],
      [
        -1701.00390625,
        -3831.650390625,
        952.875
      ],
      [
        -1701.0054931640625,
        -3831.653564453125,
        952.87060546875
      ],
      [
        -1701.0040283203125,
        -3831.650390625,
        952.875
      ],
      [
        -1730.8856201171875,
        -3837.3154296875,
        959.5593872070312
      ],
      [
        -1719.619384765625,
        -3831.267822265625,
        963.9846801757812
      ],
      [
        -1720.2037353515625,
        -3831.127197265625,
        964.0
      ],
      [
        -1719.619384765625,
        -3831.267822265625,
        963.9846801757812
      ],
      [
        -1724.14599609375,
        -3820.8876953125,
        962.1122436523438
      ],
      [
        -1710.6253662109375,
        -3840.755859375,
        961.78955078125
      ],
      [
        -1702.5343017578125,
        -3831.7666015625,
        961.7894287109375
      ],
      [
        -1710.312255859375,
        -3821.470703125,
        953.8350219726562
      ],
      [
        -1725.2164306640625,
        -3823.496826171875,
        953.0078735351562
      ],
      [
        -1717.1468505859375,
        -3825.2607421875,
        949.6311645507812
      ],
      [
        -1702.571533203125,
        -3891.322509765625,
        936.5
      ],
      [
        -1704.86083984375,
        -3895.0,
        936.5
      ],
      [
        -1710.578857421875,
        -3883.5,
        946.8157958984375
      ],
      [
        -1704.86083984375,
        -3895.0,
        945.962646484375
      ],
      [
        -1702.571533203125,
        -3891.322509765625,
        945.5
      ],
      [
        -1702.571533203125,
        -3891.322509765625,
        945.5
      ],
      [
        -1701.32080078125,
        -3889.3134765625,
        943.2252197265625
      ],
      [
        -1700.43212890625,
        -3887.885986328125,
        941.0
      ],
      [
        -1701.32080078125,
        -3889.3134765625,
        943.2252197265625
      ],
      [
        -1702.571533203125,
        -3891.322509765625,
        936.5
      ],
      [
        -1701.724853515625,
        -3889.96240234375,
        938.4712524414062
      ],
      [
        -1700.43212890625,
        -3887.885986328125,
        941.0
      ],
      [
        -1701.724853515625,
        -3889.96240234375,
        938.4712524414062
      ],
      [
        -1664.2498779296875,
        -3867.37158203125,
        940.82421875
      ],
      [
        -1640.9583740234375,
        -3840.373291015625,
        945.3120727539062
      ],
      [
        -1640.8818359375,
        -3839.209228515625,
        945.3009643554688
      ],
      [
        -1640.9583740234375,
        -3840.373291015625,
        945.3120727539062
      ],
      [
        -1640.8818359375,
        -3839.209228515625,
        945.3009643554688
      ],
      [
        -1640.86962890625,
        -3839.195068359375,
        945.3043823242188
      ],
      [
        -1640.63232421875,
        -3838.919677734375,
        945.3712158203125
      ],
      [
        -1640.63232421875,
        -3838.919677734375,
        945.3712158203125
      ],
      [
        -1640.9583740234375,
        -3840.372802734375,
        936.6878662109375
      ],
      [
        -1640.8818359375,
        -3839.209228515625,
        936.698974609375
      ],
      [
        -1640.9583740234375,
        -3840.372802734375,
        936.6878662109375
      ],
      [
        -1640.8818359375,
        -3839.209228515625,
        936.698974609375
      ],
      [
        -1640.8695068359375,
        -3839.19482421875,
        936.6954956054688
      ],
      [
        -1640.6324462890625,
        -3838.919921875,
        936.6287231445312
      ],
      [
        -1640.6324462890625,
        -3838.919921875,
        936.6287231445312
      ],
      [
        -1630.0281982421875,
        -3839.984619140625,
        937.2103271484375
      ],
      [
        -1630.0281982421875,
        -3839.984619140625,
        944.78955078125
      ],
      [
        -1630.3411865234375,
        -3836.40966796875,
        941.7083129882812
      ],
      [
        -1635.329345703125,
        -3836.439697265625,
        936.2632446289062
      ],
      [
        -1635.329345703125,
        -3836.439697265625,
        945.7367553710938
      ],
      [
        -1727.44384765625,
        -3915.0,
        941.6659545898438
      ],
      [
        -1694.565673828125,
        -3915.0,
        941.6659545898438
      ],
      [
        -1696.334716796875,
        -3913.693115234375,
        941.328369140625
      ],
      [
        -1695.3914794921875,
        -3915.0,
        933.9505615234375
      ],
      [
        -1701.646240234375,
        -3915.0,
        933.9505615234375
      ],
      [
        -1700.95458984375,
        -3913.693115234375,
        941.328369140625
      ],
      [
        -1693.797119140625,
        -3910.0,
        940.3744506835938
      ],
      [
        -1695.1273193359375,
        -3915.0,
        932.8438110351562
      ],
      [
        -1695.3914794921875,
        -3915.0,
        933.9505615234375
      ],
      [
        -1696.334716796875,
        -3913.693115234375,
        941.328369140625
      ],
      [
        -1700.95458984375,
        -3913.693115234375,
        941.328369140625
      ],
      [
        -1701.646240234375,
        -3915.0,
        933.9505615234375
      ],
      [
        -1701.8726806640625,
        -3915.0,
        932.8438110351562
      ],
      [
        -1703.4595947265625,
        -3910.0,
        940.3744506835938
      ],
      [
        -1696.0791015625,
        -3905.95263671875,
        939.3289794921875
      ],
      [
        -1693.797119140625,
        -3910.0,
        940.3744506835938
      ],
      [
        -1703.4595947265625,
        -3910.0,
        940.3744506835938
      ],
      [
        -1701.1419677734375,
        -3905.95263671875,
        939.3290405273438
      ],
      [
        -1701.1419677734375,
        -3905.95263671875,
        939.3289794921875
      ],
      [
        -1696.0791015625,
        -3905.95263671875,
        939.3290405273438
      ],
      [
        -1701.38232421875,
        -3915.0,
        968.6401977539062
      ],
      [
        -1728.4510498046875,
        -3915.0,
        968.6401977539062
      ],
      [
        -1700.7490234375,
        -3906.6953125,
        965.6521606445312
      ],
      [
        -1696.614990234375,
        -3906.6953125,
        965.6521606445312
      ],
      [
        -1696.614990234375,
        -3906.6953125,
        965.6521606445312
      ],
      [
        -1694.2506103515625,
        -3910.0,
        966.8412475585938
      ],
      [
        -1703.0709228515625,
        -3910.0,
        966.8412475585938
      ],
      [
        -1700.7490234375,
        -3906.6953125,
        965.6521606445312
      ],
      [
        -1695.1273193359375,
        -3915.0,
        975.8438110351562
      ],
      [
        -1694.2506103515625,
        -3910.0,
        966.8412475585938
      ],
      [
        -1696.273681640625,
        -3913.777587890625,
        968.2003173828125
      ],
      [
        -1695.3914794921875,
        -3915.0,
        974.787353515625
      ],
      [
        -1701.8726806640625,
        -3915.0,
        975.8438110351562
      ],
      [
        -1701.646240234375,
        -3915.0,
        974.787353515625
      ],
      [
        -1700.999267578125,
        -3913.777587890625,
        968.2003173828125
      ],
      [
        -1703.0709228515625,
        -3910.0,
        966.8412475585938
      ],
      [
        -1695.3914794921875,
        -3915.0,
        974.787353515625
      ],
      [
        -1696.273681640625,
        -3913.777587890625,
        968.2003173828125
      ],
      [
        -1700.999267578125,
        -3913.777587890625,
        968.2003173828125
      ],
      [
        -1701.646240234375,
        -3915.0,
        974.787353515625
      ],
      [
        -1732.682373046875,
        -3915.0,
        948.2280883789062
      ],
      [
        -1732.74267578125,
        -3915.0,
        947.239013671875
      ],
      [
        -1732.764892578125,
        -3915.0,
        962.7142944335938
      ],
      [
        -1732.682373046875,
        -3915.0,
        948.2280883789062
      ],
      [
        -1732.61767578125,
        -3915.0,
        962.9259033203125
      ],
      [
        -1730.8765869140625,
        -3910.445556640625,
        962.5885620117188
      ],
      [
        -1732.764892578125,
        -3915.0,
        962.7142944335938
      ],
      [
        -1730.8765869140625,
        -3910.445556640625,
        962.5885620117188
      ],
      [
        -1732.61767578125,
        -3915.0,
        962.9259033203125
      ],
      [
        -1731.71044921875,
        -3915.0,
        964.1701049804688
      ],
      [
        -1727.61474609375,
        -3915.0,
        942.0579223632812
      ],
      [
        -1732.74267578125,
        -3915.0,
        947.239013671875
      ],
      [
        -1727.44384765625,
        -3915.0,
        941.6659545898438
      ],
      [
        -1727.61474609375,
        -3915.0,
        942.0579223632812
      ],
      [
        -1728.4510498046875,
        -3915.0,
        968.6401977539062
      ],
      [
        -1689.2894287109375,
        -3915.0,
        947.239013671875
      ],
      [
        -1689.6070556640625,
        -3915.0,
        948.2280883789062
      ],
      [
        -1689.6070556640625,
        -3915.0,
        948.2280883789062
      ],
      [
        -1693.735107421875,
        -3915.0,
        962.7142944335938
      ],
      [
        -1695.2989501953125,
        -3910.0,
        962.647705078125
      ],
      [
        -1695.853515625,
        -3912.992919921875,
        967.9180297851562
      ],
      [
        -1696.7794189453125,
        -3906.923095703125,
        964.4246215820312
      ],
      [
        -1695.2989501953125,
        -3910.0,
        962.647705078125
      ],
      [
        -1696.7794189453125,
        -3906.923095703125,
        964.4246215820312
      ],
      [
        -1697.201171875,
        -3906.6953125,
        965.6521606445312
      ],
      [
        -1693.735107421875,
        -3915.0,
        962.7142944335938
      ],
      [
        -1694.4322509765625,
        -3915.0,
        963.2540893554688
      ],
      [
        -1695.492431640625,
        -3910.0,
        961.8739013671875
      ],
      [
        -1696.3121337890625,
        -3913.724365234375,
        967.9130859375
      ],
      [
        -1696.8992919921875,
        -3907.089111328125,
        963.5293579101562
      ],
      [
        -1695.492431640625,
        -3910.0,
        961.8739013671875
      ],
      [
        -1696.8992919921875,
        -3907.089111328125,
        963.5293579101562
      ],
      [
        -1697.699462890625,
        -3906.6953125,
        965.6521606445312
      ],
      [
        -1696.3121337890625,
        -3913.724365234375,
        967.9130859375
      ],
      [
        -1696.388427734375,
        -3913.777587890625,
        968.2003173828125
      ],
      [
        -1694.565673828125,
        -3915.0,
        941.6659545898438
      ],
      [
        -1694.4234619140625,
        -3915.0,
        942.0579223632812
      ],
      [
        -1689.2894287109375,
        -3915.0,
        947.239013671875
      ],
      [
        -1694.4234619140625,
        -3915.0,
        942.0579223632812
      ],
      [
        -1694.8375244140625,
        -3908.15478515625,
        939.8978271484375
      ],
      [
        -1694.1767578125,
        -3910.0,
        941.9656372070312
      ],
      [
        -1694.1912841796875,
        -3909.97021484375,
        941.9489135742188
      ],
      [
        -1694.1767578125,
        -3910.0,
        941.9656372070312
      ],
      [
        -1694.71142578125,
        -3911.33056640625,
        940.7181396484375
      ],
      [
        -1694.1943359375,
        -3910.033935546875,
        941.9502563476562
      ],
      [
        -1694.1807861328125,
        -3910.0,
        941.982421875
      ],
      [
        -1694.1807861328125,
        -3910.0,
        941.982421875
      ],
      [
        -1701.1160888671875,
        -3915.0,
        968.4285888671875
      ],
      [
        -1701.1160888671875,
        -3915.0,
        968.4285888671875
      ],
      [
        -1701.38232421875,
        -3915.0,
        968.6401977539062
      ],
      [
        -1695.521240234375,
        -3910.0,
        961.7584838867188
      ],
      [
        -1696.8126220703125,
        -3913.03076171875,
        964.176025390625
      ],
      [
        -1696.8126220703125,
        -3913.03076171875,
        964.176025390625
      ],
      [
        -1700.9483642578125,
        -3913.681396484375,
        967.681884765625
      ],
      [
        -1700.614990234375,
        -3906.94873046875,
        964.2868041992188
      ],
      [
        -1700.049072265625,
        -3907.025634765625,
        963.8726806640625
      ],
      [
        -1697.1317138671875,
        -3907.4111328125,
        961.7943115234375
      ],
      [
        -1697.1317138671875,
        -3907.4111328125,
        961.7943115234375
      ],
      [
        -1695.521240234375,
        -3910.0,
        961.7584838867188
      ],
      [
        -1700.614990234375,
        -3906.94873046875,
        964.2869873046875
      ],
      [
        -1702.206298828125,
        -3908.76953125,
        966.3984375
      ],
      [
        -1700.9483642578125,
        -3913.681396484375,
        967.681884765625
      ],
      [
        -1701.7169189453125,
        -3912.468994140625,
        967.7295532226562
      ],
      [
        -1700.61376953125,
        -3906.950927734375,
        964.2747802734375
      ],
      [
        -1702.24951171875,
        -3908.8310546875,
        966.4205932617188
      ],
      [
        -1701.7509765625,
        -3912.40673828125,
        967.7071533203125
      ],
      [
        -1700.61376953125,
        -3906.950927734375,
        964.2749633789062
      ],
      [
        -1697.237060546875,
        -3910.893798828125,
        957.1318359375
      ],
      [
        -1697.214111328125,
        -3912.474609375,
        961.1782836914062
      ],
      [
        -1697.33642578125,
        -3912.65966796875,
        962.1761474609375
      ],
      [
        -1697.214111328125,
        -3912.474609375,
        961.1782836914062
      ],
      [
        -1700.5423583984375,
        -3912.914306640625,
        963.548095703125
      ],
      [
        -1700.23046875,
        -3913.568359375,
        967.0733642578125
      ],
      [
        -1697.670654296875,
        -3913.165771484375,
        964.9033203125
      ],
      [
        -1700.5423583984375,
        -3912.914306640625,
        963.5484008789062
      ],
      [
        -1695.5672607421875,
        -3909.926025390625,
        961.759521484375
      ],
      [
        -1702.0714111328125,
        -3910.0,
        962.1771850585938
      ],
      [
        -1702.5870361328125,
        -3910.88232421875,
        967.15869140625
      ],
      [
        -1702.0714111328125,
        -3910.0,
        962.1771850585938
      ],
      [
        -1712.90966796875,
        -3925.281982421875,
        944.55322265625
      ],
      [
        -1718.2662353515625,
        -3925.281982421875,
        944.55322265625
      ],
      [
        -1709.8885498046875,
        -3921.0,
        943.332275390625
      ],
      [
        -1712.90966796875,
        -3925.281982421875,
        944.55322265625
      ],
      [
        -1718.2662353515625,
        -3925.281982421875,
        944.55322265625
      ],
      [
        -1721.2384033203125,
        -3921.0,
        943.332275390625
      ],
      [
        -1718.5526123046875,
        -3916.177001953125,
        941.95703125
      ],
      [
        -1712.5191650390625,
        -3916.177001953125,
        941.95703125
      ],
      [
        -1721.2384033203125,
        -3921.0,
        943.332275390625
      ],
      [
        -1718.5526123046875,
        -3916.177001953125,
        941.95703125
      ],
      [
        -1712.5191650390625,
        -3916.177001953125,
        941.95703125
      ],
      [
        -1709.8885498046875,
        -3921.0,
        943.332275390625
      ],
      [
        -1718.5511474609375,
        -3916.179931640625,
        941.9706420898438
      ],
      [
        -1712.521240234375,
        -3916.179931640625,
        941.9706420898438
      ],
      [
        -1718.8193359375,
        -3916.656005859375,
        942.0936279296875
      ],
      [
        -1718.5511474609375,
        -3916.179931640625,
        941.9706420898438
      ],
      [
        -1712.521240234375,
        -3916.179931640625,
        941.9706420898438
      ],
      [
        -1712.2579345703125,
        -3916.656005859375,
        942.0936279296875
      ],
      [
        -1717.909912109375,
        -3917.391357421875,
        969.4464721679688
      ],
      [
        -1713.3956298828125,
        -3917.391357421875,
        969.4464721679688
      ],
      [
        -1713.3956298828125,
        -3917.391357421875,
        969.4464721679688
      ],
      [
        -1710.7978515625,
        -3921.0,
        970.6046752929688
      ],
      [
        -1720.458984375,
        -3921.0,
        970.6046752929688
      ],
      [
        -1717.909912109375,
        -3917.391357421875,
        969.4464721679688
      ],
      [
        -1710.7978515625,
        -3921.0,
        970.6046752929688
      ],
      [
        -1713.003173828125,
        -3925.152587890625,
        971.9374389648438
      ],
      [
        -1718.19775390625,
        -3925.152587890625,
        971.9374389648438
      ],
      [
        -1720.458984375,
        -3921.0,
        970.6046752929688
      ],
      [
        -1713.003173828125,
        -3925.152587890625,
        971.9374389648438
      ],
      [
        -1718.19775390625,
        -3925.152587890625,
        971.9374389648438
      ],
      [
        -1692.1082763671875,
        -3936.71826171875,
        975.6493530273438
      ],
      [
        -1686.152587890625,
        -3936.187744140625,
        975.4791259765625
      ],
      [
        -1692.4124755859375,
        -3937.41455078125,
        975.872802734375
      ],
      [
        -1692.1082763671875,
        -3936.71826171875,
        975.6493530273438
      ],
      [
        -1693.4010009765625,
        -3940.0,
        976.7025756835938
      ],
      [
        -1692.4124755859375,
        -3937.41455078125,
        975.872802734375
      ],
      [
        -1694.0771484375,
        -3915.0,
        942.4073486328125
      ],
      [
        -1690.095947265625,
        -3936.5390625,
        975.5918579101562
      ],
      [
        -1690.1087646484375,
        -3936.367431640625,
        974.7728881835938
      ],
      [
        -1690.1087646484375,
        -3936.367431640625,
        974.7728881835938
      ],
      [
        -1690.171142578125,
        -3935.551513671875,
        970.968505859375
      ],
      [
        -1690.03662109375,
        -3935.517333984375,
        965.2359008789062
      ],
      [
        -1690.0523681640625,
        -3935.50830078125,
        965.2271118164062
      ],
      [
        -1690.10302734375,
        -3935.759033203125,
        969.5567016601562
      ],
      [
        -1690.1539306640625,
        -3935.600341796875,
        970.5761108398438
      ],
      [
        -1690.098876953125,
        -3935.523681640625,
        967.4632568359375
      ],
      [
        -1690.102783203125,
        -3935.759033203125,
        969.5563354492188
      ],
      [
        -1690.098876953125,
        -3935.523681640625,
        967.4632568359375
      ],
      [
        -1690.171142578125,
        -3935.551513671875,
        970.968505859375
      ],
      [
        -1690.1536865234375,
        -3935.600341796875,
        970.576171875
      ],
      [
        -1694.0506591796875,
        -3931.407470703125,
        969.0516357421875
      ],
      [
        -1694.7884521484375,
        -3935.03955078125,
        972.5686645507812
      ],
      [
        -1694.0506591796875,
        -3931.407470703125,
        969.0516357421875
      ],
      [
        -1695.2210693359375,
        -3935.703857421875,
        974.23583984375
      ],
      [
        -1695.2647705078125,
        -3936.647705078125,
        974.6405639648438
      ],
      [
        -1690.10791015625,
        -3936.378173828125,
        974.8245849609375
      ],
      [
        -1694.8770751953125,
        -3940.0,
        976.0492553710938
      ],
      [
        -1695.2647705078125,
        -3936.647705078125,
        974.6405639648438
      ],
      [
        -1695.2987060546875,
        -3937.55224609375,
        975.0013427734375
      ],
      [
        -1690.144287109375,
        -3935.63037109375,
        970.3831176757812
      ],
      [
        -1694.7884521484375,
        -3935.03955078125,
        972.5686645507812
      ],
      [
        -1695.2210693359375,
        -3935.703857421875,
        974.23583984375
      ],
      [
        -1690.0989990234375,
        -3935.52734375,
        967.4964599609375
      ],
      [
        -1695.390380859375,
        -3940.0,
        975.9776000976562
      ],
      [
        -1695.1810302734375,
        -3935.642578125,
        974.081787109375
      ],
      [
        -1691.21875,
        -3915.0,
        953.8836669921875
      ],
      [
        -1690.96435546875,
        -3916.211181640625,
        954.3366088867188
      ],
      [
        -1732.6763916015625,
        -3915.0,
        947.1720581054688
      ],
      [
        -1715.916015625,
        -3922.74560546875,
        960.9126586914062
      ],
      [
        -1714.214111328125,
        -3923.474609375,
        964.2520751953125
      ],
      [
        -1714.214111328125,
        -3923.474609375,
        964.2520751953125
      ],
      [
        -1714.33642578125,
        -3923.659912109375,
        965.1004028320312
      ],
      [
        -1717.5123291015625,
        -3920.150390625,
        961.024169921875
      ],
      [
        -1717.309814453125,
        -3918.525146484375,
        964.2529907226562
      ],
      [
        -1717.309814453125,
        -3918.525146484375,
        964.2525024414062
      ],
      [
        -1717.53564453125,
        -3918.544677734375,
        965.1002807617188
      ],
      [
        -1715.3221435546875,
        -3925.152587890625,
        971.9374389648438
      ],
      [
        -1718.801513671875,
        -3918.653564453125,
        969.8515625
      ],
      [
        -1635.0,
        -3940.0,
        1035.5
      ],
      [
        -1630.8995361328125,
        -3930.1005859375,
        1035.5
      ],
      [
        -1679.675048828125,
        -3936.18017578125,
        984.0698852539062
      ],
      [
        -1679.8446044921875,
        -3936.225341796875,
        981.7044067382812
      ],
      [
        -1679.675048828125,
        -3936.18017578125,
        984.0698852539062
      ],
      [
        -1681.0162353515625,
        -3936.537841796875,
        977.3654174804688
      ],
      [
        -1679.8446044921875,
        -3936.225341796875,
        981.7044067382812
      ],
      [
        -1682.6605224609375,
        -3936.976318359375,
        971.3323364257812
      ],
      [
        -1681.0162353515625,
        -3936.537841796875,
        977.3654174804688
      ],
      [
        -1688.905029296875,
        -3937.94677734375,
        978.7476196289062
      ],
      [
        -1684.3822021484375,
        -3937.435302734375,
        985.2269897460938
      ],
      [
        -1685.5477294921875,
        -3937.74609375,
        983.7171020507812
      ],
      [
        -1684.3822021484375,
        -3937.435302734375,
        985.2269897460938
      ],
      [
        -1689.1590576171875,
        -3938.708984375,
        979.04931640625
      ],
      [
        -1685.5477294921875,
        -3937.74609375,
        983.7171020507812
      ],
      [
        -1691.981201171875,
        -3942.1904296875,
        976.4361572265625
      ],
      [
        -1693.40087890625,
        -3940.0,
        976.7025756835938
      ],
      [
        -1691.2523193359375,
        -3943.213134765625,
        976.3118286132812
      ],
      [
        -1691.981201171875,
        -3942.1904296875,
        976.4361572265625
      ],
      [
        -1686.8150634765625,
        -3943.591552734375,
        976.2658081054688
      ],
      [
        -1691.2523193359375,
        -3943.213134765625,
        976.3118286132812
      ],
      [
        -1698.6805419921875,
        -3958.111083984375,
        969.5184936523438
      ],
      [
        -1688.2001953125,
        -3940.0,
        963.5697021484375
      ],
      [
        -1690.5540771484375,
        -3944.78125,
        964.9468383789062
      ],
      [
        -1692.9979248046875,
        -3945.043701171875,
        971.132080078125
      ],
      [
        -1693.417236328125,
        -3945.140869140625,
        971.2294311523438
      ],
      [
        -1692.9979248046875,
        -3945.043701171875,
        971.132080078125
      ],
      [
        -1692.0440673828125,
        -3942.093505859375,
        976.4479370117188
      ],
      [
        -1694.28369140625,
        -3943.8525390625,
        974.4818725585938
      ],
      [
        -1693.9112548828125,
        -3940.0,
        976.3200073242188
      ],
      [
        -1693.9583740234375,
        -3940.690185546875,
        975.8654174804688
      ],
      [
        -1694.28369140625,
        -3943.8525390625,
        974.4818725585938
      ],
      [
        -1693.9583740234375,
        -3940.68994140625,
        975.8654174804688
      ],
      [
        -1694.3253173828125,
        -3942.904052734375,
        974.8887329101562
      ],
      [
        -1689.044189453125,
        -3940.0,
        958.1063232421875
      ],
      [
        -1694.4158935546875,
        -3940.835693359375,
        975.7759399414062
      ],
      [
        -1694.445068359375,
        -3940.0,
        976.1095581054688
      ],
      [
        -1694.4158935546875,
        -3940.835693359375,
        975.7759399414062
      ],
      [
        -1694.0552978515625,
        -3944.192138671875,
        973.62451171875
      ],
      [
        -1630.8995361328125,
        -3949.8994140625,
        1035.5
      ],
      [
        -1635.0,
        -3940.0,
        1035.5
      ],
      [
        -1679.6756591796875,
        -3943.820068359375,
        984.0689086914062
      ],
      [
        -1679.8450927734375,
        -3943.77490234375,
        981.7047729492188
      ],
      [
        -1679.6756591796875,
        -3943.820068359375,
        984.0689086914062
      ],
      [
        -1679.8450927734375,
        -3943.77490234375,
        981.7047729492188
      ],
      [
        -1681.016845703125,
        -3943.46240234375,
        977.3650512695312
      ],
      [
        -1684.2239990234375,
        -3942.9921875,
        985.0786743164062
      ],
      [
        -1684.2130126953125,
        -3942.9921875,
        985.0956420898438
      ],
      [
        -1683.91796875,
        -3942.688720703125,
        988.006103515625
      ],
      [
        -1684.2130126953125,
        -3942.9921875,
        985.0956420898438
      ],
      [
        -1684.2239990234375,
        -3942.9921875,
        985.0786743164062
      ],
      [
        -1684.382080078125,
        -3942.56494140625,
        985.2268676757812
      ],
      [
        -1685.546875,
        -3942.25439453125,
        983.718017578125
      ],
      [
        -1685.546875,
        -3942.25439453125,
        983.718017578125
      ],
      [
        -1689.158935546875,
        -3941.291259765625,
        979.0491943359375
      ],
      [
        -1684.382080078125,
        -3942.56494140625,
        985.2268676757812
      ],
      [
        -1681.016845703125,
        -3943.46240234375,
        977.3650512695312
      ],
      [
        -1682.660888671875,
        -3943.02392578125,
        971.3328247070312
      ],
      [
        -1815.1942138671875,
        -3664.117431640625,
        955.1499633789062
      ],
      [
        -1804.336669921875,
        -3676.714599609375,
        948.8031616210938
      ],
      [
        -1815.1942138671875,
        -3664.117431640625,
        955.1499633789062
      ],
      [
        -1807.6737060546875,
        -3677.889404296875,
        953.3975830078125
      ],
      [
        -1806.8277587890625,
        -3679.57470703125,
        953.2717895507812
      ],
      [
        -1807.6737060546875,
        -3677.889404296875,
        953.3975830078125
      ],
      [
        -1804.283935546875,
        -3676.654052734375,
        948.6624145507812
      ],
      [
        -1808.0965576171875,
        -3677.73779296875,
        953.492919921875
      ],
      [
        -1807.05322265625,
        -3679.83349609375,
        953.338623046875
      ],
      [
        -1808.0965576171875,
        -3677.73779296875,
        953.492919921875
      ],
      [
        -1810.0089111328125,
        -3666.6962890625,
        950.2374267578125
      ],
      [
        -1811.4193115234375,
        -3676.546875,
        944.1380004882812
      ],
      [
        -1809.7178955078125,
        -3682.892822265625,
        942.8718872070312
      ],
      [
        -1811.4193115234375,
        -3676.546875,
        944.1380004882812
      ],
      [
        -1807.1966552734375,
        -3673.005615234375,
        950.122314453125
      ],
      [
        -1807.0406494140625,
        -3673.306396484375,
        950.1390380859375
      ],
      [
        -1807.1966552734375,
        -3673.005615234375,
        950.122314453125
      ],
      [
        -1851.213623046875,
        -3660.28271484375,
        946.7112426757812
      ],
      [
        -1853.904541015625,
        -3655.976318359375,
        951.0446166992188
      ],
      [
        -1851.213623046875,
        -3660.28271484375,
        946.7112426757812
      ],
      [
        -1850.9775390625,
        -3660.66064453125,
        946.2284545898438
      ],
      [
        -1850.9036865234375,
        -3660.77880859375,
        946.2052001953125
      ],
      [
        -1850.9775390625,
        -3660.66064453125,
        946.2284545898438
      ],
      [
        -1854.066650390625,
        -3655.716796875,
        951.3421020507812
      ],
      [
        -1853.904541015625,
        -3655.976318359375,
        951.0446166992188
      ],
      [
        -1838.2537841796875,
        -3629.981201171875,
        955.0933227539062
      ],
      [
        -1834.2305908203125,
        -3628.49755859375,
        954.5902099609375
      ],
      [
        -1838.2537841796875,
        -3629.981201171875,
        955.0933227539062
      ],
      [
        -1837.0777587890625,
        -3628.69287109375,
        954.8760986328125
      ],
      [
        -1835.9727783203125,
        -3627.812744140625,
        954.6991577148438
      ],
      [
        -1834.2305908203125,
        -3628.49755859375,
        954.5902099609375
      ],
      [
        -1835.9727783203125,
        -3627.812744140625,
        954.6991577148438
      ],
      [
        -1837.0777587890625,
        -3628.69287109375,
        954.8760986328125
      ],
      [
        -1854.0667724609375,
        -3655.716796875,
        951.3421020507812
      ],
      [
        -1853.904541015625,
        -3655.976318359375,
        951.6386108398438
      ],
      [
        -1851.213623046875,
        -3660.28271484375,
        955.7954711914062
      ],
      [
        -1853.904541015625,
        -3655.976318359375,
        951.6386108398438
      ],
      [
        -1850.9036865234375,
        -3660.77880859375,
        956.318359375
      ],
      [
        -1850.8724365234375,
        -3660.828857421875,
        956.3226928710938
      ],
      [
        -1850.9775390625,
        -3660.66064453125,
        956.2913818359375
      ],
      [
        -1851.213623046875,
        -3660.28271484375,
        955.7954711914062
      ],
      [
        -1850.9775390625,
        -3660.66064453125,
        956.2913818359375
      ],
      [
        -1850.9036865234375,
        -3660.77880859375,
        956.318359375
      ],
      [
        -1850.53564453125,
        -3661.367919921875,
        956.369140625
      ],
      [
        -1838.2293701171875,
        -3628.77197265625,
        954.2557983398438
      ],
      [
        -1836.001953125,
        -3627.37451171875,
        954.2607421875
      ],
      [
        -1838.2293701171875,
        -3628.77197265625,
        954.2557983398438
      ],
      [
        -1836.001953125,
        -3627.37451171875,
        954.2607421875
      ],
      [
        -1834.004150390625,
        -3628.48193359375,
        954.46826171875
      ],
      [
        -1834.004150390625,
        -3628.48193359375,
        954.46826171875
      ],
      [
        -1833.3609619140625,
        -3629.004638671875,
        954.5493774414062
      ],
      [
        -1850.4163818359375,
        -3661.55859375,
        946.1204833984375
      ],
      [
        -1845.272705078125,
        -3669.7900390625,
        945.3287353515625
      ],
      [
        -1836.976318359375,
        -3670.053466796875,
        945.0907592773438
      ],
      [
        -1844.4464111328125,
        -3671.112548828125,
        945.3059692382812
      ],
      [
        -1845.272705078125,
        -3669.7900390625,
        945.3287353515625
      ],
      [
        -1844.4464111328125,
        -3671.112548828125,
        945.3059692382812
      ],
      [
        -1836.976318359375,
        -3670.053466796875,
        945.0907592773438
      ],
      [
        -1842.4884033203125,
        -3674.24609375,
        946.0134887695312
      ],
      [
        -1850.4163818359375,
        -3661.55859375,
        946.1204833984375
      ],
      [
        -1850.9036865234375,
        -3660.77880859375,
        946.2052001953125
      ],
      [
        -1818.0521240234375,
        -3674.16943359375,
        944.30419921875
      ],
      [
        -1820.0167236328125,
        -3674.127685546875,
        944.2120971679688
      ],
      [
        -1818.0521240234375,
        -3674.16943359375,
        944.30419921875
      ],
      [
        -1820.0167236328125,
        -3674.127685546875,
        944.2120971679688
      ],
      [
        -1814.81982421875,
        -3683.097412109375,
        943.4953002929688
      ],
      [
        -1818.236083984375,
        -3677.4912109375,
        943.991455078125
      ],
      [
        -1814.81982421875,
        -3683.097412109375,
        943.4953002929688
      ],
      [
        -1813.18505859375,
        -3686.873779296875,
        943.1553955078125
      ],
      [
        -1815.360107421875,
        -3682.923828125,
        943.6350708007812
      ],
      [
        -1815.360107421875,
        -3682.923828125,
        943.6350708007812
      ],
      [
        -1813.6839599609375,
        -3687.446533203125,
        943.30322265625
      ],
      [
        -1833.6483154296875,
        -3628.457763671875,
        947.723388671875
      ],
      [
        -1839.8900146484375,
        -3630.93994140625,
        947.1917724609375
      ],
      [
        -1837.769287109375,
        -3628.740478515625,
        947.4963989257812
      ],
      [
        -1835.9996337890625,
        -3627.4091796875,
        947.7045288085938
      ],
      [
        -1833.6483154296875,
        -3628.457763671875,
        947.723388671875
      ],
      [
        -1835.9996337890625,
        -3627.4091796875,
        947.70458984375
      ],
      [
        -1837.7694091796875,
        -3628.740478515625,
        947.4964599609375
      ],
      [
        -1850.4163818359375,
        -3661.55859375,
        956.3855590820312
      ],
      [
        -1845.272705078125,
        -3669.7900390625,
        957.3287353515625
      ],
      [
        -1850.4163818359375,
        -3661.55859375,
        956.3855590820312
      ],
      [
        -1840.4287109375,
        -3664.6591796875,
        957.1859130859375
      ],
      [
        -1812.994140625,
        -3683.684326171875,
        954.55810546875
      ],
      [
        -1811.7457275390625,
        -3685.22119140625,
        954.2710571289062
      ],
      [
        -1812.994140625,
        -3683.684326171875,
        954.55810546875
      ],
      [
        -1844.4464111328125,
        -3671.112548828125,
        957.3059692382812
      ],
      [
        -1845.272705078125,
        -3669.7900390625,
        957.3287353515625
      ],
      [
        -1819.4962158203125,
        -3675.11083984375,
        944.1475830078125
      ],
      [
        -1819.34765625,
        -3674.141845703125,
        944.2434692382812
      ],
      [
        -1818.23779296875,
        -3677.488037109375,
        943.9916381835938
      ],
      [
        -1826.211669921875,
        -3674.629638671875,
        945.2503662109375
      ],
      [
        -1822.113037109375,
        -3680.75341796875,
        945.3822021484375
      ],
      [
        -1821.9376220703125,
        -3682.74853515625,
        945.3863525390625
      ],
      [
        -1822.9339599609375,
        -3677.730712890625,
        945.3573608398438
      ],
      [
        -1822.113037109375,
        -3680.75341796875,
        945.3822021484375
      ],
      [
        -1822.9339599609375,
        -3677.730712890625,
        945.3573608398438
      ],
      [
        -1826.211669921875,
        -3674.629638671875,
        945.2503662109375
      ],
      [
        -1821.9376220703125,
        -3682.74853515625,
        945.3863525390625
      ],
      [
        -1818.1707763671875,
        -3688.3310546875,
        945.507568359375
      ],
      [
        -1816.6195068359375,
        -3690.81689453125,
        945.5573120117188
      ],
      [
        -1818.1707763671875,
        -3688.3310546875,
        945.507568359375
      ],
      [
        -1841.3310546875,
        -3676.098388671875,
        956.1409301757812
      ],
      [
        -1844.4464111328125,
        -3671.112548828125,
        957.3059692382812
      ],
      [
        -1840.36328125,
        -3677.647216796875,
        955.7494506835938
      ],
      [
        -1841.3310546875,
        -3676.098388671875,
        956.1409301757812
      ],
      [
        -1840.36328125,
        -3677.647216796875,
        955.7494506835938
      ],
      [
        -1840.1947021484375,
        -3677.9169921875,
        955.1904907226562
      ],
      [
        -1816.374267578125,
        -3689.8583984375,
        952.9014892578125
      ],
      [
        -1816.10009765625,
        -3690.220703125,
        952.8278198242188
      ],
      [
        -1816.374267578125,
        -3689.8583984375,
        952.9014892578125
      ],
      [
        -1841.3310546875,
        -3676.098388671875,
        946.4317626953125
      ],
      [
        -1840.36328125,
        -3677.647216796875,
        946.7494506835938
      ],
      [
        -1841.3310546875,
        -3676.098388671875,
        946.4317626953125
      ],
      [
        -1819.5340576171875,
        -3687.171875,
        946.4700927734375
      ],
      [
        -1817.106689453125,
        -3691.376220703125,
        946.8563842773438
      ],
      [
        -1819.5340576171875,
        -3687.171875,
        946.4700927734375
      ],
      [
        -1840.36328125,
        -3677.647216796875,
        946.7494506835938
      ],
      [
        -1840.148193359375,
        -3677.991455078125,
        947.459228515625
      ],
      [
        -1839.0008544921875,
        -3679.8271484375,
        951.2213745117188
      ],
      [
        -1839.4849853515625,
        -3679.052734375,
        952.837158203125
      ],
      [
        -1839.4849853515625,
        -3679.052734375,
        952.837158203125
      ],
      [
        -1839.0008544921875,
        -3679.8271484375,
        951.2213745117188
      ],
      [
        -1839.4849853515625,
        -3679.052734375,
        949.6470336914062
      ],
      [
        -1838.3511962890625,
        -3678.587646484375,
        949.0164184570312
      ],
      [
        -1838.3511962890625,
        -3678.587646484375,
        949.0164184570312
      ],
      [
        -1839.4849853515625,
        -3679.052734375,
        949.6470336914062
      ],
      [
        -1839.88232421875,
        -3678.416748046875,
        948.3361206054688
      ],
      [
        -1833.0823974609375,
        -3676.990478515625,
        946.4525756835938
      ],
      [
        -1787.837158203125,
        -3704.404052734375,
        948.1018676757812
      ],
      [
        -1755.0,
        -3710.990234375,
        946.803466796875
      ],
      [
        -1755.0,
        -3716.22998046875,
        946.6685180664062
      ],
      [
        -1779.0284423828125,
        -3735.719970703125,
        947.0
      ],
      [
        -1778.9820556640625,
        -3735.731201171875,
        946.9905395507812
      ],
      [
        -1779.0284423828125,
        -3735.719970703125,
        947.0
      ],
      [
        -1779.06982421875,
        -3735.7099609375,
        946.99267578125
      ],
      [
        -1798.8731689453125,
        -3714.436767578125,
        948.2227783203125
      ],
      [
        -1792.6800537109375,
        -3708.806640625,
        937.72412109375
      ],
      [
        -1788.789306640625,
        -3733.3544921875,
        936.3704833984375
      ],
      [
        -1788.789306640625,
        -3733.3544921875,
        936.3704833984375
      ],
      [
        -1788.693115234375,
        -3733.377685546875,
        936.3569946289062
      ],
      [
        -1755.0,
        -3709.12548828125,
        935.732177734375
      ],
      [
        -1771.691650390625,
        -3737.498046875,
        936.4977416992188
      ],
      [
        -1771.678466796875,
        -3737.501220703125,
        936.5
      ],
      [
        -1779.0284423828125,
        -3735.719970703125,
        935.0
      ],
      [
        -1771.691650390625,
        -3737.498046875,
        936.4977416992188
      ],
      [
        -1779.0284423828125,
        -3735.719970703125,
        935.0
      ],
      [
        -1779.06982421875,
        -3735.7099609375,
        935.00732421875
      ],
      [
        -1779.06982421875,
        -3735.7099609375,
        935.00732421875
      ],
      [
        -1779.133056640625,
        -3735.694580078125,
        935.0161743164062
      ],
      [
        -1771.678466796875,
        -3737.501220703125,
        936.5
      ],
      [
        -1771.6722412109375,
        -3737.5029296875,
        936.509521484375
      ],
      [
        -1760.8624267578125,
        -3722.990966796875,
        936.5
      ],
      [
        -1760.8624267578125,
        -3722.990966796875,
        936.5
      ],
      [
        -1755.0,
        -3721.8330078125,
        937.346923828125
      ],
      [
        -1765.631591796875,
        -3718.000244140625,
        935.0609741210938
      ],
      [
        -1765.9560546875,
        -3718.28564453125,
        935.0384521484375
      ],
      [
        -1765.631591796875,
        -3718.000244140625,
        935.0609741210938
      ],
      [
        -1765.6044921875,
        -3717.992431640625,
        935.0608520507812
      ],
      [
        -1755.0,
        -3721.929931640625,
        937.5471801757812
      ],
      [
        -1788.789306640625,
        -3733.3544921875,
        946.3697509765625
      ],
      [
        -1788.789306640625,
        -3733.3544921875,
        946.3697509765625
      ],
      [
        -1787.912109375,
        -3733.567138671875,
        946.4259643554688
      ],
      [
        -1787.739501953125,
        -3733.60888671875,
        946.43701171875
      ],
      [
        -1779.06982421875,
        -3735.7099609375,
        946.99267578125
      ],
      [
        -1756.935791015625,
        -3708.74755859375,
        946.6439208984375
      ],
      [
        -1771.678466796875,
        -3737.501220703125,
        945.5
      ],
      [
        -1771.691650390625,
        -3737.498046875,
        945.5022583007812
      ],
      [
        -1771.691650390625,
        -3737.498046875,
        945.5022583007812
      ],
      [
        -1771.678466796875,
        -3737.501220703125,
        945.5
      ],
      [
        -1771.6722412109375,
        -3737.5029296875,
        945.4905395507812
      ],
      [
        -1760.86376953125,
        -3722.9912109375,
        945.5
      ],
      [
        -1760.86376953125,
        -3722.9912109375,
        945.5
      ],
      [
        -1755.0,
        -3721.8330078125,
        944.6529541015625
      ],
      [
        -1756.935791015625,
        -3708.74755859375,
        946.6439208984375
      ],
      [
        -1755.0,
        -3706.90771484375,
        946.5494995117188
      ],
      [
        -1768.285400390625,
        -3717.902099609375,
        947.0821533203125
      ],
      [
        -1786.361083984375,
        -3703.06201171875,
        945.6962280273438
      ],
      [
        -1779.0604248046875,
        -3706.594970703125,
        945.1064453125
      ],
      [
        -1779.0604248046875,
        -3706.594970703125,
        945.1064453125
      ],
      [
        -1780.423095703125,
        -3706.4873046875,
        946.048828125
      ],
      [
        -1757.454833984375,
        -3708.794921875,
        946.6376342773438
      ],
      [
        -1755.0,
        -3721.929931640625,
        944.4528198242188
      ],
      [
        -1771.6722412109375,
        -3737.5029296875,
        936.5094604492188
      ],
      [
        -1755.7940673828125,
        -3722.080810546875,
        944.5799560546875
      ],
      [
        -1771.6722412109375,
        -3737.5029296875,
        945.490478515625
      ],
      [
        -1766.499755859375,
        -3764.492431640625,
        935.1376953125
      ],
      [
        -1766.499755859375,
        -3764.492431640625,
        935.1376953125
      ],
      [
        -1765.4500732421875,
        -3766.77587890625,
        935.1397094726562
      ],
      [
        -1767.60888671875,
        -3758.725830078125,
        946.57177734375
      ],
      [
        -1763.9769287109375,
        -3765.511474609375,
        946.4674072265625
      ],
      [
        -1767.60888671875,
        -3758.725830078125,
        946.57177734375
      ],
      [
        -1760.2388916015625,
        -3762.302978515625,
        936.764404296875
      ],
      [
        -1755.0,
        -3765.212646484375,
        945.4580688476562
      ],
      [
        -1755.0,
        -3765.212646484375,
        936.5418701171875
      ],
      [
        -1844.2569580078125,
        -3671.415771484375,
        957.235107421875
      ],
      [
        -1853.661865234375,
        -3656.36474609375,
        950.65380859375
      ],
      [
        -1840.19091796875,
        -3677.923095703125,
        955.1777954101562
      ],
      [
        -1839.4068603515625,
        -3679.177734375,
        949.9010009765625
      ],
      [
        -1840.9832763671875,
        -3676.65478515625,
        946.5458984375
      ],
      [
        -1863.738037109375,
        -3668.693603515625,
        953.0270385742188
      ],
      [
        -1878.9119873046875,
        -3694.455078125,
        949.4639282226562
      ],
      [
        -1878.911865234375,
        -3694.455322265625,
        958.5361328125
      ],
      [
        -1869.2288818359375,
        -3702.5888671875,
        957.2877807617188
      ],
      [
        -1869.2288818359375,
        -3702.5888671875,
        950.7120361328125
      ],
      [
        -1836.4071044921875,
        -3757.67529296875,
        942.6824340820312
      ],
      [
        -1836.89892578125,
        -3761.123291015625,
        943.82763671875
      ],
      [
        -1836.4071044921875,
        -3757.67529296875,
        942.6824340820312
      ],
      [
        -1830.116455078125,
        -3762.3564453125,
        939.988525390625
      ],
      [
        -1818.7847900390625,
        -3738.638671875,
        925.0186767578125
      ],
      [
        -1818.7847900390625,
        -3738.638671875,
        925.0186767578125
      ],
      [
        -1818.685546875,
        -3736.988037109375,
        923.001220703125
      ],
      [
        -1821.01708984375,
        -3737.648681640625,
        917.9323120117188
      ],
      [
        -1820.6868896484375,
        -3737.645751953125,
        918.7744750976562
      ],
      [
        -1820.6868896484375,
        -3737.645751953125,
        918.7744750976562
      ],
      [
        -1818.685546875,
        -3736.988037109375,
        923.001220703125
      ],
      [
        -1821.29736328125,
        -3738.35302734375,
        918.1809692382812
      ],
      [
        -1821.29736328125,
        -3738.35302734375,
        918.1809692382812
      ],
      [
        -1821.01708984375,
        -3737.648681640625,
        917.9323120117188
      ],
      [
        -1818.6885986328125,
        -3736.9794921875,
        923.0
      ],
      [
        -1821.0279541015625,
        -3737.622802734375,
        917.91845703125
      ],
      [
        -1820.6864013671875,
        -3737.62255859375,
        918.7880249023438
      ],
      [
        -1820.6864013671875,
        -3737.62255859375,
        918.7880249023438
      ],
      [
        -1818.6885986328125,
        -3736.9794921875,
        923.0
      ],
      [
        -1823.64013671875,
        -3742.9677734375,
        918.5567016601562
      ],
      [
        -1821.317138671875,
        -3738.3515625,
        918.1759033203125
      ],
      [
        -1821.317138671875,
        -3738.3515625,
        918.1759033203125
      ],
      [
        -1821.0279541015625,
        -3737.622802734375,
        917.91845703125
      ],
      [
        -1818.7518310546875,
        -3738.0693359375,
        924.3258666992188
      ],
      [
        -1820.680908203125,
        -3737.361328125,
        928.56201171875
      ],
      [
        -1821.13037109375,
        -3737.37939453125,
        929.96142578125
      ],
      [
        -1818.7679443359375,
        -3736.75732421875,
        922.96826171875
      ],
      [
        -1820.680908203125,
        -3737.361328125,
        928.56201171875
      ],
      [
        -1818.7679443359375,
        -3736.75732421875,
        922.96826171875
      ],
      [
        -1818.77490234375,
        -3737.00732421875,
        922.8179321289062
      ],
      [
        -1821.4404296875,
        -3738.342529296875,
        930.2711791992188
      ],
      [
        -1821.13037109375,
        -3737.37939453125,
        929.96142578125
      ],
      [
        -1821.4404296875,
        -3738.342529296875,
        930.2711791992188
      ],
      [
        -1835.0211181640625,
        -3733.311279296875,
        934.3433837890625
      ],
      [
        -1847.3048095703125,
        -3759.2314453125,
        926.5597534179688
      ],
      [
        -1833.3109130859375,
        -3778.767333984375,
        949.8875732421875
      ],
      [
        -1831.531982421875,
        -3782.07568359375,
        951.07275390625
      ],
      [
        -1833.3109130859375,
        -3778.767333984375,
        949.8875732421875
      ],
      [
        -1808.0,
        -3818.11865234375,
        817.5
      ],
      [
        -1799.21533203125,
        -3811.75,
        817.5
      ],
      [
        -1808.0,
        -3818.11865234375,
        816.0
      ],
      [
        -1799.21533203125,
        -3811.75,
        816.0
      ],
      [
        -1832.80615234375,
        -3784.4990234375,
        932.0
      ],
      [
        -1832.657470703125,
        -3782.575927734375,
        932.0
      ],
      [
        -1835.29150390625,
        -3783.746826171875,
        932.0
      ],
      [
        -1833.75244140625,
        -3784.18408203125,
        932.0
      ],
      [
        -1832.80615234375,
        -3784.4990234375,
        932.0
      ],
      [
        -1833.75244140625,
        -3784.18408203125,
        932.0
      ],
      [
        -1808.0,
        -3819.813720703125,
        816.0
      ],
      [
        -1805.7073974609375,
        -3816.45654296875,
        816.0
      ],
      [
        -1808.0,
        -3819.813720703125,
        817.5
      ],
      [
        -1805.7073974609375,
        -3816.45654296875,
        817.5
      ],
      [
        -1784.0,
        -3831.00537109375,
        816.0
      ],
      [
        -1790.053466796875,
        -3834.0,
        816.0
      ],
      [
        -1784.0,
        -3831.00537109375,
        817.5
      ],
      [
        -1790.053466796875,
        -3834.0,
        817.5
      ],
      [
        -1784.0,
        -3829.486328125,
        816.0
      ],
      [
        -1785.0,
        -3831.5,
        816.0
      ],
      [
        -1784.0,
        -3829.486328125,
        817.5
      ],
      [
        -1785.0,
        -3831.5,
        817.5
      ],
      [
        -1791.05419921875,
        -3811.75,
        816.0
      ],
      [
        -1806.2486572265625,
        -3834.0,
        816.0
      ],
      [
        -1791.411865234375,
        -3811.75,
        817.5
      ],
      [
        -1806.6060791015625,
        -3834.0,
        817.5
      ],
      [
        -1789.9801025390625,
        -3833.963623046875,
        816.0
      ],
      [
        -1800.718994140625,
        -3825.902587890625,
        816.0
      ],
      [
        -1790.6312255859375,
        -3834.0,
        817.5
      ],
      [
        -1801.1922607421875,
        -3826.072021484375,
        817.5
      ],
      [
        -1784.0,
        -3811.81689453125,
        816.0
      ],
      [
        -1798.06103515625,
        -3822.01025390625,
        816.0
      ],
      [
        -1784.385986328125,
        -3811.75,
        817.5
      ],
      [
        -1798.3004150390625,
        -3821.83740234375,
        817.5
      ],
      [
        -1784.0,
        -3826.17626953125,
        816.0
      ],
      [
        -1794.0501708984375,
        -3819.102783203125,
        816.0
      ],
      [
        -1784.0,
        -3825.6650390625,
        817.5
      ],
      [
        -1793.934814453125,
        -3818.672607421875,
        817.5
      ],
      [
        -1789.94775390625,
        -3833.94775390625,
        817.5
      ],
      [
        -1791.6536865234375,
        -3820.278076171875,
        817.5
      ],
      [
        -1790.314453125,
        -3833.712646484375,
        816.0
      ],
      [
        -1791.953369140625,
        -3820.57861328125,
        816.0
      ],
      [
        -1799.0528564453125,
        -3827.677978515625,
        817.5
      ],
      [
        -1790.7933349609375,
        -3827.172119140625,
        817.5
      ],
      [
        -1798.7535400390625,
        -3827.3779296875,
        816.0
      ],
      [
        -1791.1629638671875,
        -3826.9130859375,
        816.0
      ],
      [
        -1791.222412109375,
        -3823.73388671875,
        817.5
      ],
      [
        -1792.9967041015625,
        -3827.30712890625,
        817.5
      ],
      [
        -1791.5572509765625,
        -3823.753662109375,
        816.0
      ],
      [
        -1793.187744140625,
        -3827.037109375,
        816.0
      ],
      [
        -1792.40673828125,
        -3826.118896484375,
        817.5
      ],
      [
        -1795.0645751953125,
        -3827.433837890625,
        817.5
      ],
      [
        -1792.645751953125,
        -3825.945556640625,
        816.0
      ],
      [
        -1795.08740234375,
        -3827.1533203125,
        816.0
      ],
      [
        -1808.4825439453125,
        -3808.986083984375,
        985.281982421875
      ],
      [
        -1809.8671875,
        -3811.975341796875,
        985.1331787109375
      ],
      [
        -1805.4967041015625,
        -3815.988037109375,
        978.2617797851562
      ],
      [
        -1805.221435546875,
        -3815.963134765625,
        977.980712890625
      ],
      [
        -1803.7322998046875,
        -3812.80029296875,
        978.1123046875
      ],
      [
        -1805.0771484375,
        -3809.327880859375,
        981.4482421875
      ],
      [
        -1805.4967041015625,
        -3815.988037109375,
        978.26171875
      ],
      [
        -1809.8671875,
        -3811.975341796875,
        985.1331787109375
      ],
      [
        -1810.1939697265625,
        -3812.800048828125,
        984.4282836914062
      ],
      [
        -1808.2506103515625,
        -3816.117431640625,
        979.712158203125
      ],
      [
        -1811.56982421875,
        -3816.273193359375,
        981.4603271484375
      ],
      [
        -1815.1253662109375,
        -3825.248046875,
        973.7904663085938
      ],
      [
        -1806.4892578125,
        -3818.368408203125,
        976.25634765625
      ],
      [
        -1805.312744140625,
        -3816.156982421875,
        977.9725952148438
      ],
      [
        -1806.4892578125,
        -3818.368408203125,
        976.25634765625
      ],
      [
        -1815.1253662109375,
        -3825.248046875,
        973.7904663085938
      ],
      [
        -1817.084716796875,
        -3829.927001953125,
        971.059814453125
      ],
      [
        -1808.6702880859375,
        -3822.6123046875,
        973.8882446289062
      ],
      [
        -1805.312744140625,
        -3816.156982421875,
        977.97265625
      ],
      [
        -1802.231689453125,
        -3809.61328125,
        978.244873046875
      ],
      [
        -1806.9569091796875,
        -3814.986083984375,
        933.3232421875
      ],
      [
        -1809.4373779296875,
        -3820.223876953125,
        933.7120361328125
      ],
      [
        -1809.437255859375,
        -3820.223876953125,
        933.7120361328125
      ],
      [
        -1811.4947509765625,
        -3824.931396484375,
        932.0
      ],
      [
        -1799.21240234375,
        -3809.916259765625,
        974.8458251953125
      ],
      [
        -1799.21240234375,
        -3809.916259765625,
        974.8458251953125
      ],
      [
        -1801.551025390625,
        -3816.423583984375,
        974.9555053710938
      ],
      [
        -1794.38916015625,
        -3810.19775390625,
        971.6893920898438
      ],
      [
        -1803.2261962890625,
        -3817.879638671875,
        975.7396850585938
      ],
      [
        -1801.551025390625,
        -3816.423583984375,
        974.9555053710938
      ],
      [
        -1803.2261962890625,
        -3817.879638671875,
        975.7396850585938
      ],
      [
        -1803.2513427734375,
        -3817.9013671875,
        975.7308349609375
      ],
      [
        -1804.2200927734375,
        -3818.743896484375,
        975.3904418945312
      ],
      [
        -1804.6414794921875,
        -3819.110107421875,
        975.242431640625
      ],
      [
        -1804.6414794921875,
        -3819.110107421875,
        975.242431640625
      ],
      [
        -1801.954833984375,
        -3813.736083984375,
        932.0
      ],
      [
        -1802.954833984375,
        -3813.6435546875,
        933.0385131835938
      ],
      [
        -1802.954833984375,
        -3813.6435546875,
        933.0385131835938
      ],
      [
        -1806.9569091796875,
        -3814.986083984375,
        933.3231811523438
      ],
      [
        -1806.3492431640625,
        -3813.55029296875,
        934.0848388671875
      ],
      [
        -1804.7509765625,
        -3800.721923828125,
        986.8544921875
      ],
      [
        -1808.476806640625,
        -3808.9736328125,
        985.2826538085938
      ],
      [
        -1808.4766845703125,
        -3808.9736328125,
        985.2825927734375
      ],
      [
        -1789.7308349609375,
        -3806.148193359375,
        969.56494140625
      ],
      [
        -1789.7308349609375,
        -3806.148193359375,
        969.56494140625
      ],
      [
        -1790.09912109375,
        -3806.468505859375,
        966.9677734375
      ],
      [
        -1790.240966796875,
        -3806.591796875,
        965.967041015625
      ],
      [
        -1800.6259765625,
        -3795.009765625,
        969.3895263671875
      ],
      [
        -1799.60546875,
        -3795.235595703125,
        955.87841796875
      ],
      [
        -1799.7705078125,
        -3798.65625,
        938.6751098632812
      ],
      [
        -1805.920654296875,
        -3812.53759765625,
        934.6219482421875
      ],
      [
        -1805.920654296875,
        -3812.53759765625,
        934.6219482421875
      ],
      [
        -1789.087890625,
        -3805.589599609375,
        934.2744140625
      ],
      [
        -1789.500244140625,
        -3805.947998046875,
        932.711181640625
      ],
      [
        -1789.500244140625,
        -3805.947998046875,
        932.0
      ],
      [
        -1789.500244140625,
        -3805.947998046875,
        932.711181640625
      ],
      [
        -1788.5474853515625,
        -3805.119873046875,
        936.3233642578125
      ],
      [
        -1799.60546875,
        -3795.235595703125,
        955.87841796875
      ],
      [
        -1790.984130859375,
        -3807.23779296875,
        960.7262573242188
      ],
      [
        -1799.714599609375,
        -3795.8955078125,
        953.487548828125
      ],
      [
        -1788.1417236328125,
        -3804.76708984375,
        942.5228271484375
      ],
      [
        -1799.174072265625,
        -3795.490478515625,
        949.2740478515625
      ],
      [
        -1799.4476318359375,
        -3795.544921875,
        952.25
      ],
      [
        -1788.69775390625,
        -3805.250244140625,
        952.25
      ],
      [
        -1788.69775390625,
        -3805.250244140625,
        952.25
      ],
      [
        -1799.4476318359375,
        -3795.544921875,
        952.25
      ],
      [
        -1799.714599609375,
        -3795.8955078125,
        953.487548828125
      ],
      [
        -1790.984130859375,
        -3807.23779296875,
        960.7262573242188
      ],
      [
        -1799.7705078125,
        -3798.65625,
        938.6751098632812
      ],
      [
        -1799.174072265625,
        -3795.490478515625,
        949.2740478515625
      ],
      [
        -1788.1417236328125,
        -3804.76708984375,
        937.86181640625
      ],
      [
        -1788.1417236328125,
        -3804.76708984375,
        942.5228271484375
      ],
      [
        -1788.1417236328125,
        -3804.76708984375,
        937.86181640625
      ],
      [
        -1801.6177978515625,
        -3795.43408203125,
        978.9132690429688
      ],
      [
        -1803.062255859375,
        -3797.20654296875,
        986.3063354492188
      ],
      [
        -1800.6259765625,
        -3795.009765625,
        969.3895263671875
      ],
      [
        -1801.6177978515625,
        -3795.43408203125,
        978.9132690429688
      ],
      [
        -1804.7509765625,
        -3800.721923828125,
        986.8544921875
      ],
      [
        -1803.3499755859375,
        -3797.671142578125,
        987.1534423828125
      ],
      [
        -1803.3499755859375,
        -3797.671142578125,
        987.1534423828125
      ],
      [
        -1803.062255859375,
        -3797.20654296875,
        986.3063354492188
      ],
      [
        -1817.3382568359375,
        -3830.1474609375,
        970.9745483398438
      ],
      [
        -1817.3382568359375,
        -3830.1474609375,
        970.9745483398438
      ],
      [
        -1817.7218017578125,
        -3830.480712890625,
        969.6207885742188
      ],
      [
        -1817.845947265625,
        -3830.588623046875,
        969.1823120117188
      ],
      [
        -1809.67919921875,
        -3811.5693359375,
        985.1533813476562
      ],
      [
        -1829.8521728515625,
        -3797.344970703125,
        937.8743896484375
      ],
      [
        -1830.22607421875,
        -3796.005126953125,
        937.6104125976562
      ],
      [
        -1829.8521728515625,
        -3797.344970703125,
        937.8743896484375
      ],
      [
        -1816.3753662109375,
        -3829.31005859375,
        952.25
      ],
      [
        -1816.1422119140625,
        -3829.107421875,
        958.8253784179688
      ],
      [
        -1823.36572265625,
        -3820.533935546875,
        984.6117553710938
      ],
      [
        -1816.1422119140625,
        -3829.107421875,
        958.8253784179688
      ],
      [
        -1818.0108642578125,
        -3830.73193359375,
        968.6002197265625
      ],
      [
        -1818.0108642578125,
        -3830.73193359375,
        968.6002197265625
      ],
      [
        -1816.6212158203125,
        -3829.52392578125,
        939.1892700195312
      ],
      [
        -1816.3753662109375,
        -3829.31005859375,
        952.25
      ],
      [
        -1816.7003173828125,
        -3829.5927734375,
        934.99169921875
      ],
      [
        -1816.8994140625,
        -3829.765869140625,
        935.1113891601562
      ],
      [
        -1816.8994140625,
        -3829.765869140625,
        935.1113891601562
      ],
      [
        -1816.65673828125,
        -3829.5546875,
        937.3016357421875
      ],
      [
        -1816.3896484375,
        -3829.32275390625,
        934.804931640625
      ],
      [
        -1800.1610107421875,
        -3799.53759765625,
        938.4177856445312
      ],
      [
        -1799.2943115234375,
        -3795.514404296875,
        950.5826416015625
      ],
      [
        -1820.0150146484375,
        -3789.912841796875,
        937.83447265625
      ],
      [
        -1821.6302490234375,
        -3789.25146484375,
        937.4549560546875
      ],
      [
        -1820.0150146484375,
        -3789.912841796875,
        937.83447265625
      ],
      [
        -1811.7235107421875,
        -3825.266357421875,
        932.0
      ],
      [
        -1806.5394287109375,
        -3813.999755859375,
        933.8463745117188
      ],
      [
        -1808.5015869140625,
        -3812.724365234375,
        934.4451293945312
      ],
      [
        -1816.6212158203125,
        -3829.52392578125,
        939.1892700195312
      ],
      [
        -1816.6212158203125,
        -3829.52392578125,
        937.6217041015625
      ],
      [
        -1816.6212158203125,
        -3829.52392578125,
        937.6217041015625
      ],
      [
        -1807.750732421875,
        -3813.54931640625,
        934.3720703125
      ],
      [
        -1807.47705078125,
        -3813.692626953125,
        934.319091796875
      ],
      [
        -1806.404541015625,
        -3813.680908203125,
        934.0154418945312
      ],
      [
        -1807.4771728515625,
        -3813.69287109375,
        934.319091796875
      ],
      [
        -1807.750732421875,
        -3813.549560546875,
        934.3720703125
      ],
      [
        -1824.8719482421875,
        -3791.798583984375,
        935.544677734375
      ],
      [
        -1828.5665283203125,
        -3800.87890625,
        970.9074096679688
      ],
      [
        -1827.798828125,
        -3798.74365234375,
        962.4985961914062
      ],
      [
        -1827.587890625,
        -3793.932373046875,
        958.6942138671875
      ],
      [
        -1827.9476318359375,
        -3800.834716796875,
        964.7213745117188
      ],
      [
        -1827.9476318359375,
        -3800.834716796875,
        964.7213745117188
      ],
      [
        -1827.798828125,
        -3798.74365234375,
        962.4985961914062
      ],
      [
        -1824.742431640625,
        -3818.09326171875,
        986.0774536132812
      ],
      [
        -1818.2830810546875,
        -3803.15869140625,
        996.4900512695312
      ],
      [
        -1813.9156494140625,
        -3791.3740234375,
        981.1641235351562
      ],
      [
        -1811.34130859375,
        -3791.737060546875,
        984.7911376953125
      ],
      [
        -1813.9156494140625,
        -3791.3740234375,
        981.1641235351562
      ],
      [
        -1809.9324951171875,
        -3791.93994140625,
        986.5371704101562
      ],
      [
        -1811.34130859375,
        -3791.737060546875,
        984.7911376953125
      ],
      [
        -1822.935791015625,
        -3790.277099609375,
        958.0643310546875
      ],
      [
        -1814.565185546875,
        -3791.69091796875,
        986.1879272460938
      ],
      [
        -1812.1865234375,
        -3792.087890625,
        989.8412475585938
      ],
      [
        -1814.565185546875,
        -3791.69091796875,
        986.1879272460938
      ],
      [
        -1828.716552734375,
        -3805.642822265625,
        993.6304931640625
      ],
      [
        -1821.9150390625,
        -3792.08154296875,
        961.4442749023438
      ],
      [
        -1820.8646240234375,
        -3790.589111328125,
        959.8062744140625
      ],
      [
        -1821.9150390625,
        -3792.08154296875,
        961.4442749023438
      ],
      [
        -1817.7244873046875,
        -3791.157958984375,
        980.4678955078125
      ],
      [
        -1800.2864990234375,
        -3828.9111328125,
        967.318115234375
      ],
      [
        -1799.6751708984375,
        -3828.2998046875,
        967.5885009765625
      ],
      [
        -1798.6622314453125,
        -3826.30029296875,
        968.7229614257812
      ],
      [
        -1799.8514404296875,
        -3823.41455078125,
        971.0326538085938
      ],
      [
        -1802.57373046875,
        -3823.36083984375,
        971.7603149414062
      ],
      [
        -1803.828369140625,
        -3826.300537109375,
        970.03271484375
      ],
      [
        -1802.4384765625,
        -3828.949462890625,
        967.8370361328125
      ],
      [
        -1799.6751708984375,
        -3828.2998046875,
        967.5885009765625
      ],
      [
        -1800.2864990234375,
        -3828.9111328125,
        967.318115234375
      ],
      [
        -1799.982666015625,
        -3828.90478515625,
        967.23095703125
      ],
      [
        -1798.3743896484375,
        -3826.9990234375,
        968.163818359375
      ],
      [
        -1797.618408203125,
        -3828.8544921875,
        966.5531005859375
      ],
      [
        -1798.3743896484375,
        -3826.9990234375,
        968.163818359375
      ],
      [
        -1804.951904296875,
        -3828.933349609375,
        968.4855346679688
      ],
      [
        -1804.953857421875,
        -3828.994140625,
        968.4436645507812
      ],
      [
        -1804.953857421875,
        -3828.994140625,
        968.4436645507812
      ],
      [
        -1804.951904296875,
        -3828.933349609375,
        968.4855346679688
      ],
      [
        -1804.9781494140625,
        -3828.99462890625,
        968.4498901367188
      ],
      [
        -1804.7744140625,
        -3823.3173828125,
        972.3485107421875
      ],
      [
        -1809.3702392578125,
        -3823.220947265625,
        973.6528930664062
      ],
      [
        -1816.2578125,
        -3829.208251953125,
        971.3377075195312
      ],
      [
        -1804.7744140625,
        -3823.3173828125,
        972.3485107421875
      ],
      [
        -1812.429443359375,
        -3826.30029296875,
        932.0
      ],
      [
        -1812.9766845703125,
        -3826.355712890625,
        932.7532348632812
      ],
      [
        -1812.85498046875,
        -3826.25,
        932.6801147460938
      ],
      [
        -1794.8946533203125,
        -3836.760009765625,
        952.49853515625
      ],
      [
        -1795.322509765625,
        -3834.489990234375,
        961.6612548828125
      ],
      [
        -1795.9005126953125,
        -3836.851806640625,
        937.3236083984375
      ],
      [
        -1795.6295166015625,
        -3836.84912109375,
        941.2637939453125
      ],
      [
        -1794.812255859375,
        -3837.358642578125,
        949.642578125
      ],
      [
        -1795.6297607421875,
        -3836.84912109375,
        941.2639770507812
      ],
      [
        -1794.812255859375,
        -3837.358642578125,
        949.642578125
      ],
      [
        -1794.8834228515625,
        -3836.841552734375,
        952.1099853515625
      ],
      [
        -1815.389404296875,
        -3830.634765625,
        932.0
      ],
      [
        -1816.621337890625,
        -3829.524169921875,
        934.9442138671875
      ],
      [
        -1802.30029296875,
        -3836.607177734375,
        932.0
      ],
      [
        -1803.5963134765625,
        -3836.6865234375,
        936.3349609375
      ],
      [
        -1803.975830078125,
        -3836.93359375,
        938.126953125
      ],
      [
        -1803.5963134765625,
        -3836.6865234375,
        936.3349609375
      ],
      [
        -1794.8946533203125,
        -3836.760009765625,
        952.49853515625
      ],
      [
        -1798.03173828125,
        -3828.86328125,
        966.671630859375
      ],
      [
        -1795.322509765625,
        -3834.489990234375,
        961.6612548828125
      ],
      [
        -1795.9007568359375,
        -3836.851806640625,
        937.3236083984375
      ],
      [
        -1796.47998046875,
        -3836.250732421875,
        933.0028076171875
      ],
      [
        -1796.54736328125,
        -3836.2548828125,
        932.0
      ],
      [
        -1796.47998046875,
        -3836.250732421875,
        933.0028076171875
      ],
      [
        -1801.619140625,
        -3819.12451171875,
        974.4660034179688
      ],
      [
        -1801.619140625,
        -3819.12451171875,
        974.4660034179688
      ],
      [
        -1802.452392578125,
        -3817.20703125,
        975.37744140625
      ],
      [
        -1792.866455078125,
        -3821.490966796875,
        968.3999633789062
      ],
      [
        -1791.22509765625,
        -3819.849609375,
        967.6739501953125
      ],
      [
        -1790.74169921875,
        -3818.80029296875,
        967.5718383789062
      ],
      [
        -1791.926025390625,
        -3816.074462890625,
        968.867431640625
      ],
      [
        -1794.5322265625,
        -3815.949462890625,
        970.5592651367188
      ],
      [
        -1795.8853759765625,
        -3818.800048828125,
        970.8622436523438
      ],
      [
        -1794.4932861328125,
        -3821.56689453125,
        969.4256591796875
      ],
      [
        -1791.22509765625,
        -3819.849609375,
        967.6739501953125
      ],
      [
        -1792.866455078125,
        -3821.490966796875,
        968.3999633789062
      ],
      [
        -1791.957763671875,
        -3821.457275390625,
        967.9440307617188
      ],
      [
        -1790.5703125,
        -3819.19482421875,
        967.3843383789062
      ],
      [
        -1789.5970458984375,
        -3821.36962890625,
        966.759521484375
      ],
      [
        -1790.5703125,
        -3819.19482421875,
        967.3843383789062
      ],
      [
        -1793.199951171875,
        -3813.1376953125,
        970.2972412109375
      ],
      [
        -1794.2822265625,
        -3815.4228515625,
        970.5032958984375
      ],
      [
        -1792.3262939453125,
        -3815.153564453125,
        969.3052978515625
      ],
      [
        -1792.326171875,
        -3815.153564453125,
        969.30517578125
      ],
      [
        -1794.2822265625,
        -3815.4228515625,
        970.5032958984375
      ],
      [
        -1779.178466796875,
        -3819.533447265625,
        941.9246826171875
      ],
      [
        -1771.2308349609375,
        -3819.96533203125,
        947.7633666992188
      ],
      [
        -1779.3021240234375,
        -3819.200439453125,
        937.4191284179688
      ],
      [
        -1779.178466796875,
        -3819.533447265625,
        941.9246826171875
      ],
      [
        -1787.4161376953125,
        -3805.545654296875,
        937.9496459960938
      ],
      [
        -1787.66357421875,
        -3805.280029296875,
        943.3262939453125
      ],
      [
        -1787.66357421875,
        -3805.280029296875,
        943.3262939453125
      ],
      [
        -1788.3944091796875,
        -3805.524169921875,
        952.25
      ],
      [
        -1781.37744140625,
        -3818.800048828125,
        932.0
      ],
      [
        -1781.356689453125,
        -3818.966064453125,
        934.2450561523438
      ],
      [
        -1779.3021240234375,
        -3819.200439453125,
        937.4191284179688
      ],
      [
        -1781.356689453125,
        -3818.966064453125,
        934.2450561523438
      ],
      [
        -1787.76416015625,
        -3807.169921875,
        932.0
      ],
      [
        -1787.8704833984375,
        -3807.094970703125,
        934.0454711914062
      ],
      [
        -1788.3944091796875,
        -3805.524169921875,
        952.25
      ],
      [
        -1788.81640625,
        -3806.123779296875,
        954.3013916015625
      ],
      [
        -1787.4161376953125,
        -3805.545654296875,
        937.9496459960938
      ],
      [
        -1787.8704833984375,
        -3807.094970703125,
        934.0454711914062
      ],
      [
        -1772.5072021484375,
        -3820.327392578125,
        952.6607666015625
      ],
      [
        -1775.184326171875,
        -3820.775146484375,
        958.7178955078125
      ],
      [
        -1790.2513427734375,
        -3808.127685546875,
        961.5117797851562
      ],
      [
        -1789.8712158203125,
        -3806.270263671875,
        968.5748901367188
      ],
      [
        -1790.000732421875,
        -3806.3828125,
        969.6880493164062
      ],
      [
        -1792.015380859375,
        -3810.63671875,
        970.0717163085938
      ],
      [
        -1771.2308349609375,
        -3819.96533203125,
        947.7633666992188
      ],
      [
        -1772.5072021484375,
        -3820.327392578125,
        952.6607666015625
      ],
      [
        -1778.9237060546875,
        -3820.9736328125,
        961.4039916992188
      ],
      [
        -1790.2613525390625,
        -3808.1767578125,
        961.3255615234375
      ],
      [
        -1790.2613525390625,
        -3808.1767578125,
        961.3255615234375
      ],
      [
        -1775.184326171875,
        -3820.775146484375,
        958.7178955078125
      ],
      [
        -1778.9237060546875,
        -3820.9736328125,
        961.4039916992188
      ],
      [
        -1797.260009765625,
        -3821.69580078125,
        971.1700439453125
      ],
      [
        -1797.5396728515625,
        -3822.28466796875,
        971.232666015625
      ],
      [
        -1797.5396728515625,
        -3822.28466796875,
        971.232666015625
      ],
      [
        -1797.8427734375,
        -3822.994873046875,
        970.8153686523438
      ],
      [
        -1796.31591796875,
        -3836.4208984375,
        934.2263793945312
      ],
      [
        -1796.36181640625,
        -3836.373291015625,
        933.8839111328125
      ],
      [
        -1793.9091796875,
        -3835.9072265625,
        932.0
      ],
      [
        -1783.15625,
        -3827.787109375,
        932.0
      ],
      [
        -1779.28466796875,
        -3819.247314453125,
        938.054443359375
      ],
      [
        -1767.583740234375,
        -3829.798583984375,
        935.8944091796875
      ],
      [
        -1798.95263671875,
        -3825.595703125,
        969.2870483398438
      ],
      [
        -1801.562255859375,
        -3819.262451171875,
        974.3555297851562
      ],
      [
        -1797.609375,
        -3822.447998046875,
        971.13671875
      ],
      [
        -1755.0,
        -3826.4580078125,
        937.6505126953125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1035.5,
      "bbox_min": [
        -1884.2122802734375,
        -3958.5,
        799.0
      ],
      "bbox_max": [
        -1507.296142578125,
        -3621.0,
        1065.0
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -956.0,
      "bbox_min": [
        -1578.5,
        -3686.5185546875,
        953.5
      ],
      "bbox_max": [
        -1508.5,
        -3621.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -954.5,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        953.5
      ],
      "bbox_max": [
        -1511.0,
        -3621.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058494724333286285,
        -0.31568625569343567,
        0.9470588564872742
      ],
      "plane_d": -2138.80419921875,
      "bbox_min": [
        -1567.2962646484375,
        -3632.0,
        953.5
      ],
      "bbox_max": [
        -1520.7037353515625,
        -3625.5,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0539231039583683,
        -0.3055642545223236,
        0.9506434202194214
      ],
      "plane_d": -2098.486572265625,
      "bbox_min": [
        -1537.7037353515625,
        -3632.0,
        953.5
      ],
      "bbox_max": [
        -1520.7037353515625,
        -3626.666748046875,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.058494724333286285,
        -0.31568628549575806,
        0.9470588564872742
      ],
      "plane_d": -1958.1724853515625,
      "bbox_min": [
        -1567.2962646484375,
        -3632.0,
        953.5
      ],
      "bbox_max": [
        -1544.0,
        -3625.5,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053923096507787704,
        -0.3055642545223236,
        0.9506434202194214
      ],
      "plane_d": -1931.9720458984375,
      "bbox_min": [
        -1567.2962646484375,
        -3632.0,
        953.5
      ],
      "bbox_max": [
        -1550.2962646484375,
        -3626.666748046875,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17378532886505127,
        -0.9847835898399353,
        0.0
      ],
      "plane_d": -3837.180419921875,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        954.5
      ],
      "bbox_max": [
        -1518.5,
        -3624.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17378532886505127,
        -0.9847835898399353,
        0.0
      ],
      "plane_d": -3300.53125,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        954.5
      ],
      "bbox_max": [
        -1518.5,
        -3624.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0539231039583683,
        -0.3055642545223236,
        0.9506434202194214
      ],
      "plane_d": -2098.486572265625,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        954.5
      ],
      "bbox_max": [
        -1518.5,
        -3624.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058494724333286285,
        -0.31568625569343567,
        0.9470588564872742
      ],
      "plane_d": -2138.80419921875,
      "bbox_min": [
        -1544.1524658203125,
        -3626.666748046875,
        954.5
      ],
      "bbox_max": [
        -1537.7037353515625,
        -3624.0,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.058494724333286285,
        -0.31568628549575806,
        0.9470588564872742
      ],
      "plane_d": -1958.1724853515625,
      "bbox_min": [
        -1544.1524658203125,
        -3625.5283203125,
        954.5
      ],
      "bbox_max": [
        -1544.0,
        -3624.0,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053923096507787704,
        -0.3055642545223236,
        0.9506434202194214
      ],
      "plane_d": -1931.9720458984375,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        954.5
      ],
      "bbox_max": [
        -1544.0,
        -3624.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.058494724333286285,
        -0.31568628549575806,
        0.9470588564872742
      ],
      "plane_d": -1958.1724853515625,
      "bbox_min": [
        -1550.2962646484375,
        -3626.666748046875,
        954.5
      ],
      "bbox_max": [
        -1544.0,
        -3624.0,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8462328910827637,
        -0.532813310623169,
        0.0
      ],
      "plane_d": -605.150634765625,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        955.0
      ],
      "bbox_max": [
        -1546.733642578125,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24937207996845245,
        -0.3473396897315979,
        0.9039738178253174
      ],
      "plane_d": -1758.0570068359375,
      "bbox_min": [
        -1550.358642578125,
        -3686.5185546875,
        955.5
      ],
      "bbox_max": [
        -1546.733642578125,
        -3685.21728515625,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24937207996845245,
        -0.3473396897315979,
        0.9039738178253174
      ],
      "plane_d": -2530.38525390625,
      "bbox_min": [
        -1548.546142578125,
        -3686.5185546875,
        955.5
      ],
      "bbox_max": [
        -1546.733642578125,
        -3685.21728515625,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17378532886505127,
        -0.9847835898399353,
        0.0
      ],
      "plane_d": -3837.180419921875,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1518.5,
        -3621.5,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.1923827975988388,
        -0.9813199043273926
      ],
      "plane_d": 267.64691162109375,
      "bbox_min": [
        -1550.97998046875,
        -3625.337158203125,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3621.5,
        986.3760375976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6397563219070435,
        -0.21210886538028717,
        -0.7387297749519348
      ],
      "plane_d": 942.6328125,
      "bbox_min": [
        -1550.97998046875,
        -3625.337158203125,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3621.5,
        986.3760375976562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6385786533355713,
        -0.22023369371891022,
        -0.737369954586029
      ],
      "plane_d": -1060.900634765625,
      "bbox_min": [
        -1550.97998046875,
        -3623.492919921875,
        982.718505859375
      ],
      "bbox_max": [
        -1546.873779296875,
        -3621.5,
        986.1759033203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.17378532886505127,
        -0.9847835898399353,
        0.0
      ],
      "plane_d": -3300.53125,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1536.4239501953125,
        -3622.827880859375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.752065122127533,
        -0.5941891074180603,
        -0.2851971387863159
      ],
      "plane_d": -3047.8212890625,
      "bbox_min": [
        -1566.0,
        -3627.8662109375,
        983.1091918945312
      ],
      "bbox_max": [
        -1544.0001220703125,
        -3622.827880859375,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6385786533355713,
        -0.22023369371891022,
        -0.737369954586029
      ],
      "plane_d": -1060.900634765625,
      "bbox_min": [
        -1558.06591796875,
        -3626.482177734375,
        983.1091918945312
      ],
      "bbox_max": [
        -1544.0001220703125,
        -3622.827880859375,
        989.2205810546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7520655393600464,
        -0.5941894054412842,
        -0.2851952910423279
      ],
      "plane_d": -702.1324462890625,
      "bbox_min": [
        -1558.06591796875,
        -3626.482177734375,
        985.0
      ],
      "bbox_max": [
        -1556.2061767578125,
        -3625.58251953125,
        989.2205810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8462328910827637,
        -0.532813310623169,
        0.0
      ],
      "plane_d": -605.150634765625,
      "bbox_min": [
        -1578.0,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1536.4239501953125,
        -3624.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.1923827975988388,
        -0.9813199043273926
      ],
      "plane_d": 267.64691162109375,
      "bbox_min": [
        -1565.908203125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1536.4239501953125,
        -3624.0,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6494667530059814,
        -0.214582622051239,
        -0.7294842600822449
      ],
      "plane_d": 939.4677734375,
      "bbox_min": [
        -1565.908203125,
        -3642.5,
        983.303955078125
      ],
      "bbox_max": [
        -1536.4239501953125,
        -3624.486328125,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.752065122127533,
        -0.5941891074180603,
        -0.2851971387863159
      ],
      "plane_d": -3047.8212890625,
      "bbox_min": [
        -1565.908203125,
        -3642.5,
        983.303955078125
      ],
      "bbox_max": [
        -1544.621337890625,
        -3624.486328125,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6385786533355713,
        -0.22023369371891022,
        -0.737369954586029
      ],
      "plane_d": -1060.900634765625,
      "bbox_min": [
        -1562.75,
        -3642.5,
        983.303955078125
      ],
      "bbox_max": [
        -1544.621337890625,
        -3624.486328125,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6482388973236084,
        -0.22282102704048157,
        -0.7281051278114319
      ],
      "plane_d": -1094.3892822265625,
      "bbox_min": [
        -1562.75,
        -3642.5,
        986.1990966796875
      ],
      "bbox_max": [
        -1544.621337890625,
        -3625.042724609375,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7520655393600464,
        -0.5941894054412842,
        -0.2851952910423279
      ],
      "plane_d": -702.1324462890625,
      "bbox_min": [
        -1562.75,
        -3631.863525390625,
        991.6578369140625
      ],
      "bbox_max": [
        -1553.0,
        -3626.484375,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9557704925537109,
        -0.29411351680755615
      ],
      "plane_d": -3176.8203125,
      "bbox_min": [
        -1562.75,
        -3631.863525390625,
        994.119384765625
      ],
      "bbox_max": [
        -1556.25,
        -3629.746337890625,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9557704925537109,
        -0.29411351680755615
      ],
      "plane_d": -3176.8203125,
      "bbox_min": [
        -1562.528076171875,
        -3631.36181640625,
        991.534423828125
      ],
      "bbox_max": [
        -1555.5428466796875,
        -3626.4677734375,
        999.369384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7520655393600464,
        -0.5941894054412842,
        -0.2851952910423279
      ],
      "plane_d": -702.1324462890625,
      "bbox_min": [
        -1557.2144775390625,
        -3629.746337890625,
        991.534423828125
      ],
      "bbox_max": [
        -1555.5428466796875,
        -3626.4677734375,
        994.119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9557704925537109,
        -0.29411351680755615
      ],
      "plane_d": -3176.8203125,
      "bbox_min": [
        -1562.46728515625,
        -3631.224365234375,
        985.0
      ],
      "bbox_max": [
        -1555.576416015625,
        -3626.154296875,
        998.9226684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7520655393600464,
        -0.5941894054412842,
        -0.2851952910423279
      ],
      "plane_d": -702.1324462890625,
      "bbox_min": [
        -1558.427490234375,
        -3629.682861328125,
        985.0
      ],
      "bbox_max": [
        -1555.576416015625,
        -3626.154296875,
        993.9132080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8631613850593567,
        -0.4983587861061096,
        -0.08118457347154617
      ],
      "plane_d": -388.05712890625,
      "bbox_min": [
        -1564.0,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3634.5,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8633504509925842,
        -0.49846795201301575,
        -0.07845883071422577
      ],
      "plane_d": -3083.61328125,
      "bbox_min": [
        -1564.0,
        -3638.397216796875,
        957.7122192382812
      ],
      "bbox_max": [
        -1558.3212890625,
        -3634.5,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9969271421432495,
        -0.0783342719078064
      ],
      "plane_d": -3549.161865234375,
      "bbox_min": [
        -1560.6787109375,
        -3638.397216796875,
        957.7122192382812
      ],
      "bbox_max": [
        -1558.3212890625,
        -3635.3544921875,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.918144941329956,
        -0.396244615316391
      ],
      "plane_d": -2951.97412109375,
      "bbox_min": [
        -1560.6787109375,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1558.3212890625,
        -3636.88671875,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7804855108261108,
        -0.4506016671657562,
        -0.4333595931529999
      ],
      "plane_d": -2433.39013671875,
      "bbox_min": [
        -1564.0,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1560.124755859375,
        -3634.5,
        980.7122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.918144941329956,
        -0.396244615316391
      ],
      "plane_d": -2951.97412109375,
      "bbox_min": [
        -1561.75,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1560.124755859375,
        -3636.88671875,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181729555130005,
        0.14209820330142975,
        -0.36981964111328125
      ],
      "plane_d": -535.7471313476562,
      "bbox_min": [
        -1558.8641357421875,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3634.5,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9181729555130005,
        0.14209820330142975,
        -0.36981964111328125
      ],
      "plane_d": 2307.919189453125,
      "bbox_min": [
        -1558.8641357421875,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3634.5,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7804855108261108,
        -0.4506016671657562,
        -0.4333595931529999
      ],
      "plane_d": 0.9442138671875,
      "bbox_min": [
        -1558.8641357421875,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1555.874267578125,
        -3635.28515625,
        980.7122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.918144941329956,
        -0.396244615316391
      ],
      "plane_d": -2951.97412109375,
      "bbox_min": [
        -1558.8641357421875,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1557.25,
        -3636.88671875,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9249667525291443,
        0.07508881390094757,
        -0.37255603075027466
      ],
      "plane_d": 2074.9521484375,
      "bbox_min": [
        -1557.3966064453125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3634.5,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7804827094078064,
        -0.4506230652332306,
        -0.4333423376083374
      ],
      "plane_d": 0.84521484375,
      "bbox_min": [
        -1557.3966064453125,
        -3636.01416015625,
        977.2122192382812
      ],
      "bbox_max": [
        -1555.0,
        -3634.5,
        980.7122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2610473930835724,
        0.19072650372982025,
        -0.9462968111038208
      ],
      "plane_d": 2025.09619140625,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3657.918212890625,
        974.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9249667525291443,
        0.07508881390094757,
        -0.37255603075027466
      ],
      "plane_d": -789.7552490234375,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3657.918212890625,
        974.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9275855422019958,
        0.0,
        -0.37361082434654236
      ],
      "plane_d": 1804.789306640625,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3657.918212890625,
        974.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9181729555130005,
        -0.14209820330142975,
        0.36981964111328125
      ],
      "plane_d": 549.0607299804688,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3657.918212890625,
        974.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9249667525291443,
        -0.07508881390094757,
        0.37255603075027466
      ],
      "plane_d": 803.167236328125,
      "bbox_min": [
        -1555.796142578125,
        -3673.8310546875,
        961.875
      ],
      "bbox_max": [
        -1552.064208984375,
        -3657.918212890625,
        968.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9275855422019958,
        -0.0,
        0.37361082434654236
      ],
      "plane_d": 1081.478759765625,
      "bbox_min": [
        -1555.796142578125,
        -3665.7685546875,
        963.3132934570312
      ],
      "bbox_max": [
        -1553.3067626953125,
        -3657.918212890625,
        968.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2659290134906769,
        0.0,
        0.9639926552772522
      ],
      "plane_d": -515.5576171875,
      "bbox_min": [
        -1553.983642578125,
        -3665.7685546875,
        962.9705200195312
      ],
      "bbox_max": [
        -1552.064208984375,
        -3658.357666015625,
        963.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2659290134906769,
        0.0,
        -0.963992714881897
      ],
      "plane_d": 1350.732177734375,
      "bbox_min": [
        -1553.983642578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3658.23828125,
        974.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26592525839805603,
        0.0,
        -0.9639936685562134
      ],
      "plane_d": 527.1322631835938,
      "bbox_min": [
        -1553.983642578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3658.576904296875,
        974.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9275854825973511,
        -0.0,
        -0.37361079454421997
      ],
      "plane_d": -1068.0286865234375,
      "bbox_min": [
        -1553.983642578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3658.576904296875,
        972.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181729555130005,
        -0.14209820330142975,
        0.36981964111328125
      ],
      "plane_d": -2294.605712890625,
      "bbox_min": [
        -1553.983642578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3658.576904296875,
        968.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9249667525291443,
        -0.07508881390094757,
        0.37255603075027466
      ],
      "plane_d": -2061.5400390625,
      "bbox_min": [
        -1544.80517578125,
        -3673.8310546875,
        961.875
      ],
      "bbox_max": [
        -1541.296142578125,
        -3659.52294921875,
        968.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9275854825973511,
        0.0,
        0.37361079454421997
      ],
      "plane_d": -1791.3392333984375,
      "bbox_min": [
        -1543.64111328125,
        -3665.7685546875,
        963.3530883789062
      ],
      "bbox_max": [
        -1541.296142578125,
        -3659.52294921875,
        968.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26594802737236023,
        0.0,
        0.963987410068512
      ],
      "plane_d": -1339.1885986328125,
      "bbox_min": [
        -1543.64111328125,
        -3665.7685546875,
        963.3530883789062
      ],
      "bbox_max": [
        -1543.108642578125,
        -3659.8427734375,
        963.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -2013.74072265625,
      "bbox_min": [
        -1544.80517578125,
        -3673.8310546875,
        961.875
      ],
      "bbox_max": [
        -1543.108642578125,
        -3659.85791015625,
        963.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24937207996845245,
        -0.3473396897315979,
        0.9039738178253174
      ],
      "plane_d": -1758.0570068359375,
      "bbox_min": [
        -1553.983642578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1543.108642578125,
        -3658.576904296875,
        963.3158569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -1205.2529296875,
      "bbox_min": [
        -1553.983642578125,
        -3673.8310546875,
        960.375
      ],
      "bbox_max": [
        -1544.1962890625,
        -3658.576904296875,
        963.3158569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24937207996845245,
        -0.3473396897315979,
        0.9039738178253174
      ],
      "plane_d": -2530.38525390625,
      "bbox_min": [
        -1548.546142578125,
        -3686.5185546875,
        956.0
      ],
      "bbox_max": [
        -1543.108642578125,
        -3663.35546875,
        963.3158569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -2013.74072265625,
      "bbox_min": [
        -1548.546142578125,
        -3673.8310546875,
        960.375
      ],
      "bbox_max": [
        -1543.108642578125,
        -3663.35546875,
        963.3158569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2659289836883545,
        3.164663894494879e-06,
        0.9639925360679626
      ],
      "plane_d": -1339.152587890625,
      "bbox_min": [
        -1545.876708984375,
        -3665.7685546875,
        962.7363891601562
      ],
      "bbox_max": [
        -1543.776123046875,
        -3663.35546875,
        963.3158569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26280197501182556,
        -0.1529032438993454,
        0.952657163143158
      ],
      "plane_d": -1066.983642578125,
      "bbox_min": [
        -1553.983642578125,
        -3697.7685546875,
        951.8101196289062
      ],
      "bbox_max": [
        -1540.7369384765625,
        -3686.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23996202647686005,
        -0.4309960901737213,
        0.8698623776435852
      ],
      "plane_d": -2791.620849609375,
      "bbox_min": [
        -1548.546142578125,
        -3697.7685546875,
        951.8101196289062
      ],
      "bbox_max": [
        -1540.7369384765625,
        -3686.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8457331657409668,
        -0.4107287526130676,
        0.340642511844635
      ],
      "plane_d": -525.898681640625,
      "bbox_min": [
        -1559.296142578125,
        -3697.7685546875,
        952.0801391601562
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8457331657409668,
        -0.4107287526130676,
        0.340642511844635
      ],
      "plane_d": -3145.212158203125,
      "bbox_min": [
        -1559.296142578125,
        -3697.7685546875,
        952.0801391601562
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7755640745162964,
        -0.38296639919281006,
        0.5018337965011597
      ],
      "plane_d": -686.853759765625,
      "bbox_min": [
        -1559.296142578125,
        -3697.7685546875,
        952.0801391601562
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25395944714546204,
        0.29663872718811035,
        -0.9206030368804932
      ],
      "plane_d": 2377.515380859375,
      "bbox_min": [
        -1556.026611328125,
        -3697.7685546875,
        956.625
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17427998781204224,
        0.2634528875350952,
        -0.9487987160682678
      ],
      "plane_d": 2158.591796875,
      "bbox_min": [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      "bbox_max": [
        -1548.546142578125,
        -3686.5185546875,
        966.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25395944714546204,
        0.29663872718811035,
        -0.9206030368804932
      ],
      "plane_d": 1590.979736328125,
      "bbox_min": [
        -1548.546142578125,
        -3697.7685546875,
        963.875
      ],
      "bbox_max": [
        -1543.108642578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622037172317505,
        -0.049794260412454605,
        -0.504108190536499
      ],
      "plane_d": -1027.77880859375,
      "bbox_min": [
        -1543.108642578125,
        -3697.7685546875,
        956.625
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        966.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9263224005699158,
        -0.05217086523771286,
        -0.3731020390987396
      ],
      "plane_d": -1261.328369140625,
      "bbox_min": [
        -1543.108642578125,
        -3697.7685546875,
        961.5
      ],
      "bbox_max": [
        -1540.6982421875,
        -3686.5185546875,
        966.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054038431495428085,
        -0.10393351316452026,
        0.9931151270866394
      ],
      "plane_d": -1412.26220703125,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2280474305152893,
        0.9736499786376953
      ],
      "plane_d": -1771.8388671875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1539.856201171875,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8681620359420776,
        -0.0435086190700531,
        0.4943700432777405
      ],
      "plane_d": -1967.85888671875,
      "bbox_min": [
        -1540.858642578125,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1539.856201171875,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8681620359420776,
        -0.0435086190700531,
        0.4943700432777405
      ],
      "plane_d": -1967.85888671875,
      "bbox_min": [
        -1539.9739990234375,
        -3728.5185546875,
        948.0535888671875
      ],
      "bbox_max": [
        -1539.2103271484375,
        -3716.478515625,
        949.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18377229571342468,
        -0.8483663201332092,
        0.49649009108543396
      ],
      "plane_d": -3894.621337890625,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        948.4600830078125
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.198095440864563,
        -0.8632487654685974,
        0.46428418159484863
      ],
      "plane_d": -3940.8701171875,
      "bbox_min": [
        -1548.5999755859375,
        -3704.629638671875,
        950.967041015625
      ],
      "bbox_max": [
        -1519.518310546875,
        -3697.7685546875,
        956.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.40067940950393677,
        0.9162183403968811
      ],
      "plane_d": -2353.93310546875,
      "bbox_min": [
        -1548.4471435546875,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1537.796142578125,
        -3697.7685546875,
        956.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26280197501182556,
        -0.1529032438993454,
        0.952657163143158
      ],
      "plane_d": -1066.983642578125,
      "bbox_min": [
        -1542.6947021484375,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1540.2161865234375,
        -3697.7685546875,
        952.0801391601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23996202647686005,
        -0.4309960901737213,
        0.8698623776435852
      ],
      "plane_d": -2791.620849609375,
      "bbox_min": [
        -1541.7158203125,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1540.2161865234375,
        -3697.7685546875,
        952.0801391601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7755640745162964,
        -0.38296639919281006,
        0.5018337965011597
      ],
      "plane_d": -3088.84716796875,
      "bbox_min": [
        -1540.7369384765625,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1537.796142578125,
        -3697.7685546875,
        956.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10289876908063889,
        0.994691789150238
      ],
      "plane_d": -1326.701904296875,
      "bbox_min": [
        -1541.58984375,
        -3700.556884765625,
        950.967041015625
      ],
      "bbox_max": [
        -1540.2091064453125,
        -3700.238525390625,
        951.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23856014013290405,
        -0.779674232006073,
        -0.5789621472358704
      ],
      "plane_d": -2696.062255859375,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        948.4600830078125
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2763727903366089,
        -0.01238174270838499,
        -0.9609708189964294
      ],
      "plane_d": 452.494873046875,
      "bbox_min": [
        -1548.5999755859375,
        -3700.629638671875,
        956.625
      ],
      "bbox_max": [
        -1537.796142578125,
        -3697.7685546875,
        963.899658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17427998781204224,
        0.2634528875350952,
        -0.9487987160682678
      ],
      "plane_d": 1618.83056640625,
      "bbox_min": [
        -1548.546142578125,
        -3700.629638671875,
        961.611083984375
      ],
      "bbox_max": [
        -1540.546142578125,
        -3697.7685546875,
        963.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9263224005699158,
        -0.05217086523771286,
        -0.3731020390987396
      ],
      "plane_d": -1261.328369140625,
      "bbox_min": [
        -1541.065673828125,
        -3700.629638671875,
        961.611083984375
      ],
      "bbox_max": [
        -1540.546142578125,
        -3697.7685546875,
        962.5009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622037172317505,
        -0.049794260412454605,
        -0.504108190536499
      ],
      "plane_d": -1027.77880859375,
      "bbox_min": [
        -1548.5999755859375,
        -3700.629638671875,
        956.625
      ],
      "bbox_max": [
        -1537.796142578125,
        -3697.7685546875,
        963.899658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9263224005699158,
        -0.05217086523771286,
        -0.3731020390987396
      ],
      "plane_d": -1261.328369140625,
      "bbox_min": [
        -1540.711669921875,
        -3700.629638671875,
        961.5885620117188
      ],
      "bbox_max": [
        -1540.546142578125,
        -3697.7685546875,
        961.6217651367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2755959928035736,
        -0.010011322796344757,
        -0.9612213969230652
      ],
      "plane_d": 1316.2508544921875,
      "bbox_min": [
        -1548.5999755859375,
        -3699.88427734375,
        963.8597412109375
      ],
      "bbox_max": [
        -1548.5369873046875,
        -3697.7685546875,
        963.899658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17427998781204224,
        0.2634528875350952,
        -0.9487987160682678
      ],
      "plane_d": 2158.591796875,
      "bbox_min": [
        -1548.5999755859375,
        -3697.787841796875,
        963.8597412109375
      ],
      "bbox_max": [
        -1548.546142578125,
        -3697.7685546875,
        963.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10108519345521927,
        0.0,
        -0.9948777556419373
      ],
      "plane_d": 799.82373046875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        948.4600830078125
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14027108252048492,
        0.07180550694465637,
        -0.9875059723854065
      ],
      "plane_d": 999.2282104492188,
      "bbox_min": [
        -1548.5999755859375,
        -3718.646484375,
        958.3333129882812
      ],
      "bbox_max": [
        -1519.518310546875,
        -3699.851318359375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34520602226257324,
        0.0646713599562645,
        -0.9362961053848267
      ],
      "plane_d": 607.87158203125,
      "bbox_min": [
        -1548.5999755859375,
        -3717.8564453125,
        960.4444580078125
      ],
      "bbox_max": [
        -1540.296142578125,
        -3699.851318359375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2763727903366089,
        -0.01238174270838499,
        -0.9609708189964294
      ],
      "plane_d": 452.494873046875,
      "bbox_min": [
        -1548.5999755859375,
        -3717.8564453125,
        961.4943237304688
      ],
      "bbox_max": [
        -1540.546142578125,
        -3699.851318359375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1548.5999755859375,
        -3717.8564453125,
        961.4943237304688
      ],
      "bbox_max": [
        -1548.5,
        -3699.851318359375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2755959928035736,
        -0.010011322796344757,
        -0.9612213969230652
      ],
      "plane_d": 1316.2508544921875,
      "bbox_min": [
        -1548.5999755859375,
        -3708.592529296875,
        963.8812255859375
      ],
      "bbox_max": [
        -1548.5,
        -3699.851318359375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3417642414569855,
        0.0648205354809761,
        -0.9375476241111755
      ],
      "plane_d": 1673.40478515625,
      "bbox_min": [
        -1548.5999755859375,
        -3708.592529296875,
        963.9571533203125
      ],
      "bbox_max": [
        -1548.5,
        -3708.402099609375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17288756370544434,
        0.2555210292339325,
        -0.9512196779251099
      ],
      "plane_d": 1596.859130859375,
      "bbox_min": [
        -1548.5999755859375,
        -3718.646484375,
        960.4444580078125
      ],
      "bbox_max": [
        -1540.296142578125,
        -3716.185302734375,
        961.5095825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1548.5999755859375,
        -3718.646484375,
        961.28271484375
      ],
      "bbox_max": [
        -1548.5421142578125,
        -3717.760009765625,
        961.5095825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.252521812915802,
        -0.8060061931610107,
        -0.5353379249572754
      ],
      "plane_d": -2856.633544921875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        948.4600830078125
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10289876908063889,
        0.994691789150238
      ],
      "plane_d": -1326.701904296875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        948.4600830078125
      ],
      "bbox_max": [
        -1516.796142578125,
        -3698.197509765625,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2280474305152893,
        0.9736499786376953
      ],
      "plane_d": -1771.8388671875,
      "bbox_min": [
        -1548.5999755859375,
        -3720.14990234375,
        948.4600830078125
      ],
      "bbox_max": [
        -1539.856201171875,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18478533625602722,
        0.8477975726127625,
        -0.4970851242542267
      ],
      "plane_d": 3342.95849609375,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3200073242188
      ],
      "bbox_max": [
        -1516.796142578125,
        -3698.197509765625,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20381586253643036,
        0.8688979148864746,
        -0.4510827362537384
      ],
      "plane_d": 3348.288818359375,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1519.518310546875,
        -3712.407470703125,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20494778454303741,
        0.37225425243377686,
        -0.9052199721336365
      ],
      "plane_d": 1937.0989990234375,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1760730892419815,
        0.3933427333831787,
        -0.9023745656013489
      ],
      "plane_d": 2057.5009765625,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234262466430664,
        0.2431025505065918,
        -0.512708842754364
      ],
      "plane_d": 127.522216796875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8402679562568665,
        0.2549531161785126,
        -0.47848591208457947
      ],
      "plane_d": 113.056640625,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1760730892419815,
        0.3933427333831787,
        -0.9023745656013489
      ],
      "plane_d": 2602.8154296875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.2882080078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8656002879142761,
        -0.042541082948446274,
        0.4989252984523773
      ],
      "plane_d": -1964.642822265625,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1548.5999755859375,
        -3718.7685546875,
        961.2447509765625
      ],
      "bbox_max": [
        -1548.545654296875,
        -3718.589111328125,
        961.2882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22476887702941895,
        0.8151643872261047,
        0.5338410139083862
      ],
      "plane_d": 2176.64306640625,
      "bbox_min": [
        -1548.5999755859375,
        -3722.03955078125,
        949.3200073242188
      ],
      "bbox_max": [
        -1516.796142578125,
        -3698.197509765625,
        958.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8656002879142761,
        -0.042541082948446274,
        0.4989252984523773
      ],
      "plane_d": -1964.642822265625,
      "bbox_min": [
        -1539.856201171875,
        -3722.03955078125,
        949.3200073242188
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.478515625,
        954.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7745364308357239,
        -0.0,
        -0.6325293779373169
      ],
      "plane_d": -570.748291015625,
      "bbox_min": [
        -1548.5999755859375,
        -3713.7685546875,
        951.0
      ],
      "bbox_max": [
        -1516.796142578125,
        -3698.197509765625,
        958.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.40067940950393677,
        0.9162183403968811
      ],
      "plane_d": -2353.93310546875,
      "bbox_min": [
        -1548.5999755859375,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1541.58984375,
        -3698.197509765625,
        951.892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8681619763374329,
        -0.043508630245923996,
        0.4943700134754181
      ],
      "plane_d": 720.9188842773438,
      "bbox_min": [
        -1557.236083984375,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1556.233642578125,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8681619763374329,
        -0.043508630245923996,
        0.4943700134754181
      ],
      "plane_d": 720.9188842773438,
      "bbox_min": [
        -1557.8819580078125,
        -3728.5185546875,
        948.0535888671875
      ],
      "bbox_max": [
        -1557.1182861328125,
        -3716.478515625,
        949.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23856014013290405,
        -0.779674232006073,
        -0.5789621472358704
      ],
      "plane_d": -1957.2193603515625,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17427998781204224,
        0.2634528875350952,
        -0.9487987160682678
      ],
      "plane_d": 2158.591796875,
      "bbox_min": [
        -1559.296142578125,
        -3700.629638671875,
        956.625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        963.881591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2755959928035736,
        -0.010011322796344757,
        -0.9612213969230652
      ],
      "plane_d": 1316.2508544921875,
      "bbox_min": [
        -1556.546142578125,
        -3700.629638671875,
        961.611083984375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.787841796875,
        963.881591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8622037768363953,
        -0.0497942790389061,
        -0.5041082501411438
      ],
      "plane_d": 1642.5458984375,
      "bbox_min": [
        -1559.296142578125,
        -3700.629638671875,
        956.625
      ],
      "bbox_max": [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.926322340965271,
        -0.05217086896300316,
        -0.3731020390987396
      ],
      "plane_d": 1607.5775146484375,
      "bbox_min": [
        -1556.546142578125,
        -3700.629638671875,
        961.5885620117188
      ],
      "bbox_max": [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10108519345521927,
        0.0,
        -0.9948777556419373
      ],
      "plane_d": 1112.8939208984375,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14027108252048492,
        0.07180550694465637,
        -0.9875059723854065
      ],
      "plane_d": 1433.66064453125,
      "bbox_min": [
        -1577.573974609375,
        -3718.6298828125,
        958.3333129882812
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3699.884765625,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3417642414569855,
        0.0648205354809761,
        -0.9375476241111755
      ],
      "plane_d": 1673.40478515625,
      "bbox_min": [
        -1556.796142578125,
        -3717.8388671875,
        960.4444580078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3699.884765625,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1556.796142578125,
        -3717.8388671875,
        960.4444580078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3699.884765625,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2755959928035736,
        -0.010011322796344757,
        -0.9612213969230652
      ],
      "plane_d": 1316.2508544921875,
      "bbox_min": [
        -1556.546142578125,
        -3708.402099609375,
        961.611083984375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3699.884765625,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1556.796142578125,
        -3718.6298828125,
        960.4444580078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.4884643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.252521812915802,
        -0.8060061931610107,
        -0.5353379249572754
      ],
      "plane_d": -2074.55029296875,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18377229571342468,
        -0.8483663201332092,
        0.49649009108543396
      ],
      "plane_d": -3325.4619140625,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.198095440864563,
        -0.8632487654685974,
        0.46428418159484863
      ],
      "plane_d": -3327.3505859375,
      "bbox_min": [
        -1577.573974609375,
        -3704.629638671875,
        950.967041015625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        956.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.40067940950393677,
        0.9162183403968811
      ],
      "plane_d": -2353.93310546875,
      "bbox_min": [
        -1559.296142578125,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1548.644287109375,
        -3697.7685546875,
        956.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7755640745162964,
        -0.38296639919281006,
        0.5018337965011597
      ],
      "plane_d": -686.853759765625,
      "bbox_min": [
        -1559.296142578125,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1556.3553466796875,
        -3697.7685546875,
        956.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10289876908063889,
        0.994691789150238
      ],
      "plane_d": -1326.701904296875,
      "bbox_min": [
        -1556.8831787109375,
        -3700.55712890625,
        950.967041015625
      ],
      "bbox_max": [
        -1555.5009765625,
        -3700.238525390625,
        951.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10289876908063889,
        0.994691789150238
      ],
      "plane_d": -1326.701904296875,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3698.2294921875,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2280474305152893,
        0.9736499786376953
      ],
      "plane_d": -1771.8388671875,
      "bbox_min": [
        -1557.236083984375,
        -3720.10546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18478533625602722,
        0.8477975726127625,
        -0.4970851242542267
      ],
      "plane_d": 3915.255859375,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        949.3200073242188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3698.2294921875,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20381586253643036,
        0.8688979148864746,
        -0.4510827362537384
      ],
      "plane_d": 3979.525390625,
      "bbox_min": [
        -1577.573974609375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3712.407470703125,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20494778454303741,
        0.37225425243377686,
        -0.9052199721336365
      ],
      "plane_d": 2571.84130859375,
      "bbox_min": [
        -1560.046142578125,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1760730892419815,
        0.3933427333831787,
        -0.9023745656013489
      ],
      "plane_d": 2602.8154296875,
      "bbox_min": [
        -1560.046142578125,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8234262466430664,
        0.2431025505065918,
        -0.512708842754364
      ],
      "plane_d": 2677.749267578125,
      "bbox_min": [
        -1560.046142578125,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8402679562568665,
        0.2549531161785126,
        -0.47848591208457947
      ],
      "plane_d": 2715.44384765625,
      "bbox_min": [
        -1560.046142578125,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1556.796142578125,
        -3718.751708984375,
        960.4444580078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.2772827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22476887702941895,
        0.8151643872261047,
        0.5338410139083862
      ],
      "plane_d": 2872.773193359375,
      "bbox_min": [
        -1580.296142578125,
        -3722.039794921875,
        949.3200073242188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3698.2294921875,
        958.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8656002879142761,
        -0.042541079223155975,
        0.4989252984523773
      ],
      "plane_d": 716.201171875,
      "bbox_min": [
        -1560.046142578125,
        -3722.039794921875,
        949.3200073242188
      ],
      "bbox_max": [
        -1557.236083984375,
        -3716.478515625,
        954.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7745364308357239,
        0.0,
        0.6325293779373169
      ],
      "plane_d": 619.931396484375,
      "bbox_min": [
        -1580.296142578125,
        -3713.7685546875,
        951.0
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3698.2294921875,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13802321255207062,
        -0.9106122255325317,
        0.38953179121017456
      ],
      "plane_d": -3984.701171875,
      "bbox_min": [
        -1532.046142578125,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1507.296142578125,
        -3738.2685546875,
        952.0046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1914253681898117,
        -0.9226510524749756,
        -0.3347705900669098
      ],
      "plane_d": -3425.15283203125,
      "bbox_min": [
        -1532.046142578125,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1507.296142578125,
        -3738.2685546875,
        952.0046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1375814527273178,
        0.9434155821800232,
        -0.3017253279685974
      ],
      "plane_d": 3616.080322265625,
      "bbox_min": [
        -1532.046142578125,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1507.296142578125,
        -3738.2685546875,
        952.0046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13314054906368256,
        0.9129636883735657,
        0.3857082724571228
      ],
      "plane_d": 2858.344970703125,
      "bbox_min": [
        -1532.046142578125,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1507.296142578125,
        -3738.2685546875,
        952.0046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011649972759187222,
        -0.09389030933380127,
        0.9955143928527832
      ],
      "plane_d": -1307.3695068359375,
      "bbox_min": [
        -1532.046142578125,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1507.296142578125,
        -3738.2685546875,
        952.0046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12581677734851837,
        -0.8961225748062134,
        0.4255989193916321
      ],
      "plane_d": -3946.01220703125,
      "bbox_min": [
        -1532.046142578125,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1507.296142578125,
        -3738.2685546875,
        952.0046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06426788866519928,
        0.0914304107427597,
        -0.9937353730201721
      ],
      "plane_d": 1189.6009521484375,
      "bbox_min": [
        -1531.9283447265625,
        -3750.979248046875,
        950.3333129882812
      ],
      "bbox_max": [
        -1510.4072265625,
        -3740.70263671875,
        952.0046997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044131290167570114,
        0.0,
        0.9990256428718567
      ],
      "plane_d": -1008.2379150390625,
      "bbox_min": [
        -1531.43115234375,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1507.296142578125,
        -3742.7685546875,
        951.0257568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12013518810272217,
        0.9237291216850281,
        -0.36372002959251404
      ],
      "plane_d": 3627.536376953125,
      "bbox_min": [
        -1531.3936767578125,
        -3753.7685546875,
        941.5729370117188
      ],
      "bbox_max": [
        -1507.296142578125,
        -3742.7685546875,
        951.0257568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7352702617645264,
        0.0,
        0.6777741312980652
      ],
      "plane_d": -1749.359619140625,
      "bbox_min": [
        -1510.4072265625,
        -3750.2685546875,
        942.5
      ],
      "bbox_max": [
        -1507.296142578125,
        -3742.7685546875,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.32010748982429504,
        0.9473812580108643
      ],
      "plane_d": -2090.22314453125,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1531.296142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09354790300130844,
        0.995614767074585
      ],
      "plane_d": -1288.2982177734375,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1531.296142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.22383302450180054,
        0.9746274948120117
      ],
      "plane_d": -1757.390869140625,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1534.856201171875,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7856389880180359,
        0.21981826424598694,
        0.5783175826072693
      ],
      "plane_d": -925.4896850585938,
      "bbox_min": [
        -1538.608642578125,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1534.856201171875,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12581677734851837,
        -0.8961225748062134,
        0.4255989193916321
      ],
      "plane_d": -3946.01220703125,
      "bbox_min": [
        -1535.2161865234375,
        -3745.128173828125,
        942.1198120117188
      ],
      "bbox_max": [
        -1531.7142333984375,
        -3738.2685546875,
        947.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011649972759187222,
        -0.09389030933380127,
        0.9955143928527832
      ],
      "plane_d": -1307.3695068359375,
      "bbox_min": [
        -1535.2161865234375,
        -3745.128173828125,
        942.1198120117188
      ],
      "bbox_max": [
        -1531.7142333984375,
        -3740.238525390625,
        942.5399780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7024253606796265,
        -0.588731586933136,
        0.3999922275543213
      ],
      "plane_d": -3656.027587890625,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.836460292339325,
        -0.2710267901420593,
        -0.4763176739215851
      ],
      "plane_d": -1844.27392578125,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7413915395736694,
        -0.2612878680229187,
        -0.6181159019470215
      ],
      "plane_d": -1526.8681640625,
      "bbox_min": [
        -1538.296142578125,
        -3749.77490234375,
        947.625
      ],
      "bbox_max": [
        -1531.4893798828125,
        -3728.5185546875,
        952.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06426788866519928,
        0.0914304107427597,
        -0.9937353730201721
      ],
      "plane_d": 1189.6009521484375,
      "bbox_min": [
        -1535.2161865234375,
        -3748.29736328125,
        947.625
      ],
      "bbox_max": [
        -1531.5609130859375,
        -3738.2685546875,
        952.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15906748175621033,
        -0.8647580146789551,
        -0.47633102536201477
      ],
      "plane_d": -3025.01318359375,
      "bbox_min": [
        -1535.2161865234375,
        -3740.70263671875,
        947.625
      ],
      "bbox_max": [
        -1531.9283447265625,
        -3738.2685546875,
        952.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06426788866519928,
        0.0914304107427597,
        -0.9937353730201721
      ],
      "plane_d": 1189.6009521484375,
      "bbox_min": [
        -1535.2161865234375,
        -3749.77490234375,
        951.1415405273438
      ],
      "bbox_max": [
        -1531.4893798828125,
        -3740.238525390625,
        952.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0975085198879242,
        0.09018269926309586,
        -0.9911403656005859
      ],
      "plane_d": 1131.4315185546875,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12069325894117355,
        0.14038754999637604,
        -0.9827128648757935
      ],
      "plane_d": 1275.5908203125,
      "bbox_min": [
        -1548.5999755859375,
        -3752.158447265625,
        950.828857421875
      ],
      "bbox_max": [
        -1531.389892578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11516054719686508,
        0.21279339492321014,
        -0.9702870845794678
      ],
      "plane_d": 1543.0672607421875,
      "bbox_min": [
        -1548.5999755859375,
        -3752.158447265625,
        950.828857421875
      ],
      "bbox_max": [
        -1531.389892578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 1584.97021484375,
      "bbox_min": [
        -1548.5999755859375,
        -3752.158447265625,
        950.828857421875
      ],
      "bbox_max": [
        -1531.389892578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06426788866519928,
        0.0914304107427597,
        -0.9937353730201721
      ],
      "plane_d": 1189.6009521484375,
      "bbox_min": [
        -1535.2161865234375,
        -3752.158447265625,
        950.828857421875
      ],
      "bbox_max": [
        -1531.389892578125,
        -3740.238525390625,
        952.260009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03297737240791321,
        0.0,
        -0.9994561672210693
      ],
      "plane_d": 900.0072021484375,
      "bbox_min": [
        -1534.856201171875,
        -3752.158447265625,
        950.9506225585938
      ],
      "bbox_max": [
        -1531.3922119140625,
        -3750.979248046875,
        951.1400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12013518810272217,
        0.9237291216850281,
        -0.36372002959251404
      ],
      "plane_d": 3627.536376953125,
      "bbox_min": [
        -1534.856201171875,
        -3752.158447265625,
        950.9506225585938
      ],
      "bbox_max": [
        -1531.3922119140625,
        -3751.753173828125,
        951.1400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12013518810272217,
        0.9237291216850281,
        -0.36372002959251404
      ],
      "plane_d": 3627.536376953125,
      "bbox_min": [
        -1534.856201171875,
        -3752.158447265625,
        950.828857421875
      ],
      "bbox_max": [
        -1531.389892578125,
        -3751.78271484375,
        951.1400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 2157.923828125,
      "bbox_min": [
        -1548.5999755859375,
        -3739.5185546875,
        954.0
      ],
      "bbox_max": [
        -1548.546142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 2157.923828125,
      "bbox_min": [
        -1548.5999755859375,
        -3739.5185546875,
        954.0
      ],
      "bbox_max": [
        -1548.546142578125,
        -3739.20458984375,
        954.0750732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11790303885936737,
        0.14043496549129486,
        -0.9830447435379028
      ],
      "plane_d": 1645.5621337890625,
      "bbox_min": [
        -1548.5999755859375,
        -3746.5185546875,
        953.0
      ],
      "bbox_max": [
        -1548.546142578125,
        -3739.385986328125,
        954.025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 2157.923828125,
      "bbox_min": [
        -1548.5999755859375,
        -3739.521484375,
        953.9931640625
      ],
      "bbox_max": [
        -1548.546142578125,
        -3739.385986328125,
        954.025634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.08342507481575012,
        0.12360234558582306,
        -0.9888187646865845
      ],
      "plane_d": 1276.235107421875,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3740.238525390625,
        953.02587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.084897980093956,
        0.3344936668872833,
        -0.9385661482810974
      ],
      "plane_d": 2017.474853515625,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3740.238525390625,
        953.02587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 1689.9024658203125,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        948.5
      ],
      "bbox_max": [
        -1538.608642578125,
        -3752.5185546875,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "bbox_max": [
        -1548.546142578125,
        -3752.5185546875,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6525701880455017,
        0.47845280170440674,
        -0.5875669121742249
      ],
      "plane_d": 1352.4876708984375,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3740.238525390625,
        953.02587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12013518810272217,
        0.9237291216850281,
        -0.36372002959251404
      ],
      "plane_d": 3627.536376953125,
      "bbox_min": [
        -1534.856201171875,
        -3753.7685546875,
        945.875
      ],
      "bbox_max": [
        -1531.296142578125,
        -3751.830322265625,
        951.1400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7140344381332397,
        0.24048978090286255,
        0.6575101613998413
      ],
      "plane_d": -812.57763671875,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3746.2919921875,
        953.02587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7856389880180359,
        0.21981826424598694,
        0.5783175826072693
      ],
      "plane_d": -925.4896850585938,
      "bbox_min": [
        -1537.7735595703125,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3750.979248046875,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12376256287097931,
        0.8975092768669128,
        0.4232729375362396
      ],
      "plane_d": 2779.16162109375,
      "bbox_min": [
        -1534.856201171875,
        -3753.7685546875,
        941.4199829101562
      ],
      "bbox_max": [
        -1531.296142578125,
        -3750.979248046875,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044131290167570114,
        0.0,
        0.9990256428718567
      ],
      "plane_d": -1008.2379150390625,
      "bbox_min": [
        -1534.856201171875,
        -3752.158447265625,
        941.4199829101562
      ],
      "bbox_max": [
        -1531.3936767578125,
        -3750.979248046875,
        941.5729370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08153200894594193,
        0.12362179160118103,
        -0.9889743328094482
      ],
      "plane_d": 1531.89990234375,
      "bbox_min": [
        -1548.5999755859375,
        -3752.690185546875,
        952.1936645507812
      ],
      "bbox_max": [
        -1548.546142578125,
        -3746.2919921875,
        953.02587890625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1548.5999755859375,
        -3752.690185546875,
        952.1936645507812
      ],
      "bbox_max": [
        -1548.546142578125,
        -3752.51708984375,
        952.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.010467521846294403,
        -0.09385613352060318,
        0.9955307245254517
      ],
      "plane_d": -1273.01953125,
      "bbox_min": [
        -1593.296142578125,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.22383302450180054,
        0.9746274948120117
      ],
      "plane_d": -1757.390869140625,
      "bbox_min": [
        -1562.55615234375,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7801473140716553,
        0.2481498122215271,
        0.5742750763893127
      ],
      "plane_d": 1609.4873046875,
      "bbox_min": [
        -1562.55615234375,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1558.483642578125,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7801473140716553,
        0.2481498122215271,
        0.5742750763893127
      ],
      "plane_d": 1609.4873046875,
      "bbox_min": [
        -1562.55615234375,
        -3760.5185546875,
        940.5975952148438
      ],
      "bbox_max": [
        -1559.2916259765625,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05776582658290863,
        0.09166227281093597,
        -0.9941132664680481
      ],
      "plane_d": 1379.734619140625,
      "bbox_min": [
        -1593.296142578125,
        -3760.5185546875,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.029601631686091423,
        0.0,
        -0.9995617866516113
      ],
      "plane_d": 996.9774169921875,
      "bbox_min": [
        -1590.2265625,
        -3754.233154296875,
        949.7849731445312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11263309419155121,
        0.21111740171909332,
        -0.970949649810791
      ],
      "plane_d": 1890.180908203125,
      "bbox_min": [
        -1562.55615234375,
        -3754.233154296875,
        951.1400146484375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09527356922626495,
        0.09026986360549927,
        -0.9913497567176819
      ],
      "plane_d": 1430.4896240234375,
      "bbox_min": [
        -1562.55615234375,
        -3754.233154296875,
        951.1400146484375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11790303885936737,
        0.14043496549129486,
        -0.9830447435379028
      ],
      "plane_d": 1645.5621337890625,
      "bbox_min": [
        -1562.1961669921875,
        -3746.493896484375,
        952.260009765625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 2157.923828125,
      "bbox_min": [
        -1556.233642578125,
        -3739.44140625,
        954.010498046875
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08153200894594193,
        0.12362179160118103,
        -0.9889743328094482
      ],
      "plane_d": 1531.89990234375,
      "bbox_min": [
        -1562.55615234375,
        -3754.233154296875,
        951.1400146484375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3746.540283203125,
        952.9928588867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802444070577621,
        0.9266340136528015,
        -0.36011117696762085
      ],
      "plane_d": 3988.18798828125,
      "bbox_min": [
        -1590.2265625,
        -3752.158447265625,
        949.7849731445312
      ],
      "bbox_max": [
        -1562.55615234375,
        -3743.74072265625,
        951.1400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865719199180603,
        0.0,
        -0.617498517036438
      ],
      "plane_d": 1837.3184814453125,
      "bbox_min": [
        -1590.2265625,
        -3749.7197265625,
        949.7849731445312
      ],
      "bbox_max": [
        -1587.5714111328125,
        -3743.74072265625,
        950.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1225382387638092,
        0.9452950358390808,
        -0.3023272156715393
      ],
      "plane_d": 4026.3134765625,
      "bbox_min": [
        -1590.2265625,
        -3749.7197265625,
        949.7849731445312
      ],
      "bbox_max": [
        -1587.5714111328125,
        -3749.29638671875,
        950.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14332911372184753,
        -0.8692939877510071,
        -0.47305887937545776
      ],
      "plane_d": -2576.983642578125,
      "bbox_min": [
        -1593.296142578125,
        -3760.5185546875,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        953.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6875588893890381,
        -0.6115307211875916,
        0.39152660965919495
      ],
      "plane_d": -1580.6815185546875,
      "bbox_min": [
        -1565.546142578125,
        -3740.238525390625,
        944.1647338867188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        953.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7189692854881287,
        -0.27710482478141785,
        -0.637413501739502
      ],
      "plane_d": 693.71630859375,
      "bbox_min": [
        -1565.546142578125,
        -3740.238525390625,
        944.1647338867188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        953.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8311151266098022,
        -0.29199230670928955,
        -0.473273903131485
      ],
      "plane_d": 656.923828125,
      "bbox_min": [
        -1562.1961669921875,
        -3740.238525390625,
        951.0
      ],
      "bbox_max": [
        -1557.3013916015625,
        -3728.5185546875,
        953.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.32010748982429504,
        0.9473812580108643
      ],
      "plane_d": -2090.22314453125,
      "bbox_min": [
        -1559.749755859375,
        -3735.429931640625,
        944.1647338867188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.32010748982429504,
        0.9473812580108643
      ],
      "plane_d": -2090.22314453125,
      "bbox_min": [
        -1565.546142578125,
        -3740.238525390625,
        942.5399780273438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3733.876953125,
        947.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1713758409023285,
        -0.9259745478630066,
        -0.33645424246788025
      ],
      "plane_d": -2874.412109375,
      "bbox_min": [
        -1593.296142578125,
        -3760.5185546875,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3738.198486328125,
        951.7596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11129294335842133,
        0.9010937213897705,
        0.41909876465797424
      ],
      "plane_d": 3160.400146484375,
      "bbox_min": [
        -1593.296142578125,
        -3760.5185546875,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3738.198486328125,
        951.7596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6592732667922974,
        0.5743206739425659,
        -0.4852983355522156
      ],
      "plane_d": 3647.515625,
      "bbox_min": [
        -1566.296142578125,
        -3760.5185546875,
        941.3113403320312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        950.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293290853500366,
        0.49560001492500305,
        -0.5986030697822571
      ],
      "plane_d": 3412.287109375,
      "bbox_min": [
        -1566.296142578125,
        -3760.5185546875,
        941.3113403320312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        950.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7801473140716553,
        0.2481498122215271,
        0.5742750763893127
      ],
      "plane_d": 1609.4873046875,
      "bbox_min": [
        -1562.55615234375,
        -3760.5185546875,
        941.3113403320312
      ],
      "bbox_max": [
        -1559.8170166015625,
        -3752.158447265625,
        944.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08296652138233185,
        0.3366177976131439,
        -0.9379792213439941
      ],
      "plane_d": 2284.832763671875,
      "bbox_min": [
        -1560.529541015625,
        -3760.5185546875,
        948.5
      ],
      "bbox_max": [
        -1554.349853515625,
        -3756.31884765625,
        950.0598754882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802444070577621,
        0.9266340136528015,
        -0.36011117696762085
      ],
      "plane_d": 3988.18798828125,
      "bbox_min": [
        -1593.296142578125,
        -3758.17578125,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3738.198486328125,
        951.7596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08296652138233185,
        0.3366177976131439,
        -0.9379792213439941
      ],
      "plane_d": 2284.832763671875,
      "bbox_min": [
        -1566.296142578125,
        -3758.17578125,
        945.875
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        951.7596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1554.3497314453125,
        -3758.17578125,
        950.0599975585938
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3753.60009765625,
        951.7596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293290853500366,
        0.49560001492500305,
        -0.5986030697822571
      ],
      "plane_d": 3412.287109375,
      "bbox_min": [
        -1566.296142578125,
        -3756.31884765625,
        945.875
      ],
      "bbox_max": [
        -1560.529541015625,
        -3752.158447265625,
        951.1400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1225382387638092,
        0.9452950358390808,
        -0.3023272156715393
      ],
      "plane_d": 4026.3134765625,
      "bbox_min": [
        -1593.296142578125,
        -3753.7685546875,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3738.198486328125,
        950.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09354790300130844,
        0.995614767074585
      ],
      "plane_d": -1288.2982177734375,
      "bbox_min": [
        -1593.296142578125,
        -3753.242431640625,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3738.198486328125,
        950.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.22383302450180054,
        0.9746274948120117
      ],
      "plane_d": -1757.390869140625,
      "bbox_min": [
        -1562.55615234375,
        -3753.242431640625,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.32010748982429504,
        0.9473812580108643
      ],
      "plane_d": -2090.22314453125,
      "bbox_min": [
        -1593.296142578125,
        -3750.2685546875,
        942.5
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3738.198486328125,
        950.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865719199180603,
        0.0,
        -0.617498517036438
      ],
      "plane_d": 1837.3184814453125,
      "bbox_min": [
        -1593.296142578125,
        -3750.2685546875,
        942.5
      ],
      "bbox_max": [
        -1589.796142578125,
        -3742.7685546875,
        950.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6941356062889099,
        0.0,
        0.7198443412780762
      ],
      "plane_d": 425.08087158203125,
      "bbox_min": [
        -1593.296142578125,
        -3750.2685546875,
        942.5
      ],
      "bbox_max": [
        -1589.796142578125,
        -3742.7685546875,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00319180591031909,
        0.038808442652225494,
        -0.9992415904998779
      ],
      "plane_d": 1096.5477294921875,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        935.0
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10515309125185013,
        4.5654909627046436e-05,
        -0.9944560527801514
      ],
      "plane_d": 779.0877685546875,
      "bbox_min": [
        -1548.5999755859375,
        -3783.485595703125,
        945.53125
      ],
      "bbox_max": [
        -1535.49609375,
        -3760.5185546875,
        950.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.08538037538528442,
        0.038680899888277054,
        -0.995597243309021
      ],
      "plane_d": 956.6168823242188,
      "bbox_min": [
        -1548.5999755859375,
        -3781.237060546875,
        945.6199951171875
      ],
      "bbox_max": [
        -1535.49609375,
        -3760.5185546875,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11559368669986725,
        0.2340877205133438,
        -0.9653190970420837
      ],
      "plane_d": 1618.04296875,
      "bbox_min": [
        -1548.5999755859375,
        -3774.5185546875,
        946.0999755859375
      ],
      "bbox_max": [
        -1535.49609375,
        -3760.5185546875,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12114037573337555,
        0.12312126159667969,
        -0.9849700927734375
      ],
      "plane_d": 1209.898681640625,
      "bbox_min": [
        -1548.5999755859375,
        -3774.5185546875,
        946.0999755859375
      ],
      "bbox_max": [
        -1535.49609375,
        -3760.5185546875,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 1689.90234375,
      "bbox_min": [
        -1548.5999755859375,
        -3768.5185546875,
        947.75
      ],
      "bbox_max": [
        -1538.608642578125,
        -3760.5185546875,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1548.5999755859375,
        -3768.5185546875,
        947.75
      ],
      "bbox_max": [
        -1548.546142578125,
        -3760.5185546875,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12114039808511734,
        0.12312127649784088,
        -0.984970211982727
      ],
      "plane_d": 1585.081787109375,
      "bbox_min": [
        -1548.5999755859375,
        -3774.5185546875,
        947.0
      ],
      "bbox_max": [
        -1548.546142578125,
        -3768.5185546875,
        947.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7986526489257812,
        -0.1285722702741623,
        -0.5878971219062805
      ],
      "plane_d": -1154.6917724609375,
      "bbox_min": [
        -1548.5999755859375,
        -3768.878662109375,
        946.0999755859375
      ],
      "bbox_max": [
        -1535.49609375,
        -3760.5185546875,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1548.5999755859375,
        -3768.6298828125,
        947.7294311523438
      ],
      "bbox_max": [
        -1548.546142578125,
        -3768.142333984375,
        947.8477172851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.12114039808511734,
        0.12312127649784088,
        -0.984970211982727
      ],
      "plane_d": 1585.081787109375,
      "bbox_min": [
        -1548.5999755859375,
        -3768.6298828125,
        947.7294311523438
      ],
      "bbox_max": [
        -1548.546142578125,
        -3768.5185546875,
        947.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7986526489257812,
        -0.1285722702741623,
        -0.5878971219062805
      ],
      "plane_d": -1154.6917724609375,
      "bbox_min": [
        -1537.1878662109375,
        -3768.878662109375,
        946.0999755859375
      ],
      "bbox_max": [
        -1535.49609375,
        -3760.5185546875,
        946.5698852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1051652655005455,
        -4.565951167023741e-05,
        -0.9944547414779663
      ],
      "plane_d": 1104.4295654296875,
      "bbox_min": [
        -1548.5999755859375,
        -3783.485595703125,
        945.53125
      ],
      "bbox_max": [
        -1535.498046875,
        -3774.419677734375,
        947.0057373046875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.12114039808511734,
        0.12312127649784088,
        -0.984970211982727
      ],
      "plane_d": 1585.081787109375,
      "bbox_min": [
        -1548.5999755859375,
        -3774.5185546875,
        946.9962768554688
      ],
      "bbox_max": [
        -1548.546142578125,
        -3774.419677734375,
        947.0057373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13491591811180115,
        0.03851613402366638,
        -0.9901081919670105
      ],
      "plane_d": 874.7416381835938,
      "bbox_min": [
        -1538.14208984375,
        -3783.485595703125,
        945.53125
      ],
      "bbox_max": [
        -1535.498046875,
        -3781.237060546875,
        945.8993530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7845215797424316,
        0.1797778606414795,
        -0.5934693217277527
      ],
      "plane_d": 36.3477783203125,
      "bbox_min": [
        -1535.9979248046875,
        -3783.485595703125,
        945.53125
      ],
      "bbox_max": [
        -1535.498046875,
        -3781.237060546875,
        945.6199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16778841614723206,
        0.8320190906524658,
        -0.5287640690803528
      ],
      "plane_d": 3388.432373046875,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        935.0
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        946.4196166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7845215797424316,
        0.1797778606414795,
        -0.5934693217277527
      ],
      "plane_d": 36.3477783203125,
      "bbox_min": [
        -1535.9462890625,
        -3783.766357421875,
        940.625
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.237060546875,
        945.6199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014132714830338955,
        -0.0,
        -0.9999001026153564
      ],
      "plane_d": 924.3047485351562,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        935.0
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        946.4196166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7986526489257812,
        -0.1285722702741623,
        -0.5878971219062805
      ],
      "plane_d": -1154.6917724609375,
      "bbox_min": [
        -1537.0772705078125,
        -3768.878662109375,
        946.0999755859375
      ],
      "bbox_max": [
        -1535.49609375,
        -3760.5185546875,
        946.4196166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26244068145751953,
        0.9050397872924805,
        -0.33470574021339417
      ],
      "plane_d": 3337.15380859375,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        935.0
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        946.1192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11071637272834778,
        0.9938520789146423
      ],
      "plane_d": -1347.8997802734375,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        935.0
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        946.1192016601562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.006360067054629326,
        0.0,
        0.9999798536300659
      ],
      "plane_d": -946.1270141601562,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        935.0
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        946.1192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.023662636056542397,
        -0.03879454359412193,
        0.9989670515060425
      ],
      "plane_d": -1117.9586181640625,
      "bbox_min": [
        -1548.5999755859375,
        -3783.505126953125,
        935.0
      ],
      "bbox_max": [
        -1516.6295166015625,
        -3768.878662109375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06866054236888885,
        -0.03870672360062599,
        0.9968889355659485
      ],
      "plane_d": -1184.7757568359375,
      "bbox_min": [
        -1548.5999755859375,
        -3783.343994140625,
        935.0
      ],
      "bbox_max": [
        -1535.49609375,
        -3768.878662109375,
        936.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06879869848489761,
        6.067194408387877e-05,
        0.9976305961608887
      ],
      "plane_d": -1039.0933837890625,
      "bbox_min": [
        -1548.5999755859375,
        -3783.343994140625,
        935.0
      ],
      "bbox_max": [
        -1535.498046875,
        -3781.237060546875,
        935.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12309727072715759,
        0.06976791471242905,
        0.9899391531944275
      ],
      "plane_d": -851.690673828125,
      "bbox_min": [
        -1548.5999755859375,
        -3783.343994140625,
        935.0
      ],
      "bbox_max": [
        -1535.498046875,
        -3781.237060546875,
        935.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14920414984226227,
        -0.0001315796107519418,
        0.9888064861297607
      ],
      "plane_d": -693.981689453125,
      "bbox_min": [
        -1548.5999755859375,
        -3782.516357421875,
        935.0
      ],
      "bbox_max": [
        -1548.549072265625,
        -3781.261474609375,
        935.0076904296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7601984739303589,
        0.19578887522220612,
        0.6194876432418823
      ],
      "plane_d": -1006.7376098632812,
      "bbox_min": [
        -1535.9979248046875,
        -3783.505126953125,
        935.9000244140625
      ],
      "bbox_max": [
        -1535.171630859375,
        -3781.237060546875,
        936.382080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18652649223804474,
        0.8080337643623352,
        0.5588284730911255
      ],
      "plane_d": 2245.948486328125,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        936.3787841796875
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        946.1192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7601984739303589,
        0.19578887522220612,
        0.6194876432418823
      ],
      "plane_d": -1006.7376098632812,
      "bbox_min": [
        -1535.692138671875,
        -3783.766357421875,
        936.3787841796875
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.4951171875,
        940.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2889784574508667,
        0.9028493762016296,
        0.3183622658252716
      ],
      "plane_d": 2673.91015625,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        936.3800048828125
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        946.1192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14275212585926056,
        -0.9033278226852417,
        -0.40450042486190796
      ],
      "plane_d": -3241.030517578125,
      "bbox_min": [
        -1548.5999755859375,
        -3778.2685546875,
        936.3800048828125
      ],
      "bbox_max": [
        -1514.296142578125,
        -3760.5185546875,
        946.1192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3496447801589966,
        0.9368823170661926
      ],
      "plane_d": -2195.046630859375,
      "bbox_min": [
        -1548.5999755859375,
        -3768.878662109375,
        937.8456420898438
      ],
      "bbox_max": [
        -1532.296142578125,
        -3760.5185546875,
        946.1192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8003882765769958,
        -0.1279698610305786,
        -0.5856640934944153
      ],
      "plane_d": -1157.1990966796875,
      "bbox_min": [
        -1538.608642578125,
        -3768.878662109375,
        937.8456420898438
      ],
      "bbox_max": [
        -1532.296142578125,
        -3760.5185546875,
        946.1192016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14085324108600616,
        -0.912384569644928,
        0.38433682918548584
      ],
      "plane_d": -4014.83154296875,
      "bbox_min": [
        -1548.5999755859375,
        -3778.2685546875,
        936.3800048828125
      ],
      "bbox_max": [
        -1514.296142578125,
        -3763.375244140625,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3496447801589966,
        0.9368823170661926
      ],
      "plane_d": -2195.046630859375,
      "bbox_min": [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      "bbox_max": [
        -1532.296142578125,
        -3763.375244140625,
        941.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18210619688034058,
        -0.9365461468696594,
        -0.2995308041572571
      ],
      "plane_d": -3525.29052734375,
      "bbox_min": [
        -1548.5999755859375,
        -3778.2685546875,
        936.3800048828125
      ],
      "bbox_max": [
        -1514.296142578125,
        -3766.478271484375,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3496447801589966,
        0.9368823170661926
      ],
      "plane_d": -2195.046630859375,
      "bbox_min": [
        -1548.5999755859375,
        -3778.2685546875,
        936.3800048828125
      ],
      "bbox_max": [
        -1514.296142578125,
        -3766.478271484375,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9020007848739624,
        0.0,
        0.4317344129085541
      ],
      "plane_d": -1772.3203125,
      "bbox_min": [
        -1516.6295166015625,
        -3778.2685546875,
        936.5
      ],
      "bbox_max": [
        -1514.296142578125,
        -3770.7685546875,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8859893679618835,
        -0.0,
        -0.46370556950569153
      ],
      "plane_d": -905.12939453125,
      "bbox_min": [
        -1516.6295166015625,
        -3778.2685546875,
        941.375
      ],
      "bbox_max": [
        -1514.296142578125,
        -3770.7685546875,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012872917577624321,
        -0.04297379404306412,
        0.9989932179450989
      ],
      "plane_d": -1077.2979736328125,
      "bbox_min": [
        -1582.796142578125,
        -3782.512451171875,
        935.0035400390625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06472378969192505,
        -0.042895738035440445,
        0.9969807863235474
      ],
      "plane_d": -994.1493530273438,
      "bbox_min": [
        -1561.5980224609375,
        -3782.512451171875,
        935.0035400390625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11071637272834778,
        0.9938520789146423
      ],
      "plane_d": -1347.8997802734375,
      "bbox_min": [
        -1561.5980224609375,
        -3782.512451171875,
        935.0035400390625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07857740670442581,
        0.10855977982282639,
        0.9909794926643372
      ],
      "plane_d": -394.3914794921875,
      "bbox_min": [
        -1561.5980224609375,
        -3782.512451171875,
        935.0035400390625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3780.037109375,
        935.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14920414984226227,
        -0.0001315796107519418,
        0.9888064861297607
      ],
      "plane_d": -693.981689453125,
      "bbox_min": [
        -1550.2620849609375,
        -3782.512451171875,
        935.0075073242188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3781.299560546875,
        935.25830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14578033983707428,
        0.9289018511772156,
        0.3404252529144287
      ],
      "plane_d": 3420.32958984375,
      "bbox_min": [
        -1582.796142578125,
        -3782.512451171875,
        935.7698364257812
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7348045706748962,
        0.3407658636569977,
        0.5864648222923279
      ],
      "plane_d": 1886.70458984375,
      "bbox_min": [
        -1564.799072265625,
        -3781.829345703125,
        935.7698364257812
      ],
      "bbox_max": [
        -1557.4801025390625,
        -3780.037109375,
        940.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07857740670442581,
        0.10855977982282639,
        0.9909794926643372
      ],
      "plane_d": -394.3914794921875,
      "bbox_min": [
        -1561.5980224609375,
        -3781.829345703125,
        935.7698364257812
      ],
      "bbox_max": [
        -1557.4801025390625,
        -3780.037109375,
        936.018310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16914314031600952,
        0.947891354560852,
        0.26998642086982727
      ],
      "plane_d": 3594.94873046875,
      "bbox_min": [
        -1582.796142578125,
        -3782.512451171875,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13288715481758118,
        0.9392994046211243,
        -0.31631872057914734
      ],
      "plane_d": 4057.22021484375,
      "bbox_min": [
        -1582.796142578125,
        -3782.512451171875,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11055321246385574,
        0.059829164296388626,
        -0.992067813873291
      ],
      "plane_d": 1336.915283203125,
      "bbox_min": [
        -1564.799072265625,
        -3782.512451171875,
        940.625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3780.037109375,
        946.9924926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14920414984226227,
        -0.0001315796107519418,
        -0.9888064861297607
      ],
      "plane_d": 1166.9521484375,
      "bbox_min": [
        -1550.2620849609375,
        -3782.512451171875,
        946.74169921875
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3781.39990234375,
        946.9924926757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7341867685317993,
        0.3785039484500885,
        -0.5636529326438904
      ],
      "plane_d": 3110.26513671875,
      "bbox_min": [
        -1564.799072265625,
        -3781.5595703125,
        940.625
      ],
      "bbox_max": [
        -1560.986328125,
        -3780.037109375,
        945.6199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8016875982284546,
        0.3298177421092987,
        -0.49851512908935547
      ],
      "plane_d": 2970.04296875,
      "bbox_min": [
        -1561.645751953125,
        -3781.5595703125,
        944.5693969726562
      ],
      "bbox_max": [
        -1560.986328125,
        -3780.037109375,
        945.6199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14609049260616302,
        0.9478827714920044,
        -0.28315305709838867
      ],
      "plane_d": 4079.140380859375,
      "bbox_min": [
        -1582.796142578125,
        -3781.413818359375,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007601691875606775,
        0.042972758412361145,
        -0.9990473389625549
      ],
      "plane_d": 1119.0284423828125,
      "bbox_min": [
        -1582.796142578125,
        -3781.413818359375,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011307028122246265,
        0.0,
        -0.9999359846115112
      ],
      "plane_d": 927.9024047851562,
      "bbox_min": [
        -1580.589599609375,
        -3781.413818359375,
        945.5909423828125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08713734894990921,
        0.0427975095808506,
        -0.9952765703201294
      ],
      "plane_d": 1239.0030517578125,
      "bbox_min": [
        -1561.5980224609375,
        -3781.413818359375,
        945.6199951171875
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1051652655005455,
        -4.565951167023741e-05,
        -0.9944547414779663
      ],
      "plane_d": 1104.4295654296875,
      "bbox_min": [
        -1561.5980224609375,
        -3781.413818359375,
        945.6199951171875
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11559368669986725,
        0.2340877205133438,
        -0.9653190970420837
      ],
      "plane_d": 1976.0472412109375,
      "bbox_min": [
        -1561.59619140625,
        -3774.495361328125,
        946.0999755859375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12114039808511734,
        0.12312127649784088,
        -0.984970211982727
      ],
      "plane_d": 1585.081787109375,
      "bbox_min": [
        -1561.59619140625,
        -3774.495361328125,
        946.0999755859375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1558.483642578125,
        -3768.47509765625,
        947.7540893554688
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.798652708530426,
        -0.1285722553730011,
        -0.5878971219062805
      ],
      "plane_d": 1318.8092041015625,
      "bbox_min": [
        -1561.59619140625,
        -3768.878662109375,
        946.0999755859375
      ],
      "bbox_max": [
        -1559.8748779296875,
        -3760.5185546875,
        946.610107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8859893679618835,
        0.0,
        -0.46370556950569153
      ],
      "plane_d": 1838.8614501953125,
      "bbox_min": [
        -1580.589599609375,
        -3777.34912109375,
        945.5909423828125
      ],
      "bbox_max": [
        -1580.4627685546875,
        -3771.74072265625,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3496447801589966,
        0.9368823170661926
      ],
      "plane_d": -2195.046630859375,
      "bbox_min": [
        -1564.796142578125,
        -3768.878662109375,
        937.845703125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        946.4718017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8003882169723511,
        -0.1279698610305786,
        -0.5856640338897705
      ],
      "plane_d": 1321.677001953125,
      "bbox_min": [
        -1564.796142578125,
        -3768.878662109375,
        937.845703125
      ],
      "bbox_max": [
        -1558.483642578125,
        -3760.5185546875,
        946.4718017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14085324108600616,
        -0.912384569644928,
        0.38433682918548584
      ],
      "plane_d": -3578.596435546875,
      "bbox_min": [
        -1582.796142578125,
        -3778.2685546875,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3763.3896484375,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3496447801589966,
        0.9368823170661926
      ],
      "plane_d": -2195.046630859375,
      "bbox_min": [
        -1564.796142578125,
        -3768.878662109375,
        936.3800048828125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3763.3896484375,
        941.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18210619688034058,
        -0.9365461468696594,
        -0.2995308041572571
      ],
      "plane_d": -2961.291015625,
      "bbox_min": [
        -1582.796142578125,
        -3778.2685546875,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3766.498291015625,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3496447801589966,
        0.9368823170661926
      ],
      "plane_d": -2195.046630859375,
      "bbox_min": [
        -1582.796142578125,
        -3778.2685546875,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3766.498291015625,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11071637272834778,
        0.9938520789146423
      ],
      "plane_d": -1347.8997802734375,
      "bbox_min": [
        -1582.796142578125,
        -3778.2685546875,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3768.878662109375,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9020007848739624,
        0.0,
        0.4317344129085541
      ],
      "plane_d": 1021.2593994140625,
      "bbox_min": [
        -1582.796142578125,
        -3778.2685546875,
        936.5
      ],
      "bbox_max": [
        -1580.4627685546875,
        -3770.7685546875,
        945.8333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13491591811180115,
        0.03851613402366638,
        -0.9901081919670105
      ],
      "plane_d": 874.7416381835938,
      "bbox_min": [
        -1564.799072265625,
        -3796.509521484375,
        935.0
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.266357421875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12309727072715759,
        0.06976791471242905,
        0.9899391531944275
      ],
      "plane_d": -851.690673828125,
      "bbox_min": [
        -1564.799072265625,
        -3796.509521484375,
        935.0
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.266357421875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7720683813095093,
        0.16424083709716797,
        -0.6139506101608276
      ],
      "plane_d": 15.9066162109375,
      "bbox_min": [
        -1564.799072265625,
        -3796.509521484375,
        935.0
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.266357421875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622888088226318,
        0.19813089072704315,
        0.6161656379699707
      ],
      "plane_d": -997.9542846679688,
      "bbox_min": [
        -1564.799072265625,
        -3796.509521484375,
        935.0
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.266357421875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7601984739303589,
        0.19578887522220612,
        0.6194876432418823
      ],
      "plane_d": -1006.7376098632812,
      "bbox_min": [
        -1564.799072265625,
        -3795.259521484375,
        935.0
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.266357421875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06879869848489761,
        6.067194408387877e-05,
        0.9976305961608887
      ],
      "plane_d": -1039.0933837890625,
      "bbox_min": [
        -1564.799072265625,
        -3791.509521484375,
        935.0
      ],
      "bbox_max": [
        -1538.14208984375,
        -3781.266357421875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11055321246385574,
        0.059829164296388626,
        -0.992067813873291
      ],
      "plane_d": 1336.915283203125,
      "bbox_min": [
        -1564.799072265625,
        -3791.509521484375,
        935.0
      ],
      "bbox_max": [
        -1548.5501708984375,
        -3781.266357421875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14920414984226227,
        -0.0001315796107519418,
        -0.9888064861297607
      ],
      "plane_d": 1166.9521484375,
      "bbox_min": [
        -1558.49560546875,
        -3791.509521484375,
        945.5
      ],
      "bbox_max": [
        -1548.5501708984375,
        -3782.384521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07857740670442581,
        0.10855977982282639,
        0.9909794926643372
      ],
      "plane_d": -394.3914794921875,
      "bbox_min": [
        -1564.799072265625,
        -3791.509521484375,
        935.0
      ],
      "bbox_max": [
        -1548.5501708984375,
        -3781.266357421875,
        945.5963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14920414984226227,
        -0.0001315796107519418,
        0.9888064861297607
      ],
      "plane_d": -693.981689453125,
      "bbox_min": [
        -1558.49560546875,
        -3791.509521484375,
        935.0
      ],
      "bbox_max": [
        -1548.5501708984375,
        -3782.384521484375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7348045706748962,
        0.3407658636569977,
        0.5864648222923279
      ],
      "plane_d": 1886.70458984375,
      "bbox_min": [
        -1564.799072265625,
        -3787.759521484375,
        936.018310546875
      ],
      "bbox_max": [
        -1558.49560546875,
        -3781.266357421875,
        945.5963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8016875982284546,
        0.3298177421092987,
        -0.49851512908935547
      ],
      "plane_d": 2970.04296875,
      "bbox_min": [
        -1564.799072265625,
        -3787.759521484375,
        940.625
      ],
      "bbox_max": [
        -1558.49560546875,
        -3781.266357421875,
        945.5963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028995314612984657,
        0.06643924117088318,
        0.9973690509796143
      ],
      "plane_d": -725.2152099609375,
      "bbox_min": [
        -1590.5830078125,
        -3819.2080078125,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3786.509521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06473939120769501,
        -0.005935287103056908,
        0.9978845715522766
      ],
      "plane_d": -1058.371337890625,
      "bbox_min": [
        -1587.0760498046875,
        -3819.2080078125,
        935.0
      ],
      "bbox_max": [
        -1574.5142822265625,
        -3812.9580078125,
        935.751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06473939120769501,
        -0.005935287103056908,
        -0.9978845715522766
      ],
      "plane_d": 819.6474609375,
      "bbox_min": [
        -1587.076416015625,
        -3819.2080078125,
        946.2487182617188
      ],
      "bbox_max": [
        -1574.513427734375,
        -3812.9580078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06473939120769501,
        -0.005935287103056908,
        0.9978845715522766
      ],
      "plane_d": -1058.371337890625,
      "bbox_min": [
        -1587.1258544921875,
        -3818.942138671875,
        935.0
      ],
      "bbox_max": [
        -1562.9969482421875,
        -3812.9580078125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06473912298679352,
        0.005935261957347393,
        0.9978845715522766
      ],
      "plane_d": -807.67333984375,
      "bbox_min": [
        -1587.1258544921875,
        -3813.6298828125,
        935.0
      ],
      "bbox_max": [
        -1586.64208984375,
        -3812.9580078125,
        935.0337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03280504792928696,
        0.12446453422307968,
        -0.9916815757751465
      ],
      "plane_d": 1361.650634765625,
      "bbox_min": [
        -1590.5830078125,
        -3818.942138671875,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3786.509521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06473939120769501,
        -0.005935287103056908,
        -0.9978845715522766
      ],
      "plane_d": 819.6474609375,
      "bbox_min": [
        -1587.1258544921875,
        -3818.942138671875,
        945.5
      ],
      "bbox_max": [
        -1562.9969482421875,
        -3812.9580078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06473912298679352,
        0.005935261957347393,
        -0.9978845715522766
      ],
      "plane_d": 1070.345458984375,
      "bbox_min": [
        -1587.1258544921875,
        -3813.627685546875,
        946.9662475585938
      ],
      "bbox_max": [
        -1586.64208984375,
        -3812.9580078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 947.0,
      "bbox_min": [
        -1590.5830078125,
        -3818.67724609375,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3786.509521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -935.0,
      "bbox_min": [
        -1590.5830078125,
        -3818.67724609375,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3786.509521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.023211762309074402,
        -0.19621102511882782,
        -0.9802869558334351
      ],
      "plane_d": 218.77220153808594,
      "bbox_min": [
        -1590.5830078125,
        -3818.67724609375,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3786.509521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020992744714021683,
        -0.19152912497520447,
        -0.9812623858451843
      ],
      "plane_d": 233.98228454589844,
      "bbox_min": [
        -1590.1461181640625,
        -3804.214111328125,
        944.3286743164062
      ],
      "bbox_max": [
        -1542.1624755859375,
        -3787.43408203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10578218847513199,
        -0.11477456986904144,
        -0.9877434372901917
      ],
      "plane_d": 664.0339965820312,
      "bbox_min": [
        -1590.14111328125,
        -3804.214111328125,
        944.3470458984375
      ],
      "bbox_max": [
        -1542.1624755859375,
        -3787.439208984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09262727946043015,
        -0.11491353064775467,
        -0.9890475273132324
      ],
      "plane_d": 644.23876953125,
      "bbox_min": [
        -1590.14111328125,
        -3804.214111328125,
        945.3919677734375
      ],
      "bbox_max": [
        -1558.49560546875,
        -3787.759521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06439700722694397,
        -0.20962128043174744,
        -0.9756597876548767
      ],
      "plane_d": 24.222976684570312,
      "bbox_min": [
        -1590.14111328125,
        -3804.214111328125,
        945.4871215820312
      ],
      "bbox_max": [
        -1588.3330078125,
        -3796.6552734375,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511857360601425,
        -0.9976769685745239
      ],
      "plane_d": 1224.299072265625,
      "bbox_min": [
        -1590.14111328125,
        -3804.214111328125,
        945.4871215820312
      ],
      "bbox_max": [
        -1588.3330078125,
        -3796.6552734375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29423192143440247,
        -0.8022502660751343,
        -0.519443929195404
      ],
      "plane_d": -3022.610595703125,
      "bbox_min": [
        -1590.14111328125,
        -3796.7080078125,
        945.4871215820312
      ],
      "bbox_max": [
        -1590.0205078125,
        -3796.6552734375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5193804502487183,
        -0.6443440318107605,
        -0.5613061785697937
      ],
      "plane_d": -1100.453125,
      "bbox_min": [
        -1566.3829345703125,
        -3794.1171875,
        945.3919677734375
      ],
      "bbox_max": [
        -1558.49560546875,
        -3787.759521484375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13314411044120789,
        0.04322950169444084,
        -0.9901534914970398
      ],
      "plane_d": 895.3989868164062,
      "bbox_min": [
        -1548.55810546875,
        -3797.84375,
        946.0346069335938
      ],
      "bbox_max": [
        -1542.1624755859375,
        -3791.509521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09559687972068787,
        -0.8721863627433777,
        -0.47974175214767456
      ],
      "plane_d": -2705.84033203125,
      "bbox_min": [
        -1590.1461181640625,
        -3796.7080078125,
        944.3286743164062
      ],
      "bbox_max": [
        -1559.34423828125,
        -3787.43408203125,
        945.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3313077688217163,
        -0.8417611718177795,
        -0.42623159289360046
      ],
      "plane_d": -3319.70556640625,
      "bbox_min": [
        -1590.1461181640625,
        -3796.7080078125,
        945.4398803710938
      ],
      "bbox_max": [
        -1590.0205078125,
        -3796.628173828125,
        945.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.02099275216460228,
        -0.19152911007404327,
        0.9812623858451843
      ],
      "plane_d": -1612.75341796875,
      "bbox_min": [
        -1590.1461181640625,
        -3804.213623046875,
        935.0
      ],
      "bbox_max": [
        -1542.16259765625,
        -3787.43408203125,
        937.6712646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10578218847513199,
        -0.11477456986904144,
        0.9877434372901917
      ],
      "plane_d": -1194.899169921875,
      "bbox_min": [
        -1590.14111328125,
        -3804.213623046875,
        935.0
      ],
      "bbox_max": [
        -1542.16259765625,
        -3787.439208984375,
        937.65283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09262727946043015,
        -0.11491353064775467,
        0.9890475273132324
      ],
      "plane_d": -1217.148681640625,
      "bbox_min": [
        -1590.14111328125,
        -3804.213623046875,
        935.0
      ],
      "bbox_max": [
        -1558.49560546875,
        -3787.759521484375,
        936.6080932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06439700722694397,
        -0.20962128043174744,
        0.9756597876548767
      ],
      "plane_d": -1811.96875,
      "bbox_min": [
        -1590.14111328125,
        -3804.213623046875,
        935.0
      ],
      "bbox_max": [
        -1588.3330078125,
        -3796.655517578125,
        936.5128173828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511858105659485,
        0.9976769089698792
      ],
      "plane_d": -653.3289184570312,
      "bbox_min": [
        -1590.14111328125,
        -3804.213623046875,
        935.0
      ],
      "bbox_max": [
        -1588.3330078125,
        -3796.655517578125,
        936.5128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29423192143440247,
        -0.8022502660751343,
        0.519443929195404
      ],
      "plane_d": -4000.203857421875,
      "bbox_min": [
        -1590.14111328125,
        -3796.7080078125,
        936.5
      ],
      "bbox_max": [
        -1590.0205078125,
        -3796.655517578125,
        936.5128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5193803906440735,
        -0.6443440914154053,
        0.5613062381744385
      ],
      "plane_d": -2156.831787109375,
      "bbox_min": [
        -1566.3829345703125,
        -3794.1171875,
        936.5
      ],
      "bbox_max": [
        -1558.49560546875,
        -3787.759521484375,
        936.6080932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1331440955400467,
        0.04322949796915054,
        0.9901533722877502
      ],
      "plane_d": -968.0697021484375,
      "bbox_min": [
        -1548.55810546875,
        -3797.843505859375,
        935.0
      ],
      "bbox_max": [
        -1542.16259765625,
        -3791.509521484375,
        935.96533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09559687972068787,
        -0.8721863627433777,
        0.47974175214767456
      ],
      "plane_d": -3608.714111328125,
      "bbox_min": [
        -1590.1461181640625,
        -3796.7080078125,
        936.5
      ],
      "bbox_max": [
        -1559.34423828125,
        -3787.43408203125,
        937.6712646484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3313077688217163,
        -0.8417611718177795,
        0.42623159289360046
      ],
      "plane_d": -4121.87353515625,
      "bbox_min": [
        -1590.1461181640625,
        -3796.7080078125,
        936.5
      ],
      "bbox_max": [
        -1590.0205078125,
        -3796.628173828125,
        936.56005859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09559687972068787,
        -0.8721863627433777,
        0.47974175214767456
      ],
      "plane_d": -3608.714111328125,
      "bbox_min": [
        -1590.5830078125,
        -3796.682373046875,
        936.5
      ],
      "bbox_max": [
        -1559.3577880859375,
        -3786.509521484375,
        944.609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5193803906440735,
        -0.6443440914154053,
        0.5613062381744385
      ],
      "plane_d": -2156.831787109375,
      "bbox_min": [
        -1590.5830078125,
        -3796.682373046875,
        936.5
      ],
      "bbox_max": [
        -1559.3577880859375,
        -3786.509521484375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3313077688217163,
        -0.8417611718177795,
        0.42623159289360046
      ],
      "plane_d": -4121.87353515625,
      "bbox_min": [
        -1590.5830078125,
        -3796.682373046875,
        936.5462646484375
      ],
      "bbox_max": [
        -1590.0262451171875,
        -3794.2080078125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5193804502487183,
        -0.6443440318107605,
        -0.5613061785697937
      ],
      "plane_d": -1100.453125,
      "bbox_min": [
        -1564.0093994140625,
        -3790.170166015625,
        941.0
      ],
      "bbox_max": [
        -1559.3577880859375,
        -3786.509521484375,
        944.609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5193804502487183,
        -0.6443440318107605,
        -0.5613061785697937
      ],
      "plane_d": -1100.453125,
      "bbox_min": [
        -1590.5830078125,
        -3796.68212890625,
        941.0
      ],
      "bbox_max": [
        -1561.041259765625,
        -3789.03564453125,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48365578055381775,
        -0.6424489617347717,
        -0.5944210290908813
      ],
      "plane_d": -1117.911376953125,
      "bbox_min": [
        -1590.5830078125,
        -3796.68212890625,
        941.0
      ],
      "bbox_max": [
        -1564.0093994140625,
        -3790.170166015625,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3313077688217163,
        -0.8417611718177795,
        -0.42623159289360046
      ],
      "plane_d": -3319.70556640625,
      "bbox_min": [
        -1590.5830078125,
        -3796.68212890625,
        941.0
      ],
      "bbox_max": [
        -1590.0263671875,
        -3794.2080078125,
        945.45361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424452424049377,
        0.2927165925502777,
        0.7874453663825989
      ],
      "plane_d": -461.12457275390625,
      "bbox_min": [
        -1588.7762451171875,
        -3818.67724609375,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3793.9228515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424452424049377,
        0.2927165925502777,
        -0.7874453663825989
      ],
      "plane_d": 1020.84765625,
      "bbox_min": [
        -1588.7762451171875,
        -3818.67724609375,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3793.9228515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3657768666744232,
        0.7139313817024231,
        0.5970839858055115
      ],
      "plane_d": 1595.396240234375,
      "bbox_min": [
        -1588.7762451171875,
        -3818.67724609375,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3793.9228515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3657768666744232,
        0.7139313220977783,
        -0.5970839858055115
      ],
      "plane_d": 2719.10791015625,
      "bbox_min": [
        -1588.7762451171875,
        -3818.67724609375,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3793.9228515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1331440955400467,
        0.04322949796915054,
        0.9901533722877502
      ],
      "plane_d": -968.0697021484375,
      "bbox_min": [
        -1588.7762451171875,
        -3818.50048828125,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3793.9228515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13314411044120789,
        0.04322950169444084,
        -0.9901534914970398
      ],
      "plane_d": 895.3989868164062,
      "bbox_min": [
        -1588.7762451171875,
        -3818.50048828125,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3793.923095703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.383934885263443,
        0.7197182178497314,
        0.5784459114074707
      ],
      "plane_d": 1606.790283203125,
      "bbox_min": [
        -1588.7762451171875,
        -3818.50048828125,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3795.259521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3839348256587982,
        0.7197180986404419,
        -0.5784459710121155
      ],
      "plane_d": 2695.42529296875,
      "bbox_min": [
        -1588.7762451171875,
        -3818.50048828125,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3795.259521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7400335073471069,
        0.2647237479686737,
        0.618281364440918
      ],
      "plane_d": -712.9560546875,
      "bbox_min": [
        -1588.7762451171875,
        -3813.354248046875,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3795.259521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7400335073471069,
        0.2647237479686737,
        -0.618281364440918
      ],
      "plane_d": 450.6494140625,
      "bbox_min": [
        -1588.7762451171875,
        -3813.354248046875,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3795.259521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044715821743011475,
        0.04851704463362694,
        0.9978209733963013
      ],
      "plane_d": -818.2548217773438,
      "bbox_min": [
        -1588.7762451171875,
        -3813.354248046875,
        935.0
      ],
      "bbox_max": [
        -1547.51806640625,
        -3797.843505859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044715821743011475,
        0.04851704090833664,
        -0.9978209137916565
      ],
      "plane_d": 1059.6441650390625,
      "bbox_min": [
        -1588.7762451171875,
        -3813.354248046875,
        935.0
      ],
      "bbox_max": [
        -1547.51806640625,
        -3797.84375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02495022863149643,
        0.004821575712412596,
        0.9996771216392517
      ],
      "plane_d": -876.7265625,
      "bbox_min": [
        -1588.7762451171875,
        -3813.354248046875,
        935.0
      ],
      "bbox_max": [
        -1586.64208984375,
        -3804.2080078125,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.02495022676885128,
        0.0048215752467513084,
        -0.9996770620346069
      ],
      "plane_d": 1004.6657104492188,
      "bbox_min": [
        -1588.7762451171875,
        -3813.354248046875,
        935.0
      ],
      "bbox_max": [
        -1586.64208984375,
        -3804.2080078125,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06473912298679352,
        0.005935261957347393,
        -0.9978845715522766
      ],
      "plane_d": 1070.345458984375,
      "bbox_min": [
        -1587.2120361328125,
        -3813.354248046875,
        935.0
      ],
      "bbox_max": [
        -1586.64208984375,
        -3812.876220703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037743739783763885,
        0.09482476115226746,
        -0.9947782158851624
      ],
      "plane_d": 1363.503662109375,
      "bbox_min": [
        -1587.2120361328125,
        -3813.11669921875,
        946.9649047851562
      ],
      "bbox_max": [
        -1586.64208984375,
        -3812.876220703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06473912298679352,
        0.005935261957347393,
        0.9978845715522766
      ],
      "plane_d": -807.67333984375,
      "bbox_min": [
        -1587.2120361328125,
        -3813.35400390625,
        935.0
      ],
      "bbox_max": [
        -1586.64208984375,
        -3812.876220703125,
        935.0350952148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037743739783763885,
        0.09482476115226746,
        0.9947782158851624
      ],
      "plane_d": -508.6690368652344,
      "bbox_min": [
        -1587.2120361328125,
        -3813.11669921875,
        935.0
      ],
      "bbox_max": [
        -1586.64208984375,
        -3812.876220703125,
        935.0350952148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06817515194416046,
        0.20299293100833893,
        0.9768040180206299
      ],
      "plane_d": -246.17001342773438,
      "bbox_min": [
        -1586.069091796875,
        -3827.895263671875,
        935.0
      ],
      "bbox_max": [
        -1555.3062744140625,
        -3818.50048828125,
        947.8250122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06421016156673431,
        -0.027978485450148582,
        -0.9975440502166748
      ],
      "plane_d": 735.976806640625,
      "bbox_min": [
        -1586.069091796875,
        -3827.895263671875,
        936.5
      ],
      "bbox_max": [
        -1555.3062744140625,
        -3818.50048828125,
        947.8250122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12784264981746674,
        -0.11661647260189056,
        -0.9849147200584412
      ],
      "plane_d": 284.5644226074219,
      "bbox_min": [
        -1586.069091796875,
        -3827.895263671875,
        946.5
      ],
      "bbox_max": [
        -1574.72021484375,
        -3819.2080078125,
        947.8250122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3628600239753723,
        0.7197369933128357,
        0.591870903968811
      ],
      "plane_d": 1627.007080078125,
      "bbox_min": [
        -1574.72021484375,
        -3827.426513671875,
        936.5
      ],
      "bbox_max": [
        -1555.3062744140625,
        -3818.50048828125,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5255221724510193,
        0.7500509023666382,
        0.4015595018863678
      ],
      "plane_d": 1666.752197265625,
      "bbox_min": [
        -1574.72021484375,
        -3827.426513671875,
        936.5
      ],
      "bbox_max": [
        -1562.9969482421875,
        -3818.67724609375,
        942.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3984864056110382,
        0.6411525011062622,
        -0.655844509601593
      ],
      "plane_d": 2445.622314453125,
      "bbox_min": [
        -1574.72021484375,
        -3827.426513671875,
        941.0
      ],
      "bbox_max": [
        -1555.3062744140625,
        -3818.50048828125,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5624163746833801,
        0.7040280699729919,
        -0.43362703919410706
      ],
      "plane_d": 2219.3955078125,
      "bbox_min": [
        -1574.72021484375,
        -3827.426513671875,
        942.0
      ],
      "bbox_max": [
        -1562.9969482421875,
        -3818.67724609375,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037743739783763885,
        0.09482476115226746,
        0.9947782158851624
      ],
      "plane_d": -508.6690368652344,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        935.0
      ],
      "bbox_max": [
        -1586.069091796875,
        -3785.778564453125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037743739783763885,
        0.09482476115226746,
        -0.9947782158851624
      ],
      "plane_d": 1363.503662109375,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        935.0
      ],
      "bbox_max": [
        -1586.069091796875,
        -3785.778564453125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06473912298679352,
        0.005935261957347393,
        -0.9978845715522766
      ],
      "plane_d": 1070.345458984375,
      "bbox_min": [
        -1609.141357421875,
        -3819.738525390625,
        945.5
      ],
      "bbox_max": [
        -1586.069091796875,
        -3813.11669921875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511858105659485,
        0.9976769089698792
      ],
      "plane_d": -653.3289184570312,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        935.0
      ],
      "bbox_max": [
        -1587.2120361328125,
        -3785.778564453125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02495022863149643,
        0.004821575712412596,
        0.9996771216392517
      ],
      "plane_d": -876.7265625,
      "bbox_min": [
        -1612.0,
        -3812.876220703125,
        935.0111083984375
      ],
      "bbox_max": [
        -1587.2120361328125,
        -3804.24365234375,
        935.6153564453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511857360601425,
        -0.9976769685745239
      ],
      "plane_d": 1224.299072265625,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        935.0
      ],
      "bbox_max": [
        -1587.2120361328125,
        -3785.778564453125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02495022676885128,
        0.0048215752467513084,
        -0.9996770620346069
      ],
      "plane_d": 1004.6657104492188,
      "bbox_min": [
        -1612.0,
        -3812.876220703125,
        946.3846435546875
      ],
      "bbox_max": [
        -1587.2120361328125,
        -3804.24365234375,
        946.9888916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29423192143440247,
        -0.8022502660751343,
        -0.519443929195404
      ],
      "plane_d": -3022.610595703125,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        935.0
      ],
      "bbox_max": [
        -1588.803466796875,
        -3785.778564453125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29423192143440247,
        -0.8022502660751343,
        0.519443929195404
      ],
      "plane_d": -4000.203857421875,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        935.0
      ],
      "bbox_max": [
        -1588.803466796875,
        -3785.778564453125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3313077688217163,
        -0.8417611718177795,
        -0.42623159289360046
      ],
      "plane_d": -3319.70556640625,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        935.0
      ],
      "bbox_max": [
        -1588.803466796875,
        -3785.778564453125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06191166117787361,
        -0.16880778968334198,
        -0.9837026000022888
      ],
      "plane_d": 190.7361297607422,
      "bbox_min": [
        -1612.0,
        -3796.699951171875,
        945.5
      ],
      "bbox_max": [
        -1590.133056640625,
        -3788.646728515625,
        946.6159057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06439700722694397,
        -0.20962128043174744,
        0.9756597876548767
      ],
      "plane_d": -1811.96875,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        935.0
      ],
      "bbox_max": [
        -1588.803466796875,
        -3788.646728515625,
        945.5904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06191166117787361,
        -0.16880778968334198,
        0.9837026000022888
      ],
      "plane_d": -1660.59228515625,
      "bbox_min": [
        -1612.0,
        -3796.699951171875,
        935.3840942382812
      ],
      "bbox_max": [
        -1590.133056640625,
        -3788.646728515625,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4012720286846161,
        0.5803803205490112,
        -0.7086178660392761
      ],
      "plane_d": 3532.6025390625,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        936.4095458984375
      ],
      "bbox_max": [
        -1609.141357421875,
        -3817.651611328125,
        945.5904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4012720584869385,
        0.580380380153656,
        0.7086179852485657
      ],
      "plane_d": 2198.984130859375,
      "bbox_min": [
        -1612.0,
        -3819.80419921875,
        936.4095458984375
      ],
      "bbox_max": [
        -1609.141357421875,
        -3817.651611328125,
        938.1726684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.059167955070734024,
        0.19492246210575104,
        0.9790323376655579
      ],
      "plane_d": -77.10138702392578,
      "bbox_min": [
        -1612.0,
        -3828.664794921875,
        935.0
      ],
      "bbox_max": [
        -1584.50048828125,
        -3819.2080078125,
        948.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12784241139888763,
        0.11661645025014877,
        0.9849146604537964
      ],
      "plane_d": -272.7458190917969,
      "bbox_min": [
        -1596.864501953125,
        -3828.48779296875,
        935.0
      ],
      "bbox_max": [
        -1584.50048828125,
        -3819.2080078125,
        937.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13855138421058655,
        0.10813199728727341,
        0.9844344258308411
      ],
      "plane_d": -727.2196655273438,
      "bbox_min": [
        -1586.069091796875,
        -3827.957275390625,
        935.0
      ],
      "bbox_max": [
        -1584.50048828125,
        -3819.2080078125,
        936.1749877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13854604959487915,
        -0.1081322431564331,
        -0.9844351410865784
      ],
      "plane_d": 739.024169921875,
      "bbox_min": [
        -1596.864501953125,
        -3828.48779296875,
        946.5
      ],
      "bbox_max": [
        -1584.50048828125,
        -3819.2080078125,
        948.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12784264981746674,
        -0.11661647260189056,
        -0.9849147200584412
      ],
      "plane_d": 284.5644226074219,
      "bbox_min": [
        -1586.069091796875,
        -3827.957275390625,
        947.0
      ],
      "bbox_max": [
        -1584.50048828125,
        -3819.2080078125,
        948.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4978741407394409,
        0.7486463785171509,
        0.43777841329574585
      ],
      "plane_d": 3250.8037109375,
      "bbox_min": [
        -1609.141357421875,
        -3828.664794921875,
        936.5
      ],
      "bbox_max": [
        -1596.864501953125,
        -3819.738525390625,
        942.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5377027988433838,
        0.70094233751297,
        -0.46856749057769775
      ],
      "plane_d": 3985.68701171875,
      "bbox_min": [
        -1612.0,
        -3828.664794921875,
        941.296875
      ],
      "bbox_max": [
        -1596.864501953125,
        -3819.738525390625,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3808179199695587,
        0.6312364339828491,
        -0.6756613850593567
      ],
      "plane_d": 3662.785888671875,
      "bbox_min": [
        -1612.0,
        -3828.664794921875,
        941.296875
      ],
      "bbox_max": [
        -1600.55517578125,
        -3819.738525390625,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2604343593120575,
        0.18772585690021515,
        0.9470654726028442
      ],
      "plane_d": 245.14804077148438,
      "bbox_min": [
        -1600.55517578125,
        -3864.203369140625,
        936.0
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11992976814508438,
        0.22858527302742004,
        0.966108500957489
      ],
      "plane_d": 160.9207763671875,
      "bbox_min": [
        -1598.629638671875,
        -3844.736328125,
        936.0
      ],
      "bbox_max": [
        -1585.792236328125,
        -3827.957275390625,
        940.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.700142502784729,
        0.40206655859947205,
        0.5900364518165588
      ],
      "plane_d": 2104.180419921875,
      "bbox_min": [
        -1598.629638671875,
        -3844.736328125,
        937.5
      ],
      "bbox_max": [
        -1590.061767578125,
        -3828.48779296875,
        940.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14136387407779694,
        0.22328796982765198,
        0.9644474387168884
      ],
      "plane_d": -272.1596984863281,
      "bbox_min": [
        -1585.792236328125,
        -3843.6748046875,
        936.0
      ],
      "bbox_max": [
        -1572.6624755859375,
        -3827.327880859375,
        940.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7328780889511108,
        0.34291741251945496,
        0.5876200199127197
      ],
      "plane_d": -392.4805908203125,
      "bbox_min": [
        -1579.91748046875,
        -3843.6748046875,
        937.5
      ],
      "bbox_max": [
        -1572.6624755859375,
        -3827.327880859375,
        940.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13901937007904053,
        -0.12321547418832779,
        -0.9825942516326904
      ],
      "plane_d": 680.2916259765625,
      "bbox_min": [
        -1598.9222412109375,
        -3844.736328125,
        943.9910278320312
      ],
      "bbox_max": [
        -1585.792236328125,
        -3827.957275390625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8867159485816956,
        0.30750009417533875,
        -0.3452223241329193
      ],
      "plane_d": 2919.978515625,
      "bbox_min": [
        -1598.9222412109375,
        -3844.736328125,
        943.9910278320312
      ],
      "bbox_max": [
        -1590.061767578125,
        -3828.48779296875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7356017827987671,
        0.2850612699985504,
        -0.6145160794258118
      ],
      "plane_d": 2847.6494140625,
      "bbox_min": [
        -1598.9222412109375,
        -3833.740966796875,
        943.9910278320312
      ],
      "bbox_max": [
        -1595.2296142578125,
        -3828.48779296875,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2604343593120575,
        -0.18772585690021515,
        -0.9470654726028442
      ],
      "plane_d": -233.78329467773438,
      "bbox_min": [
        -1600.55517578125,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12627467513084412,
        -0.14090879261493683,
        -0.9819365739822388
      ],
      "plane_d": 191.23757934570312,
      "bbox_min": [
        -1585.792236328125,
        -3843.6748046875,
        944.347900390625
      ],
      "bbox_max": [
        -1572.955078125,
        -3827.342041015625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138331413269043,
        0.23058485984802246,
        -0.3342747092247009
      ],
      "plane_d": -240.0938720703125,
      "bbox_min": [
        -1579.91748046875,
        -3843.6748046875,
        944.347900390625
      ],
      "bbox_max": [
        -1572.955078125,
        -3827.342041015625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7580680251121521,
        0.22261370718479156,
        -0.6130056381225586
      ],
      "plane_d": 238.50244140625,
      "bbox_min": [
        -1575.7442626953125,
        -3832.119873046875,
        944.347900390625
      ],
      "bbox_max": [
        -1572.955078125,
        -3827.342041015625,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.700142502784729,
        0.40206655859947205,
        0.5900364518165588
      ],
      "plane_d": 2104.180419921875,
      "bbox_min": [
        -1600.55517578125,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6693123579025269,
        0.531091570854187,
        0.5195793509483337
      ],
      "plane_d": 2619.685791015625,
      "bbox_min": [
        -1587.265869140625,
        -3858.7724609375,
        943.5479736328125
      ],
      "bbox_max": [
        -1584.5699462890625,
        -3855.70849609375,
        944.4815673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.884308934211731,
        0.333933025598526,
        0.32632291316986084
      ],
      "plane_d": 2383.16943359375,
      "bbox_min": [
        -1588.3648681640625,
        -3858.489501953125,
        943.888916015625
      ],
      "bbox_max": [
        -1585.519287109375,
        -3853.06396484375,
        946.197509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6693123579025269,
        0.531091570854187,
        0.5195793509483337
      ],
      "plane_d": 2619.685791015625,
      "bbox_min": [
        -1587.265869140625,
        -3858.489501953125,
        943.888916015625
      ],
      "bbox_max": [
        -1585.519287109375,
        -3855.70849609375,
        946.197509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9193751215934753,
        0.21134932339191437,
        -0.33178409934043884
      ],
      "plane_d": 2589.5732421875,
      "bbox_min": [
        -1600.55517578125,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7356017827987671,
        0.2850612699985504,
        -0.6145160794258118
      ],
      "plane_d": 2847.6494140625,
      "bbox_min": [
        -1600.55517578125,
        -3844.9130859375,
        941.1856079101562
      ],
      "bbox_max": [
        -1590.4613037109375,
        -3828.58642578125,
        949.2310180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8867159485816956,
        0.30750009417533875,
        -0.3452223241329193
      ],
      "plane_d": 2919.978515625,
      "bbox_min": [
        -1595.2296142578125,
        -3844.9130859375,
        945.0
      ],
      "bbox_max": [
        -1590.4613037109375,
        -3833.740966796875,
        949.2310180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.806119441986084,
        0.49624428153038025,
        0.32235556840896606
      ],
      "plane_d": 2886.53271484375,
      "bbox_min": [
        -1600.55517578125,
        -3844.9130859375,
        941.1856079101562
      ],
      "bbox_max": [
        -1591.75244140625,
        -3828.664794921875,
        945.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8867159485816956,
        0.30750009417533875,
        -0.3452223241329193
      ],
      "plane_d": 2919.978515625,
      "bbox_min": [
        -1591.75244140625,
        -3844.9130859375,
        945.0
      ],
      "bbox_max": [
        -1590.061767578125,
        -3843.88623046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48235395550727844,
        -0.061687566339969635,
        -0.8738017082214355
      ],
      "plane_d": 1358.371826171875,
      "bbox_min": [
        -1594.858154296875,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28540948033332825,
        -0.019454048946499825,
        -0.9582082033157349
      ],
      "plane_d": 1288.8416748046875,
      "bbox_min": [
        -1590.061767578125,
        -3855.70849609375,
        949.5
      ],
      "bbox_max": [
        -1584.9896240234375,
        -3844.20556640625,
        951.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.884308934211731,
        0.333933025598526,
        0.32632291316986084
      ],
      "plane_d": 2383.16943359375,
      "bbox_min": [
        -1594.858154296875,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.806119441986084,
        0.49624428153038025,
        0.32235556840896606
      ],
      "plane_d": 2886.53271484375,
      "bbox_min": [
        -1594.858154296875,
        -3844.9130859375,
        940.5376586914062
      ],
      "bbox_max": [
        -1590.3251953125,
        -3837.39013671875,
        945.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.913616955280304,
        0.23161566257476807,
        0.3341529667377472
      ],
      "plane_d": -867.4549560546875,
      "bbox_min": [
        -1591.75244140625,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8496394157409668,
        0.43216243386268616,
        0.3022388815879822
      ],
      "plane_d": 34.47607421875,
      "bbox_min": [
        -1579.91748046875,
        -3843.6748046875,
        940.0089111328125
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        945.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7328780889511108,
        0.34291741251945496,
        0.5876200199127197
      ],
      "plane_d": -392.4805908203125,
      "bbox_min": [
        -1579.91748046875,
        -3843.6748046875,
        940.0089111328125
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        945.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7580680251121521,
        0.22261370718479156,
        -0.6130056381225586
      ],
      "plane_d": 238.50244140625,
      "bbox_min": [
        -1578.226806640625,
        -3843.498046875,
        942.0
      ],
      "bbox_max": [
        -1571.0294189453125,
        -3827.249755859375,
        945.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4881589412689209,
        0.22684460878372192,
        0.84275883436203
      ],
      "plane_d": -693.0400390625,
      "bbox_min": [
        -1591.75244140625,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1574.744384765625,
        -3830.406982421875,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29931578040122986,
        0.31433650851249695,
        0.9008898735046387
      ],
      "plane_d": -111.973876953125,
      "bbox_min": [
        -1584.9896240234375,
        -3854.92236328125,
        939.0
      ],
      "bbox_max": [
        -1579.91748046875,
        -3843.6748046875,
        943.888916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9215608835220337,
        0.23646415770053864,
        0.3079127371311188
      ],
      "plane_d": -836.5601806640625,
      "bbox_min": [
        -1591.75244140625,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1574.744384765625,
        -3830.406982421875,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9399988651275635,
        0.11565205454826355,
        -0.3209778964519501
      ],
      "plane_d": -735.6988525390625,
      "bbox_min": [
        -1591.75244140625,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1574.744384765625,
        -3830.406982421875,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7580680251121521,
        0.22261370718479156,
        -0.6130056381225586
      ],
      "plane_d": 238.50244140625,
      "bbox_min": [
        -1579.5677490234375,
        -3843.498046875,
        945.0
      ],
      "bbox_max": [
        -1574.744384765625,
        -3830.406982421875,
        949.2118530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138331413269043,
        0.23058485984802246,
        -0.3342747092247009
      ],
      "plane_d": -240.0938720703125,
      "bbox_min": [
        -1579.5677490234375,
        -3843.498046875,
        945.0
      ],
      "bbox_max": [
        -1575.7442626953125,
        -3832.119873046875,
        949.2118530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9326125383377075,
        0.10114722698926926,
        -0.3464144766330719
      ],
      "plane_d": -755.7532958984375,
      "bbox_min": [
        -1591.75244140625,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1578.226806640625,
        -3842.706298828125,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138331413269043,
        0.23058485984802246,
        -0.3342747092247009
      ],
      "plane_d": -240.0938720703125,
      "bbox_min": [
        -1579.91748046875,
        -3843.6748046875,
        945.0
      ],
      "bbox_max": [
        -1578.226806640625,
        -3842.706298828125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46174752712249756,
        -0.11259812861680984,
        -0.8798357248306274
      ],
      "plane_d": -327.9916076660156,
      "bbox_min": [
        -1591.75244140625,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1579.91748046875,
        -3843.6748046875,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27840954065322876,
        -0.05011295527219772,
        -0.9591541886329651
      ],
      "plane_d": 278.23486328125,
      "bbox_min": [
        -1584.9896240234375,
        -3854.92236328125,
        949.5
      ],
      "bbox_max": [
        -1579.91748046875,
        -3843.6748046875,
        951.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4275912046432495,
        0.28060874342918396,
        0.8593162298202515
      ],
      "plane_d": 949.5474243164062,
      "bbox_min": [
        -1591.75244140625,
        -3864.203369140625,
        939.0
      ],
      "bbox_max": [
        -1581.1182861328125,
        -3844.20556640625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23364396393299103,
        0.3408011198043823,
        0.9106400012969971
      ],
      "plane_d": 825.3418579101562,
      "bbox_min": [
        -1590.7894287109375,
        -3854.140869140625,
        939.0
      ],
      "bbox_max": [
        -1584.9896240234375,
        -3844.20556640625,
        943.2225952148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.806119441986084,
        0.49624428153038025,
        0.32235556840896606
      ],
      "plane_d": 2886.53271484375,
      "bbox_min": [
        -1590.7894287109375,
        -3844.795166015625,
        940.5
      ],
      "bbox_max": [
        -1590.061767578125,
        -3844.332763671875,
        941.9959716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.806119441986084,
        0.49624428153038025,
        0.32235556840896606
      ],
      "plane_d": 2886.53271484375,
      "bbox_min": [
        -1591.75244140625,
        -3844.9130859375,
        941.9890747070312
      ],
      "bbox_max": [
        -1590.623779296875,
        -3844.521484375,
        945.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7551835179328918,
        0.4664452075958252,
        0.4605722725391388
      ],
      "plane_d": 169.2027587890625,
      "bbox_min": [
        -1587.265869140625,
        -3864.203369140625,
        943.5
      ],
      "bbox_max": [
        -1581.1182861328125,
        -3854.92236328125,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6348687410354614,
        0.5867730975151062,
        0.502632200717926
      ],
      "plane_d": 2795.99658203125,
      "bbox_min": [
        -1587.265869140625,
        -3864.203369140625,
        943.5
      ],
      "bbox_max": [
        -1581.1182861328125,
        -3854.92236328125,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8009088039398193,
        0.31418266892433167,
        -0.5097394585609436
      ],
      "plane_d": 429.229736328125,
      "bbox_min": [
        -1587.265869140625,
        -3864.203369140625,
        943.5
      ],
      "bbox_max": [
        -1581.1182861328125,
        -3854.92236328125,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7256180047988892,
        0.42014944553375244,
        -0.5449338555335999
      ],
      "plane_d": 3290.009033203125,
      "bbox_min": [
        -1587.265869140625,
        -3864.203369140625,
        943.5
      ],
      "bbox_max": [
        -1581.1182861328125,
        -3854.92236328125,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7671140432357788,
        0.4338468015193939,
        0.47256022691726685
      ],
      "plane_d": 13.1878662109375,
      "bbox_min": [
        -1587.265869140625,
        -3859.734619140625,
        943.5
      ],
      "bbox_max": [
        -1581.1182861328125,
        -3854.92236328125,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8103329539299011,
        0.2666674554347992,
        -0.52177494764328
      ],
      "plane_d": 242.3929443359375,
      "bbox_min": [
        -1587.265869140625,
        -3859.734619140625,
        943.5
      ],
      "bbox_max": [
        -1581.1182861328125,
        -3854.92236328125,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7527207732200623,
        0.3532431423664093,
        -0.5555453896522522
      ],
      "plane_d": 3084.84716796875,
      "bbox_min": [
        -1587.265869140625,
        -3859.734619140625,
        943.5
      ],
      "bbox_max": [
        -1584.1904296875,
        -3855.70849609375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6693123579025269,
        0.531091570854187,
        0.5195793509483337
      ],
      "plane_d": 2619.685791015625,
      "bbox_min": [
        -1587.2640380859375,
        -3859.734619140625,
        943.5
      ],
      "bbox_max": [
        -1584.1904296875,
        -3857.969482421875,
        948.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3895.0,
      "bbox_min": [
        -1755.0,
        -3958.5,
        920.0
      ],
      "bbox_max": [
        -1612.0,
        -3652.330078125,
        1035.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.23653686046600342,
        -0.1538044661283493,
        0.9593718647956848
      ],
      "plane_d": -1060.6834716796875,
      "bbox_min": [
        -1726.2510986328125,
        -3690.406494140625,
        936.0477905273438
      ],
      "bbox_max": [
        -1695.3804931640625,
        -3652.330078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08207004517316818,
        -0.19731438159942627,
        0.9768989086151123
      ],
      "plane_d": -1502.0540771484375,
      "bbox_min": [
        -1724.149658203125,
        -3690.041748046875,
        936.064453125
      ],
      "bbox_max": [
        -1711.764404296875,
        -3672.43408203125,
        940.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6943234801292419,
        -0.34586653113365173,
        0.6311031579971313
      ],
      "plane_d": -671.757080078125,
      "bbox_min": [
        -1724.149658203125,
        -3689.809326171875,
        936.9876708984375
      ],
      "bbox_max": [
        -1716.277587890625,
        -3672.43408203125,
        940.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23553027212619781,
        0.0060649169608950615,
        -0.9718481302261353
      ],
      "plane_d": 1345.8765869140625,
      "bbox_min": [
        -1726.2510986328125,
        -3690.406494140625,
        936.0477905273438
      ],
      "bbox_max": [
        -1695.3804931640625,
        -3652.330078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08326416462659836,
        -0.03430940583348274,
        -0.9959367513656616
      ],
      "plane_d": 959.0615844726562,
      "bbox_min": [
        -1724.0389404296875,
        -3690.041748046875,
        944.0107421875
      ],
      "bbox_max": [
        -1711.764404296875,
        -3672.43408203125,
        946.98388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7239624857902527,
        -0.25038811564445496,
        -0.6427939534187317
      ],
      "plane_d": 931.06982421875,
      "bbox_min": [
        -1724.0389404296875,
        -3689.809326171875,
        944.0107421875
      ],
      "bbox_max": [
        -1716.277587890625,
        -3672.43408203125,
        946.1038818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22846738994121552,
        -0.16577208042144775,
        0.9593342542648315
      ],
      "plane_d": -1900.756103515625,
      "bbox_min": [
        -1726.2510986328125,
        -3690.406494140625,
        936.0477905273438
      ],
      "bbox_max": [
        -1695.3804931640625,
        -3652.330078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08026933670043945,
        -0.19954659044742584,
        0.9765951633453369
      ],
      "plane_d": -1787.882080078125,
      "bbox_min": [
        -1711.6328125,
        -3690.352294921875,
        936.0630493164062
      ],
      "bbox_max": [
        -1697.8070068359375,
        -3672.22607421875,
        940.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6104714870452881,
        -0.43253353238105774,
        0.6635052561759949
      ],
      "plane_d": -3255.896240234375,
      "bbox_min": [
        -1702.3560791015625,
        -3690.352294921875,
        937.324462890625
      ],
      "bbox_max": [
        -1697.8070068359375,
        -3683.877685546875,
        939.3380737304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.640159010887146,
        -0.3395208418369293,
        -0.6891458630561829
      ],
      "plane_d": -1689.4521484375,
      "bbox_min": [
        -1702.4593505859375,
        -3690.35546875,
        943.6024780273438
      ],
      "bbox_max": [
        -1697.6708984375,
        -3683.596923828125,
        945.732666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8967656493186951,
        -0.1596149057149887,
        -0.4127161204814911
      ],
      "plane_d": -1727.415771484375,
      "bbox_min": [
        -1709.9522705078125,
        -3683.596923828125,
        943.0
      ],
      "bbox_max": [
        -1702.4593505859375,
        -3661.141845703125,
        946.1156005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8432630896568298,
        -0.369214802980423,
        -0.3906249701976776
      ],
      "plane_d": -2426.6279296875,
      "bbox_min": [
        -1708.030517578125,
        -3683.596923828125,
        943.0
      ],
      "bbox_max": [
        -1702.4593505859375,
        -3672.19140625,
        946.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2341812402009964,
        -0.05033176764845848,
        -0.9708892703056335
      ],
      "plane_d": 333.6429138183594,
      "bbox_min": [
        -1709.9522705078125,
        -3672.238037109375,
        945.888916015625
      ],
      "bbox_max": [
        -1708.030517578125,
        -3661.141845703125,
        946.1156005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.82228684425354,
        -0.4221445322036743,
        0.3816259205341339
      ],
      "plane_d": -3313.4296875,
      "bbox_min": [
        -1706.656005859375,
        -3683.877685546875,
        939.3380737304688
      ],
      "bbox_max": [
        -1702.3560791015625,
        -3672.19140625,
        943.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28284966945648193,
        -0.03950883820652962,
        -0.9583501219749451
      ],
      "plane_d": 278.18585205078125,
      "bbox_min": [
        -1726.2510986328125,
        -3689.76806640625,
        939.0
      ],
      "bbox_max": [
        -1703.0645751953125,
        -3652.330078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2341812402009964,
        -0.05033176764845848,
        -0.9708892703056335
      ],
      "plane_d": 333.6429138183594,
      "bbox_min": [
        -1712.154052734375,
        -3672.330078125,
        945.888916015625
      ],
      "bbox_max": [
        -1708.50732421875,
        -3661.141845703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.82228684425354,
        -0.4221445322036743,
        0.3816259205341339
      ],
      "plane_d": -3313.4296875,
      "bbox_min": [
        -1708.030517578125,
        -3682.4228515625,
        939.4207153320312
      ],
      "bbox_max": [
        -1703.0645751953125,
        -3672.19140625,
        943.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22325724363327026,
        -0.23770707845687866,
        0.9453315734863281
      ],
      "plane_d": -2142.85595703125,
      "bbox_min": [
        -1709.9522705078125,
        -3672.238037109375,
        939.8837890625
      ],
      "bbox_max": [
        -1708.030517578125,
        -3661.141845703125,
        942.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22325724363327026,
        -0.23770707845687866,
        0.9453315734863281
      ],
      "plane_d": -2142.85595703125,
      "bbox_min": [
        -1712.154052734375,
        -3672.330078125,
        939.0
      ],
      "bbox_max": [
        -1708.5096435546875,
        -3661.141845703125,
        942.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8930960893630981,
        -0.19170492887496948,
        0.4069749712944031
      ],
      "plane_d": 446.220703125,
      "bbox_min": [
        -1718.921875,
        -3678.255859375,
        939.7186279296875
      ],
      "bbox_max": [
        -1714.9500732421875,
        -3661.296142578125,
        942.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8182753324508667,
        -0.44006291031837463,
        0.36982429027557373
      ],
      "plane_d": -559.3492431640625,
      "bbox_min": [
        -1717.2364501953125,
        -3674.095947265625,
        940.0
      ],
      "bbox_max": [
        -1716.277587890625,
        -3672.43408203125,
        940.2635498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8481891751289368,
        -0.17530283331871033,
        0.4998440444469452
      ],
      "plane_d": 341.746826171875,
      "bbox_min": [
        -1726.2510986328125,
        -3689.76806640625,
        939.162353515625
      ],
      "bbox_max": [
        -1709.681640625,
        -3652.330078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8182753324508667,
        -0.44006291031837463,
        0.36982429027557373
      ],
      "plane_d": -559.3492431640625,
      "bbox_min": [
        -1726.2510986328125,
        -3689.76806640625,
        939.162353515625
      ],
      "bbox_max": [
        -1714.9500732421875,
        -3661.296142578125,
        944.8344116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8930960893630981,
        -0.19170492887496948,
        0.4069749712944031
      ],
      "plane_d": 446.220703125,
      "bbox_min": [
        -1717.652099609375,
        -3672.46875,
        940.2635498046875
      ],
      "bbox_max": [
        -1714.9500732421875,
        -3661.296142578125,
        943.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6943234801292419,
        -0.34586653113365173,
        0.6311031579971313
      ],
      "plane_d": -671.757080078125,
      "bbox_min": [
        -1726.2510986328125,
        -3689.76806640625,
        939.162353515625
      ],
      "bbox_max": [
        -1717.2364501953125,
        -3674.095947265625,
        944.8344116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9039047956466675,
        -0.11185265332460403,
        -0.412850022315979
      ],
      "plane_d": 1531.13623046875,
      "bbox_min": [
        -1720.8251953125,
        -3682.590576171875,
        943.0
      ],
      "bbox_max": [
        -1714.9500732421875,
        -3661.296142578125,
        946.114501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7239624857902527,
        -0.25038811564445496,
        -0.6427939534187317
      ],
      "plane_d": 931.06982421875,
      "bbox_min": [
        -1720.8251953125,
        -3682.590576171875,
        943.0
      ],
      "bbox_max": [
        -1716.277587890625,
        -3672.43408203125,
        946.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8404038548469543,
        -0.3858404755592346,
        -0.3805895447731018
      ],
      "plane_d": 385.4302978515625,
      "bbox_min": [
        -1719.731689453125,
        -3678.42041015625,
        943.0
      ],
      "bbox_max": [
        -1716.277587890625,
        -3672.43408203125,
        946.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23641188442707062,
        -0.03786098212003708,
        -0.9709149599075317
      ],
      "plane_d": 1185.1920166015625,
      "bbox_min": [
        -1715.8052978515625,
        -3672.422119140625,
        945.888916015625
      ],
      "bbox_max": [
        -1712.154052734375,
        -3661.296142578125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5622134804725647,
        -0.22380958497524261,
        -0.7961314916610718
      ],
      "plane_d": 897.8145141601562,
      "bbox_min": [
        -1715.4287109375,
        -3661.296142578125,
        942.3333129882812
      ],
      "bbox_max": [
        -1709.681640625,
        -3652.330078125,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5463082194328308,
        -0.254043310880661,
        -0.7981287240982056
      ],
      "plane_d": -1109.2744140625,
      "bbox_min": [
        -1715.4287109375,
        -3661.296142578125,
        942.3333129882812
      ],
      "bbox_max": [
        -1709.681640625,
        -3652.330078125,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5173586010932922,
        -0.38666823506355286,
        0.7634314894676208
      ],
      "plane_d": -3019.712890625,
      "bbox_min": [
        -1715.4287109375,
        -3661.296142578125,
        942.3333129882812
      ],
      "bbox_max": [
        -1709.681640625,
        -3657.22607421875,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.541869580745697,
        -0.35914236307144165,
        0.7598645687103271
      ],
      "plane_d": -1101.6929931640625,
      "bbox_min": [
        -1715.4287109375,
        -3661.296142578125,
        942.3333129882812
      ],
      "bbox_max": [
        -1709.681640625,
        -3657.22607421875,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5477241277694702,
        -0.24580956995487213,
        -0.7997349500656128
      ],
      "plane_d": -1080.0654296875,
      "bbox_min": [
        -1715.4287109375,
        -3661.296142578125,
        944.5
      ],
      "bbox_max": [
        -1709.681640625,
        -3657.22607421875,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5629229545593262,
        -0.2170417308807373,
        -0.7975028157234192
      ],
      "plane_d": 925.0797729492188,
      "bbox_min": [
        -1715.4287109375,
        -3661.296142578125,
        944.5
      ],
      "bbox_max": [
        -1712.55517578125,
        -3657.330078125,
        946.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0024838284589350224,
        0.17567482590675354,
        0.9844451546669006
      ],
      "plane_d": -265.0772705078125,
      "bbox_min": [
        -1755.0,
        -3723.683349609375,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04134446382522583,
        -0.1353481262922287,
        0.9899351000785828
      ],
      "plane_d": -1355.77783203125,
      "bbox_min": [
        -1755.0,
        -3722.10302734375,
        935.0
      ],
      "bbox_max": [
        -1668.1134033203125,
        -3706.206298828125,
        937.9052124023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05370009317994118,
        0.2123509645462036,
        0.9757168889045715
      ],
      "plane_d": -34.02091979980469,
      "bbox_min": [
        -1691.371337890625,
        -3721.3271484375,
        935.0
      ],
      "bbox_max": [
        -1668.373291015625,
        -3714.05224609375,
        937.5496826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21344631910324097,
        0.8440494537353516,
        0.491956502199173
      ],
      "plane_d": 3036.052001953125,
      "bbox_min": [
        -1691.371337890625,
        -3721.3271484375,
        936.5
      ],
      "bbox_max": [
        -1668.935791015625,
        -3715.128662109375,
        937.5496826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2072044163942337,
        0.8715353608131409,
        0.44440117478370667
      ],
      "plane_d": 3172.43994140625,
      "bbox_min": [
        -1673.1185302734375,
        -3721.3271484375,
        936.5
      ],
      "bbox_max": [
        -1668.935791015625,
        -3720.25048828125,
        937.5496826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23402035236358643,
        0.8751896023750305,
        0.4234119951725006
      ],
      "plane_d": 2449.719970703125,
      "bbox_min": [
        -1755.0,
        -3722.10302734375,
        935.4457397460938
      ],
      "bbox_max": [
        -1729.446044921875,
        -3714.59033203125,
        937.9052124023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05974610522389412,
        0.22343851625919342,
        0.972885251045227
      ],
      "plane_d": -184.45217895507812,
      "bbox_min": [
        -1755.0,
        -3721.42333984375,
        935.4457397460938
      ],
      "bbox_max": [
        -1729.446044921875,
        -3714.59033203125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010896914638578892,
        0.8487632274627686,
        0.5286608934402466
      ],
      "plane_d": 2676.6044921875,
      "bbox_min": [
        -1755.0,
        -3723.683349609375,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21103280782699585,
        0.840233564376831,
        0.4994725286960602
      ],
      "plane_d": 2288.3974609375,
      "bbox_min": [
        -1755.0,
        -3723.683349609375,
        936.5
      ],
      "bbox_max": [
        -1668.9439697265625,
        -3714.643798828125,
        945.802490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2072044163942337,
        0.8715353608131409,
        -0.44440117478370667
      ],
      "plane_d": 4008.802734375,
      "bbox_min": [
        -1691.371337890625,
        -3723.05224609375,
        936.5
      ],
      "bbox_max": [
        -1668.9439697265625,
        -3715.128662109375,
        945.3038330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21344631910324097,
        0.8440494537353516,
        0.491956502199173
      ],
      "plane_d": 3036.052001953125,
      "bbox_min": [
        -1691.371337890625,
        -3720.25048828125,
        936.5
      ],
      "bbox_max": [
        -1673.1185302734375,
        -3715.128662109375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05974610522389412,
        0.22343851625919342,
        -0.972885251045227
      ],
      "plane_d": 1646.517822265625,
      "bbox_min": [
        -1755.0,
        -3721.42333984375,
        945.5
      ],
      "bbox_max": [
        -1749.62744140625,
        -3719.98681640625,
        945.6103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05974610522389412,
        0.22343851625919342,
        -0.972885251045227
      ],
      "plane_d": 1646.517822265625,
      "bbox_min": [
        -1755.0,
        -3720.94287109375,
        945.5944213867188
      ],
      "bbox_max": [
        -1751.3043212890625,
        -3720.024169921875,
        945.802490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01193996425718069,
        0.8444831371307373,
        0.5354490876197815
      ],
      "plane_d": 2656.110107421875,
      "bbox_min": [
        -1755.0,
        -3720.900390625,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21103280782699585,
        0.840233564376831,
        0.4994725286960602
      ],
      "plane_d": 2288.3974609375,
      "bbox_min": [
        -1730.117919921875,
        -3717.43408203125,
        936.5
      ],
      "bbox_max": [
        -1729.446044921875,
        -3714.59033203125,
        941.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.05678233876824379,
        0.18588665127754211,
        -0.9809290766716003
      ],
      "plane_d": 1519.7591552734375,
      "bbox_min": [
        -1755.0,
        -3720.106201171875,
        941.0
      ],
      "bbox_max": [
        -1729.6236572265625,
        -3713.415283203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05974610522389412,
        0.22343851625919342,
        -0.972885251045227
      ],
      "plane_d": 1646.517822265625,
      "bbox_min": [
        -1755.0,
        -3720.106201171875,
        941.0
      ],
      "bbox_max": [
        -1729.6236572265625,
        -3713.415283203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21103282272815704,
        0.8402336239814758,
        -0.499472439289093
      ],
      "plane_d": 3228.405029296875,
      "bbox_min": [
        -1742.2239990234375,
        -3718.9140625,
        941.0
      ],
      "bbox_max": [
        -1729.6375732421875,
        -3714.655029296875,
        945.471923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2072044163942337,
        0.8715353608131409,
        -0.44440117478370667
      ],
      "plane_d": 4008.802734375,
      "bbox_min": [
        -1690.621337890625,
        -3720.900390625,
        941.0
      ],
      "bbox_max": [
        -1668.935791015625,
        -3717.941162109375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01193996425718069,
        0.8444831371307373,
        -0.5354490876197815
      ],
      "plane_d": 3663.825439453125,
      "bbox_min": [
        -1755.0,
        -3717.43408203125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05678233876824379,
        0.18588665127754211,
        -0.9809290766716003
      ],
      "plane_d": 1519.7591552734375,
      "bbox_min": [
        -1755.0,
        -3717.43408203125,
        941.0
      ],
      "bbox_max": [
        -1729.446044921875,
        -3713.319580078125,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01716766692698002,
        -0.056201282888650894,
        -0.9982717633247375
      ],
      "plane_d": 766.7340698242188,
      "bbox_min": [
        -1755.0,
        -3713.42236328125,
        946.9346313476562
      ],
      "bbox_max": [
        -1751.23583984375,
        -3713.319580078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0024838284589350224,
        0.17567482590675354,
        -0.9844451546669006
      ],
      "plane_d": 1587.6485595703125,
      "bbox_min": [
        -1755.0,
        -3715.128662109375,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06169648841023445,
        -0.21161502599716187,
        -0.9754037261009216
      ],
      "plane_d": 34.82530975341797,
      "bbox_min": [
        -1755.0,
        -3715.128662109375,
        945.5
      ],
      "bbox_max": [
        -1668.113525390625,
        -3706.20654296875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01716766692698002,
        -0.056201282888650894,
        -0.9982717633247375
      ],
      "plane_d": 766.7340698242188,
      "bbox_min": [
        -1755.0,
        -3714.59033203125,
        945.5
      ],
      "bbox_max": [
        -1727.9130859375,
        -3706.20654296875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018472295254468918,
        -0.0706440806388855,
        -0.9973305463790894
      ],
      "plane_d": 714.5704956054688,
      "bbox_min": [
        -1755.0,
        -3708.571044921875,
        946.6224975585938
      ],
      "bbox_max": [
        -1731.5299072265625,
        -3706.4326171875,
        946.9505004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053700096905231476,
        0.2123509645462036,
        -0.9757168889045715
      ],
      "plane_d": 1802.2781982421875,
      "bbox_min": [
        -1691.371337890625,
        -3715.128662109375,
        945.5
      ],
      "bbox_max": [
        -1668.373291015625,
        -3714.05224609375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003223642474040389,
        0.17242814600467682,
        -0.9850167632102966
      ],
      "plane_d": 1577.4083251953125,
      "bbox_min": [
        -1755.0,
        -3714.59033203125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018472295254468918,
        -0.0706440806388855,
        -0.9973305463790894
      ],
      "plane_d": 714.5704956054688,
      "bbox_min": [
        -1755.0,
        -3714.59033203125,
        945.5
      ],
      "bbox_max": [
        -1727.430419921875,
        -3706.05908203125,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.04134446382522583,
        -0.1353481262922287,
        0.9899351000785828
      ],
      "plane_d": -1355.77783203125,
      "bbox_min": [
        -1755.0,
        -3714.59033203125,
        935.0
      ],
      "bbox_max": [
        -1727.430419921875,
        -3706.05908203125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08026933670043945,
        -0.19954659044742584,
        0.9765951633453369
      ],
      "plane_d": -1787.882080078125,
      "bbox_min": [
        -1704.687744140625,
        -3692.87109375,
        936.52001953125
      ],
      "bbox_max": [
        -1695.3804931640625,
        -3690.199462890625,
        941.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6104714870452881,
        -0.43253353238105774,
        0.6635052561759949
      ],
      "plane_d": -3255.896240234375,
      "bbox_min": [
        -1700.165771484375,
        -3692.87109375,
        936.52001953125
      ],
      "bbox_max": [
        -1695.3804931640625,
        -3690.300048828125,
        941.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.82228684425354,
        -0.4221445322036743,
        0.3816259205341339
      ],
      "plane_d": -3313.4296875,
      "bbox_min": [
        -1700.165771484375,
        -3692.87109375,
        936.52001953125
      ],
      "bbox_max": [
        -1699.046875,
        -3690.300048828125,
        937.324462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33398252725601196,
        -0.6955732107162476,
        -0.6361082792282104
      ],
      "plane_d": -2534.279541015625,
      "bbox_min": [
        -1755.0,
        -3710.9345703125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07725824415683746,
        -0.03940919041633606,
        -0.9962319135665894
      ],
      "plane_d": 665.7565307617188,
      "bbox_min": [
        -1705.375732421875,
        -3692.87109375,
        941.5
      ],
      "bbox_max": [
        -1695.3804931640625,
        -3690.18408203125,
        946.5045166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.640159010887146,
        -0.3395208418369293,
        -0.6891458630561829
      ],
      "plane_d": -1689.4521484375,
      "bbox_min": [
        -1700.165771484375,
        -3692.87109375,
        941.5
      ],
      "bbox_max": [
        -1695.3804931640625,
        -3690.300048828125,
        946.1199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8432630896568298,
        -0.369214802980423,
        -0.3906249701976776
      ],
      "plane_d": -2426.6279296875,
      "bbox_min": [
        -1700.165771484375,
        -3692.87109375,
        945.732666015625
      ],
      "bbox_max": [
        -1699.046875,
        -3690.300048828125,
        946.1199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0011967980535700917,
        -0.06401505321264267,
        -0.9979481101036072
      ],
      "plane_d": 705.7459106445312,
      "bbox_min": [
        -1755.0,
        -3710.9345703125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05775298550724983,
        0.057792890816926956,
        -0.9966566562652588
      ],
      "plane_d": 1058.25341796875,
      "bbox_min": [
        -1727.430419921875,
        -3706.05908203125,
        945.9512939453125
      ],
      "bbox_max": [
        -1699.046875,
        -3689.806396484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09433850646018982,
        -0.09440366923809052,
        -0.9910540580749512
      ],
      "plane_d": 751.6257934570312,
      "bbox_min": [
        -1727.430419921875,
        -3706.05908203125,
        945.9512939453125
      ],
      "bbox_max": [
        -1699.046875,
        -3689.806396484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23553027212619781,
        0.0060649169608950615,
        -0.9718481302261353
      ],
      "plane_d": 1345.8765869140625,
      "bbox_min": [
        -1711.764404296875,
        -3690.330078125,
        946.98388671875
      ],
      "bbox_max": [
        -1711.6658935546875,
        -3690.041748046875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23553027212619781,
        -0.0060649169608950615,
        -0.9718481302261353
      ],
      "plane_d": 494.8037109375,
      "bbox_min": [
        -1711.697998046875,
        -3690.330078125,
        946.9922485351562
      ],
      "bbox_max": [
        -1711.6658935546875,
        -3690.043212890625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7239624857902527,
        -0.25038811564445496,
        -0.6427939534187317
      ],
      "plane_d": 931.06982421875,
      "bbox_min": [
        -1723.081298828125,
        -3692.41259765625,
        945.9512939453125
      ],
      "bbox_max": [
        -1711.5985107421875,
        -3689.806396484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23553027212619781,
        -0.0060649169608950615,
        -0.9718481302261353
      ],
      "plane_d": 494.8037109375,
      "bbox_min": [
        -1711.6905517578125,
        -3690.330078125,
        946.9842529296875
      ],
      "bbox_max": [
        -1711.6328125,
        -3690.0439453125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07725824415683746,
        -0.03940919041633606,
        -0.9962319135665894
      ],
      "plane_d": 665.7565307617188,
      "bbox_min": [
        -1711.6905517578125,
        -3692.87109375,
        946.1199951171875
      ],
      "bbox_max": [
        -1699.046875,
        -3690.04541015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2558348476886749,
        -0.7409781217575073,
        -0.620886504650116
      ],
      "plane_d": -1707.801025390625,
      "bbox_min": [
        -1755.0,
        -3710.9345703125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7239624857902527,
        -0.25038811564445496,
        -0.6427939534187317
      ],
      "plane_d": 931.06982421875,
      "bbox_min": [
        -1726.2510986328125,
        -3692.506591796875,
        941.5
      ],
      "bbox_max": [
        -1722.3291015625,
        -3689.71875,
        946.1246948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08326416462659836,
        -0.03430940583348274,
        -0.9959367513656616
      ],
      "plane_d": 959.0615844726562,
      "bbox_min": [
        -1723.11328125,
        -3692.506591796875,
        946.1194458007812
      ],
      "bbox_max": [
        -1723.052490234375,
        -3692.41259765625,
        946.1246948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0020588585175573826,
        -0.11012546718120575,
        0.9939156174659729
      ],
      "plane_d": -1340.9991455078125,
      "bbox_min": [
        -1755.0,
        -3710.9345703125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0448271781206131,
        -0.018643712624907494,
        0.9988207817077637
      ],
      "plane_d": -1080.427978515625,
      "bbox_min": [
        -1727.430419921875,
        -3706.05908203125,
        935.0
      ],
      "bbox_max": [
        -1699.046875,
        -3689.85400390625,
        936.8104858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07040464878082275,
        -0.13330349326133728,
        0.9885714054107666
      ],
      "plane_d": -1296.7257080078125,
      "bbox_min": [
        -1727.430419921875,
        -3706.05908203125,
        935.0
      ],
      "bbox_max": [
        -1699.046875,
        -3689.85400390625,
        936.8104858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22846738994121552,
        -0.16577208042144775,
        0.9593342542648315
      ],
      "plane_d": -1900.756103515625,
      "bbox_min": [
        -1711.7288818359375,
        -3690.330078125,
        936.0
      ],
      "bbox_max": [
        -1711.6328125,
        -3690.04248046875,
        936.0630493164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23653686046600342,
        -0.1538044661283493,
        0.9593718647956848
      ],
      "plane_d": -1060.6834716796875,
      "bbox_min": [
        -1711.7288818359375,
        -3690.330078125,
        936.0
      ],
      "bbox_max": [
        -1711.6905517578125,
        -3690.04248046875,
        936.0555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08207004517316818,
        -0.19731438159942627,
        0.9768989086151123
      ],
      "plane_d": -1502.0540771484375,
      "bbox_min": [
        -1722.9755859375,
        -3692.48046875,
        936.0
      ],
      "bbox_max": [
        -1711.6905517578125,
        -3689.85400390625,
        936.8104858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23653686046600342,
        -0.1538044661283493,
        0.9593718647956848
      ],
      "plane_d": -1060.6834716796875,
      "bbox_min": [
        -1711.764404296875,
        -3690.330078125,
        936.0
      ],
      "bbox_max": [
        -1711.6905517578125,
        -3690.041748046875,
        936.064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04036008566617966,
        -0.1240561306476593,
        0.9914540648460388
      ],
      "plane_d": -1317.0496826171875,
      "bbox_min": [
        -1755.0,
        -3710.9345703125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.04134446382522583,
        -0.1353481262922287,
        0.9899351000785828
      ],
      "plane_d": -1355.77783203125,
      "bbox_min": [
        -1755.0,
        -3709.463134765625,
        935.0
      ],
      "bbox_max": [
        -1727.430419921875,
        -3706.05908203125,
        935.8079833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018472295254468918,
        -0.0706440806388855,
        -0.9973305463790894
      ],
      "plane_d": 714.5704956054688,
      "bbox_min": [
        -1755.0,
        -3710.9345703125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6943234801292419,
        -0.34586653113365173,
        0.6311031579971313
      ],
      "plane_d": -671.757080078125,
      "bbox_min": [
        -1726.2510986328125,
        -3692.506591796875,
        936.5172119140625
      ],
      "bbox_max": [
        -1720.193115234375,
        -3689.71875,
        941.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06063435599207878,
        -0.132614865899086,
        0.9893112182617188
      ],
      "plane_d": -1519.260009765625,
      "bbox_min": [
        -1755.0,
        -3710.9345703125,
        935.0
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05984721705317497,
        -0.08681593835353851,
        -0.9944251179695129
      ],
      "plane_d": 518.5621337890625,
      "bbox_min": [
        -1755.0,
        -3710.9345703125,
        936.5137329101562
      ],
      "bbox_max": [
        -1667.623291015625,
        -3689.71875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06169648841023445,
        -0.21161502599716187,
        -0.9754037261009216
      ],
      "plane_d": 34.82530975341797,
      "bbox_min": [
        -1693.621337890625,
        -3710.9345703125,
        945.5
      ],
      "bbox_max": [
        -1667.810791015625,
        -3706.691162109375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.282471626996994,
        -0.7856700420379639,
        -0.5503928661346436
      ],
      "plane_d": -1893.089599609375,
      "bbox_min": [
        -1755.0,
        -3702.145751953125,
        936.5137329101562
      ],
      "bbox_max": [
        -1722.9429931640625,
        -3689.71875,
        944.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08207004517316818,
        -0.19731438159942627,
        0.9768989086151123
      ],
      "plane_d": -1502.0540771484375,
      "bbox_min": [
        -1723.11328125,
        -3692.506591796875,
        936.5137329101562
      ],
      "bbox_max": [
        -1722.9429931640625,
        -3692.44970703125,
        936.52001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4957096576690674,
        -0.7339592576026917,
        -0.4643014967441559
      ],
      "plane_d": -3109.106689453125,
      "bbox_min": [
        -1669.123291015625,
        -3725.0,
        935.0
      ],
      "bbox_max": [
        -1639.08984375,
        -3705.05224609375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5222010016441345,
        -0.7538856863975525,
        -0.3987012207508087
      ],
      "plane_d": -3288.8427734375,
      "bbox_min": [
        -1667.853515625,
        -3725.0,
        941.0
      ],
      "bbox_max": [
        -1642.075927734375,
        -3705.05224609375,
        945.6140747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14099636673927307,
        -0.20355214178562164,
        -0.9688583612442017
      ],
      "plane_d": -73.72895812988281,
      "bbox_min": [
        -1667.853515625,
        -3725.0,
        945.5
      ],
      "bbox_max": [
        -1642.2611083984375,
        -3707.30224609375,
        945.6140747070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5222010016441345,
        -0.7538856863975525,
        0.39870119094848633
      ],
      "plane_d": -4039.1982421875,
      "bbox_min": [
        -1667.8536376953125,
        -3725.0,
        936.3858642578125
      ],
      "bbox_max": [
        -1642.075927734375,
        -3705.05224609375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14099636673927307,
        -0.20355214178562164,
        -0.9688583612442017
      ],
      "plane_d": -73.72895812988281,
      "bbox_min": [
        -1669.123291015625,
        -3725.0,
        935.0
      ],
      "bbox_max": [
        -1642.3095703125,
        -3707.8154296875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12458312511444092,
        -0.16466595232486725,
        0.9784499406814575
      ],
      "plane_d": -1734.27978515625,
      "bbox_min": [
        -1669.123291015625,
        -3725.0,
        935.0
      ],
      "bbox_max": [
        -1643.2301025390625,
        -3714.05224609375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1529887169599533,
        0.20221063494682312,
        -0.9673186540603638
      ],
      "plane_d": 1922.31396484375,
      "bbox_min": [
        -1669.123291015625,
        -3725.0,
        935.0
      ],
      "bbox_max": [
        -1653.9031982421875,
        -3714.05224609375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13330842554569244,
        0.15731118619441986,
        -0.9785101413726807
      ],
      "plane_d": 1732.98828125,
      "bbox_min": [
        -1668.935791015625,
        -3725.0,
        945.39208984375
      ],
      "bbox_max": [
        -1659.6912841796875,
        -3720.80224609375,
        946.0845947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718773603439331,
        0.6748464703559875,
        -0.4664103388786316
      ],
      "plane_d": 3906.3876953125,
      "bbox_min": [
        -1668.935791015625,
        -3725.0,
        945.39208984375
      ],
      "bbox_max": [
        -1663.982177734375,
        -3720.80224609375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1529887169599533,
        0.20221063494682312,
        0.9673186540603638
      ],
      "plane_d": 101.82022094726562,
      "bbox_min": [
        -1669.123291015625,
        -3725.0,
        935.0
      ],
      "bbox_max": [
        -1653.9031982421875,
        -3714.05224609375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13330842554569244,
        0.15731118619441986,
        0.9785101413726807
      ],
      "plane_d": -108.56773376464844,
      "bbox_min": [
        -1668.935791015625,
        -3725.0,
        935.9154052734375
      ],
      "bbox_max": [
        -1659.6912841796875,
        -3720.80224609375,
        936.6079711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718773603439331,
        0.6748464703559875,
        0.4664103388786316
      ],
      "plane_d": 3028.603515625,
      "bbox_min": [
        -1668.935791015625,
        -3725.0,
        936.5
      ],
      "bbox_max": [
        -1663.982177734375,
        -3720.80224609375,
        936.6079711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6156865954399109,
        0.6942403316497803,
        0.37277379631996155
      ],
      "plane_d": 3261.569580078125,
      "bbox_min": [
        -1669.123291015625,
        -3725.0,
        936.5
      ],
      "bbox_max": [
        -1664.0701904296875,
        -3720.80224609375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6156865954399109,
        0.6942403316497803,
        -0.37277379631996155
      ],
      "plane_d": 3963.1298828125,
      "bbox_min": [
        -1669.123291015625,
        -3725.0,
        936.5
      ],
      "bbox_max": [
        -1664.0701904296875,
        -3720.80224609375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718773603439331,
        0.6748464703559875,
        -0.4664103388786316
      ],
      "plane_d": 3906.3876953125,
      "bbox_min": [
        -1668.935791015625,
        -3725.0,
        936.5
      ],
      "bbox_max": [
        -1664.0701904296875,
        -3720.80224609375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718773603439331,
        0.6748464703559875,
        0.4664103388786316
      ],
      "plane_d": 3028.603515625,
      "bbox_min": [
        -1668.935791015625,
        -3725.0,
        936.5
      ],
      "bbox_max": [
        -1664.0701904296875,
        -3720.80224609375,
        937.5482177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8353012800216675,
        -0.34901198744773865,
        -0.42480871081352234
      ],
      "plane_d": -2269.222412109375,
      "bbox_min": [
        -1639.661376953125,
        -3725.0,
        939.3203735351562
      ],
      "bbox_max": [
        -1638.80712890625,
        -3724.323486328125,
        942.6796264648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8353013396263123,
        -0.34901201725006104,
        0.4248087704181671
      ],
      "plane_d": -3068.71240234375,
      "bbox_min": [
        -1639.661376953125,
        -3725.0,
        939.3203735351562
      ],
      "bbox_max": [
        -1638.80712890625,
        -3724.323486328125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04464482516050339,
        -0.3516724407672882,
        0.9350579977035522
      ],
      "plane_d": -2125.474365234375,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        935.0
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6156865954399109,
        0.6942403316497803,
        0.37277379631996155
      ],
      "plane_d": 3261.569580078125,
      "bbox_min": [
        -1666.927001953125,
        -3738.823486328125,
        935.0
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6156865954399109,
        0.6942403316497803,
        -0.37277379631996155
      ],
      "plane_d": 3963.1298828125,
      "bbox_min": [
        -1666.927001953125,
        -3738.823486328125,
        935.0
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718773603439331,
        0.6748464703559875,
        0.4664103388786316
      ],
      "plane_d": 3028.603515625,
      "bbox_min": [
        -1664.837158203125,
        -3738.823486328125,
        935.0
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5718773603439331,
        0.6748464703559875,
        -0.4664103388786316
      ],
      "plane_d": 3906.3876953125,
      "bbox_min": [
        -1664.837158203125,
        -3738.823486328125,
        935.0
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13330842554569244,
        0.15731118619441986,
        0.9785101413726807
      ],
      "plane_d": -108.56773376464844,
      "bbox_min": [
        -1663.982177734375,
        -3737.010986328125,
        935.0
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1529887169599533,
        0.20221063494682312,
        0.9673186540603638
      ],
      "plane_d": 101.82022094726562,
      "bbox_min": [
        -1659.6912841796875,
        -3731.573486328125,
        935.0
      ],
      "bbox_max": [
        -1645.21484375,
        -3725.0,
        935.9154052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12458312511444092,
        -0.16466595232486725,
        0.9784499406814575
      ],
      "plane_d": -1734.27978515625,
      "bbox_min": [
        -1653.9031982421875,
        -3731.573486328125,
        935.0
      ],
      "bbox_max": [
        -1645.21484375,
        -3725.0,
        935.0613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13330842554569244,
        0.15731118619441986,
        -0.9785101413726807
      ],
      "plane_d": 1732.98828125,
      "bbox_min": [
        -1663.982177734375,
        -3737.010986328125,
        935.0
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1529887169599533,
        0.20221063494682312,
        -0.9673186540603638
      ],
      "plane_d": 1922.31396484375,
      "bbox_min": [
        -1659.6912841796875,
        -3731.573486328125,
        946.0845947265625
      ],
      "bbox_max": [
        -1645.21484375,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12458311766386032,
        -0.16466593742370605,
        -0.9784499406814575
      ],
      "plane_d": 107.16300964355469,
      "bbox_min": [
        -1653.9031982421875,
        -3731.573486328125,
        946.9386596679688
      ],
      "bbox_max": [
        -1645.21484375,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12458312511444092,
        -0.16466595232486725,
        0.9784499406814575
      ],
      "plane_d": -1734.27978515625,
      "bbox_min": [
        -1653.421630859375,
        -3731.573486328125,
        935.0
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12458311766386032,
        -0.16466593742370605,
        -0.9784499406814575
      ],
      "plane_d": 107.16300964355469,
      "bbox_min": [
        -1653.42138671875,
        -3731.573486328125,
        936.3590087890625
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14099636673927307,
        -0.20355214178562164,
        -0.9688583612442017
      ],
      "plane_d": -73.72895812988281,
      "bbox_min": [
        -1643.2301025390625,
        -3726.135986328125,
        936.3590087890625
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        945.6409912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4957096576690674,
        -0.7339592576026917,
        -0.4643014967441559
      ],
      "plane_d": -3109.106689453125,
      "bbox_min": [
        -1643.2301025390625,
        -3726.135986328125,
        936.3590087890625
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5222010016441345,
        -0.7538856863975525,
        -0.3987012207508087
      ],
      "plane_d": -3288.8427734375,
      "bbox_min": [
        -1642.2611083984375,
        -3726.135986328125,
        945.257568359375
      ],
      "bbox_max": [
        -1640.62109375,
        -3725.0,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14099638164043427,
        -0.20355218648910522,
        0.9688584208488464
      ],
      "plane_d": -1897.1207275390625,
      "bbox_min": [
        -1643.2301025390625,
        -3726.135986328125,
        936.3590087890625
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        939.3203735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49570977687835693,
        -0.7339593768119812,
        0.46430113911628723
      ],
      "plane_d": -3982.922607421875,
      "bbox_min": [
        -1642.2611083984375,
        -3726.135986328125,
        936.5
      ],
      "bbox_max": [
        -1639.661376953125,
        -3725.0,
        939.3203735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5222010016441345,
        -0.7538856863975525,
        0.39870119094848633
      ],
      "plane_d": -4039.1982421875,
      "bbox_min": [
        -1642.2611083984375,
        -3726.135986328125,
        936.5
      ],
      "bbox_max": [
        -1640.62109375,
        -3725.0,
        936.742431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24599575996398926,
        -0.842688262462616,
        0.478918194770813
      ],
      "plane_d": -4023.988037109375,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.7672119140625,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.127153217792511,
        -0.2435910850763321,
        0.9615067839622498
      ],
      "plane_d": -2033.915283203125,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.7672119140625,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15280823409557343,
        -0.24193567037582397,
        0.9581841230392456
      ],
      "plane_d": -1552.895751953125,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.7672119140625,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4761888384819031,
        -0.7461191415786743,
        0.4653497338294983
      ],
      "plane_d": -2445.32275390625,
      "bbox_min": [
        -1701.1209716796875,
        -3778.16259765625,
        937.9686279296875
      ],
      "bbox_max": [
        -1700.97705078125,
        -3777.95947265625,
        938.0225830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01011640951037407,
        -0.25487616658210754,
        0.9669207334518433
      ],
      "plane_d": -1852.6971435546875,
      "bbox_min": [
        -1701.1103515625,
        -3778.16259765625,
        937.9686279296875
      ],
      "bbox_max": [
        -1700.97705078125,
        -3777.95947265625,
        938.0223388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2657856345176697,
        -0.8546001315116882,
        0.4461126923561096
      ],
      "plane_d": -4070.936279296875,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.7672119140625,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03241300210356712,
        -0.251219779253006,
        0.9673871994018555
      ],
      "plane_d": -1908.889892578125,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.7672119140625,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7688782811164856,
        -0.36060476303100586,
        -0.5280059576034546
      ],
      "plane_d": -2140.578125,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.7672119140625,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6980690956115723,
        -0.49600571393966675,
        0.5164086222648621
      ],
      "plane_d": -3519.3251953125,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.7672119140625,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6909632682800293,
        -0.48769912123680115,
        0.533591091632843
      ],
      "plane_d": -3492.461181640625,
      "bbox_min": [
        -1680.0675048828125,
        -3760.87353515625,
        943.5
      ],
      "bbox_max": [
        -1669.7672119140625,
        -3746.827392578125,
        948.1014404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40619856119155884,
        -0.7719826698303223,
        -0.4889228641986847
      ],
      "plane_d": -3110.539306640625,
      "bbox_min": [
        -1677.9205322265625,
        -3746.93798828125,
        948.0
      ],
      "bbox_max": [
        -1677.7393798828125,
        -3746.827392578125,
        948.1014404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20776121318340302,
        -0.2535672187805176,
        0.9447426795959473
      ],
      "plane_d": -1490.089599609375,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.96826171875,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16399310529232025,
        -0.12098494172096252,
        0.9790143370628357
      ],
      "plane_d": -1101.3155517578125,
      "bbox_min": [
        -1714.742919921875,
        -3743.8330078125,
        948.0
      ],
      "bbox_max": [
        -1702.5269775390625,
        -3739.273193359375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08426851034164429,
        -0.8860228657722473,
        0.45591920614242554
      ],
      "plane_d": -3601.947021484375,
      "bbox_min": [
        -1711.5450439453125,
        -3739.49853515625,
        948.0
      ],
      "bbox_max": [
        -1702.5269775390625,
        -3739.273193359375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18544593453407288,
        0.05325925722718239,
        0.9812100529670715
      ],
      "plane_d": -1031.67919921875,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.96826171875,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15339013934135437,
        0.04405297338962555,
        0.987183153629303
      ],
      "plane_d": -1018.042236328125,
      "bbox_min": [
        -1685.6278076171875,
        -3779.409423828125,
        938.0
      ],
      "bbox_max": [
        -1681.8201904296875,
        -3774.80859375,
        938.4747924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1898244172334671,
        -0.0772196426987648,
        0.9787766933441162
      ],
      "plane_d": -1529.304443359375,
      "bbox_min": [
        -1684.3065185546875,
        -3775.4423828125,
        938.0
      ],
      "bbox_max": [
        -1681.8201904296875,
        -3774.80859375,
        938.4747924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04228940233588219,
        0.21931250393390656,
        -0.9747377634048462
      ],
      "plane_d": 1682.63525390625,
      "bbox_min": [
        -1718.5859375,
        -3786.293701171875,
        936.5
      ],
      "bbox_max": [
        -1669.96826171875,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622434496879578,
        -0.3452620208263397,
        -0.5475208759307861
      ],
      "plane_d": -2053.33056640625,
      "bbox_min": [
        -1718.5859375,
        -3783.486328125,
        936.5
      ],
      "bbox_max": [
        -1669.96826171875,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40619856119155884,
        -0.7719826698303223,
        -0.4889228641986847
      ],
      "plane_d": -3110.539306640625,
      "bbox_min": [
        -1718.5859375,
        -3783.486328125,
        936.5
      ],
      "bbox_max": [
        -1671.449951171875,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1898244172334671,
        -0.0772196426987648,
        0.9787766933441162
      ],
      "plane_d": -1529.304443359375,
      "bbox_min": [
        -1718.5859375,
        -3783.486328125,
        936.5
      ],
      "bbox_max": [
        -1671.449951171875,
        -3738.620849609375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15337200462818146,
        -0.06239099055528641,
        0.9861968755722046
      ],
      "plane_d": -1419.185302734375,
      "bbox_min": [
        -1681.04931640625,
        -3770.678955078125,
        939.5
      ],
      "bbox_max": [
        -1671.569091796875,
        -3762.641845703125,
        941.43017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8241796493530273,
        0.13714832067489624,
        0.5494710206985474
      ],
      "plane_d": -1378.9217529296875,
      "bbox_min": [
        -1672.0089111328125,
        -3763.2890625,
        940.9384765625
      ],
      "bbox_max": [
        -1671.569091796875,
        -3762.641845703125,
        941.43017578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.17555537819862366,
        -0.1331346333026886,
        0.9754257798194885
      ],
      "plane_d": -1122.3878173828125,
      "bbox_min": [
        -1718.5859375,
        -3783.486328125,
        936.5
      ],
      "bbox_max": [
        -1671.449951171875,
        -3746.53759765625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01011640951037407,
        -0.25487616658210754,
        0.9669207334518433
      ],
      "plane_d": -1852.6971435546875,
      "bbox_min": [
        -1702.8487548828125,
        -3783.486328125,
        936.5
      ],
      "bbox_max": [
        -1681.04931640625,
        -3763.802734375,
        941.6814575195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08064378798007965,
        -0.26309970021247864,
        0.9613924026489258
      ],
      "plane_d": -1759.1082763671875,
      "bbox_min": [
        -1694.7353515625,
        -3783.486328125,
        936.5
      ],
      "bbox_max": [
        -1681.04931640625,
        -3763.802734375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08865679055452347,
        -0.24028052389621735,
        0.9666464328765869
      ],
      "plane_d": -1664.402099609375,
      "bbox_min": [
        -1693.1658935546875,
        -3774.80859375,
        938.0
      ],
      "bbox_max": [
        -1681.04931640625,
        -3763.802734375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18037843704223633,
        -0.18504509329795837,
        0.9660341739654541
      ],
      "plane_d": -1300.837158203125,
      "bbox_min": [
        -1690.23681640625,
        -3774.80859375,
        938.0
      ],
      "bbox_max": [
        -1681.04931640625,
        -3763.802734375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.719903290271759,
        -0.41382649540901184,
        0.557213544845581
      ],
      "plane_d": -865.5577392578125,
      "bbox_min": [
        -1693.1658935546875,
        -3772.04296875,
        939.5
      ],
      "bbox_max": [
        -1690.23681640625,
        -3764.927734375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.719903290271759,
        -0.41382649540901184,
        0.557213544845581
      ],
      "plane_d": -865.5577392578125,
      "bbox_min": [
        -1693.1658935546875,
        -3772.04296875,
        939.5
      ],
      "bbox_max": [
        -1690.8162841796875,
        -3765.99072265625,
        940.959228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4761888384819031,
        -0.7461191415786743,
        0.4653497338294983
      ],
      "plane_d": -2445.32275390625,
      "bbox_min": [
        -1702.8487548828125,
        -3778.039794921875,
        938.0220947265625
      ],
      "bbox_max": [
        -1691.0933837890625,
        -3766.4990234375,
        941.6814575195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.719903290271759,
        -0.41382649540901184,
        0.557213544845581
      ],
      "plane_d": -865.5577392578125,
      "bbox_min": [
        -1702.8487548828125,
        -3778.039794921875,
        938.0220947265625
      ],
      "bbox_max": [
        -1691.0933837890625,
        -3766.4990234375,
        941.6814575195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4311477243900299,
        -0.7478467226028442,
        0.504813551902771
      ],
      "plane_d": -2565.486572265625,
      "bbox_min": [
        -1702.8487548828125,
        -3778.039794921875,
        938.0220947265625
      ],
      "bbox_max": [
        -1698.45556640625,
        -3774.364013671875,
        941.6814575195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09150524437427521,
        0.23209568858146667,
        -0.9683792591094971
      ],
      "plane_d": 1641.9542236328125,
      "bbox_min": [
        -1718.5859375,
        -3783.486328125,
        940.7367553710938
      ],
      "bbox_max": [
        -1671.449951171875,
        -3746.53759765625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20001673698425293,
        0.15116630494594574,
        0.9680608510971069
      ],
      "plane_d": -9.010406494140625,
      "bbox_min": [
        -1718.5859375,
        -3777.128173828125,
        940.7367553710938
      ],
      "bbox_max": [
        -1687.0518798828125,
        -3746.53759765625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7925426959991455,
        0.2424003928899765,
        0.5595694184303284
      ],
      "plane_d": 1725.6500244140625,
      "bbox_min": [
        -1703.2353515625,
        -3777.128173828125,
        940.7367553710938
      ],
      "bbox_max": [
        -1687.0518798828125,
        -3753.4013671875,
        944.7142944335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4311477243900299,
        -0.7478467226028442,
        0.504813551902771
      ],
      "plane_d": -2565.486572265625,
      "bbox_min": [
        -1703.2353515625,
        -3776.56591796875,
        940.7367553710938
      ],
      "bbox_max": [
        -1693.9775390625,
        -3771.24853515625,
        943.7432861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4761888384819031,
        -0.7461191415786743,
        0.4653497338294983
      ],
      "plane_d": -2445.32275390625,
      "bbox_min": [
        -1698.45556640625,
        -3774.364013671875,
        940.7367553710938
      ],
      "bbox_max": [
        -1693.9775390625,
        -3771.24853515625,
        943.5521850585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7432280778884888,
        -0.4802660644054413,
        0.46578583121299744
      ],
      "plane_d": -990.239990234375,
      "bbox_min": [
        -1694.4488525390625,
        -3769.362548828125,
        941.0
      ],
      "bbox_max": [
        -1690.23681640625,
        -3764.927734375,
        943.148193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31820744276046753,
        -0.1688590794801712,
        0.9328614473342896
      ],
      "plane_d": -975.718994140625,
      "bbox_min": [
        -1694.0362548828125,
        -3764.927734375,
        941.0
      ],
      "bbox_max": [
        -1687.0518798828125,
        -3753.4013671875,
        943.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46052873134613037,
        0.7317205667495728,
        0.5024920701980591
      ],
      "plane_d": 3056.05908203125,
      "bbox_min": [
        -1717.133056640625,
        -3783.486328125,
        941.4071655273438
      ],
      "bbox_max": [
        -1671.449951171875,
        -3746.53759765625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07664580643177032,
        0.8773496150970459,
        0.47369083762168884
      ],
      "plane_d": 2974.99462890625,
      "bbox_min": [
        -1717.133056640625,
        -3783.486328125,
        942.5570068359375
      ],
      "bbox_max": [
        -1687.2596435546875,
        -3748.607177734375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6434131860733032,
        0.5905600190162659,
        -0.4870917499065399
      ],
      "plane_d": 3773.673828125,
      "bbox_min": [
        -1702.189697265625,
        -3783.486328125,
        942.5570068359375
      ],
      "bbox_max": [
        -1687.2596435546875,
        -3758.2763671875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16022354364395142,
        -0.021974677219986916,
        -0.9868361353874207
      ],
      "plane_d": 1124.40966796875,
      "bbox_min": [
        -1702.189697265625,
        -3783.486328125,
        942.9058837890625
      ],
      "bbox_max": [
        -1687.2596435546875,
        -3764.969482421875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20245642960071564,
        0.12151037901639938,
        -0.9717234969139099
      ],
      "plane_d": 1722.814453125,
      "bbox_min": [
        -1693.1658935546875,
        -3773.88671875,
        948.5
      ],
      "bbox_max": [
        -1687.2596435546875,
        -3764.969482421875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8145354986190796,
        -0.22235766053199768,
        -0.5358068346977234
      ],
      "plane_d": 1048.61376953125,
      "bbox_min": [
        -1693.1658935546875,
        -3772.04296875,
        948.5
      ],
      "bbox_max": [
        -1690.5771484375,
        -3764.969482421875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5672186017036438,
        -0.6355099678039551,
        -0.523822546005249
      ],
      "plane_d": -940.0261840820312,
      "bbox_min": [
        -1702.189697265625,
        -3778.048828125,
        942.9058837890625
      ],
      "bbox_max": [
        -1691.1400146484375,
        -3765.038330078125,
        948.6729125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7893961071968079,
        -0.2365136593580246,
        -0.5664936304092407
      ],
      "plane_d": 981.7581176757812,
      "bbox_min": [
        -1701.1103515625,
        -3778.048828125,
        942.918701171875
      ],
      "bbox_max": [
        -1691.1400146484375,
        -3765.038330078125,
        948.6729125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5779713988304138,
        -0.637198269367218,
        -0.5098308324813843
      ],
      "plane_d": -941.36328125,
      "bbox_min": [
        -1701.1103515625,
        -3778.048828125,
        944.0
      ],
      "bbox_max": [
        -1691.1400146484375,
        -3765.038330078125,
        948.6729125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8145354986190796,
        -0.22235766053199768,
        -0.5358068346977234
      ],
      "plane_d": 1048.61376953125,
      "bbox_min": [
        -1693.29931640625,
        -3772.04296875,
        945.5
      ],
      "bbox_max": [
        -1691.1400146484375,
        -3765.038330078125,
        948.6729125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4311477243900299,
        -0.7478467226028442,
        0.504813551902771
      ],
      "plane_d": -2565.486572265625,
      "bbox_min": [
        -1697.3369140625,
        -3771.99658203125,
        943.3782958984375
      ],
      "bbox_max": [
        -1695.7110595703125,
        -3771.12109375,
        944.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4761888384819031,
        -0.7461191415786743,
        0.4653497338294983
      ],
      "plane_d": -2445.32275390625,
      "bbox_min": [
        -1696.4915771484375,
        -3771.63818359375,
        943.3782958984375
      ],
      "bbox_max": [
        -1695.7110595703125,
        -3771.12109375,
        944.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7432280778884888,
        -0.4802660644054413,
        0.46578583121299744
      ],
      "plane_d": -990.239990234375,
      "bbox_min": [
        -1696.1190185546875,
        -3771.12109375,
        942.9058837890625
      ],
      "bbox_max": [
        -1693.15673828125,
        -3767.58642578125,
        944.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7432280778884888,
        -0.4802660644054413,
        0.46578583121299744
      ],
      "plane_d": -990.239990234375,
      "bbox_min": [
        -1693.29931640625,
        -3767.597900390625,
        942.5570068359375
      ],
      "bbox_max": [
        -1691.29638671875,
        -3765.057373046875,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8270545601844788,
        0.23242802917957306,
        0.5118182301521301
      ],
      "plane_d": 1791.688720703125,
      "bbox_min": [
        -1696.3643798828125,
        -3765.302734375,
        943.5
      ],
      "bbox_max": [
        -1693.29931640625,
        -3758.2763671875,
        948.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20001673698425293,
        0.15116630494594574,
        0.9680608510971069
      ],
      "plane_d": -9.010406494140625,
      "bbox_min": [
        -1717.133056640625,
        -3754.021240234375,
        948.0
      ],
      "bbox_max": [
        -1706.2769775390625,
        -3748.607177734375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24716691672801971,
        0.29721325635910034,
        0.9222650527954102
      ],
      "plane_d": 663.0662841796875,
      "bbox_min": [
        -1716.35009765625,
        -3754.021240234375,
        948.0
      ],
      "bbox_max": [
        -1706.2769775390625,
        -3749.940185546875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37496891617774963,
        0.09545239806175232,
        0.9221101403236389
      ],
      "plane_d": 123.93649291992188,
      "bbox_min": [
        -1715.5347900390625,
        -3764.0322265625,
        941.4071655273438
      ],
      "bbox_max": [
        -1671.449951171875,
        -3746.53759765625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20001673698425293,
        0.15116630494594574,
        0.9680608510971069
      ],
      "plane_d": -9.010406494140625,
      "bbox_min": [
        -1715.5347900390625,
        -3753.66259765625,
        946.5
      ],
      "bbox_max": [
        -1704.4019775390625,
        -3746.53759765625,
        949.1234130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07664580643177032,
        0.8773496150970459,
        0.47369083762168884
      ],
      "plane_d": 2974.99462890625,
      "bbox_min": [
        -1706.6829833984375,
        -3754.454345703125,
        948.0
      ],
      "bbox_max": [
        -1706.2769775390625,
        -3753.66259765625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6434131860733032,
        0.5905600190162659,
        -0.4870917499065399
      ],
      "plane_d": 3773.673828125,
      "bbox_min": [
        -1699.876953125,
        -3763.77880859375,
        941.4071655273438
      ],
      "bbox_max": [
        -1671.449951171875,
        -3758.613525390625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15665780007839203,
        0.9002783894538879,
        -0.40614914894104004
      ],
      "plane_d": 4035.736083984375,
      "bbox_min": [
        -1699.876953125,
        -3759.9013671875,
        948.0
      ],
      "bbox_max": [
        -1695.752685546875,
        -3758.613525390625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6342456936836243,
        0.5618966221809387,
        -0.531041145324707
      ],
      "plane_d": 3692.0146484375,
      "bbox_min": [
        -1696.3643798828125,
        -3763.671142578125,
        941.4071655273438
      ],
      "bbox_max": [
        -1671.449951171875,
        -3759.3310546875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15665780007839203,
        0.9002783894538879,
        -0.40614914894104004
      ],
      "plane_d": 4035.736083984375,
      "bbox_min": [
        -1696.3643798828125,
        -3759.9013671875,
        948.0
      ],
      "bbox_max": [
        -1695.58837890625,
        -3759.3310546875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.865427553653717,
        0.2875504791736603,
        -0.4103046953678131
      ],
      "plane_d": 2890.312255859375,
      "bbox_min": [
        -1691.4439697265625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3725.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6073133945465088,
        0.16578488051891327,
        -0.776972234249115
      ],
      "plane_d": 2353.85205078125,
      "bbox_min": [
        -1691.4439697265625,
        -3810.47607421875,
        937.2744140625
      ],
      "bbox_max": [
        -1626.2039794921875,
        -3738.823486328125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5464208722114563,
        0.6743042469024658,
        -0.4967272877693176
      ],
      "plane_d": 2102.880859375,
      "bbox_min": [
        -1691.4439697265625,
        -3790.736328125,
        937.2744140625
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996442437171936,
        0.6096530556678772,
        0.5184108018875122
      ],
      "plane_d": 811.2906494140625,
      "bbox_min": [
        -1691.4439697265625,
        -3790.736328125,
        937.2744140625
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5290439128875732,
        0.670646607875824,
        -0.5199478268623352
      ],
      "plane_d": 2140.20263671875,
      "bbox_min": [
        -1691.4439697265625,
        -3790.736328125,
        937.2744140625
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5951794981956482,
        0.6076816916465759,
        0.5258176326751709
      ],
      "plane_d": 804.3653564453125,
      "bbox_min": [
        -1691.4439697265625,
        -3790.736328125,
        937.2744140625
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8241796493530273,
        0.13714832067489624,
        0.5494710206985474
      ],
      "plane_d": -1378.9217529296875,
      "bbox_min": [
        -1691.4439697265625,
        -3788.923828125,
        937.2744140625
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.814555823802948,
        0.1393483281135559,
        0.5630993247032166
      ],
      "plane_d": -1367.37841796875,
      "bbox_min": [
        -1691.4439697265625,
        -3788.923828125,
        937.2744140625
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15339013934135437,
        0.04405297338962555,
        0.987183153629303
      ],
      "plane_d": -1018.042236328125,
      "bbox_min": [
        -1691.4439697265625,
        -3788.923828125,
        937.2744140625
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18544593453407288,
        0.05325925722718239,
        0.9812100529670715
      ],
      "plane_d": -1031.67919921875,
      "bbox_min": [
        -1691.4439697265625,
        -3788.923828125,
        937.2744140625
      ],
      "bbox_max": [
        -1685.6278076171875,
        -3779.409423828125,
        938.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09150524437427521,
        0.23209568858146667,
        -0.9683792591094971
      ],
      "plane_d": 1641.9542236328125,
      "bbox_min": [
        -1691.4439697265625,
        -3788.923828125,
        938.34375
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8102931976318359,
        0.24846681952476501,
        -0.5307439565658569
      ],
      "plane_d": 84.4090576171875,
      "bbox_min": [
        -1691.4439697265625,
        -3788.923828125,
        938.34375
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7905066013336182,
        0.2328355610370636,
        -0.5664688944816589
      ],
      "plane_d": 92.3973388671875,
      "bbox_min": [
        -1675.4471435546875,
        -3778.49609375,
        944.0
      ],
      "bbox_max": [
        -1668.79931640625,
        -3762.302734375,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15337200462818146,
        -0.06239099055528641,
        0.9861968755722046
      ],
      "plane_d": -1419.185302734375,
      "bbox_min": [
        -1691.4439697265625,
        -3788.923828125,
        938.34375
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1898244172334671,
        -0.0772196426987648,
        0.9787766933441162
      ],
      "plane_d": -1529.304443359375,
      "bbox_min": [
        -1682.2763671875,
        -3777.57421875,
        938.34375
      ],
      "bbox_max": [
        -1675.4471435546875,
        -3770.678955078125,
        939.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04228940233588219,
        0.21931250393390656,
        -0.9747377634048462
      ],
      "plane_d": 1682.63525390625,
      "bbox_min": [
        -1691.4439697265625,
        -3788.923828125,
        941.6052856445312
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17627021670341492,
        0.1405280977487564,
        -0.9742590188980103
      ],
      "plane_d": 1159.6085205078125,
      "bbox_min": [
        -1681.3533935546875,
        -3777.57421875,
        941.6052856445312
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11365069448947906,
        0.16711382567882538,
        -0.9793654084205627
      ],
      "plane_d": 1369.797119140625,
      "bbox_min": [
        -1681.3533935546875,
        -3777.57421875,
        941.6052856445312
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622434496879578,
        -0.3452620208263397,
        -0.5475208759307861
      ],
      "plane_d": -2053.33056640625,
      "bbox_min": [
        -1671.449951171875,
        -3762.627197265625,
        941.6052856445312
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        949.3949584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6909632682800293,
        -0.48769912123680115,
        0.533591091632843
      ],
      "plane_d": -3492.461181640625,
      "bbox_min": [
        -1671.449951171875,
        -3762.627197265625,
        941.6052856445312
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        946.2261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6980690956115723,
        -0.49600571393966675,
        0.5164086222648621
      ],
      "plane_d": -3519.3251953125,
      "bbox_min": [
        -1671.449951171875,
        -3762.627197265625,
        941.6052856445312
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.87353515625,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7688782811164856,
        -0.36060476303100586,
        -0.5280059576034546
      ],
      "plane_d": -2140.578125,
      "bbox_min": [
        -1669.96826171875,
        -3762.302734375,
        945.5
      ],
      "bbox_max": [
        -1668.79931640625,
        -3760.635498046875,
        946.2261962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.607313334941864,
        0.16578488051891327,
        0.7769721746444702
      ],
      "plane_d": 891.5902709960938,
      "bbox_min": [
        -1651.33984375,
        -3810.47607421875,
        938.7177734375
      ],
      "bbox_max": [
        -1626.2039794921875,
        -3738.823486328125,
        946.0399780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547726154327393,
        0.6288760304450989,
        -0.5447404384613037
      ],
      "plane_d": 3811.828125,
      "bbox_min": [
        -1633.12744140625,
        -3810.47607421875,
        938.7177734375
      ],
      "bbox_max": [
        -1626.2039794921875,
        -3805.540283203125,
        946.0399780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547725558280945,
        0.6288760304450989,
        0.544740617275238
      ],
      "plane_d": 2786.62646484375,
      "bbox_min": [
        -1633.12744140625,
        -3810.47607421875,
        938.7177734375
      ],
      "bbox_max": [
        -1627.5323486328125,
        -3805.540283203125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.865427553653717,
        0.28755050897598267,
        0.4103046953678131
      ],
      "plane_d": 2118.11865234375,
      "bbox_min": [
        -1651.33984375,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.607313334941864,
        0.16578488051891327,
        0.7769721746444702
      ],
      "plane_d": 891.5902709960938,
      "bbox_min": [
        -1651.33984375,
        -3810.47607421875,
        935.9600219726562
      ],
      "bbox_max": [
        -1626.2039794921875,
        -3738.823486328125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547725558280945,
        0.6288760304450989,
        0.544740617275238
      ],
      "plane_d": 2786.62646484375,
      "bbox_min": [
        -1629.9923095703125,
        -3810.47607421875,
        935.9600219726562
      ],
      "bbox_max": [
        -1626.2039794921875,
        -3806.3291015625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09657304733991623,
        0.024793673306703568,
        0.9950169920921326
      ],
      "plane_d": -679.8521728515625,
      "bbox_min": [
        -1649.80859375,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21440313756465912,
        0.0872364416718483,
        0.972841739654541
      ],
      "plane_d": -231.33859252929688,
      "bbox_min": [
        -1649.80859375,
        -3794.61328125,
        935.0
      ],
      "bbox_max": [
        -1619.565185546875,
        -3729.17333984375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20046472549438477,
        -0.08156517148017883,
        0.9762997031211853
      ],
      "plane_d": -1547.01416015625,
      "bbox_min": [
        -1645.21484375,
        -3794.61328125,
        935.0
      ],
      "bbox_max": [
        -1619.565185546875,
        -3729.17333984375,
        935.662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21305984258651733,
        -0.08842315524816513,
        0.9730296730995178
      ],
      "plane_d": -1590.2694091796875,
      "bbox_min": [
        -1645.21484375,
        -3748.56103515625,
        935.0
      ],
      "bbox_max": [
        -1636.08349609375,
        -3729.17333984375,
        935.662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09657304733991623,
        0.024793673306703568,
        -0.9950169920921326
      ],
      "plane_d": 1192.769775390625,
      "bbox_min": [
        -1649.80859375,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21440313756465912,
        0.0872364416718483,
        -0.972841739654541
      ],
      "plane_d": 1599.549560546875,
      "bbox_min": [
        -1649.80859375,
        -3794.61328125,
        945.5
      ],
      "bbox_max": [
        -1619.565185546875,
        -3729.17333984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20046472549438477,
        -0.08156517148017883,
        -0.9762997031211853
      ],
      "plane_d": 290.38189697265625,
      "bbox_min": [
        -1645.21484375,
        -3794.61328125,
        946.337890625
      ],
      "bbox_max": [
        -1619.565185546875,
        -3729.17333984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21305984258651733,
        -0.08842315524816513,
        -0.9730296730995178
      ],
      "plane_d": 240.97238159179688,
      "bbox_min": [
        -1645.21484375,
        -3748.5625,
        946.337890625
      ],
      "bbox_max": [
        -1636.082763671875,
        -3729.17333984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8248628973960876,
        -0.3423309326171875,
        -0.44990074634552
      ],
      "plane_d": -2203.47802734375,
      "bbox_min": [
        -1643.1871337890625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06191166117787361,
        -0.16880778968334198,
        -0.9837026000022888
      ],
      "plane_d": 190.7361297607422,
      "bbox_min": [
        -1615.158935546875,
        -3797.060791015625,
        939.23974609375
      ],
      "bbox_max": [
        -1612.0,
        -3785.11328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511857360601425,
        -0.9976769685745239
      ],
      "plane_d": 1224.299072265625,
      "bbox_min": [
        -1612.063720703125,
        -3797.060791015625,
        946.991943359375
      ],
      "bbox_max": [
        -1612.0,
        -3796.917724609375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29423192143440247,
        -0.8022502660751343,
        0.519443929195404
      ],
      "plane_d": -4000.203857421875,
      "bbox_min": [
        -1613.690185546875,
        -3786.872802734375,
        939.23974609375
      ],
      "bbox_max": [
        -1612.0,
        -3785.11328125,
        941.3213500976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3313077688217163,
        -0.8417611718177795,
        -0.42623159289360046
      ],
      "plane_d": -3319.70556640625,
      "bbox_min": [
        -1613.690185546875,
        -3785.941162109375,
        940.6786499023438
      ],
      "bbox_max": [
        -1612.0,
        -3785.11328125,
        941.3213500976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3313077688217163,
        -0.8417611718177795,
        0.42623159289360046
      ],
      "plane_d": -4121.87353515625,
      "bbox_min": [
        -1613.690185546875,
        -3785.941162109375,
        940.6786499023438
      ],
      "bbox_max": [
        -1612.0,
        -3785.11328125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8353012800216675,
        -0.34901198744773865,
        -0.42480871081352234
      ],
      "plane_d": -2269.222412109375,
      "bbox_min": [
        -1643.1871337890625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29423192143440247,
        -0.8022502660751343,
        0.519443929195404
      ],
      "plane_d": -4000.203857421875,
      "bbox_min": [
        -1613.690185546875,
        -3786.922607421875,
        939.162841796875
      ],
      "bbox_max": [
        -1612.0,
        -3785.11328125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8248629570007324,
        -0.3423309922218323,
        0.4499008059501648
      ],
      "plane_d": -3050.19140625,
      "bbox_min": [
        -1643.1871337890625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06191166117787361,
        -0.16880778968334198,
        0.9837026000022888
      ],
      "plane_d": -1660.59228515625,
      "bbox_min": [
        -1615.158935546875,
        -3797.060791015625,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3785.11328125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511858105659485,
        0.9976769089698792
      ],
      "plane_d": -653.3289184570312,
      "bbox_min": [
        -1612.063720703125,
        -3797.060791015625,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3796.917724609375,
        935.008056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29423192143440247,
        -0.8022502660751343,
        0.519443929195404
      ],
      "plane_d": -4000.203857421875,
      "bbox_min": [
        -1615.158935546875,
        -3788.646728515625,
        936.5
      ],
      "bbox_max": [
        -1612.0,
        -3785.11328125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8353013396263123,
        -0.34901201725006104,
        0.4248087704181671
      ],
      "plane_d": -3068.71240234375,
      "bbox_min": [
        -1643.1871337890625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3725.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21305984258651733,
        -0.08842315524816513,
        0.9730296730995178
      ],
      "plane_d": -1590.2694091796875,
      "bbox_min": [
        -1643.1871337890625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3726.135986328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511858105659485,
        0.9976769089698792
      ],
      "plane_d": -653.3289184570312,
      "bbox_min": [
        -1618.9775390625,
        -3805.474365234375,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3787.48828125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06191166117787361,
        -0.16880778968334198,
        0.9837026000022888
      ],
      "plane_d": -1660.59228515625,
      "bbox_min": [
        -1618.9775390625,
        -3796.917724609375,
        935.0
      ],
      "bbox_max": [
        -1612.063720703125,
        -3787.48828125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06439700722694397,
        -0.20962128043174744,
        0.9756597876548767
      ],
      "plane_d": -1811.96875,
      "bbox_min": [
        -1618.9775390625,
        -3796.917724609375,
        935.0
      ],
      "bbox_max": [
        -1612.063720703125,
        -3794.66259765625,
        935.3524169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21305984258651733,
        -0.08842315524816513,
        -0.9730296730995178
      ],
      "plane_d": 240.97238159179688,
      "bbox_min": [
        -1643.1871337890625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3726.135986328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511857360601425,
        -0.9976769685745239
      ],
      "plane_d": 1224.299072265625,
      "bbox_min": [
        -1618.9776611328125,
        -3805.47412109375,
        945.5
      ],
      "bbox_max": [
        -1612.0,
        -3787.48828125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06191166117787361,
        -0.16880778968334198,
        -0.9837026000022888
      ],
      "plane_d": 190.7361297607422,
      "bbox_min": [
        -1618.9776611328125,
        -3796.917724609375,
        945.5
      ],
      "bbox_max": [
        -1612.063720703125,
        -3787.48828125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06439700722694397,
        -0.20962128043174744,
        -0.9756597876548767
      ],
      "plane_d": 24.222976684570312,
      "bbox_min": [
        -1618.9776611328125,
        -3796.917724609375,
        946.6475830078125
      ],
      "bbox_max": [
        -1612.063720703125,
        -3794.66259765625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20046472549438477,
        -0.08156517148017883,
        -0.9762997031211853
      ],
      "plane_d": 290.38189697265625,
      "bbox_min": [
        -1636.0836181640625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3748.56103515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511857360601425,
        -0.9976769685745239
      ],
      "plane_d": 1224.299072265625,
      "bbox_min": [
        -1619.565185546875,
        -3806.07080078125,
        945.5
      ],
      "bbox_max": [
        -1612.0,
        -3787.48828125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06191166117787361,
        -0.16880778968334198,
        -0.9837026000022888
      ],
      "plane_d": 190.7361297607422,
      "bbox_min": [
        -1619.565185546875,
        -3794.793701171875,
        945.5
      ],
      "bbox_max": [
        -1615.158935546875,
        -3787.48828125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06439700722694397,
        -0.20962128043174744,
        -0.9756597876548767
      ],
      "plane_d": 24.222976684570312,
      "bbox_min": [
        -1619.565185546875,
        -3794.793701171875,
        946.9647827148438
      ],
      "bbox_max": [
        -1618.8712158203125,
        -3794.61328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20046472549438477,
        -0.08156517148017883,
        0.9762997031211853
      ],
      "plane_d": -1547.01416015625,
      "bbox_min": [
        -1636.08349609375,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3748.56103515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511858105659485,
        0.9976769089698792
      ],
      "plane_d": -653.3289184570312,
      "bbox_min": [
        -1619.565185546875,
        -3806.0703125,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3787.48828125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06191166117787361,
        -0.16880778968334198,
        0.9837026000022888
      ],
      "plane_d": -1660.59228515625,
      "bbox_min": [
        -1619.565185546875,
        -3794.793701171875,
        935.0
      ],
      "bbox_max": [
        -1615.158935546875,
        -3787.48828125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06439700722694397,
        -0.20962128043174744,
        0.9756597876548767
      ],
      "plane_d": -1811.96875,
      "bbox_min": [
        -1619.565185546875,
        -3794.793701171875,
        935.0
      ],
      "bbox_max": [
        -1618.8709716796875,
        -3794.61328125,
        935.0352172851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020004846155643463,
        0.06511857360601425,
        -0.9976769685745239
      ],
      "plane_d": 1224.299072265625,
      "bbox_min": [
        -1627.5323486328125,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3794.61328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02495022676885128,
        0.0048215752467513084,
        -0.9996770620346069
      ],
      "plane_d": 1004.6657104492188,
      "bbox_min": [
        -1626.2039794921875,
        -3813.0,
        945.859375
      ],
      "bbox_max": [
        -1612.0,
        -3806.129150390625,
        946.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037743739783763885,
        0.09482476115226746,
        -0.9947782158851624
      ],
      "plane_d": 1363.503662109375,
      "bbox_min": [
        -1626.2039794921875,
        -3813.0,
        945.859375
      ],
      "bbox_max": [
        -1612.0,
        -3807.2822265625,
        946.3846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02495022863149643,
        0.004821575712412596,
        0.9996771216392517
      ],
      "plane_d": -876.7265625,
      "bbox_min": [
        -1626.2039794921875,
        -3813.0,
        935.5999755859375
      ],
      "bbox_max": [
        -1612.0,
        -3806.129150390625,
        936.1405639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037743739783763885,
        0.09482476115226746,
        0.9947782158851624
      ],
      "plane_d": -508.6690368652344,
      "bbox_min": [
        -1626.2039794921875,
        -3813.0,
        935.6153564453125
      ],
      "bbox_max": [
        -1612.0,
        -3807.2822265625,
        936.1405639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037743739783763885,
        0.09482476115226746,
        -0.9947782158851624
      ],
      "plane_d": 1363.503662109375,
      "bbox_min": [
        -1627.5323486328125,
        -3813.0,
        935.9600219726562
      ],
      "bbox_max": [
        -1616.5992431640625,
        -3807.2822265625,
        946.0399780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4012720286846161,
        0.5803803205490112,
        -0.7086178660392761
      ],
      "plane_d": 3532.6025390625,
      "bbox_min": [
        -1627.5323486328125,
        -3813.0,
        935.9600219726562
      ],
      "bbox_max": [
        -1618.371826171875,
        -3807.2822265625,
        946.0399780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4012720584869385,
        0.580380380153656,
        0.7086179852485657
      ],
      "plane_d": 2198.984130859375,
      "bbox_min": [
        -1627.5323486328125,
        -3813.0,
        935.9600219726562
      ],
      "bbox_max": [
        -1618.371826171875,
        -3807.2822265625,
        946.0399780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.399713933467865,
        -0.7731451988220215,
        0.49241769313812256
      ],
      "plane_d": -4073.88671875,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        935.0
      ],
      "bbox_max": [
        -1738.2646484375,
        -3762.584228515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4174700081348419,
        -0.7864490151405334,
        0.4552105963230133
      ],
      "plane_d": -4120.13134765625,
      "bbox_min": [
        -1755.0,
        -3773.423828125,
        936.4584350585938
      ],
      "bbox_max": [
        -1739.5771484375,
        -3763.111083984375,
        940.1726684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09030041098594666,
        -0.1701120287179947,
        0.9812785983085632
      ],
      "plane_d": -1717.9566650390625,
      "bbox_min": [
        -1755.0,
        -3773.423828125,
        936.4584350585938
      ],
      "bbox_max": [
        -1739.5771484375,
        -3765.23681640625,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4174700081348419,
        -0.7864490151405334,
        -0.4552105963230133
      ],
      "plane_d": -3263.4248046875,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        935.0
      ],
      "bbox_max": [
        -1738.2646484375,
        -3762.584228515625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.399713933467865,
        -0.7731451988220215,
        -0.49241769313812256
      ],
      "plane_d": -3147.156982421875,
      "bbox_min": [
        -1755.0,
        -3773.423828125,
        941.0
      ],
      "bbox_max": [
        -1738.2646484375,
        -3762.584228515625,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09030041098594666,
        -0.1701120138168335,
        -0.9812785983085632
      ],
      "plane_d": 128.8096466064453,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        935.0
      ],
      "bbox_max": [
        -1739.5771484375,
        -3765.23681640625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10383892804384232,
        -0.18276113271713257,
        -0.9776583909988403
      ],
      "plane_d": 53.96327209472656,
      "bbox_min": [
        -1755.0,
        -3779.986328125,
        945.9766235351562
      ],
      "bbox_max": [
        -1743.5146484375,
        -3767.986328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09504114836454391,
        0.16727665066719055,
        -0.9813183546066284
      ],
      "plane_d": 1727.3175048828125,
      "bbox_min": [
        -1755.0,
        -3779.986328125,
        946.963134765625
      ],
      "bbox_max": [
        -1743.5146484375,
        -3773.460693359375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09030041098594666,
        -0.1701120287179947,
        0.9812785983085632
      ],
      "plane_d": -1717.9566650390625,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        935.0
      ],
      "bbox_max": [
        -1739.5771484375,
        -3765.4765625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10383892059326172,
        -0.18276111781597137,
        0.9776583313941956
      ],
      "plane_d": -1785.98974609375,
      "bbox_min": [
        -1755.0,
        -3779.986328125,
        935.0
      ],
      "bbox_max": [
        -1743.5146484375,
        -3767.986328125,
        936.0233764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09504114836454391,
        0.16727665066719055,
        0.9813183546066284
      ],
      "plane_d": -119.5235595703125,
      "bbox_min": [
        -1755.0,
        -3779.986328125,
        935.0
      ],
      "bbox_max": [
        -1743.5146484375,
        -3773.460693359375,
        935.0368041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09504114836454391,
        0.16727665066719055,
        0.9813183546066284
      ],
      "plane_d": -119.5235595703125,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        935.0
      ],
      "bbox_max": [
        -1743.5146484375,
        -3773.6767578125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09504114836454391,
        0.16727665066719055,
        -0.9813183546066284
      ],
      "plane_d": 1727.3175048828125,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        935.8887329101562
      ],
      "bbox_max": [
        -1743.5146484375,
        -3773.6767578125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10733222216367722,
        0.17880146205425262,
        -0.9780131578445435
      ],
      "plane_d": 1789.309814453125,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        935.8887329101562
      ],
      "bbox_max": [
        -1747.4521484375,
        -3778.674560546875,
        946.1112670898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10733222216367722,
        0.17880146205425262,
        0.9780131578445435
      ],
      "plane_d": -51.3109130859375,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        935.8887329101562
      ],
      "bbox_max": [
        -1747.4521484375,
        -3778.674560546875,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4477357268333435,
        0.7458693385124207,
        -0.49316495656967163
      ],
      "plane_d": 4072.954833984375,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        936.5
      ],
      "bbox_max": [
        -1747.4521484375,
        -3782.01806640625,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4477357864379883,
        0.7458693385124207,
        0.49316495656967163
      ],
      "plane_d": 3144.818603515625,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        936.5
      ],
      "bbox_max": [
        -1747.4521484375,
        -3782.01806640625,
        942.2288208007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46160078048706055,
        0.7566993236541748,
        -0.46295875310897827
      ],
      "plane_d": 4109.8095703125,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        939.7711791992188
      ],
      "bbox_max": [
        -1748.7646484375,
        -3784.180908203125,
        942.2288208007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46160078048706055,
        0.7566993236541748,
        0.4629588723182678
      ],
      "plane_d": 3238.52099609375,
      "bbox_min": [
        -1755.0,
        -3788.736328125,
        939.7711791992188
      ],
      "bbox_max": [
        -1748.7646484375,
        -3784.180908203125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4067182242870331,
        0.769355297088623,
        0.4926183223724365
      ],
      "plane_d": 3162.5849609375,
      "bbox_min": [
        -1748.7646484375,
        -3800.93408203125,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4067182242870331,
        0.769355297088623,
        -0.4926183223724365
      ],
      "plane_d": 4089.69287109375,
      "bbox_min": [
        -1748.7646484375,
        -3800.93408203125,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3872987926006317,
        0.7525067329406738,
        0.5326660871505737
      ],
      "plane_d": 3027.347900390625,
      "bbox_min": [
        -1747.4521484375,
        -3800.93408203125,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3872987926006317,
        0.7525067329406738,
        -0.5326660871505737
      ],
      "plane_d": 4029.825439453125,
      "bbox_min": [
        -1747.4521484375,
        -3800.93408203125,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06622421741485596,
        0.09116021543741226,
        -0.9936317801475525
      ],
      "plane_d": 1400.385009765625,
      "bbox_min": [
        -1747.4521484375,
        -3797.994140625,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.07411664724349976,
        0.17973987758159637,
        -0.9809181094169617
      ],
      "plane_d": 1737.5672607421875,
      "bbox_min": [
        -1747.4521484375,
        -3789.079833984375,
        945.5
      ],
      "bbox_max": [
        -1721.4620361328125,
        -3778.22216796875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07411664724349976,
        -0.17973987758159637,
        -0.9809181094169617
      ],
      "plane_d": 120.29170227050781,
      "bbox_min": [
        -1743.5146484375,
        -3789.079833984375,
        946.5968017578125
      ],
      "bbox_max": [
        -1721.4620361328125,
        -3778.22216796875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06622421741485596,
        0.09116021543741226,
        0.9936317801475525
      ],
      "plane_d": -469.6299133300781,
      "bbox_min": [
        -1747.4521484375,
        -3797.994140625,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.07411664724349976,
        0.17973987758159637,
        0.9809181094169617
      ],
      "plane_d": -108.52072143554688,
      "bbox_min": [
        -1747.4521484375,
        -3789.079833984375,
        935.0
      ],
      "bbox_max": [
        -1721.4620361328125,
        -3778.222412109375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07411664724349976,
        -0.17973987758159637,
        0.9809181094169617
      ],
      "plane_d": -1725.7962646484375,
      "bbox_min": [
        -1743.5146484375,
        -3789.079833984375,
        935.0
      ],
      "bbox_max": [
        -1721.4620361328125,
        -3778.222412109375,
        935.4031372070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0007207528688013554,
        -0.09454670548439026,
        -0.9955201745033264
      ],
      "plane_d": 585.7532958984375,
      "bbox_min": [
        -1742.4561767578125,
        -3789.229248046875,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07411664724349976,
        -0.17973987758159637,
        -0.9809181094169617
      ],
      "plane_d": 120.29170227050781,
      "bbox_min": [
        -1742.4561767578125,
        -3789.079833984375,
        945.5
      ],
      "bbox_max": [
        -1721.4620361328125,
        -3773.423828125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2376393973827362,
        -0.7860981225967407,
        -0.5705937147140503
      ],
      "plane_d": -2840.17724609375,
      "bbox_min": [
        -1739.5771484375,
        -3789.229248046875,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2316037118434906,
        -0.8466455340385437,
        -0.4791148602962494
      ],
      "plane_d": -3144.6416015625,
      "bbox_min": [
        -1739.5771484375,
        -3789.229248046875,
        935.0
      ],
      "bbox_max": [
        -1716.625,
        -3771.236328125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.057979848235845566,
        -0.10626766085624695,
        0.9926457405090332
      ],
      "plane_d": -1430.5904541015625,
      "bbox_min": [
        -1721.4620361328125,
        -3789.229248046875,
        935.0
      ],
      "bbox_max": [
        -1720.862060546875,
        -3788.3818359375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.034950435161590576,
        -0.06405847519636154,
        -0.9973338842391968
      ],
      "plane_d": 641.586669921875,
      "bbox_min": [
        -1721.4620361328125,
        -3789.229248046875,
        946.9341430664062
      ],
      "bbox_max": [
        -1720.862060546875,
        -3788.3818359375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4733531177043915,
        0.6952812671661377,
        -0.540851891040802
      ],
      "plane_d": 2347.36376953125,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1686.2353515625,
        -3776.236328125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7736882567405701,
        0.20922663807868958,
        -0.5980223417282104
      ],
      "plane_d": 42.8154296875,
      "bbox_min": [
        -1705.3992919921875,
        -3801.0,
        942.7822875976562
      ],
      "bbox_max": [
        -1701.279296875,
        -3799.921142578125,
        946.3880004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11628187447786331,
        0.08510337024927139,
        -0.989563524723053
      ],
      "plane_d": 1061.681884765625,
      "bbox_min": [
        -1705.3992919921875,
        -3801.0,
        946.2156982421875
      ],
      "bbox_max": [
        -1703.6910400390625,
        -3799.921142578125,
        946.3880004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49222683906555176,
        0.701718270778656,
        -0.5150769948959351
      ],
      "plane_d": 2315.478515625,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1686.2353515625,
        -3776.236328125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08042412996292114,
        0.17634087800979614,
        -0.9810382127761841
      ],
      "plane_d": 1461.400390625,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1686.2353515625,
        -3776.236328125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08999401330947876,
        -0.0028123129159212112,
        -0.9959383010864258
      ],
      "plane_d": 778.427978515625,
      "bbox_min": [
        -1713.0892333984375,
        -3801.0,
        946.280029296875
      ],
      "bbox_max": [
        -1703.6910400390625,
        -3799.554443359375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09754284471273422,
        0.0030482138972729445,
        -0.9952266812324524
      ],
      "plane_d": 1121.022705078125,
      "bbox_min": [
        -1713.0892333984375,
        -3801.0,
        946.8565063476562
      ],
      "bbox_max": [
        -1711.625,
        -3799.554443359375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16802319884300232,
        0.06026086211204529,
        0.9839394688606262
      ],
      "plane_d": -978.437255859375,
      "bbox_min": [
        -1707.2210693359375,
        -3801.0,
        935.6632690429688
      ],
      "bbox_max": [
        -1703.6910400390625,
        -3799.921142578125,
        936.24169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7949953675270081,
        0.1915421187877655,
        0.5755813717842102
      ],
      "plane_d": -1165.4407958984375,
      "bbox_min": [
        -1703.93310546875,
        -3801.0,
        936.2000122070312
      ],
      "bbox_max": [
        -1703.6910400390625,
        -3799.921142578125,
        936.24169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.531930685043335,
        0.6533656120300293,
        0.5386678576469421
      ],
      "plane_d": 1072.19140625,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1686.2353515625,
        -3776.236328125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7949953675270081,
        0.1915421187877655,
        0.5755813717842102
      ],
      "plane_d": -1165.4407958984375,
      "bbox_min": [
        -1703.9208984375,
        -3801.0,
        936.2000122070312
      ],
      "bbox_max": [
        -1701.2791748046875,
        -3799.921142578125,
        939.8902587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5423941612243652,
        0.658713161945343,
        0.521445631980896
      ],
      "plane_d": 1090.941162109375,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1686.2353515625,
        -3776.236328125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08305107057094574,
        -0.18180008232593536,
        0.979822039604187
      ],
      "plane_d": -1747.20166015625,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1694.7353515625,
        -3776.236328125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03400755301117897,
        -0.2285272479057312,
        0.9729433059692383
      ],
      "plane_d": -1718.1573486328125,
      "bbox_min": [
        -1706.0172119140625,
        -3789.954833984375,
        935.375
      ],
      "bbox_max": [
        -1694.7353515625,
        -3778.048828125,
        938.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1285545527935028,
        0.05197533220052719,
        0.990339457988739
      ],
      "plane_d": -948.6708984375,
      "bbox_min": [
        -1706.0172119140625,
        -3789.954833984375,
        935.375
      ],
      "bbox_max": [
        -1694.7353515625,
        -3783.486328125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16195067763328552,
        -0.8864686489105225,
        0.43352657556533813
      ],
      "plane_d": -3480.27392578125,
      "bbox_min": [
        -1718.2552490234375,
        -3781.60595703125,
        936.0773315429688
      ],
      "bbox_max": [
        -1701.1103515625,
        -3776.236328125,
        942.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2531822621822357,
        -0.7988235354423523,
        0.545691967010498
      ],
      "plane_d": -3965.770263671875,
      "bbox_min": [
        -1718.2552490234375,
        -3781.60595703125,
        936.0773315429688
      ],
      "bbox_max": [
        -1714.9033203125,
        -3777.3681640625,
        941.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.030199315398931503,
        -0.12989680469036102,
        0.9910674691200256
      ],
      "plane_d": -1470.824462890625,
      "bbox_min": [
        -1718.2552490234375,
        -3781.60595703125,
        936.0773315429688
      ],
      "bbox_max": [
        -1714.9033203125,
        -3780.49755859375,
        936.235595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23533105850219727,
        -0.8579374551773071,
        -0.45668670535087585
      ],
      "plane_d": -2408.523193359375,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1694.7353515625,
        -3776.236328125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11816131323575974,
        -0.7425679564476013,
        -0.6592652797698975
      ],
      "plane_d": -1981.498046875,
      "bbox_min": [
        -1718.6058349609375,
        -3782.517333984375,
        941.375
      ],
      "bbox_max": [
        -1703.2353515625,
        -3776.236328125,
        946.3788452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2376393973827362,
        -0.7860981225967407,
        -0.5705937147140503
      ],
      "plane_d": -2840.17724609375,
      "bbox_min": [
        -1718.4296875,
        -3782.0595703125,
        941.375
      ],
      "bbox_max": [
        -1714.9033203125,
        -3777.3681640625,
        946.3355102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0007207528688013554,
        -0.09454670548439026,
        -0.9955201745033264
      ],
      "plane_d": 585.7532958984375,
      "bbox_min": [
        -1718.4296875,
        -3782.0595703125,
        946.1875610351562
      ],
      "bbox_max": [
        -1714.9033203125,
        -3780.49755859375,
        946.3355102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0007207528688013554,
        -0.09454670548439026,
        -0.9955201745033264
      ],
      "plane_d": 585.7532958984375,
      "bbox_min": [
        -1718.6058349609375,
        -3782.517333984375,
        946.280029296875
      ],
      "bbox_max": [
        -1714.9033203125,
        -3781.448974609375,
        946.3788452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03215252235531807,
        0.11656557768583298,
        -0.9926623702049255
      ],
      "plane_d": 1437.0545654296875,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1694.7353515625,
        -3778.048828125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04978793114423752,
        0.09125319868326187,
        -0.9945822954177856
      ],
      "plane_d": 1373.3431396484375,
      "bbox_min": [
        -1724.5958251953125,
        -3801.0,
        945.583251953125
      ],
      "bbox_max": [
        -1703.6910400390625,
        -3789.078857421875,
        947.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09754284471273422,
        0.0030482138972729445,
        -0.9952266812324524
      ],
      "plane_d": 1121.022705078125,
      "bbox_min": [
        -1721.4656982421875,
        -3801.0,
        945.9314575195312
      ],
      "bbox_max": [
        -1708.2095947265625,
        -3794.333251953125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12013634294271469,
        0.0851246565580368,
        -0.9891011714935303
      ],
      "plane_d": 1465.9744873046875,
      "bbox_min": [
        -1721.4656982421875,
        -3801.0,
        945.9314575195312
      ],
      "bbox_max": [
        -1716.302490234375,
        -3799.541259765625,
        946.5415649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6929394006729126,
        0.288609117269516,
        -0.6607116460800171
      ],
      "plane_d": 2914.51318359375,
      "bbox_min": [
        -1721.4656982421875,
        -3801.0,
        945.9314575195312
      ],
      "bbox_max": [
        -1720.9139404296875,
        -3799.541259765625,
        946.0399780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015419281087815762,
        0.10564041882753372,
        -0.9942849278450012
      ],
      "plane_d": 1316.027587890625,
      "bbox_min": [
        -1724.5958251953125,
        -3801.0,
        945.583251953125
      ],
      "bbox_max": [
        -1703.6910400390625,
        -3789.078857421875,
        947.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08999401330947876,
        -0.0028123129159212112,
        -0.9959383010864258
      ],
      "plane_d": 778.427978515625,
      "bbox_min": [
        -1711.8333740234375,
        -3799.921142578125,
        946.280029296875
      ],
      "bbox_max": [
        -1703.6910400390625,
        -3794.333251953125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06622421741485596,
        0.09116021543741226,
        -0.9936317801475525
      ],
      "plane_d": 1400.385009765625,
      "bbox_min": [
        -1724.5958251953125,
        -3801.0,
        945.583251953125
      ],
      "bbox_max": [
        -1720.961669921875,
        -3789.942138671875,
        946.9208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3872987926006317,
        0.7525067329406738,
        -0.5326660871505737
      ],
      "plane_d": 4029.825439453125,
      "bbox_min": [
        -1724.5958251953125,
        -3801.0,
        945.583251953125
      ],
      "bbox_max": [
        -1720.961669921875,
        -3797.994140625,
        946.0399780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15174783766269684,
        -0.09353259205818176,
        -0.9839839339256287
      ],
      "plane_d": 836.6019287109375,
      "bbox_min": [
        -1721.1302490234375,
        -3791.583984375,
        946.280029296875
      ],
      "bbox_max": [
        -1694.7353515625,
        -3778.048828125,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.034950435161590576,
        -0.06405847519636154,
        -0.9973338842391968
      ],
      "plane_d": 641.586669921875,
      "bbox_min": [
        -1721.1302490234375,
        -3791.583984375,
        946.280029296875
      ],
      "bbox_max": [
        -1714.3831787109375,
        -3781.448974609375,
        946.98828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0007207528688013554,
        -0.09454670548439026,
        -0.9955201745033264
      ],
      "plane_d": 585.7532958984375,
      "bbox_min": [
        -1720.862060546875,
        -3788.3818359375,
        946.280029296875
      ],
      "bbox_max": [
        -1714.9033203125,
        -3781.448974609375,
        946.9341430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08991894125938416,
        -0.03419555351138115,
        -0.995361864566803
      ],
      "plane_d": 966.7845458984375,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1697.3681640625,
        -3781.448974609375,
        947.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.034950435161590576,
        -0.06405847519636154,
        -0.9973338842391968
      ],
      "plane_d": 641.586669921875,
      "bbox_min": [
        -1714.9033203125,
        -3792.355712890625,
        946.280029296875
      ],
      "bbox_max": [
        -1712.3045654296875,
        -3781.448974609375,
        946.9127197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0047609927132725716,
        -0.09161060303449631,
        0.9957835078239441
      ],
      "plane_d": -1270.5086669921875,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1697.3681640625,
        -3781.448974609375,
        945.8182983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.057979848235845566,
        -0.10626766085624695,
        0.9926457405090332
      ],
      "plane_d": -1430.5904541015625,
      "bbox_min": [
        -1722.149658203125,
        -3794.333251953125,
        935.0
      ],
      "bbox_max": [
        -1711.8333740234375,
        -3781.448974609375,
        936.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04978792369365692,
        0.09125319123268127,
        0.9945822954177856
      ],
      "plane_d": -498.4608154296875,
      "bbox_min": [
        -1722.149658203125,
        -3794.333251953125,
        935.0
      ],
      "bbox_max": [
        -1711.8333740234375,
        -3781.448974609375,
        936.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06622421741485596,
        0.09116021543741226,
        0.9936317801475525
      ],
      "plane_d": -469.6299133300781,
      "bbox_min": [
        -1722.149658203125,
        -3791.9599609375,
        935.0791015625
      ],
      "bbox_max": [
        -1721.4622802734375,
        -3789.942138671875,
        935.288818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1285545527935028,
        0.05197533220052719,
        0.990339457988739
      ],
      "plane_d": -948.6708984375,
      "bbox_min": [
        -1711.8333740234375,
        -3799.921142578125,
        935.0
      ],
      "bbox_max": [
        -1697.3681640625,
        -3788.31787109375,
        936.4118041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10704652220010757,
        0.05718318372964859,
        0.9926081895828247
      ],
      "plane_d": -894.3623657226562,
      "bbox_min": [
        -1711.8333740234375,
        -3799.921142578125,
        935.0
      ],
      "bbox_max": [
        -1703.6910400390625,
        -3789.954833984375,
        936.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04978792369365692,
        0.09125319123268127,
        0.9945822954177856
      ],
      "plane_d": -498.4608154296875,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.0
      ],
      "bbox_max": [
        -1711.625,
        -3791.72900390625,
        945.8182983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12013634294271469,
        0.0851246565580368,
        0.9891011714935303
      ],
      "plane_d": -395.513916015625,
      "bbox_min": [
        -1721.4656982421875,
        -3801.0,
        935.4584350585938
      ],
      "bbox_max": [
        -1716.302490234375,
        -3799.541259765625,
        936.068603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6929394006729126,
        0.288609117269516,
        0.6607116460800171
      ],
      "plane_d": 1671.053955078125,
      "bbox_min": [
        -1721.4656982421875,
        -3801.0,
        935.9600219726562
      ],
      "bbox_max": [
        -1720.9139404296875,
        -3799.541259765625,
        936.068603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06622421741485596,
        0.09116021543741226,
        0.9936317801475525
      ],
      "plane_d": -469.6299133300781,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        935.2642822265625
      ],
      "bbox_max": [
        -1720.961669921875,
        -3791.72900390625,
        945.8182983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3872987926006317,
        0.7525067329406738,
        0.5326660871505737
      ],
      "plane_d": 3027.347900390625,
      "bbox_min": [
        -1725.691162109375,
        -3800.93408203125,
        935.9600219726562
      ],
      "bbox_max": [
        -1721.4656982421875,
        -3797.994140625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3872987926006317,
        0.7525067329406738,
        -0.5326660871505737
      ],
      "plane_d": 4029.825439453125,
      "bbox_min": [
        -1725.691162109375,
        -3800.93408203125,
        941.0
      ],
      "bbox_max": [
        -1721.7252197265625,
        -3798.087158203125,
        945.8182983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8066834211349487,
        0.5142031311988831,
        -0.29130232334136963
      ],
      "plane_d": 3620.654052734375,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        940.9754028320312
      ],
      "bbox_max": [
        -1725.6402587890625,
        -3800.93408203125,
        941.0245971679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8066834211349487,
        0.5142031311988831,
        0.29130232334136963
      ],
      "plane_d": 3072.423095703125,
      "bbox_min": [
        -1725.691162109375,
        -3801.0,
        940.9754028320312
      ],
      "bbox_max": [
        -1725.6402587890625,
        -3800.93408203125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8066834211349487,
        0.5142031311988831,
        -0.29130232334136963
      ],
      "plane_d": 3620.654052734375,
      "bbox_min": [
        -1725.649169921875,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1699.73779296875,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8066834211349487,
        0.5142031311988831,
        0.29130232334136963
      ],
      "plane_d": 3072.423095703125,
      "bbox_min": [
        -1725.649169921875,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1699.73779296875,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6929394006729126,
        0.288609117269516,
        0.6607116460800171
      ],
      "plane_d": 1671.053955078125,
      "bbox_min": [
        -1725.6402587890625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1699.73779296875,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6929394006729126,
        0.288609117269516,
        -0.6607116460800171
      ],
      "plane_d": 2914.51318359375,
      "bbox_min": [
        -1725.6402587890625,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1699.73779296875,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7949953675270081,
        0.1915421187877655,
        0.5755813717842102
      ],
      "plane_d": -1165.4407958984375,
      "bbox_min": [
        -1720.9139404296875,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1699.73779296875,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.531930685043335,
        0.6533656120300293,
        0.5386678576469421
      ],
      "plane_d": 1072.19140625,
      "bbox_min": [
        -1701.279296875,
        -3801.43408203125,
        939.8902587890625
      ],
      "bbox_max": [
        -1699.73779296875,
        -3801.0,
        941.6605224609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49222683906555176,
        0.701718270778656,
        -0.5150769948959351
      ],
      "plane_d": 2315.478515625,
      "bbox_min": [
        -1700.308837890625,
        -3801.43408203125,
        941.375
      ],
      "bbox_max": [
        -1699.73779296875,
        -3801.0,
        941.6605224609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7736882567405701,
        0.20922663807868958,
        -0.5980223417282104
      ],
      "plane_d": 42.8154296875,
      "bbox_min": [
        -1720.9139404296875,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1699.9974365234375,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4733531177043915,
        0.6952812671661377,
        -0.540851891040802
      ],
      "plane_d": 2347.36376953125,
      "bbox_min": [
        -1701.2791748046875,
        -3801.43408203125,
        941.375
      ],
      "bbox_max": [
        -1699.9974365234375,
        -3801.0,
        942.7822875976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8819721341133118,
        0.34740352630615234,
        0.3184899389743805
      ],
      "plane_d": -478.8118896484375,
      "bbox_min": [
        -1720.9139404296875,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1700.308837890625,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8755273818969727,
        0.36536672711372375,
        -0.316162645816803
      ],
      "plane_d": 197.878173828125,
      "bbox_min": [
        -1720.9139404296875,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1700.308837890625,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12013634294271469,
        0.0851246565580368,
        -0.9891011714935303
      ],
      "plane_d": 1465.9744873046875,
      "bbox_min": [
        -1720.9139404296875,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1703.93310546875,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2940850853919983,
        0.002298644045367837,
        -0.9557765126228333
      ],
      "plane_d": 1417.211669921875,
      "bbox_min": [
        -1716.375,
        -3813.0,
        945.5
      ],
      "bbox_max": [
        -1709.38427734375,
        -3802.333251953125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2940850853919983,
        -0.002298644045367837,
        -0.9557765126228333
      ],
      "plane_d": 393.02899169921875,
      "bbox_min": [
        -1711.5833740234375,
        -3813.0,
        946.3489990234375
      ],
      "bbox_max": [
        -1709.38427734375,
        -3802.333251953125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2940850853919983,
        -0.002298644045367837,
        -0.9557765126228333
      ],
      "plane_d": 393.02899169921875,
      "bbox_min": [
        -1711.5833740234375,
        -3813.0,
        945.5
      ],
      "bbox_max": [
        -1706.625,
        -3802.333251953125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2940850853919983,
        -0.002298644045367837,
        0.9557765126228333
      ],
      "plane_d": -1405.742431640625,
      "bbox_min": [
        -1711.5833740234375,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1709.3843994140625,
        -3802.333251953125,
        935.6509399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2940850853919983,
        -0.002298644045367837,
        0.9557765126228333
      ],
      "plane_d": -1405.742431640625,
      "bbox_min": [
        -1711.5833740234375,
        -3813.0,
        935.0
      ],
      "bbox_max": [
        -1706.625,
        -3802.333251953125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14892812073230743,
        -0.004654003772884607,
        0.9888370633125305
      ],
      "plane_d": -1197.16162109375,
      "bbox_min": [
        -1711.625,
        -3802.333251953125,
        935.0
      ],
      "bbox_max": [
        -1707.2210693359375,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08999401330947876,
        -0.0028123129159212112,
        -0.9959383010864258
      ],
      "plane_d": 778.427978515625,
      "bbox_min": [
        -1711.625,
        -3802.333251953125,
        946.60205078125
      ],
      "bbox_max": [
        -1707.2210693359375,
        -3801.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11365069448947906,
        0.16711382567882538,
        -0.9793654084205627
      ],
      "plane_d": 1369.797119140625,
      "bbox_min": [
        -1691.213134765625,
        -3777.701171875,
        949.5
      ],
      "bbox_max": [
        -1671.521484375,
        -3762.635986328125,
        951.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17627021670341492,
        0.1405280977487564,
        -0.9742590188980103
      ],
      "plane_d": 1159.6085205078125,
      "bbox_min": [
        -1691.213134765625,
        -3777.701171875,
        949.5
      ],
      "bbox_max": [
        -1671.521484375,
        -3762.635986328125,
        951.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14975056052207947,
        0.08987735956907272,
        -0.9846302270889282
      ],
      "plane_d": 1526.8944091796875,
      "bbox_min": [
        -1691.213134765625,
        -3777.701171875,
        949.5
      ],
      "bbox_max": [
        -1671.521484375,
        -3762.635986328125,
        951.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16022354364395142,
        -0.021974677219986916,
        -0.9868361353874207
      ],
      "plane_d": 1124.40966796875,
      "bbox_min": [
        -1687.7828369140625,
        -3777.701171875,
        949.5
      ],
      "bbox_max": [
        -1684.3065185546875,
        -3774.80859375,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04228940233588219,
        0.21931250393390656,
        -0.9747377634048462
      ],
      "plane_d": 1682.63525390625,
      "bbox_min": [
        -1687.7828369140625,
        -3777.701171875,
        949.5
      ],
      "bbox_max": [
        -1684.3065185546875,
        -3774.80859375,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20245642960071564,
        0.12151037901639938,
        -0.9717234969139099
      ],
      "plane_d": 1722.814453125,
      "bbox_min": [
        -1691.213134765625,
        -3777.36865234375,
        949.5
      ],
      "bbox_max": [
        -1671.521484375,
        -3762.635986328125,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16022354364395142,
        -0.021974677219986916,
        -0.9868361353874207
      ],
      "plane_d": 1124.40966796875,
      "bbox_min": [
        -1687.4248046875,
        -3777.36865234375,
        949.5
      ],
      "bbox_max": [
        -1684.3065185546875,
        -3773.88671875,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04228940233588219,
        0.21931250393390656,
        -0.9747377634048462
      ],
      "plane_d": 1682.63525390625,
      "bbox_min": [
        -1686.0582275390625,
        -3777.36865234375,
        949.5
      ],
      "bbox_max": [
        -1684.3065185546875,
        -3774.80859375,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8102931976318359,
        0.24846681952476501,
        -0.5307439565658569
      ],
      "plane_d": 84.4090576171875,
      "bbox_min": [
        -1691.213134765625,
        -3777.215087890625,
        949.5
      ],
      "bbox_max": [
        -1671.521484375,
        -3762.635986328125,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09150524437427521,
        0.23209568858146667,
        -0.9683792591094971
      ],
      "plane_d": 1641.9542236328125,
      "bbox_min": [
        -1691.213134765625,
        -3777.215087890625,
        949.5
      ],
      "bbox_max": [
        -1681.3533935546875,
        -3764.927734375,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04228940233588219,
        0.21931250393390656,
        -0.9747377634048462
      ],
      "plane_d": 1682.63525390625,
      "bbox_min": [
        -1691.213134765625,
        -3777.215087890625,
        949.5
      ],
      "bbox_max": [
        -1684.3065185546875,
        -3764.927734375,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8145354986190796,
        -0.22235766053199768,
        -0.5358068346977234
      ],
      "plane_d": 1048.61376953125,
      "bbox_min": [
        -1691.213134765625,
        -3767.299560546875,
        949.5
      ],
      "bbox_max": [
        -1690.23681640625,
        -3764.927734375,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622434496879578,
        -0.3452620208263397,
        -0.5475208759307861
      ],
      "plane_d": -2053.33056640625,
      "bbox_min": [
        -1695.58837890625,
        -3764.969482421875,
        949.5
      ],
      "bbox_max": [
        -1671.521484375,
        -3747.443115234375,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2622433602809906,
        0.07980754971504211,
        -0.9616959691047668
      ],
      "plane_d": 774.5894775390625,
      "bbox_min": [
        -1695.58837890625,
        -3764.969482421875,
        949.5
      ],
      "bbox_max": [
        -1671.86181640625,
        -3747.443115234375,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16964086890220642,
        0.07522639632225037,
        -0.9826306104660034
      ],
      "plane_d": 932.9356079101562,
      "bbox_min": [
        -1681.04931640625,
        -3763.802734375,
        950.0
      ],
      "bbox_max": [
        -1671.86181640625,
        -3748.5263671875,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.032027408480644226,
        0.3355688154697418,
        -0.9414710402488708
      ],
      "plane_d": 2103.65576171875,
      "bbox_min": [
        -1695.58837890625,
        -3764.969482421875,
        949.5
      ],
      "bbox_max": [
        -1675.23828125,
        -3747.443115234375,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1184711828827858,
        0.2961660921573639,
        -0.9477606415748596
      ],
      "plane_d": 2215.660888671875,
      "bbox_min": [
        -1690.23681640625,
        -3764.927734375,
        950.0
      ],
      "bbox_max": [
        -1681.04931640625,
        -3753.4013671875,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7688782811164856,
        -0.36060476303100586,
        -0.5280059576034546
      ],
      "plane_d": -2140.578125,
      "bbox_min": [
        -1695.58837890625,
        -3764.969482421875,
        949.5
      ],
      "bbox_max": [
        -1675.23828125,
        -3747.443115234375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6342456936836243,
        0.5618966221809387,
        -0.531041145324707
      ],
      "plane_d": 3692.0146484375,
      "bbox_min": [
        -1695.58837890625,
        -3764.969482421875,
        949.5
      ],
      "bbox_max": [
        -1690.23681640625,
        -3758.2763671875,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6434131860733032,
        0.5905600190162659,
        -0.4870917499065399
      ],
      "plane_d": 3773.673828125,
      "bbox_min": [
        -1691.7686767578125,
        -3764.969482421875,
        949.5
      ],
      "bbox_max": [
        -1690.23681640625,
        -3763.671142578125,
        950.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4111386835575104,
        -0.7813714146614075,
        -0.4694930613040924
      ],
      "plane_d": -3172.5400390625,
      "bbox_min": [
        -1706.9019775390625,
        -3759.359619140625,
        949.5
      ],
      "bbox_max": [
        -1678.515380859375,
        -3737.03759765625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40619856119155884,
        -0.7719826698303223,
        -0.4889228641986847
      ],
      "plane_d": -3110.539306640625,
      "bbox_min": [
        -1701.9019775390625,
        -3748.5263671875,
        949.5
      ],
      "bbox_max": [
        -1678.515380859375,
        -3737.03759765625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2657856345176697,
        -0.8546001315116882,
        0.4461126923561096
      ],
      "plane_d": -4070.936279296875,
      "bbox_min": [
        -1701.9019775390625,
        -3743.613525390625,
        949.5
      ],
      "bbox_max": [
        -1685.7935791015625,
        -3737.03759765625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20142413675785065,
        -0.012781400233507156,
        -0.9794206619262695
      ],
      "plane_d": 546.58056640625,
      "bbox_min": [
        -1706.9019775390625,
        -3759.359619140625,
        949.5
      ],
      "bbox_max": [
        -1680.0675048828125,
        -3737.03759765625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2941766083240509,
        -0.1221458837389946,
        -0.9479137659072876
      ],
      "plane_d": -50.443939208984375,
      "bbox_min": [
        -1705.3699951171875,
        -3753.4013671875,
        954.0
      ],
      "bbox_max": [
        -1687.0518798828125,
        -3739.41259765625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08033949136734009,
        0.3964914381504059,
        -0.9145163893699646
      ],
      "plane_d": 2225.103271484375,
      "bbox_min": [
        -1705.3699951171875,
        -3753.4013671875,
        954.0
      ],
      "bbox_max": [
        -1687.0518798828125,
        -3746.53759765625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24488675594329834,
        0.26102375984191895,
        -0.9337543249130249
      ],
      "plane_d": 1455.5533447265625,
      "bbox_min": [
        -1705.3699951171875,
        -3750.216064453125,
        956.9758911132812
      ],
      "bbox_max": [
        -1701.7689208984375,
        -3746.53759765625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2657856345176697,
        -0.8546001315116882,
        0.4461126923561096
      ],
      "plane_d": -4070.936279296875,
      "bbox_min": [
        -1706.9019775390625,
        -3759.359619140625,
        949.5
      ],
      "bbox_max": [
        -1686.2467041015625,
        -3737.03759765625,
        957.7255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.150607630610466,
        0.8655093312263489,
        -0.47771430015563965
      ],
      "plane_d": 3962.98095703125,
      "bbox_min": [
        -1706.9019775390625,
        -3759.359619140625,
        949.5
      ],
      "bbox_max": [
        -1687.0518798828125,
        -3737.03759765625,
        957.7255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08033949136734009,
        0.3964914381504059,
        -0.9145163893699646
      ],
      "plane_d": 2225.103271484375,
      "bbox_min": [
        -1706.9019775390625,
        -3759.359619140625,
        949.5
      ],
      "bbox_max": [
        -1687.0518798828125,
        -3737.03759765625,
        957.7255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24488675594329834,
        0.26102375984191895,
        -0.9337543249130249
      ],
      "plane_d": 1455.5533447265625,
      "bbox_min": [
        -1706.2769775390625,
        -3758.2763671875,
        952.5
      ],
      "bbox_max": [
        -1694.0362548828125,
        -3749.519287109375,
        957.7255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15665780007839203,
        0.9002783894538879,
        -0.40614914894104004
      ],
      "plane_d": 4035.736083984375,
      "bbox_min": [
        -1706.9019775390625,
        -3759.359619140625,
        949.5
      ],
      "bbox_max": [
        -1694.0362548828125,
        -3737.03759765625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24599575996398926,
        -0.842688262462616,
        0.478918194770813
      ],
      "plane_d": -4023.988037109375,
      "bbox_min": [
        -1706.9019775390625,
        -3758.613525390625,
        949.5
      ],
      "bbox_max": [
        -1694.623779296875,
        -3737.03759765625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47245892882347107,
        0.7506760954856873,
        0.4618094563484192
      ],
      "plane_d": 3186.13525390625,
      "bbox_min": [
        -1706.9019775390625,
        -3758.613525390625,
        949.5
      ],
      "bbox_max": [
        -1699.876953125,
        -3754.454345703125,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06981081515550613,
        -0.8781920671463013,
        -0.473186194896698
      ],
      "plane_d": -2949.93798828125,
      "bbox_min": [
        -1728.4674072265625,
        -3757.1484375,
        949.5
      ],
      "bbox_max": [
        -1701.9019775390625,
        -3737.03759765625,
        962.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0699511393904686,
        -0.8794181942939758,
        -0.47088268399238586
      ],
      "plane_d": -2956.96630859375,
      "bbox_min": [
        -1728.4674072265625,
        -3739.666015625,
        956.625
      ],
      "bbox_max": [
        -1702.5269775390625,
        -3737.1484375,
        961.12841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15593737363815308,
        -0.26165133714675903,
        -0.9524819850921631
      ],
      "plane_d": -332.3846130371094,
      "bbox_min": [
        -1727.3267822265625,
        -3739.666015625,
        957.0
      ],
      "bbox_max": [
        -1702.5269775390625,
        -3739.41259765625,
        961.12841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08426851034164429,
        -0.8860228657722473,
        0.45591920614242554
      ],
      "plane_d": -3601.947021484375,
      "bbox_min": [
        -1727.3267822265625,
        -3739.697509765625,
        949.5
      ],
      "bbox_max": [
        -1701.9019775390625,
        -3737.03759765625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16399310529232025,
        -0.12098494172096252,
        0.9790143370628357
      ],
      "plane_d": -1101.3155517578125,
      "bbox_min": [
        -1727.3267822265625,
        -3739.697509765625,
        949.5
      ],
      "bbox_max": [
        -1711.5450439453125,
        -3739.49853515625,
        952.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15593737363815308,
        -0.26165133714675903,
        -0.9524819850921631
      ],
      "plane_d": -332.3846130371094,
      "bbox_min": [
        -1727.3267822265625,
        -3757.1484375,
        949.5
      ],
      "bbox_max": [
        -1702.5269775390625,
        -3739.41259765625,
        962.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20776121318340302,
        0.2535672187805176,
        -0.9447426795959473
      ],
      "plane_d": 1501.4263916015625,
      "bbox_min": [
        -1727.3267822265625,
        -3757.1484375,
        949.5
      ],
      "bbox_max": [
        -1704.4019775390625,
        -3739.648681640625,
        962.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28231170773506165,
        0.0626482143998146,
        -0.957274854183197
      ],
      "plane_d": 669.5703735351562,
      "bbox_min": [
        -1723.9049072265625,
        -3755.53271484375,
        957.0
      ],
      "bbox_max": [
        -1706.2769775390625,
        -3747.1484375,
        962.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20719650387763977,
        0.8319705128669739,
        -0.5146792531013489
      ],
      "plane_d": 3261.949951171875,
      "bbox_min": [
        -1720.4830322265625,
        -3755.53271484375,
        957.0
      ],
      "bbox_max": [
        -1706.2769775390625,
        -3753.66259765625,
        961.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22103716433048248,
        0.8748481273651123,
        -0.43102577328681946
      ],
      "plane_d": 3319.225830078125,
      "bbox_min": [
        -1727.3267822265625,
        -3757.1484375,
        949.5
      ],
      "bbox_max": [
        -1706.2769775390625,
        -3739.648681640625,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16399310529232025,
        -0.12098494172096252,
        0.9790143370628357
      ],
      "plane_d": -1101.3155517578125,
      "bbox_min": [
        -1727.3267822265625,
        -3756.03759765625,
        949.5
      ],
      "bbox_max": [
        -1706.4853515625,
        -3739.648681640625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20776121318340302,
        -0.2535672187805176,
        0.9447426795959473
      ],
      "plane_d": -1490.089599609375,
      "bbox_min": [
        -1723.9049072265625,
        -3747.999755859375,
        949.5
      ],
      "bbox_max": [
        -1714.742919921875,
        -3743.8330078125,
        950.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20001673698425293,
        0.15116630494594574,
        0.9680608510971069
      ],
      "plane_d": -9.010406494140625,
      "bbox_min": [
        -1723.9049072265625,
        -3747.999755859375,
        949.5
      ],
      "bbox_max": [
        -1717.816650390625,
        -3746.98193359375,
        950.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07664580643177032,
        0.8773496150970459,
        0.47369083762168884
      ],
      "plane_d": 2974.99462890625,
      "bbox_min": [
        -1723.9049072265625,
        -3756.03759765625,
        949.5
      ],
      "bbox_max": [
        -1706.4853515625,
        -3747.1484375,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24716691672801971,
        0.29721325635910034,
        0.9222650527954102
      ],
      "plane_d": 663.0662841796875,
      "bbox_min": [
        -1723.9049072265625,
        -3754.648681640625,
        949.5
      ],
      "bbox_max": [
        -1711.44287109375,
        -3747.1484375,
        952.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20001673698425293,
        0.15116630494594574,
        0.9680608510971069
      ],
      "plane_d": -9.010406494140625,
      "bbox_min": [
        -1723.9049072265625,
        -3749.940185546875,
        949.5
      ],
      "bbox_max": [
        -1716.35009765625,
        -3747.1484375,
        950.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5449427962303162,
        -0.6554672718048096,
        -0.5228767991065979
      ],
      "plane_d": -1007.4655151367188,
      "bbox_min": [
        -1744.615966796875,
        -3766.6708984375,
        950.625
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3737.1484375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5556496977806091,
        -0.6589654684066772,
        -0.5069694519042969
      ],
      "plane_d": -1017.2495727539062,
      "bbox_min": [
        -1742.553466796875,
        -3753.5458984375,
        956.625
      ],
      "bbox_max": [
        -1727.2740478515625,
        -3737.1484375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06406660377979279,
        -0.16753163933753967,
        -0.9837828278541565
      ],
      "plane_d": 429.6927185058594,
      "bbox_min": [
        -1742.553466796875,
        -3753.5458984375,
        961.125
      ],
      "bbox_max": [
        -1727.2740478515625,
        -3739.648681640625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5930757522583008,
        -0.6096938848495483,
        0.5258654952049255
      ],
      "plane_d": -1756.4605712890625,
      "bbox_min": [
        -1744.615966796875,
        -3753.5458984375,
        953.5
      ],
      "bbox_max": [
        -1728.4674072265625,
        -3737.1484375,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18801604211330414,
        -0.10943136364221573,
        0.9760505557060242
      ],
      "plane_d": -1013.791748046875,
      "bbox_min": [
        -1742.553466796875,
        -3766.6708984375,
        950.625
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3739.648681640625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17515571415424347,
        -0.06922315061092377,
        0.9821041822433472
      ],
      "plane_d": -891.0504150390625,
      "bbox_min": [
        -1742.553466796875,
        -3766.6708984375,
        950.625
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3739.764404296875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06988241523504257,
        -0.18455204367637634,
        -0.9803351163864136
      ],
      "plane_d": 372.6218566894531,
      "bbox_min": [
        -1742.553466796875,
        -3766.6708984375,
        950.625
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3739.764404296875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06406660377979279,
        -0.16753163933753967,
        -0.9837828278541565
      ],
      "plane_d": 429.6927185058594,
      "bbox_min": [
        -1742.553466796875,
        -3753.5458984375,
        961.1481323242188
      ],
      "bbox_max": [
        -1723.9049072265625,
        -3739.764404296875,
        962.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2050202637910843,
        0.10115940123796463,
        -0.9735159873962402
      ],
      "plane_d": 962.754638671875,
      "bbox_min": [
        -1736.365966796875,
        -3759.1708984375,
        961.125
      ],
      "bbox_max": [
        -1720.4830322265625,
        -3747.1484375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.062491290271282196,
        0.19241224229335785,
        0.9793224930763245
      ],
      "plane_d": -317.51226806640625,
      "bbox_min": [
        -1736.365966796875,
        -3766.6708984375,
        952.0
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3754.648681640625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5786029696464539,
        0.62400883436203,
        0.5251967310905457
      ],
      "plane_d": 847.404296875,
      "bbox_min": [
        -1730.178466796875,
        -3766.6708984375,
        952.125
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3754.648681640625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000866293907166,
        0.6249871850013733,
        0.4992864429950714
      ],
      "plane_d": 838.7855224609375,
      "bbox_min": [
        -1730.178466796875,
        -3766.6708984375,
        952.125
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3754.648681640625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6643405556678772,
        0.569105863571167,
        -0.48453086614608765
      ],
      "plane_d": 1459.5006103515625,
      "bbox_min": [
        -1730.178466796875,
        -3766.6708984375,
        956.625
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3754.648681640625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6620054244995117,
        0.5340011119842529,
        -0.5259196162223816
      ],
      "plane_d": 1371.2152099609375,
      "bbox_min": [
        -1730.178466796875,
        -3766.6708984375,
        956.625
      ],
      "bbox_max": [
        -1719.3424072265625,
        -3757.1484375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19030475616455078,
        -0.05208936706185341,
        0.9803422093391418
      ],
      "plane_d": -798.6599731445312,
      "bbox_min": [
        -1751.0999755859375,
        -3781.39990234375,
        952.0
      ],
      "bbox_max": [
        -1728.115966796875,
        -3751.6708984375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19099846482276917,
        -0.052609335631132126,
        0.980179488658905
      ],
      "plane_d": -799.2550659179688,
      "bbox_min": [
        -1748.7406005859375,
        -3778.40478515625,
        952.0
      ],
      "bbox_max": [
        -1736.365966796875,
        -3759.1708984375,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19007164239883423,
        0.05235404521226883,
        0.9803732633590698
      ],
      "plane_d": -1066.54150390625,
      "bbox_min": [
        -1741.6624755859375,
        -3778.40478515625,
        952.0
      ],
      "bbox_max": [
        -1736.365966796875,
        -3759.1708984375,
        952.0032958984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8452292084693909,
        -0.23135237395763397,
        0.4817297160625458
      ],
      "plane_d": 145.135986328125,
      "bbox_min": [
        -1751.0999755859375,
        -3776.150146484375,
        953.5
      ],
      "bbox_max": [
        -1742.553466796875,
        -3753.5458984375,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8452292084693909,
        -0.23135237395763397,
        -0.4817297160625458
      ],
      "plane_d": 1068.130126953125,
      "bbox_min": [
        -1751.0999755859375,
        -3781.39990234375,
        952.0
      ],
      "bbox_max": [
        -1728.115966796875,
        -3751.6708984375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8445311188697815,
        -0.23077021539211273,
        -0.4832310378551483
      ],
      "plane_d": 1070.5439453125,
      "bbox_min": [
        -1751.0999755859375,
        -3775.39990234375,
        958.0
      ],
      "bbox_max": [
        -1742.553466796875,
        -3751.6708984375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1903047412633896,
        -0.05208935588598251,
        -0.9803421497344971
      ],
      "plane_d": 1079.67578125,
      "bbox_min": [
        -1748.7406005859375,
        -3781.39990234375,
        952.0
      ],
      "bbox_max": [
        -1728.115966796875,
        -3753.5458984375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19099849462509155,
        -0.052609335631132126,
        -0.980179488658905
      ],
      "plane_d": 1078.768798828125,
      "bbox_min": [
        -1748.7406005859375,
        -3778.40478515625,
        962.5
      ],
      "bbox_max": [
        -1736.365966796875,
        -3759.1708984375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19007164239883423,
        0.05235404521226883,
        -0.9803732633590698
      ],
      "plane_d": 811.8536987304688,
      "bbox_min": [
        -1741.6474609375,
        -3781.39990234375,
        952.0
      ],
      "bbox_max": [
        -1728.115966796875,
        -3759.1708984375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1908589005470276,
        0.0530395470559597,
        0.980183482170105
      ],
      "plane_d": -1065.141845703125,
      "bbox_min": [
        -1741.64697265625,
        -3781.39990234375,
        952.0032348632812
      ],
      "bbox_max": [
        -1728.115966796875,
        -3764.7958984375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.843095064163208,
        0.23429548740386963,
        -0.484041690826416
      ],
      "plane_d": -110.7401123046875,
      "bbox_min": [
        -1734.5843505859375,
        -3781.39990234375,
        953.5
      ],
      "bbox_max": [
        -1728.115966796875,
        -3764.7958984375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8430951237678528,
        0.23429548740386963,
        0.4840417206287384
      ],
      "plane_d": -1038.1640625,
      "bbox_min": [
        -1734.5843505859375,
        -3781.39990234375,
        953.5
      ],
      "bbox_max": [
        -1728.115966796875,
        -3764.7958984375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8440627455711365,
        0.23547153174877167,
        -0.4817792475223541
      ],
      "plane_d": -110.1500244140625,
      "bbox_min": [
        -1734.5843505859375,
        -3781.39990234375,
        953.5
      ],
      "bbox_max": [
        -1728.115966796875,
        -3766.6708984375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8440627455711365,
        0.23547153174877167,
        0.48177921772003174
      ],
      "plane_d": -1033.239013671875,
      "bbox_min": [
        -1734.5843505859375,
        -3781.39990234375,
        953.5
      ],
      "bbox_max": [
        -1728.115966796875,
        -3766.6708984375,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.888242244720459,
        0.07777769863605499,
        -0.45274320244789124
      ],
      "plane_d": 2282.77099609375,
      "bbox_min": [
        -1751.0999755859375,
        -3803.130859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3775.39990234375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8882421851158142,
        0.0777776911854744,
        0.45274317264556885
      ],
      "plane_d": 1415.3148193359375,
      "bbox_min": [
        -1751.0999755859375,
        -3803.130859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3775.39990234375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8873180150985718,
        0.07806865870952606,
        -0.4545018970966339
      ],
      "plane_d": 2283.9462890625,
      "bbox_min": [
        -1748.7406005859375,
        -3803.130859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3776.150146484375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8873180747032166,
        0.07806867361068726,
        0.4545018970966339
      ],
      "plane_d": 1413.12060546875,
      "bbox_min": [
        -1748.7406005859375,
        -3803.130859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3776.150146484375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21297630667686462,
        0.018738238140940666,
        -0.9768776893615723
      ],
      "plane_d": 1383.4434814453125,
      "bbox_min": [
        -1748.7406005859375,
        -3802.505859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3776.150146484375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21297630667686462,
        0.018738238140940666,
        0.9768776893615723
      ],
      "plane_d": -488.2541809082031,
      "bbox_min": [
        -1748.7406005859375,
        -3802.505859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3776.150146484375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186654269695282,
        0.018972082063555717,
        -0.9771144986152649
      ],
      "plane_d": 1382.62255859375,
      "bbox_min": [
        -1746.4217529296875,
        -3802.505859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3778.39990234375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186654269695282,
        0.018972082063555717,
        0.9771144986152649
      ],
      "plane_d": -489.5289306640625,
      "bbox_min": [
        -1746.4217529296875,
        -3802.505859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3778.39990234375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21173962950706482,
        -0.019443459808826447,
        -0.9771326184272766
      ],
      "plane_d": 499.7010192871094,
      "bbox_min": [
        -1741.6624755859375,
        -3800.630859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3778.39990234375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2130802869796753,
        -0.019080769270658493,
        -0.9768483638763428
      ],
      "plane_d": 498.4731140136719,
      "bbox_min": [
        -1741.6624755859375,
        -3800.630859375,
        962.5
      ],
      "bbox_max": [
        -1734.5843505859375,
        -3778.39990234375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.211739644408226,
        -0.019443467259407043,
        0.9771326780319214
      ],
      "plane_d": -1372.4852294921875,
      "bbox_min": [
        -1741.6624755859375,
        -3800.630859375,
        952.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3778.39990234375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2130803018808365,
        -0.019080771133303642,
        0.9768484234809875
      ],
      "plane_d": -1373.16845703125,
      "bbox_min": [
        -1741.6624755859375,
        -3800.630859375,
        952.0
      ],
      "bbox_max": [
        -1734.5843505859375,
        -3778.39990234375,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8867707252502441,
        -0.0823235809803009,
        0.4548191726207733
      ],
      "plane_d": -2283.1015625,
      "bbox_min": [
        -1734.5843505859375,
        -3798.755859375,
        953.5
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3780.650146484375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8882244229316711,
        -0.08156319707632065,
        0.45211154222488403
      ],
      "plane_d": -2280.150390625,
      "bbox_min": [
        -1734.5843505859375,
        -3798.755859375,
        953.5
      ],
      "bbox_max": [
        -1732.2249755859375,
        -3780.650146484375,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8882244229316711,
        -0.08156319707632065,
        -0.45211154222488403
      ],
      "plane_d": -1413.9046630859375,
      "bbox_min": [
        -1734.5843505859375,
        -3798.755859375,
        958.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3780.650146484375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8867707252502441,
        -0.0823235809803009,
        -0.4548191726207733
      ],
      "plane_d": -1411.66796875,
      "bbox_min": [
        -1732.9217529296875,
        -3798.755859375,
        958.0
      ],
      "bbox_max": [
        -1730.6717529296875,
        -3781.39990234375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20071475207805634,
        -0.05969059467315674,
        -0.9778295755386353
      ],
      "plane_d": 366.58795166015625,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        952.0
      ],
      "bbox_max": [
        -1726.6197509765625,
        -3798.130859375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20705337822437286,
        -0.06524030864238739,
        -0.9761518239974976
      ],
      "plane_d": 332.85113525390625,
      "bbox_min": [
        -1739.6717529296875,
        -3813.0,
        962.6077270507812
      ],
      "bbox_max": [
        -1729.2105712890625,
        -3800.630859375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1998036503791809,
        0.06295599788427353,
        -0.9778113961219788
      ],
      "plane_d": 1529.4754638671875,
      "bbox_min": [
        -1739.6717529296875,
        -3813.0,
        963.9776000976562
      ],
      "bbox_max": [
        -1735.7744140625,
        -3800.630859375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8526129126548767,
        -0.2468050867319107,
        -0.46058496832847595
      ],
      "plane_d": -1971.750732421875,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        952.0
      ],
      "bbox_max": [
        -1726.6197509765625,
        -3798.130859375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8589522242546082,
        -0.2554439604282379,
        -0.44378986954689026
      ],
      "plane_d": -2031.718505859375,
      "bbox_min": [
        -1732.9217529296875,
        -3813.0,
        958.0
      ],
      "bbox_max": [
        -1726.6197509765625,
        -3798.755859375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8589522242546082,
        -0.2554439604282379,
        0.44378986954689026
      ],
      "plane_d": -2882.02001953125,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        952.0
      ],
      "bbox_max": [
        -1726.6197509765625,
        -3798.130859375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8526129126548767,
        -0.2468050867319107,
        0.46058496832847595
      ],
      "plane_d": -2854.2314453125,
      "bbox_min": [
        -1732.9217529296875,
        -3812.12890625,
        953.5
      ],
      "bbox_max": [
        -1726.6197509765625,
        -3798.130859375,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20705337822437286,
        -0.06524030864238739,
        0.9761519432067871
      ],
      "plane_d": -1537.455810546875,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        952.0
      ],
      "bbox_max": [
        -1728.6856689453125,
        -3798.755859375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20071475207805634,
        -0.05969059467315674,
        0.9778295755386353
      ],
      "plane_d": -1506.933349609375,
      "bbox_min": [
        -1739.6717529296875,
        -3813.0,
        952.0
      ],
      "bbox_max": [
        -1728.6856689453125,
        -3798.755859375,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1998036503791809,
        0.06295599788427353,
        0.9778113961219788
      ],
      "plane_d": -344.0111389160156,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        952.0
      ],
      "bbox_max": [
        -1735.7744140625,
        -3800.630859375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1998036503791809,
        0.06295599788427353,
        -0.9778113961219788
      ],
      "plane_d": 1529.4754638671875,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        952.5704956054688
      ],
      "bbox_max": [
        -1735.8841552734375,
        -3800.630859375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20519639551639557,
        0.06711622327566147,
        -0.976416826248169
      ],
      "plane_d": 1553.370361328125,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        952.5704956054688
      ],
      "bbox_max": [
        -1738.56640625,
        -3802.505859375,
        963.4295043945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20519639551639557,
        0.06711622327566147,
        0.976416826248169
      ],
      "plane_d": -317.44415283203125,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        952.5704956054688
      ],
      "bbox_max": [
        -1738.56640625,
        -3802.505859375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8438066840171814,
        0.2759946584701538,
        -0.46023592352867126
      ],
      "plane_d": 2966.0908203125,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        953.5
      ],
      "bbox_max": [
        -1742.9892578125,
        -3802.505859375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8438067436218262,
        0.2759947180747986,
        0.46023595333099365
      ],
      "plane_d": 2084.279052734375,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        953.5
      ],
      "bbox_max": [
        -1742.9892578125,
        -3802.505859375,
        960.0376586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8481993079185486,
        0.2801354229450226,
        -0.44953542947769165
      ],
      "plane_d": 2979.268798828125,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        955.9623413085938
      ],
      "bbox_max": [
        -1744.332275390625,
        -3803.130859375,
        960.0376586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8481993079185486,
        0.2801354229450226,
        0.44953539967536926
      ],
      "plane_d": 2117.958984375,
      "bbox_min": [
        -1748.6717529296875,
        -3813.0,
        955.9623413085938
      ],
      "bbox_max": [
        -1744.332275390625,
        -3803.130859375,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7815960049629211,
        -0.4053915739059448,
        -0.47409412264823914
      ],
      "plane_d": -2440.741943359375,
      "bbox_min": [
        -1727.4683837890625,
        -3813.0,
        955.8560791015625
      ],
      "bbox_max": [
        -1726.16796875,
        -3812.12890625,
        960.1439208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7815960645675659,
        -0.4053916037082672,
        0.47409412264823914
      ],
      "plane_d": -3349.1064453125,
      "bbox_min": [
        -1727.4683837890625,
        -3813.0,
        955.8560791015625
      ],
      "bbox_max": [
        -1726.16796875,
        -3812.12890625,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.028840895742177963,
        -0.9786328673362732,
        0.2035827785730362
      ],
      "plane_d": -3884.80322265625,
      "bbox_min": [
        -1755.0,
        -3838.0,
        935.0
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.29408586025238037,
        0.9557790160179138
      ],
      "plane_d": 233.13653564453125,
      "bbox_min": [
        -1755.0,
        -3838.0,
        935.0
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.032873403280973434,
        -0.2939269244670868,
        0.9552623629570007
      ],
      "plane_d": -1962.31591796875,
      "bbox_min": [
        -1755.0,
        -3838.0,
        935.0
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.46527862548828125,
        0.8851642608642578
      ],
      "plane_d": -2610.34375,
      "bbox_min": [
        -1755.0,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1735.0,
        -3828.342041015625,
        936.659912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01168737094849348,
        -0.9404897093772888,
        0.33962127566337585
      ],
      "plane_d": -3896.67919921875,
      "bbox_min": [
        -1755.0,
        -3838.0,
        935.6044921875
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00998904462903738,
        0.9405069947242737,
        0.33962753415107727
      ],
      "plane_d": 3307.4072265625,
      "bbox_min": [
        -1755.0,
        -3838.0,
        935.6044921875
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02404947206377983,
        0.9775403141975403,
        0.2093718945980072
      ],
      "plane_d": 3596.506591796875,
      "bbox_min": [
        -1755.0,
        -3838.0,
        935.6044921875
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02619413286447525,
        0.4540315568447113,
        0.8906004428863525
      ],
      "plane_d": 953.23486328125,
      "bbox_min": [
        -1755.0,
        -3838.0,
        935.6044921875
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.041608307510614395,
        0.978481113910675,
        -0.20209749042987823
      ],
      "plane_d": 3872.713134765625,
      "bbox_min": [
        -1755.0,
        -3838.0,
        941.0
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038983557373285294,
        0.9398388862609863,
        -0.3393862545490265
      ],
      "plane_d": 3858.82763671875,
      "bbox_min": [
        -1755.0,
        -3838.0,
        941.0
      ],
      "bbox_max": [
        -1735.0,
        -3836.375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04806070029735565,
        -0.9394670724868774,
        -0.3392519950866699
      ],
      "plane_d": -3357.61083984375,
      "bbox_min": [
        -1755.0,
        -3836.375,
        941.0
      ],
      "bbox_max": [
        -1735.0,
        -3825.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05109425261616707,
        -0.9759101271629333,
        -0.21210555732250214
      ],
      "plane_d": -3622.544921875,
      "bbox_min": [
        -1755.0,
        -3827.26171875,
        945.3333129882812
      ],
      "bbox_max": [
        -1735.0,
        -3825.541748046875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22436819970607758,
        -0.2865879535675049,
        -0.9314108490943909
      ],
      "plane_d": -605.2945556640625,
      "bbox_min": [
        -1751.6051025390625,
        -3827.26171875,
        945.5
      ],
      "bbox_max": [
        -1735.0,
        -3826.625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17112234234809875,
        0.5290375351905823,
        -0.8311656713485718
      ],
      "plane_d": 2518.55615234375,
      "bbox_min": [
        -1754.428466796875,
        -3836.375,
        945.5
      ],
      "bbox_max": [
        -1735.0,
        -3826.625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22436819970607758,
        -0.2865879535675049,
        -0.9314108490943909
      ],
      "plane_d": -605.2945556640625,
      "bbox_min": [
        -1750.791748046875,
        -3836.375,
        945.5
      ],
      "bbox_max": [
        -1735.0,
        -3826.625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23012220859527588,
        -0.3528193235397339,
        -0.9069522619247437
      ],
      "plane_d": -892.2055053710938,
      "bbox_min": [
        -1748.0001220703125,
        -3831.7109375,
        947.0
      ],
      "bbox_max": [
        -1735.0,
        -3829.447265625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2356797605752945,
        0.2858017086982727,
        -0.9288554787635803
      ],
      "plane_d": 1565.7708740234375,
      "bbox_min": [
        -1745.1087646484375,
        -3831.7109375,
        947.0
      ],
      "bbox_max": [
        -1735.0,
        -3831.5,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2356797605752945,
        0.2858017086982727,
        -0.9288554787635803
      ],
      "plane_d": 1565.7708740234375,
      "bbox_min": [
        -1748.4000244140625,
        -3836.375,
        945.5
      ],
      "bbox_max": [
        -1735.0,
        -3831.5,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35527539253234863,
        -0.8537275195121765,
        0.380695104598999
      ],
      "plane_d": -4224.6181640625,
      "bbox_min": [
        -1689.460205078125,
        -3847.67041015625,
        937.0
      ],
      "bbox_max": [
        -1667.45849609375,
        -3827.84521484375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37225353717803955,
        -0.8637615442276001,
        0.3396223783493042
      ],
      "plane_d": -4252.9765625,
      "bbox_min": [
        -1685.0157470703125,
        -3835.551025390625,
        937.0
      ],
      "bbox_max": [
        -1670.2294921875,
        -3827.84521484375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45763325691223145,
        0.822503387928009,
        0.33772796392440796
      ],
      "plane_d": 3613.63671875,
      "bbox_min": [
        -1689.460205078125,
        -3847.67041015625,
        937.0
      ],
      "bbox_max": [
        -1674.5140380859375,
        -3838.511962890625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4359668493270874,
        0.8137689828872681,
        0.3843345046043396
      ],
      "plane_d": 3499.873291015625,
      "bbox_min": [
        -1687.3419189453125,
        -3847.67041015625,
        937.0
      ],
      "bbox_max": [
        -1674.5140380859375,
        -3839.38134765625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2443707436323166,
        -0.8548916578292847,
        0.45764967799186707
      ],
      "plane_d": -4114.0498046875,
      "bbox_min": [
        -1706.4444580078125,
        -3855.0,
        937.0
      ],
      "bbox_max": [
        -1684.460205078125,
        -3813.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8421555161476135,
        -0.44529786705970764,
        0.3041117191314697
      ],
      "plane_d": -3419.965087890625,
      "bbox_min": [
        -1706.4444580078125,
        -3824.1748046875,
        937.0
      ],
      "bbox_max": [
        -1699.864990234375,
        -3813.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7773036360740662,
        -0.2800218462944031,
        0.5633708834648132
      ],
      "plane_d": -2921.885986328125,
      "bbox_min": [
        -1705.8739013671875,
        -3824.1748046875,
        937.0
      ],
      "bbox_max": [
        -1699.864990234375,
        -3814.0791015625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2974614202976227,
        -0.892582356929779,
        0.3388415277004242
      ],
      "plane_d": -4236.57861328125,
      "bbox_min": [
        -1706.4444580078125,
        -3855.0,
        937.0
      ],
      "bbox_max": [
        -1684.460205078125,
        -3822.71142578125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8447264432907104,
        0.19645759463310242,
        0.497837096452713
      ],
      "plane_d": -1150.5115966796875,
      "bbox_min": [
        -1706.4444580078125,
        -3855.0,
        937.0
      ],
      "bbox_max": [
        -1688.9046630859375,
        -3838.511962890625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11500050127506256,
        0.8512046933174133,
        0.5120795369148254
      ],
      "plane_d": 2593.43798828125,
      "bbox_min": [
        -1702.9710693359375,
        -3842.71142578125,
        937.0
      ],
      "bbox_max": [
        -1688.9046630859375,
        -3838.511962890625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2293282449245453,
        0.9325104355812073,
        0.2789856493473053
      ],
      "plane_d": 2930.729248046875,
      "bbox_min": [
        -1701.114990234375,
        -3842.71142578125,
        937.0
      ],
      "bbox_max": [
        -1688.9046630859375,
        -3838.511962890625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9015410542488098,
        0.28502050042152405,
        0.3255564868450165
      ],
      "plane_d": -744.7220458984375,
      "bbox_min": [
        -1706.4444580078125,
        -3855.0,
        937.0
      ],
      "bbox_max": [
        -1701.114990234375,
        -3842.71142578125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10293527692556381,
        -0.23884673416614532,
        0.9655860662460327
      ],
      "plane_d": -1992.3526611328125,
      "bbox_min": [
        -1688.9046630859375,
        -3846.253662109375,
        935.0
      ],
      "bbox_max": [
        -1668.3404541015625,
        -3829.178466796875,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12734191119670868,
        -0.2654959559440613,
        0.9556651711463928
      ],
      "plane_d": -2126.238037109375,
      "bbox_min": [
        -1687.0848388671875,
        -3841.29541015625,
        935.0
      ],
      "bbox_max": [
        -1671.42724609375,
        -3829.34521484375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12734191119670868,
        0.2654959559440613,
        0.9556651711463928
      ],
      "plane_d": 339.14422607421875,
      "bbox_min": [
        -1687.0848388671875,
        -3841.29541015625,
        935.0
      ],
      "bbox_max": [
        -1671.42724609375,
        -3833.84521484375,
        935.0997314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12734191119670868,
        0.2654959559440613,
        0.9556651711463928
      ],
      "plane_d": 339.14422607421875,
      "bbox_min": [
        -1688.835205078125,
        -3841.29541015625,
        935.0
      ],
      "bbox_max": [
        -1671.42724609375,
        -3834.144287109375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37225353717803955,
        -0.8637615442276001,
        0.3396223783493042
      ],
      "plane_d": -4252.9765625,
      "bbox_min": [
        -1688.9046630859375,
        -3846.253662109375,
        936.5
      ],
      "bbox_max": [
        -1668.3404541015625,
        -3829.178466796875,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35527539253234863,
        -0.8537275195121765,
        0.380695104598999
      ],
      "plane_d": -4224.6181640625,
      "bbox_min": [
        -1670.2294921875,
        -3836.51416015625,
        936.5
      ],
      "bbox_max": [
        -1668.3404541015625,
        -3835.551025390625,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4359668493270874,
        0.8137689828872681,
        0.3843345046043396
      ],
      "plane_d": 3499.873291015625,
      "bbox_min": [
        -1688.9046630859375,
        -3846.253662109375,
        936.5
      ],
      "bbox_max": [
        -1674.40380859375,
        -3838.34521484375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45763325691223145,
        0.822503387928009,
        0.33772796392440796
      ],
      "plane_d": 3613.63671875,
      "bbox_min": [
        -1688.9046630859375,
        -3839.38134765625,
        936.5
      ],
      "bbox_max": [
        -1687.3419189453125,
        -3838.34521484375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2443707436323166,
        -0.8548916578292847,
        0.45764967799186707
      ],
      "plane_d": -4114.0498046875,
      "bbox_min": [
        -1711.5,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1685.0157470703125,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11898886412382126,
        -0.08506324887275696,
        0.9892451763153076
      ],
      "plane_d": -1453.8436279296875,
      "bbox_min": [
        -1711.5,
        -3824.55517578125,
        935.0
      ],
      "bbox_max": [
        -1702.2369384765625,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.0,
        0.9557790160179138
      ],
      "plane_d": -1396.9813232421875,
      "bbox_min": [
        -1711.5,
        -3822.651611328125,
        935.0
      ],
      "bbox_max": [
        -1706.625,
        -3813.0,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7773036360740662,
        -0.2800218462944031,
        0.5633708834648132
      ],
      "plane_d": -2921.885986328125,
      "bbox_min": [
        -1706.625,
        -3824.55517578125,
        935.9600219726562
      ],
      "bbox_max": [
        -1702.2369384765625,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8421555161476135,
        -0.44529786705970764,
        0.3041117191314697
      ],
      "plane_d": -3419.965087890625,
      "bbox_min": [
        -1706.625,
        -3814.0791015625,
        936.5
      ],
      "bbox_max": [
        -1705.8739013671875,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0657803863286972,
        -0.13252057135105133,
        0.9889951348304749
      ],
      "plane_d": -1544.506591796875,
      "bbox_min": [
        -1711.5,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1685.0157470703125,
        -3822.597412109375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03514411672949791,
        -0.30282285809516907,
        0.9523986577987671
      ],
      "plane_d": -2110.755615234375,
      "bbox_min": [
        -1711.5,
        -3835.405517578125,
        935.0
      ],
      "bbox_max": [
        -1685.085205078125,
        -3822.597412109375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1103537455201149,
        0.0,
        0.9938923120498657
      ],
      "plane_d": -1118.1597900390625,
      "bbox_min": [
        -1711.5,
        -3827.428466796875,
        935.0
      ],
      "bbox_max": [
        -1702.8536376953125,
        -3822.597412109375,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11898886412382126,
        -0.08506324887275696,
        0.9892451763153076
      ],
      "plane_d": -1453.8436279296875,
      "bbox_min": [
        -1711.5,
        -3824.55517578125,
        935.0
      ],
      "bbox_max": [
        -1702.8536376953125,
        -3822.597412109375,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.0,
        0.9557790160179138
      ],
      "plane_d": -1396.9813232421875,
      "bbox_min": [
        -1711.5,
        -3823.625,
        935.0
      ],
      "bbox_max": [
        -1711.0533447265625,
        -3822.597412109375,
        935.137451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03514411672949791,
        0.30282285809516907,
        0.9523986577987671
      ],
      "plane_d": 329.76995849609375,
      "bbox_min": [
        -1702.114990234375,
        -3835.405517578125,
        935.0
      ],
      "bbox_max": [
        -1686.960205078125,
        -3832.08642578125,
        935.5200805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0511280819773674,
        0.12886594235897064,
        0.9903430938720703
      ],
      "plane_d": -519.1712646484375,
      "bbox_min": [
        -1711.5,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1685.0157470703125,
        -3824.55517578125,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12299992889165878,
        0.06164249777793884,
        0.9904903769493103
      ],
      "plane_d": -899.877197265625,
      "bbox_min": [
        -1711.5,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1687.6103515625,
        -3832.08642578125,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8447264432907104,
        0.19645759463310242,
        0.497837096452713
      ],
      "plane_d": -1150.5115966796875,
      "bbox_min": [
        -1711.5,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1703.45361328125,
        -3835.8095703125,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1184707060456276,
        0.0,
        0.9929575324058533
      ],
      "plane_d": -1131.1778564453125,
      "bbox_min": [
        -1711.5,
        -3840.625,
        935.0
      ],
      "bbox_max": [
        -1703.45361328125,
        -3835.8095703125,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11500050127506256,
        0.8512046933174133,
        0.5120795369148254
      ],
      "plane_d": 2593.43798828125,
      "bbox_min": [
        -1711.5,
        -3848.531494140625,
        935.0
      ],
      "bbox_max": [
        -1685.0157470703125,
        -3824.55517578125,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8447264432907104,
        0.19645759463310242,
        0.497837096452713
      ],
      "plane_d": -1150.5115966796875,
      "bbox_min": [
        -1704.825927734375,
        -3848.531494140625,
        935.9600219726562
      ],
      "bbox_max": [
        -1702.9710693359375,
        -3839.995361328125,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007451606914401054,
        0.11925362795591354,
        0.9928358197212219
      ],
      "plane_d": -458.6277770996094,
      "bbox_min": [
        -1711.5,
        -3839.995361328125,
        935.0
      ],
      "bbox_max": [
        -1685.0157470703125,
        -3824.55517578125,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00794887077063322,
        -0.12721170485019684,
        0.9918437004089355
      ],
      "plane_d": -1428.3900146484375,
      "bbox_min": [
        -1711.5,
        -3838.830322265625,
        935.0
      ],
      "bbox_max": [
        -1685.0157470703125,
        -3824.55517578125,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1103537455201149,
        0.0,
        0.9938923120498657
      ],
      "plane_d": -1118.1597900390625,
      "bbox_min": [
        -1711.5,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1702.8536376953125,
        -3824.55517578125,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2974614202976227,
        -0.892582356929779,
        0.3388415277004242
      ],
      "plane_d": -4236.57861328125,
      "bbox_min": [
        -1690.1995849609375,
        -3838.830322265625,
        936.5
      ],
      "bbox_max": [
        -1685.0157470703125,
        -3828.608154296875,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2293282449245453,
        0.9325104355812073,
        0.2789856493473053
      ],
      "plane_d": 2930.729248046875,
      "bbox_min": [
        -1690.1995849609375,
        -3838.830322265625,
        936.5
      ],
      "bbox_max": [
        -1688.835205078125,
        -3838.34521484375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8447264432907104,
        0.19645759463310242,
        0.497837096452713
      ],
      "plane_d": -1150.5115966796875,
      "bbox_min": [
        -1706.625,
        -3855.0,
        936.5
      ],
      "bbox_max": [
        -1705.0,
        -3849.27978515625,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9015410542488098,
        0.28502050042152405,
        0.3255564868450165
      ],
      "plane_d": -744.7220458984375,
      "bbox_min": [
        -1706.625,
        -3855.0,
        936.5
      ],
      "bbox_max": [
        -1706.0128173828125,
        -3853.634521484375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19727976620197296,
        0.8289830088615417,
        0.5233239531517029
      ],
      "plane_d": 3032.47705078125,
      "bbox_min": [
        -1735.0,
        -3855.0,
        937.0
      ],
      "bbox_max": [
        -1716.5555419921875,
        -3813.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289878368377686,
        0.1972855031490326,
        0.5233141183853149
      ],
      "plane_d": 1693.305908203125,
      "bbox_min": [
        -1722.25,
        -3855.0,
        937.0
      ],
      "bbox_max": [
        -1716.5555419921875,
        -3840.210205078125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8974793553352356,
        0.29915979504585266,
        0.32408976554870605
      ],
      "plane_d": 2390.162109375,
      "bbox_min": [
        -1722.25,
        -3855.0,
        937.0
      ],
      "bbox_max": [
        -1716.5555419921875,
        -3842.25,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15948998928070068,
        -0.8782714605331421,
        0.4507795572280884
      ],
      "plane_d": -3506.25537109375,
      "bbox_min": [
        -1735.0,
        -3842.25,
        937.0
      ],
      "bbox_max": [
        -1716.5555419921875,
        -3813.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8089356422424316,
        -0.26588791608810425,
        0.5243345499038696
      ],
      "plane_d": -116.4329833984375,
      "bbox_min": [
        -1722.25,
        -3823.6826171875,
        937.0
      ],
      "bbox_max": [
        -1716.5555419921875,
        -3813.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.859582781791687,
        -0.4059140980243683,
        0.310404896736145
      ],
      "plane_d": -363.078125,
      "bbox_min": [
        -1722.25,
        -3822.0,
        937.0
      ],
      "bbox_max": [
        -1716.5555419921875,
        -3813.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29915979504585266,
        0.8974793553352356,
        0.32408976554870605
      ],
      "plane_d": 3658.599609375,
      "bbox_min": [
        -1735.0,
        -3842.25,
        937.0
      ],
      "bbox_max": [
        -1722.25,
        -3822.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21607862412929535,
        -0.9183341860771179,
        0.3316206634044647
      ],
      "plane_d": -3449.786865234375,
      "bbox_min": [
        -1735.0,
        -3826.4443359375,
        937.0
      ],
      "bbox_max": [
        -1722.25,
        -3822.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.29408586025238037,
        0.9557790756225586
      ],
      "plane_d": -2020.443359375,
      "bbox_min": [
        -1735.0,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05709380283951759,
        -0.1359744518995285,
        0.9890658855438232
      ],
      "plane_d": -1347.5257568359375,
      "bbox_min": [
        -1735.0,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12116508930921555,
        -0.08403979241847992,
        0.9890683889389038
      ],
      "plane_d": -1038.7415771484375,
      "bbox_min": [
        -1719.6800537109375,
        -3827.66943359375,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29408586025238037,
        0.0,
        0.9557790160179138
      ],
      "plane_d": -390.3254089355469,
      "bbox_min": [
        -1716.375,
        -3823.625,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8089356422424316,
        -0.26588791608810425,
        0.5243345499038696
      ],
      "plane_d": -116.4329833984375,
      "bbox_min": [
        -1719.6800537109375,
        -3827.66943359375,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11656133830547333,
        0.0,
        0.9931834936141968
      ],
      "plane_d": -729.1318359375,
      "bbox_min": [
        -1719.6800537109375,
        -3827.66943359375,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.859582781791687,
        -0.4059140980243683,
        0.310404896736145
      ],
      "plane_d": -363.078125,
      "bbox_min": [
        -1717.02783203125,
        -3814.0,
        936.5
      ],
      "bbox_max": [
        -1716.375,
        -3813.0,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15948998928070068,
        -0.8782714605331421,
        0.4507795572280884
      ],
      "plane_d": -3506.25537109375,
      "bbox_min": [
        -1735.0,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3815.672607421875,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8089356422424316,
        -0.26588791608810425,
        0.5243345499038696
      ],
      "plane_d": -116.4329833984375,
      "bbox_min": [
        -1720.2103271484375,
        -3824.1201171875,
        935.9600219726562
      ],
      "bbox_max": [
        -1717.57763671875,
        -3815.672607421875,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.12899942696094513,
        0.9916446805000305
      ],
      "plane_d": -1421.4490966796875,
      "bbox_min": [
        -1720.625,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3824.1201171875,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11656133830547333,
        0.0,
        0.9931834936141968
      ],
      "plane_d": -729.1318359375,
      "bbox_min": [
        -1719.6800537109375,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3824.1201171875,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29408586025238037,
        -0.0,
        0.9557790756225586
      ],
      "plane_d": -390.32550048828125,
      "bbox_min": [
        -1735.0,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3831.5,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12334872037172318,
        0.061520468443632126,
        0.9904545545578003
      ],
      "plane_d": -478.6866455078125,
      "bbox_min": [
        -1735.0,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3831.5,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06152017042040825,
        0.12334960699081421,
        0.9904544949531555
      ],
      "plane_d": -347.6077880859375,
      "bbox_min": [
        -1735.0,
        -3839.679931640625,
        935.0
      ],
      "bbox_max": [
        -1716.051025390625,
        -3831.5,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19727976620197296,
        0.8289830088615417,
        0.5233239531517029
      ],
      "plane_d": 3032.47705078125,
      "bbox_min": [
        -1735.0,
        -3839.679931640625,
        935.0
      ],
      "bbox_max": [
        -1716.051025390625,
        -3831.5,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.11656304448843002,
        0.9931832551956177
      ],
      "plane_d": -482.0150451660156,
      "bbox_min": [
        -1720.625,
        -3839.679931640625,
        935.0
      ],
      "bbox_max": [
        -1716.051025390625,
        -3831.5,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289878368377686,
        0.1972855031490326,
        0.5233141183853149
      ],
      "plane_d": 1693.305908203125,
      "bbox_min": [
        -1728.78369140625,
        -3855.0,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3831.5,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19727976620197296,
        0.8289830088615417,
        0.5233239531517029
      ],
      "plane_d": 3032.47705078125,
      "bbox_min": [
        -1728.78369140625,
        -3840.210205078125,
        935.9600219726562
      ],
      "bbox_max": [
        -1719.6800537109375,
        -3838.170166015625,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11656133085489273,
        0.0,
        0.9931834936141968
      ],
      "plane_d": -729.1318359375,
      "bbox_min": [
        -1719.6800537109375,
        -3840.625,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3831.5,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.11656304448843002,
        0.9931832551956177
      ],
      "plane_d": -482.0150451660156,
      "bbox_min": [
        -1719.6800537109375,
        -3839.679931640625,
        935.0
      ],
      "bbox_max": [
        -1711.5,
        -3831.5,
        935.9600219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8974793553352356,
        0.29915979504585266,
        0.32408976554870605
      ],
      "plane_d": 2390.162109375,
      "bbox_min": [
        -1717.02783203125,
        -3855.0,
        936.5
      ],
      "bbox_max": [
        -1716.375,
        -3853.583251953125,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15948998928070068,
        -0.8782714605331421,
        0.4507795572280884
      ],
      "plane_d": -3506.25537109375,
      "bbox_min": [
        -1735.0,
        -3838.0,
        936.5
      ],
      "bbox_max": [
        -1727.463623046875,
        -3824.999755859375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19727976620197296,
        0.8289830088615417,
        0.5233239531517029
      ],
      "plane_d": 3032.47705078125,
      "bbox_min": [
        -1735.0,
        -3838.0,
        936.5
      ],
      "bbox_max": [
        -1729.4984130859375,
        -3826.111083984375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29915979504585266,
        0.8974793553352356,
        0.32408976554870605
      ],
      "plane_d": 3658.599609375,
      "bbox_min": [
        -1735.0,
        -3837.02783203125,
        936.5
      ],
      "bbox_max": [
        -1733.5833740234375,
        -3826.111083984375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21607862412929535,
        -0.9183341860771179,
        0.3316206634044647
      ],
      "plane_d": -3449.786865234375,
      "bbox_min": [
        -1735.0,
        -3826.625,
        936.5
      ],
      "bbox_max": [
        -1733.5833740234375,
        -3826.111083984375,
        937.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37225353717803955,
        -0.8637616038322449,
        -0.3396224081516266
      ],
      "plane_d": -3613.807373046875,
      "bbox_min": [
        -1689.460205078125,
        -3847.67041015625,
        941.0
      ],
      "bbox_max": [
        -1667.45849609375,
        -3827.84521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35527539253234863,
        -0.8537275195121765,
        -0.3806951344013214
      ],
      "plane_d": -3508.14990234375,
      "bbox_min": [
        -1684.460205078125,
        -3836.51416015625,
        941.0
      ],
      "bbox_max": [
        -1667.45849609375,
        -3827.84521484375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12734191119670868,
        -0.2654959559440613,
        -0.9556651711463928
      ],
      "plane_d": -327.67620849609375,
      "bbox_min": [
        -1689.460205078125,
        -3847.67041015625,
        941.0
      ],
      "bbox_max": [
        -1668.45068359375,
        -3829.34521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10293527692556381,
        -0.23884673416614532,
        -0.9655860662460327
      ],
      "plane_d": -175.11962890625,
      "bbox_min": [
        -1685.085205078125,
        -3841.29541015625,
        945.5
      ],
      "bbox_max": [
        -1668.45068359375,
        -3829.34521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12177541851997375,
        0.2273041158914566,
        -0.9661799073219299
      ],
      "plane_d": 1991.6534423828125,
      "bbox_min": [
        -1689.460205078125,
        -3847.67041015625,
        941.0
      ],
      "bbox_max": [
        -1671.42724609375,
        -3833.84521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12734191119670868,
        0.2654959559440613,
        -0.9556651711463928
      ],
      "plane_d": 2137.7060546875,
      "bbox_min": [
        -1688.835205078125,
        -3841.29541015625,
        945.5
      ],
      "bbox_max": [
        -1671.42724609375,
        -3833.84521484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4359668493270874,
        0.8137689828872681,
        -0.3843345046043396
      ],
      "plane_d": 4223.1904296875,
      "bbox_min": [
        -1689.460205078125,
        -3847.67041015625,
        941.0
      ],
      "bbox_max": [
        -1674.40380859375,
        -3838.34521484375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45763325691223145,
        0.822503387928009,
        -0.33772796392440796
      ],
      "plane_d": 4249.24072265625,
      "bbox_min": [
        -1689.460205078125,
        -3847.67041015625,
        941.0
      ],
      "bbox_max": [
        -1675.39599609375,
        -3838.34521484375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2554323077201843,
        -0.863752007484436,
        -0.43438082933425903
      ],
      "plane_d": -3327.32275390625,
      "bbox_min": [
        -1711.5,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1684.460205078125,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8421555161476135,
        -0.44529786705970764,
        -0.3041117191314697
      ],
      "plane_d": -2847.626953125,
      "bbox_min": [
        -1711.5,
        -3825.6083984375,
        941.0
      ],
      "bbox_max": [
        -1699.864990234375,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7767663598060608,
        -0.27909091114997864,
        -0.5645726323127747
      ],
      "plane_d": -1856.01904296875,
      "bbox_min": [
        -1711.5,
        -3825.6083984375,
        941.0
      ],
      "bbox_max": [
        -1699.864990234375,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669416606426239,
        -0.8643639087677002,
        -0.3438440263271332
      ],
      "plane_d": -3605.29931640625,
      "bbox_min": [
        -1705.2613525390625,
        -3825.6083984375,
        946.611083984375
      ],
      "bbox_max": [
        -1703.293701171875,
        -3824.519287109375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2592773735523224,
        -0.7813338041305542,
        -0.5677081942558289
      ],
      "plane_d": -2891.6103515625,
      "bbox_min": [
        -1705.2613525390625,
        -3825.07861328125,
        949.358154296875
      ],
      "bbox_max": [
        -1704.6832275390625,
        -3824.80859375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29324209690093994,
        -0.0756978914141655,
        -0.9530367255210876
      ],
      "plane_d": 112.00592041015625,
      "bbox_min": [
        -1711.5,
        -3824.88671875,
        945.5
      ],
      "bbox_max": [
        -1703.293701171875,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17706404626369476,
        -0.14509856700897217,
        -0.9734447598457336
      ],
      "plane_d": 64.94924926757812,
      "bbox_min": [
        -1711.5,
        -3824.88671875,
        945.5
      ],
      "bbox_max": [
        -1703.293701171875,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3669416606426239,
        -0.8643639087677002,
        -0.3438440263271332
      ],
      "plane_d": -3605.29931640625,
      "bbox_min": [
        -1711.5,
        -3824.88671875,
        946.611083984375
      ],
      "bbox_max": [
        -1703.293701171875,
        -3821.509033203125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2668778598308563,
        -0.7115438580513,
        -0.6499857306480408
      ],
      "plane_d": -1646.51123046875,
      "bbox_min": [
        -1711.5,
        -3823.28369140625,
        947.625
      ],
      "bbox_max": [
        -1710.8389892578125,
        -3821.509033203125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2934761941432953,
        -0.06435710936784744,
        -0.9537975788116455
      ],
      "plane_d": 1160.1370849609375,
      "bbox_min": [
        -1711.5,
        -3821.626220703125,
        947.0
      ],
      "bbox_max": [
        -1711.334716796875,
        -3813.0,
        947.6852416992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17367957532405853,
        -0.14054356515407562,
        -0.9747219085693359
      ],
      "plane_d": 683.80615234375,
      "bbox_min": [
        -1711.5,
        -3821.54931640625,
        947.5552978515625
      ],
      "bbox_max": [
        -1711.334716796875,
        -3821.22998046875,
        947.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3355409801006317,
        -0.7647876143455505,
        -0.5500110983848572
      ],
      "plane_d": -1827.215576171875,
      "bbox_min": [
        -1711.5,
        -3821.62060546875,
        947.6013793945312
      ],
      "bbox_max": [
        -1711.334716796875,
        -3821.509033203125,
        947.6791381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17367957532405853,
        -0.14054356515407562,
        -0.9747219085693359
      ],
      "plane_d": 683.80615234375,
      "bbox_min": [
        -1711.5,
        -3821.56640625,
        947.6013793945312
      ],
      "bbox_max": [
        -1711.334716796875,
        -3821.509033203125,
        947.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2974614202976227,
        -0.892582356929779,
        -0.3388415277004242
      ],
      "plane_d": -3598.87890625,
      "bbox_min": [
        -1711.5,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1684.460205078125,
        -3822.71142578125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0840403363108635,
        -0.28341880440711975,
        -0.9553067684173584
      ],
      "plane_d": -323.68096923828125,
      "bbox_min": [
        -1711.5,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1685.085205078125,
        -3824.519287109375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10692020505666733,
        -0.17821058630943298,
        -0.9781661629676819
      ],
      "plane_d": 62.25654602050781,
      "bbox_min": [
        -1704.5230712890625,
        -3837.0703125,
        945.5
      ],
      "bbox_max": [
        -1685.085205078125,
        -3824.519287109375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7876694798469543,
        -0.4114963114261627,
        -0.45852774381637573
      ],
      "plane_d": -2481.36083984375,
      "bbox_min": [
        -1704.5230712890625,
        -3837.0703125,
        946.611083984375
      ],
      "bbox_max": [
        -1699.918701171875,
        -3824.519287109375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5266107320785522,
        0.17175430059432983,
        -0.8325753808021545
      ],
      "plane_d": 551.955078125,
      "bbox_min": [
        -1704.5010986328125,
        -3837.0703125,
        947.625
      ],
      "bbox_max": [
        -1699.918701171875,
        -3831.5927734375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08794434368610382,
        0.17769594490528107,
        -0.9801478981971741
      ],
      "plane_d": 1460.2646484375,
      "bbox_min": [
        -1705.154052734375,
        -3842.71142578125,
        941.0
      ],
      "bbox_max": [
        -1686.960205078125,
        -3832.109375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003215034957975149,
        0.31743156909942627,
        -0.9482757449150085
      ],
      "plane_d": 2109.5771484375,
      "bbox_min": [
        -1705.154052734375,
        -3839.5888671875,
        945.5
      ],
      "bbox_max": [
        -1686.960205078125,
        -3832.109375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7392820715904236,
        0.4453080892562866,
        -0.505136251449585
      ],
      "plane_d": 928.4296875,
      "bbox_min": [
        -1705.154052734375,
        -3839.5888671875,
        946.611083984375
      ],
      "bbox_max": [
        -1699.918701171875,
        -3832.109375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5266107320785522,
        0.17175430059432983,
        -0.8325753808021545
      ],
      "plane_d": 551.955078125,
      "bbox_min": [
        -1705.154052734375,
        -3839.5888671875,
        946.611083984375
      ],
      "bbox_max": [
        -1699.918701171875,
        -3832.109375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3945503830909729,
        0.7581518888473511,
        -0.5191682577133179
      ],
      "plane_d": 2730.234130859375,
      "bbox_min": [
        -1705.154052734375,
        -3839.5888671875,
        946.611083984375
      ],
      "bbox_max": [
        -1703.731201171875,
        -3838.20361328125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23449066281318665,
        0.6251938939094543,
        -0.7444102168083191
      ],
      "plane_d": 2706.66259765625,
      "bbox_min": [
        -1705.154052734375,
        -3838.38818359375,
        949.426025390625
      ],
      "bbox_max": [
        -1704.8707275390625,
        -3838.20361328125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10955419391393661,
        0.8459670543670654,
        -0.5218597054481506
      ],
      "plane_d": 3555.512939453125,
      "bbox_min": [
        -1703.731201171875,
        -3842.71142578125,
        941.0
      ],
      "bbox_max": [
        -1688.835205078125,
        -3838.34521484375,
        946.611083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2293282449245453,
        0.9325104355812073,
        -0.2789856493473053
      ],
      "plane_d": 3455.780029296875,
      "bbox_min": [
        -1701.114990234375,
        -3842.71142578125,
        941.0
      ],
      "bbox_max": [
        -1688.835205078125,
        -3838.34521484375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17391397058963776,
        0.10326248407363892,
        -0.9793317914009094
      ],
      "plane_d": 1027.2291259765625,
      "bbox_min": [
        -1711.5,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1701.114990234375,
        -3838.309814453125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29369211196899414,
        0.051729146391153336,
        -0.954499363899231
      ],
      "plane_d": 600.672607421875,
      "bbox_min": [
        -1711.5,
        -3855.0,
        945.5
      ],
      "bbox_max": [
        -1703.731201171875,
        -3838.309814453125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3945503830909729,
        0.7581518888473511,
        -0.5191682577133179
      ],
      "plane_d": 2730.234130859375,
      "bbox_min": [
        -1711.5,
        -3842.884033203125,
        946.611083984375
      ],
      "bbox_max": [
        -1703.731201171875,
        -3838.309814453125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19767449796199799,
        0.5956931114196777,
        -0.7785078287124634
      ],
      "plane_d": 3365.21240234375,
      "bbox_min": [
        -1711.5,
        -3842.884033203125,
        947.625
      ],
      "bbox_max": [
        -1711.0889892578125,
        -3840.3994140625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29376420378685,
        0.04675767570734024,
        -0.954733669757843
      ],
      "plane_d": 1587.1611328125,
      "bbox_min": [
        -1711.5,
        -3855.0,
        947.0
      ],
      "bbox_max": [
        -1711.397216796875,
        -3842.806884765625,
        947.657958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40117719769477844,
        0.7554662823677063,
        -0.5180034041404724
      ],
      "plane_d": 4080.61572265625,
      "bbox_min": [
        -1711.5,
        -3842.884033203125,
        947.625
      ],
      "bbox_max": [
        -1711.397216796875,
        -3842.806884765625,
        947.657958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9015410542488098,
        0.28502050042152405,
        -0.3255564868450165
      ],
      "plane_d": -132.02490234375,
      "bbox_min": [
        -1711.5,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1701.114990234375,
        -3842.71142578125,
        947.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29376420378685,
        0.04675767570734024,
        -0.954733669757843
      ],
      "plane_d": 1587.1611328125,
      "bbox_min": [
        -1711.5,
        -3843.765625,
        947.5501708984375
      ],
      "bbox_max": [
        -1711.397216796875,
        -3842.811767578125,
        947.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1712542474269867,
        0.10151863098144531,
        -0.9799825549125671
      ],
      "plane_d": 1611.8642578125,
      "bbox_min": [
        -1711.5,
        -3843.13427734375,
        947.5811157226562
      ],
      "bbox_max": [
        -1711.397216796875,
        -3842.811767578125,
        947.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40117719769477844,
        0.7554662823677063,
        -0.5180034041404724
      ],
      "plane_d": 4080.61572265625,
      "bbox_min": [
        -1711.5,
        -3842.884033203125,
        947.6117553710938
      ],
      "bbox_max": [
        -1711.397216796875,
        -3842.811767578125,
        947.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19637343287467957,
        0.8282111883163452,
        -0.5248844027519226
      ],
      "plane_d": 4014.314697265625,
      "bbox_min": [
        -1735.0,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8231745958328247,
        0.19052956998348236,
        -0.5348663330078125
      ],
      "plane_d": 2653.083984375,
      "bbox_min": [
        -1722.25,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1711.5,
        -3838.015625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1712542474269867,
        0.10151863098144531,
        -0.9799825549125671
      ],
      "plane_d": 1611.8642578125,
      "bbox_min": [
        -1722.25,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1711.5,
        -3838.015625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29376420378685,
        0.04675767570734024,
        -0.954733669757843
      ],
      "plane_d": 1587.1611328125,
      "bbox_min": [
        -1719.2633056640625,
        -3855.0,
        945.5
      ],
      "bbox_max": [
        -1711.5,
        -3838.015625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19767449796199799,
        0.5956931114196777,
        -0.7785078287124634
      ],
      "plane_d": 3365.21240234375,
      "bbox_min": [
        -1719.2633056640625,
        -3842.806884765625,
        946.611083984375
      ],
      "bbox_max": [
        -1711.5,
        -3838.015625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7002774477005005,
        0.3751676380634308,
        -0.6073391437530518
      ],
      "plane_d": 3219.294677734375,
      "bbox_min": [
        -1719.2633056640625,
        -3839.402099609375,
        946.611083984375
      ],
      "bbox_max": [
        -1717.2447509765625,
        -3838.015625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49620553851127625,
        0.14995703101158142,
        -0.855156660079956
      ],
      "plane_d": 2239.686767578125,
      "bbox_min": [
        -1717.5906982421875,
        -3838.4931640625,
        949.3778076171875
      ],
      "bbox_max": [
        -1717.2447509765625,
        -3838.015625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8974793553352356,
        0.29915979504585266,
        -0.32408976554870605
      ],
      "plane_d": 3000.09912109375,
      "bbox_min": [
        -1722.25,
        -3855.0,
        941.0
      ],
      "bbox_max": [
        -1716.375,
        -3842.25,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29915979504585266,
        0.8974793553352356,
        -0.32408976554870605
      ],
      "plane_d": 4268.5361328125,
      "bbox_min": [
        -1735.0,
        -3842.25,
        941.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1641259342432022,
        -0.8820887804031372,
        -0.4415677487850189
      ],
      "plane_d": -2673.162353515625,
      "bbox_min": [
        -1735.0,
        -3839.402099609375,
        941.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8047024607658386,
        -0.2579321265220642,
        -0.5347195267677307
      ],
      "plane_d": 903.2532958984375,
      "bbox_min": [
        -1722.25,
        -3825.211181640625,
        941.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17367957532405853,
        -0.14054356515407562,
        -0.9747219085693359
      ],
      "plane_d": 683.80615234375,
      "bbox_min": [
        -1722.25,
        -3825.211181640625,
        941.0
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2934761941432953,
        -0.06435710936784744,
        -0.9537975788116455
      ],
      "plane_d": 1160.1370849609375,
      "bbox_min": [
        -1719.242431640625,
        -3825.211181640625,
        945.5
      ],
      "bbox_max": [
        -1711.5,
        -3813.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3355409801006317,
        -0.7647876143455505,
        -0.5500110983848572
      ],
      "plane_d": -1827.215576171875,
      "bbox_min": [
        -1719.242431640625,
        -3825.211181640625,
        946.611083984375
      ],
      "bbox_max": [
        -1711.5,
        -3821.56640625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2668778598308563,
        -0.7115438580513,
        -0.6499857306480408
      ],
      "plane_d": -1646.51123046875,
      "bbox_min": [
        -1716.813232421875,
        -3825.211181640625,
        947.6791381835938
      ],
      "bbox_max": [
        -1711.5,
        -3821.62060546875,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.859582781791687,
        -0.4059140980243683,
        -0.310404896736145
      ],
      "plane_d": 221.103759765625,
      "bbox_min": [
        -1722.25,
        -3822.0,
        941.0
      ],
      "bbox_max": [
        -1716.375,
        -3813.0,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21607862412929535,
        -0.9183341860771179,
        -0.3316206634044647
      ],
      "plane_d": -2825.677001953125,
      "bbox_min": [
        -1735.0,
        -3839.402099609375,
        941.0
      ],
      "bbox_max": [
        -1716.6385498046875,
        -3822.0,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09586340188980103,
        -0.17779476940631866,
        -0.979387104511261
      ],
      "plane_d": 411.97955322265625,
      "bbox_min": [
        -1735.0,
        -3839.402099609375,
        945.5
      ],
      "bbox_max": [
        -1716.6385498046875,
        -3824.249267578125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0451212115585804,
        -0.29378634691238403,
        -0.9548056125640869
      ],
      "plane_d": -143.15621948242188,
      "bbox_min": [
        -1735.0,
        -3838.093017578125,
        945.5
      ],
      "bbox_max": [
        -1716.6385498046875,
        -3824.249267578125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6583316326141357,
        -0.3847378194332123,
        -0.6469746232032776
      ],
      "plane_d": 272.93170166015625,
      "bbox_min": [
        -1722.5533447265625,
        -3836.968994140625,
        946.611083984375
      ],
      "bbox_max": [
        -1716.6385498046875,
        -3824.249267578125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4710867702960968,
        -0.1536451280117035,
        -0.8686026334762573
      ],
      "plane_d": 1045.8719482421875,
      "bbox_min": [
        -1722.5533447265625,
        -3836.968994140625,
        946.611083984375
      ],
      "bbox_max": [
        -1716.6385498046875,
        -3824.249267578125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49620553851127625,
        0.14995703101158142,
        -0.855156660079956
      ],
      "plane_d": 2239.686767578125,
      "bbox_min": [
        -1722.5533447265625,
        -3836.968994140625,
        946.611083984375
      ],
      "bbox_max": [
        -1716.6385498046875,
        -3824.249267578125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3355409801006317,
        -0.7647876143455505,
        -0.5500110983848572
      ],
      "plane_d": -1827.215576171875,
      "bbox_min": [
        -1719.242431640625,
        -3825.3681640625,
        946.611083984375
      ],
      "bbox_max": [
        -1716.6385498046875,
        -3824.249267578125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2668778598308563,
        -0.7115438580513,
        -0.6499857306480408
      ],
      "plane_d": -1646.51123046875,
      "bbox_min": [
        -1717.0572509765625,
        -3825.3681640625,
        949.4200439453125
      ],
      "bbox_max": [
        -1716.6385498046875,
        -3825.20361328125,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05075482279062271,
        0.29370683431625366,
        -0.9545471668243408
      ],
      "plane_d": 2117.353515625,
      "bbox_min": [
        -1735.0,
        -3838.093017578125,
        946.6131591796875
      ],
      "bbox_max": [
        -1717.3890380859375,
        -3831.5,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49620553851127625,
        0.14995703101158142,
        -0.855156660079956
      ],
      "plane_d": 2239.686767578125,
      "bbox_min": [
        -1722.5533447265625,
        -3838.045166015625,
        947.625
      ],
      "bbox_max": [
        -1717.3890380859375,
        -3831.61962890625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8481993079185486,
        0.2801354229450226,
        -0.44953542947769165
      ],
      "plane_d": 2979.268798828125,
      "bbox_min": [
        -1755.0,
        -3836.3994140625,
        949.5
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2356797605752945,
        0.2858017086982727,
        -0.9288554787635803
      ],
      "plane_d": 1565.7708740234375,
      "bbox_min": [
        -1755.0,
        -3836.3994140625,
        949.5
      ],
      "bbox_max": [
        -1745.244873046875,
        -3826.447265625,
        952.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22436819970607758,
        -0.2865879535675049,
        -0.9314108490943909
      ],
      "plane_d": -605.2945556640625,
      "bbox_min": [
        -1755.0,
        -3836.3994140625,
        949.5
      ],
      "bbox_max": [
        -1745.244873046875,
        -3826.447265625,
        952.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23012220859527588,
        -0.3528193235397339,
        -0.9069522619247437
      ],
      "plane_d": -892.2055053710938,
      "bbox_min": [
        -1755.0,
        -3831.5,
        949.5
      ],
      "bbox_max": [
        -1745.244873046875,
        -3828.342041015625,
        952.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.041608307510614395,
        0.978481113910675,
        -0.20209749042987823
      ],
      "plane_d": 3872.713134765625,
      "bbox_min": [
        -1755.0,
        -3836.3994140625,
        949.5
      ],
      "bbox_max": [
        -1754.428466796875,
        -3836.375,
        949.61767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8438067436218262,
        0.2759947180747986,
        0.46023595333099365
      ],
      "plane_d": 2084.279052734375,
      "bbox_min": [
        -1744.332275390625,
        -3824.926025390625,
        952.0
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20519639551639557,
        0.06711622327566147,
        -0.976416826248169
      ],
      "plane_d": 1553.370361328125,
      "bbox_min": [
        -1742.9892578125,
        -3824.926025390625,
        952.0
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20519639551639557,
        0.06711622327566147,
        0.976416826248169
      ],
      "plane_d": -317.44415283203125,
      "bbox_min": [
        -1742.9892578125,
        -3824.926025390625,
        952.0
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20705337822437286,
        -0.06524030864238739,
        -0.9761518239974976
      ],
      "plane_d": 332.85113525390625,
      "bbox_min": [
        -1738.56640625,
        -3819.44140625,
        952.0
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        964.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.20705337822437286,
        -0.06524030864238739,
        0.9761519432067871
      ],
      "plane_d": -1537.455810546875,
      "bbox_min": [
        -1738.56640625,
        -3819.44140625,
        952.0
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        964.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1998036503791809,
        0.06295599788427353,
        -0.9778113961219788
      ],
      "plane_d": 1529.4754638671875,
      "bbox_min": [
        -1738.56640625,
        -3819.44140625,
        952.0
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1998036503791809,
        0.06295599788427353,
        0.9778113961219788
      ],
      "plane_d": -344.0111389160156,
      "bbox_min": [
        -1738.56640625,
        -3819.44140625,
        952.0
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8589522242546082,
        -0.2554439604282379,
        -0.44378986954689026
      ],
      "plane_d": -2031.718505859375,
      "bbox_min": [
        -1728.6856689453125,
        -3813.957275390625,
        953.5
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8589522242546082,
        -0.2554439604282379,
        0.44378986954689026
      ],
      "plane_d": -2882.02001953125,
      "bbox_min": [
        -1728.6856689453125,
        -3813.957275390625,
        953.5
      ],
      "bbox_max": [
        -1727.4683837890625,
        -3813.0,
        955.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6778796315193176,
        0.5727662444114685,
        -0.4608882963657379
      ],
      "plane_d": 3813.466552734375,
      "bbox_min": [
        -1748.1156005859375,
        -3838.16015625,
        949.5
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2356797605752945,
        0.2858017086982727,
        -0.9288554787635803
      ],
      "plane_d": 1565.7708740234375,
      "bbox_min": [
        -1748.1156005859375,
        -3834.1904296875,
        949.5
      ],
      "bbox_max": [
        -1744.8529052734375,
        -3831.244384765625,
        949.6626586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6735336780548096,
        0.5524901747703552,
        -0.49102625250816345
      ],
      "plane_d": 3757.181396484375,
      "bbox_min": [
        -1740.8697509765625,
        -3835.72265625,
        952.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6735336780548096,
        0.5524901747703552,
        0.49102625250816345
      ],
      "plane_d": 2816.375244140625,
      "bbox_min": [
        -1740.8697509765625,
        -3835.72265625,
        952.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16295292973518372,
        0.1336679905653,
        -0.9775373935699463
      ],
      "plane_d": 1735.5394287109375,
      "bbox_min": [
        -1739.0885009765625,
        -3835.72265625,
        952.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1629529446363449,
        0.1336679905653,
        0.9775372743606567
      ],
      "plane_d": -137.42202758789062,
      "bbox_min": [
        -1739.0885009765625,
        -3835.72265625,
        952.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15774862468242645,
        0.11454766988754272,
        -0.9808130264282227
      ],
      "plane_d": 1656.5078125,
      "bbox_min": [
        -1739.0885009765625,
        -3828.41015625,
        952.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15774860978126526,
        0.11454766988754272,
        0.9808130860328674
      ],
      "plane_d": -222.7301025390625,
      "bbox_min": [
        -1739.0885009765625,
        -3828.41015625,
        952.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17201191186904907,
        -0.10042703151702881,
        -0.9799624085426331
      ],
      "plane_d": 262.8838195800781,
      "bbox_min": [
        -1733.7447509765625,
        -3828.41015625,
        952.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17617717385292053,
        -0.12792938947677612,
        -0.9760101437568665
      ],
      "plane_d": 146.8087158203125,
      "bbox_min": [
        -1733.7447509765625,
        -3828.41015625,
        962.5
      ],
      "bbox_max": [
        -1724.232177734375,
        -3819.44140625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17201191186904907,
        -0.10042703151702881,
        0.9799624085426331
      ],
      "plane_d": -1614.72412109375,
      "bbox_min": [
        -1733.7447509765625,
        -3828.41015625,
        952.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17617717385292053,
        -0.12792938947677612,
        0.9760101437568665
      ],
      "plane_d": -1723.2266845703125,
      "bbox_min": [
        -1733.7447509765625,
        -3828.41015625,
        952.0
      ],
      "bbox_max": [
        -1724.232177734375,
        -3819.44140625,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7815960049629211,
        -0.4053915739059448,
        -0.47409412264823914
      ],
      "plane_d": -2440.741943359375,
      "bbox_min": [
        -1728.4010009765625,
        -3821.09765625,
        953.5
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7830649018287659,
        -0.4571828246116638,
        -0.4216551184654236
      ],
      "plane_d": -2691.282958984375,
      "bbox_min": [
        -1728.4010009765625,
        -3821.09765625,
        958.0
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.957275390625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7830649614334106,
        -0.45718279480934143,
        0.42165514826774597
      ],
      "plane_d": -3499.17431640625,
      "bbox_min": [
        -1728.4010009765625,
        -3821.09765625,
        953.5
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7815960645675659,
        -0.4053916037082672,
        0.47409412264823914
      ],
      "plane_d": -3349.1064453125,
      "bbox_min": [
        -1728.4010009765625,
        -3818.66015625,
        953.5
      ],
      "bbox_max": [
        -1723.232177734375,
        -3813.0,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0661642923951149,
        0.17643074691295624,
        -0.9820867776870728
      ],
      "plane_d": 1736.4776611328125,
      "bbox_min": [
        -1731.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06724267452955246,
        0.1739429533481598,
        -0.9824572801589966
      ],
      "plane_d": 1729.1575927734375,
      "bbox_min": [
        -1731.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08716320991516113,
        0.8540472388267517,
        -0.5128409266471863
      ],
      "plane_d": 3922.57470703125,
      "bbox_min": [
        -1731.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1007959321141243,
        0.9876240491867065,
        0.12016123533248901
      ],
      "plane_d": 3852.8251953125,
      "bbox_min": [
        -1731.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08208766579627991,
        0.8498944044113159,
        -0.520520031452179
      ],
      "plane_d": 3905.288818359375,
      "bbox_min": [
        -1731.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18019966781139374,
        0.9431988596916199,
        0.27911290526390076
      ],
      "plane_d": 3666.50537109375,
      "bbox_min": [
        -1731.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9463014602661133,
        0.30465272068977356,
        0.10816715657711029
      ],
      "plane_d": -545.4095458984375,
      "bbox_min": [
        -1731.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9461901187896729,
        0.3054608404636383,
        0.10685516148805618
      ],
      "plane_d": -540.8668212890625,
      "bbox_min": [
        -1703.5550537109375,
        -3839.57470703125,
        952.8571166992188
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3831.650390625,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8526041507720947,
        0.27524828910827637,
        0.4441896677017212
      ],
      "plane_d": -818.87890625,
      "bbox_min": [
        -1703.5550537109375,
        -3839.57470703125,
        952.8571166992188
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3831.650390625,
        958.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9557263851165771,
        -0.27477356791496277,
        0.10529231280088425
      ],
      "plane_d": -2778.861083984375,
      "bbox_min": [
        -1701.0054931640625,
        -3831.685302734375,
        952.87060546875
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3831.650390625,
        958.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.30106669664382935,
        0.8088797330856323,
        -0.5050469040870667
      ],
      "plane_d": 4109.6611328125,
      "bbox_min": [
        -1731.232177734375,
        -3842.037109375,
        958.0
      ],
      "bbox_max": [
        -1720.81591796875,
        -3837.3154296875,
        959.5593872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30106669664382935,
        0.8088797330856323,
        -0.5050469040870667
      ],
      "plane_d": 4109.6611328125,
      "bbox_min": [
        -1730.8856201171875,
        -3842.037109375,
        958.0
      ],
      "bbox_max": [
        -1720.81591796875,
        -3835.72265625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3124850392341614,
        -0.9445563554763794,
        0.10082932561635971
      ],
      "plane_d": -4240.216796875,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.32664936780929565,
        0.8243948817253113,
        0.4622478783130646
      ],
      "plane_d": 2168.39599609375,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8540040254592896,
        0.2785336971282959,
        0.439426988363266
      ],
      "plane_d": -804.13330078125,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8526041507720947,
        0.27524828910827637,
        0.4441896677017212
      ],
      "plane_d": -818.87890625,
      "bbox_min": [
        -1704.8707275390625,
        -3839.57470703125,
        949.5
      ],
      "bbox_max": [
        -1701.020751953125,
        -3831.696044921875,
        952.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8562653660774231,
        -0.24617834389209747,
        0.45409882068634033
      ],
      "plane_d": -2832.4794921875,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8629119396209717,
        -0.2607784569263458,
        0.4328712522983551
      ],
      "plane_d": -2879.5009765625,
      "bbox_min": [
        -1704.6832275390625,
        -3831.66162109375,
        949.5
      ],
      "bbox_max": [
        -1701.0054931640625,
        -3825.07861328125,
        952.8705444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561171531677246,
        -0.2711374759674072,
        0.11101607978343964
      ],
      "plane_d": -2771.07666015625,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9557263851165771,
        -0.27477356791496277,
        0.10529231280088425
      ],
      "plane_d": -2778.861083984375,
      "bbox_min": [
        -1703.2269287109375,
        -3831.685302734375,
        952.875
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3823.91845703125,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014315947890281677,
        -0.18238556385040283,
        -0.9831229448318481
      ],
      "plane_d": 224.32957458496094,
      "bbox_min": [
        -1720.2037353515625,
        -3832.07177734375,
        963.9846801757812
      ],
      "bbox_max": [
        -1710.427978515625,
        -3831.127197265625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06811404228210449,
        -0.17619700729846954,
        -0.9819954633712769
      ],
      "plane_d": 154.44044494628906,
      "bbox_min": [
        -1720.2037353515625,
        -3831.349609375,
        963.9846801757812
      ],
      "bbox_max": [
        -1719.619384765625,
        -3831.127197265625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01025551650673151,
        -0.1786504089832306,
        -0.9838591814041138
      ],
      "plane_d": 246.2977752685547,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07029009610414505,
        -0.17269417643547058,
        -0.9824642539024353
      ],
      "plane_d": 164.5440673828125,
      "bbox_min": [
        -1727.232177734375,
        -3832.07177734375,
        962.1122436523438
      ],
      "bbox_max": [
        -1710.427978515625,
        -3820.8876953125,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014315947890281677,
        -0.18238556385040283,
        -0.9831229448318481
      ],
      "plane_d": 224.32957458496094,
      "bbox_min": [
        -1727.232177734375,
        -3832.07177734375,
        962.5
      ],
      "bbox_max": [
        -1710.427978515625,
        -3823.333984375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06811404228210449,
        -0.17619700729846954,
        -0.9819954633712769
      ],
      "plane_d": 154.44044494628906,
      "bbox_min": [
        -1727.232177734375,
        -3831.267822265625,
        962.5
      ],
      "bbox_max": [
        -1718.73779296875,
        -3823.333984375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32533180713653564,
        -0.799300491809845,
        -0.5052503943443298
      ],
      "plane_d": -3128.849365234375,
      "bbox_min": [
        -1724.232177734375,
        -3823.333984375,
        962.1122436523438
      ],
      "bbox_max": [
        -1718.73779296875,
        -3820.8876953125,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28529059886932373,
        -0.8618294596672058,
        0.4193556010723114
      ],
      "plane_d": -4181.07373046875,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.30644655227661133,
        0.8170410990715027,
        0.48839977383613586
      ],
      "plane_d": 2149.782470703125,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13184146583080292,
        0.7602789402008057,
        0.6360768675804138
      ],
      "plane_d": 2540.7744140625,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28101539611816406,
        0.8468414545059204,
        0.4515417516231537
      ],
      "plane_d": 3304.4287109375,
      "bbox_min": [
        -1717.2447509765625,
        -3842.437744140625,
        949.5
      ],
      "bbox_max": [
        -1710.78076171875,
        -3838.4931640625,
        952.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1992454081773758,
        0.2459866851568222,
        -0.9485734701156616
      ],
      "plane_d": 1516.2685546875,
      "bbox_min": [
        -1730.232177734375,
        -3843.07177734375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27173134684562683,
        0.17812921106815338,
        -0.9457442164421082
      ],
      "plane_d": 1129.5244140625,
      "bbox_min": [
        -1710.6253662109375,
        -3840.755859375,
        961.3333129882812
      ],
      "bbox_max": [
        -1705.0120849609375,
        -3832.07177734375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42327141761779785,
        0.7756797075271606,
        -0.46814778447151184
      ],
      "plane_d": 2705.3974609375,
      "bbox_min": [
        -1710.6253662109375,
        -3840.755859375,
        961.3333129882812
      ],
      "bbox_max": [
        -1705.0120849609375,
        -3837.96826171875,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42327141761779785,
        0.7756797075271606,
        -0.46814778447151184
      ],
      "plane_d": 2705.3974609375,
      "bbox_min": [
        -1710.677978515625,
        -3843.07177734375,
        958.0
      ],
      "bbox_max": [
        -1705.0120849609375,
        -3837.96826171875,
        961.78955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188223242759705,
        0.36004483699798584,
        -0.4470992684364319
      ],
      "plane_d": 415.5501708984375,
      "bbox_min": [
        -1730.232177734375,
        -3840.499755859375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7684380412101746,
        0.24739129841327667,
        -0.5901698470115662
      ],
      "plane_d": 206.6336669921875,
      "bbox_min": [
        -1705.0120849609375,
        -3840.031982421875,
        958.0
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3831.685302734375,
        961.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25988316535949707,
        -0.1670183688402176,
        -0.9510864615440369
      ],
      "plane_d": -167.69049072265625,
      "bbox_min": [
        -1730.232177734375,
        -3840.499755859375,
        949.5
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3818.66015625,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18159335851669312,
        -0.2386971265077591,
        -0.9539641737937927
      ],
      "plane_d": -305.6854248046875,
      "bbox_min": [
        -1710.427978515625,
        -3832.07177734375,
        961.3333129882812
      ],
      "bbox_max": [
        -1702.5343017578125,
        -3825.745849609375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8206239938735962,
        -0.3349302113056183,
        -0.46303123235702515
      ],
      "plane_d": -2235.17626953125,
      "bbox_min": [
        -1704.7342529296875,
        -3831.781982421875,
        961.3333129882812
      ],
      "bbox_max": [
        -1702.5343017578125,
        -3825.745849609375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8206239938735962,
        -0.3349302113056183,
        -0.46303123235702515
      ],
      "plane_d": -2235.17626953125,
      "bbox_min": [
        -1704.7342529296875,
        -3831.7666015625,
        958.0
      ],
      "bbox_max": [
        -1700.4293212890625,
        -3825.745849609375,
        961.7894287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37827765941619873,
        -0.7875293493270874,
        -0.48652178049087524
      ],
      "plane_d": -3190.04052734375,
      "bbox_min": [
        -1730.232177734375,
        -3840.499755859375,
        949.5
      ],
      "bbox_max": [
        -1702.741455078125,
        -3818.66015625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.243071511387825,
        -0.7347383499145508,
        -0.633305549621582
      ],
      "plane_d": -2616.476806640625,
      "bbox_min": [
        -1710.177978515625,
        -3825.745849609375,
        958.0
      ],
      "bbox_max": [
        -1702.741455078125,
        -3821.07177734375,
        961.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3344689607620239,
        -0.8004820942878723,
        -0.49735188484191895
      ],
      "plane_d": -3156.673828125,
      "bbox_min": [
        -1730.232177734375,
        -3840.499755859375,
        949.5
      ],
      "bbox_max": [
        -1710.177978515625,
        -3818.66015625,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04225409775972366,
        -0.8522586226463318,
        -0.5214115977287292
      ],
      "plane_d": -2829.291015625,
      "bbox_min": [
        -1718.73779296875,
        -3823.82177734375,
        953.8350219726562
      ],
      "bbox_max": [
        -1710.177978515625,
        -3820.662109375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04921858385205269,
        -0.8573838472366333,
        -0.5123186707496643
      ],
      "plane_d": -2869.552001953125,
      "bbox_min": [
        -1718.73779296875,
        -3823.82177734375,
        958.0
      ],
      "bbox_max": [
        -1710.240478515625,
        -3820.662109375,
        962.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04928549751639366,
        -0.9940809011459351,
        0.09682083129882812
      ],
      "plane_d": -3975.49560546875,
      "bbox_min": [
        -1718.44091796875,
        -3821.470703125,
        953.8350219726562
      ],
      "bbox_max": [
        -1710.177978515625,
        -3820.662109375,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35510674118995667,
        -0.8498743176460266,
        0.38937512040138245
      ],
      "plane_d": -4230.333984375,
      "bbox_min": [
        -1725.2164306640625,
        -3823.496826171875,
        952.5599975585938
      ],
      "bbox_max": [
        -1718.44091796875,
        -3818.66015625,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19933506846427917,
        -0.8424137830734253,
        0.5006041526794434
      ],
      "plane_d": -4039.971435546875,
      "bbox_min": [
        -1725.2164306640625,
        -3823.496826171875,
        952.5599975585938
      ],
      "bbox_max": [
        -1719.1466064453125,
        -3818.66015625,
        958.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09627649188041687,
        -0.2377626597881317,
        0.9665400981903076
      ],
      "plane_d": -1664.1072998046875,
      "bbox_min": [
        -1725.2164306640625,
        -3823.496826171875,
        952.5599975585938
      ],
      "bbox_max": [
        -1719.1466064453125,
        -3821.09765625,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0853586494922638,
        -0.741162121295929,
        0.6658772826194763
      ],
      "plane_d": -3320.90283203125,
      "bbox_min": [
        -1730.232177734375,
        -3840.499755859375,
        949.5
      ],
      "bbox_max": [
        -1710.34326171875,
        -3821.562744140625,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3307248055934906,
        -0.8817712664604187,
        0.33630433678627014
      ],
      "plane_d": -3124.54736328125,
      "bbox_min": [
        -1717.0572509765625,
        -3825.3681640625,
        949.5
      ],
      "bbox_max": [
        -1710.34326171875,
        -3821.562744140625,
        952.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16720645129680634,
        0.15115100145339966,
        0.974266529083252
      ],
      "plane_d": -59.88385009765625,
      "bbox_min": [
        -1730.232177734375,
        -3840.499755859375,
        949.5
      ],
      "bbox_max": [
        -1717.0572509765625,
        -3822.859619140625,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6035842299461365,
        0.1913110464811325,
        0.7740066051483154
      ],
      "plane_d": 1035.870849609375,
      "bbox_min": [
        -1721.82470703125,
        -3840.499755859375,
        949.5
      ],
      "bbox_max": [
        -1717.0572509765625,
        -3825.2607421875,
        952.5599975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6163809299468994,
        0.1862749308347702,
        0.7650988698005676
      ],
      "plane_d": 1047.0306396484375,
      "bbox_min": [
        -1720.4366455078125,
        -3840.499755859375,
        949.5
      ],
      "bbox_max": [
        -1717.2447509765625,
        -3831.97900390625,
        952.5599975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6524635553359985,
        -0.303568571805954,
        0.6943612098693848
      ],
      "plane_d": -700.240234375,
      "bbox_min": [
        -1721.82470703125,
        -3831.97900390625,
        949.5
      ],
      "bbox_max": [
        -1717.0572509765625,
        -3825.2607421875,
        951.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.544313907623291,
        -0.17752817273139954,
        0.8198817372322083
      ],
      "plane_d": -522.97021484375,
      "bbox_min": [
        -1721.82470703125,
        -3831.97900390625,
        949.5
      ],
      "bbox_max": [
        -1717.0572509765625,
        -3825.3681640625,
        951.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03385869786143303,
        -0.14902812242507935,
        0.988253116607666
      ],
      "plane_d": -1452.8759765625,
      "bbox_min": [
        -1730.232177734375,
        -3835.72265625,
        949.6311645507812
      ],
      "bbox_max": [
        -1717.1468505859375,
        -3822.859619140625,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18067216873168945,
        0.12596899271011353,
        0.9754431247711182
      ],
      "plane_d": -134.298095703125,
      "bbox_min": [
        -1730.232177734375,
        -3835.72265625,
        951.375
      ],
      "bbox_max": [
        -1719.1466064453125,
        -3822.859619140625,
        953.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -936.5,
      "bbox_min": [
        -1721.5,
        -3883.5,
        935.0
      ],
      "bbox_max": [
        -1701.5,
        -3855.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2917170822620392,
        0.12666663527488708,
        0.9480805397033691
      ],
      "plane_d": 101.11834716796875,
      "bbox_min": [
        -1716.375,
        -3883.5,
        935.0
      ],
      "bbox_max": [
        -1704.0,
        -3855.0,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2939780354499817,
        -0.027076924219727516,
        0.9554286003112793
      ],
      "plane_d": -1500.8507080078125,
      "bbox_min": [
        -1711.5,
        -3883.5,
        935.0
      ],
      "bbox_max": [
        -1704.0,
        -3855.0,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8691632747650146,
        -0.1067393496632576,
        0.4828684628009796
      ],
      "plane_d": -2347.78271484375,
      "bbox_min": [
        -1721.5,
        -3883.5,
        936.5
      ],
      "bbox_max": [
        -1701.5,
        -3855.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370443224906921,
        -0.08630671352148056,
        0.33837711811065674
      ],
      "plane_d": -2248.78564453125,
      "bbox_min": [
        -1706.625,
        -3883.5,
        936.5
      ],
      "bbox_max": [
        -1704.0,
        -3855.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8691632747650146,
        -0.1067393496632576,
        0.4828684628009796
      ],
      "plane_d": 627.363037109375,
      "bbox_min": [
        -1721.5,
        -3883.5,
        936.5
      ],
      "bbox_max": [
        -1701.5,
        -3855.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370443224906921,
        -0.08630671352148056,
        0.33837711811065674
      ],
      "plane_d": 958.7169189453125,
      "bbox_min": [
        -1719.0,
        -3883.5,
        936.5
      ],
      "bbox_max": [
        -1716.375,
        -3855.0,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370443224906921,
        -0.08630671352148056,
        -0.33837711811065674
      ],
      "plane_d": -1611.9599609375,
      "bbox_min": [
        -1721.5,
        -3883.5,
        941.0
      ],
      "bbox_max": [
        -1701.5,
        -3855.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8691632747650146,
        -0.1067393496632576,
        -0.4828684628009796
      ],
      "plane_d": -1439.0244140625,
      "bbox_min": [
        -1705.0,
        -3883.5,
        941.0
      ],
      "bbox_max": [
        -1701.5,
        -3855.0,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        3.78447939652915e-09,
        -0.9557790756225586
      ],
      "plane_d": 401.79486083984375,
      "bbox_min": [
        -1721.5,
        -3883.5,
        941.0
      ],
      "bbox_max": [
        -1704.0,
        -3855.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1960841417312622,
        -0.018060382455587387,
        -0.980420708656311
      ],
      "plane_d": 522.722900390625,
      "bbox_min": [
        -1711.5,
        -3883.5,
        945.5
      ],
      "bbox_max": [
        -1704.0,
        -3855.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1960841417312622,
        -0.018060382455587387,
        -0.980420708656311
      ],
      "plane_d": 1193.9189453125,
      "bbox_min": [
        -1721.5,
        -3883.5,
        941.0
      ],
      "bbox_max": [
        -1711.5,
        -3855.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29408586025238037,
        0.0,
        -0.9557790160179138
      ],
      "plane_d": 1408.45068359375,
      "bbox_min": [
        -1716.375,
        -3883.5,
        945.5
      ],
      "bbox_max": [
        -1711.5,
        -3855.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8691632747650146,
        -0.1067393496632576,
        -0.4828684628009796
      ],
      "plane_d": 1536.12158203125,
      "bbox_min": [
        -1721.5,
        -3883.5,
        941.0
      ],
      "bbox_max": [
        -1716.375,
        -3855.0,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370443224906921,
        -0.08630671352148056,
        -0.33837711811065674
      ],
      "plane_d": 1595.5426025390625,
      "bbox_min": [
        -1719.0,
        -3883.5,
        941.0
      ],
      "bbox_max": [
        -1716.375,
        -3855.0,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -936.5,
      "bbox_min": [
        -1724.300048828125,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1700.43212890625,
        -3883.5,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8060724139213562,
        -0.14719411730766296,
        0.5732201337814331
      ],
      "plane_d": 277.189453125,
      "bbox_min": [
        -1724.300048828125,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1700.43212890625,
        -3883.5,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.855005145072937,
        -0.2081788033246994,
        0.47500285506248474
      ],
      "plane_d": 216.4512939453125,
      "bbox_min": [
        -1724.300048828125,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1700.43212890625,
        -3883.5,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15431594848632812,
        -0.02817910723388195,
        -0.9876196384429932
      ],
      "plane_d": 1089.6298828125,
      "bbox_min": [
        -1724.300048828125,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1700.43212890625,
        -3883.5,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        0.0,
        -0.980580747127533
      ],
      "plane_d": 1264.2628173828125,
      "bbox_min": [
        -1719.0,
        -3895.0,
        945.5
      ],
      "bbox_max": [
        -1710.578857421875,
        -3883.5,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1961161494255066,
        -0.0,
        -0.980580747127533
      ],
      "plane_d": 592.9571533203125,
      "bbox_min": [
        -1711.5,
        -3895.0,
        946.8157958984375
      ],
      "bbox_max": [
        -1710.578857421875,
        -3883.5,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8632286190986633,
        -0.15763121843338013,
        -0.4795714318752289
      ],
      "plane_d": 1325.1639404296875,
      "bbox_min": [
        -1721.5,
        -3895.0,
        941.0
      ],
      "bbox_max": [
        -1719.0,
        -3883.5,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15431594848632812,
        -0.02817910723388195,
        -0.9876195788383484
      ],
      "plane_d": 561.4063720703125,
      "bbox_min": [
        -1711.5,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1700.43212890625,
        -3883.5,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1961161494255066,
        -0.0,
        -0.980580747127533
      ],
      "plane_d": 592.9571533203125,
      "bbox_min": [
        -1711.5,
        -3895.0,
        945.5
      ],
      "bbox_max": [
        -1704.0,
        -3883.5,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8632286190986633,
        -0.15763121843338013,
        0.4795714318752289
      ],
      "plane_d": -2532.22119140625,
      "bbox_min": [
        -1704.0,
        -3891.322509765625,
        936.5
      ],
      "bbox_max": [
        -1700.43212890625,
        -3883.5,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7993643879890442,
        -0.19463123381137848,
        0.568449854850769
      ],
      "plane_d": -2650.88037109375,
      "bbox_min": [
        -1701.724853515625,
        -3889.96240234375,
        938.4712524414062
      ],
      "bbox_max": [
        -1700.43212890625,
        -3883.5,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8157945275306702,
        0.4646025598049164,
        -0.34441810846328735
      ],
      "plane_d": 3478.513671875,
      "bbox_min": [
        -1704.86083984375,
        -3895.0,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8109691739082336,
        0.45553717017173767,
        0.3671714961528778
      ],
      "plane_d": 2765.94287109375,
      "bbox_min": [
        -1704.86083984375,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1663.4390869140625,
        -3847.67041015625,
        945.962646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8060724139213562,
        -0.14719411730766296,
        -0.5732201337814331
      ],
      "plane_d": -1403.196044921875,
      "bbox_min": [
        -1704.86083984375,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1698.699951171875,
        -3887.885986328125,
        945.962646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8632286190986633,
        -0.15763121843338013,
        0.4795714318752289
      ],
      "plane_d": -2532.22119140625,
      "bbox_min": [
        -1704.86083984375,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1698.699951171875,
        -3887.885986328125,
        945.962646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7993643879890442,
        -0.19463123381137848,
        0.568449854850769
      ],
      "plane_d": -2650.88037109375,
      "bbox_min": [
        -1701.9000244140625,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1698.699951171875,
        -3887.885986328125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15431594848632812,
        -0.02817910723388195,
        -0.9876195788383484
      ],
      "plane_d": 561.4063720703125,
      "bbox_min": [
        -1704.86083984375,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1701.9000244140625,
        -3891.322509765625,
        945.962646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -936.5,
      "bbox_min": [
        -1704.86083984375,
        -3895.0,
        936.5
      ],
      "bbox_max": [
        -1701.9000244140625,
        -3891.322509765625,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8109691739082336,
        0.45553717017173767,
        -0.3671714961528778
      ],
      "plane_d": 3456.95947265625,
      "bbox_min": [
        -1675.39599609375,
        -3867.45458984375,
        941.0
      ],
      "bbox_max": [
        -1663.4390869140625,
        -3847.67041015625,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8157945275306702,
        0.4646025598049164,
        0.34441810846328735
      ],
      "plane_d": 2830.319091796875,
      "bbox_min": [
        -1675.39599609375,
        -3867.37158203125,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8109691739082336,
        0.45553717017173767,
        0.3671714961528778
      ],
      "plane_d": 2765.94287109375,
      "bbox_min": [
        -1675.39599609375,
        -3867.37158203125,
        936.5
      ],
      "bbox_max": [
        -1663.4390869140625,
        -3847.67041015625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24667970836162567,
        0.1469448059797287,
        0.957891583442688
      ],
      "plane_d": 81.136962890625,
      "bbox_min": [
        -1674.40380859375,
        -3865.32958984375,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23440812528133392,
        0.13349759578704834,
        0.9629284739494324
      ],
      "plane_d": 4.153350830078125,
      "bbox_min": [
        -1674.40380859375,
        -3865.32958984375,
        935.0
      ],
      "bbox_max": [
        -1660.9078369140625,
        -3846.07666015625,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24667969346046448,
        0.1469448059797287,
        -0.957891583442688
      ],
      "plane_d": 1883.8887939453125,
      "bbox_min": [
        -1674.40380859375,
        -3865.32958984375,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23440809547901154,
        0.13349759578704834,
        -0.9629284739494324
      ],
      "plane_d": 1816.3846435546875,
      "bbox_min": [
        -1674.40380859375,
        -3865.32958984375,
        945.5
      ],
      "bbox_max": [
        -1660.9078369140625,
        -3846.07666015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22847744822502136,
        -0.13610190153121948,
        0.9639888405799866
      ],
      "plane_d": -1806.0205078125,
      "bbox_min": [
        -1671.42724609375,
        -3858.95458984375,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22847744822502136,
        -0.13610190153121948,
        -0.9639888405799866
      ],
      "plane_d": 8.2064208984375,
      "bbox_min": [
        -1671.42724609375,
        -3858.95458984375,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7839590907096863,
        -0.49159467220306396,
        -0.37913423776626587
      ],
      "plane_d": -2835.53564453125,
      "bbox_min": [
        -1671.42724609375,
        -3852.57958984375,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.783959150314331,
        -0.49159473180770874,
        0.37913429737091064
      ],
      "plane_d": -3549.06640625,
      "bbox_min": [
        -1671.42724609375,
        -3852.57958984375,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7886297702789307,
        -0.5038998126983643,
        -0.35234639048576355
      ],
      "plane_d": -2915.865234375,
      "bbox_min": [
        -1671.42724609375,
        -3852.57958984375,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7886298298835754,
        -0.5038998126983643,
        0.3523464500904083
      ],
      "plane_d": -3578.981201171875,
      "bbox_min": [
        -1671.42724609375,
        -3852.57958984375,
        935.0
      ],
      "bbox_max": [
        -1657.5328369140625,
        -3834.92041015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2407110333442688,
        -0.1509418934583664,
        0.9587881565093994
      ],
      "plane_d": -1878.6103515625,
      "bbox_min": [
        -1671.42724609375,
        -3852.57958984375,
        935.0
      ],
      "bbox_max": [
        -1658.3765869140625,
        -3836.51416015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2407110333442688,
        -0.1509418934583664,
        -0.9587881565093994
      ],
      "plane_d": -74.17105102539062,
      "bbox_min": [
        -1671.42724609375,
        -3852.57958984375,
        945.5
      ],
      "bbox_max": [
        -1658.3765869140625,
        -3836.51416015625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8391901850700378,
        0.4414845407009125,
        0.3175707161426544
      ],
      "plane_d": 2805.2373046875,
      "bbox_min": [
        -1664.2828369140625,
        -3886.77783203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8391902446746826,
        0.44148460030555725,
        -0.31757068634033203
      ],
      "plane_d": 3402.90576171875,
      "bbox_min": [
        -1664.2828369140625,
        -3886.77783203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313612937927246,
        0.4258989989757538,
        0.3569992184638977
      ],
      "plane_d": 2694.8291015625,
      "bbox_min": [
        -1664.2828369140625,
        -3884.09033203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313612341880798,
        0.4258989989757538,
        -0.3569992184638977
      ],
      "plane_d": 3366.70166015625,
      "bbox_min": [
        -1664.2828369140625,
        -3884.09033203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28441014885902405,
        0.14570079743862152,
        0.9475663900375366
      ],
      "plane_d": 148.88467407226562,
      "bbox_min": [
        -1663.4390869140625,
        -3884.09033203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28441014885902405,
        0.14570079743862152,
        -0.9475663900375366
      ],
      "plane_d": 1932.20458984375,
      "bbox_min": [
        -1663.4390869140625,
        -3884.09033203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2612290680408478,
        0.12159150838851929,
        0.9575880169868469
      ],
      "plane_d": 7.748687744140625,
      "bbox_min": [
        -1663.4390869140625,
        -3876.02783203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2612290680408478,
        0.12159150838851929,
        -0.9575880169868469
      ],
      "plane_d": 1809.929443359375,
      "bbox_min": [
        -1663.4390869140625,
        -3876.02783203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2785987854003906,
        -0.11376705765724182,
        0.9536455273628235
      ],
      "plane_d": -1793.407470703125,
      "bbox_min": [
        -1660.9078369140625,
        -3876.02783203125,
        935.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30566805601119995,
        -0.14227604866027832,
        0.9414480924606323
      ],
      "plane_d": -1936.977294921875,
      "bbox_min": [
        -1660.9078369140625,
        -3876.02783203125,
        935.0
      ],
      "bbox_max": [
        -1652.09375,
        -3858.95458984375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8817456960678101,
        -0.34073323011398315,
        0.32622915506362915
      ],
      "plane_d": -3080.48193359375,
      "bbox_min": [
        -1660.9078369140625,
        -3876.02783203125,
        936.5
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8902746438980103,
        -0.3635476529598236,
        0.2743065357208252
      ],
      "plane_d": -3133.89501953125,
      "bbox_min": [
        -1658.3765869140625,
        -3867.96533203125,
        936.5
      ],
      "bbox_max": [
        -1651.8046875,
        -3852.57958984375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8902746438980103,
        -0.3635476529598236,
        -0.2743065357208252
      ],
      "plane_d": -2617.650146484375,
      "bbox_min": [
        -1660.9078369140625,
        -3876.02783203125,
        941.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8817456960678101,
        -0.34073323011398315,
        -0.32622915506362915
      ],
      "plane_d": -2466.5185546875,
      "bbox_min": [
        -1658.3765869140625,
        -3865.27783203125,
        941.0
      ],
      "bbox_max": [
        -1651.8046875,
        -3850.45458984375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3056681156158447,
        -0.14227606356143951,
        -0.9414481520652771
      ],
      "plane_d": -165.17205810546875,
      "bbox_min": [
        -1660.9078369140625,
        -3876.02783203125,
        945.5
      ],
      "bbox_max": [
        -1652.09375,
        -3852.57958984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2785987854003906,
        -0.11376706510782242,
        -0.9536455273628235
      ],
      "plane_d": 1.353515625,
      "bbox_min": [
        -1660.9078369140625,
        -3867.96533203125,
        945.5
      ],
      "bbox_max": [
        -1652.09375,
        -3852.57958984375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4466797709465027,
        0.778244137763977,
        0.44137653708457947
      ],
      "plane_d": 3348.387451171875,
      "bbox_min": [
        -1654.1171875,
        -3893.21875,
        935.0
      ],
      "bbox_max": [
        -1642.895263671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4466797709465027,
        0.778244137763977,
        -0.44137653708457947
      ],
      "plane_d": 4179.05810546875,
      "bbox_min": [
        -1654.1171875,
        -3893.21875,
        935.0
      ],
      "bbox_max": [
        -1642.895263671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534975290298462,
        0.7520580291748047,
        0.47827672958374023
      ],
      "plane_d": 3223.162109375,
      "bbox_min": [
        -1654.1171875,
        -3890.34375,
        935.0
      ],
      "bbox_max": [
        -1643.457763671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4534975290298462,
        0.7520580291748047,
        -0.47827672958374023
      ],
      "plane_d": 4123.27880859375,
      "bbox_min": [
        -1654.1171875,
        -3890.34375,
        935.0
      ],
      "bbox_max": [
        -1643.457763671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11586705595254898,
        0.19214822351932526,
        0.97450190782547
      ],
      "plane_d": 25.324203491210938,
      "bbox_min": [
        -1653.828125,
        -3890.34375,
        935.0
      ],
      "bbox_max": [
        -1643.457763671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11586705595254898,
        0.19214823842048645,
        -0.9745018482208252
      ],
      "plane_d": 1859.3367919921875,
      "bbox_min": [
        -1653.828125,
        -3890.34375,
        935.0
      ],
      "bbox_max": [
        -1643.457763671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12286218255758286,
        0.1687338799238205,
        0.9779742956161499
      ],
      "plane_d": -57.3023681640625,
      "bbox_min": [
        -1653.828125,
        -3884.09033203125,
        935.0
      ],
      "bbox_max": [
        -1645.145263671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12286218255758286,
        0.1687338799238205,
        -0.9779743552207947
      ],
      "plane_d": 1783.245361328125,
      "bbox_min": [
        -1653.828125,
        -3884.09033203125,
        935.0
      ],
      "bbox_max": [
        -1645.145263671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15978914499282837,
        -0.16391967236995697,
        0.9734463095664978
      ],
      "plane_d": -1809.65478515625,
      "bbox_min": [
        -1652.9609375,
        -3881.71875,
        935.0
      ],
      "bbox_max": [
        -1645.145263671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14323239028453827,
        -0.1967095136642456,
        0.9699432849884033
      ],
      "plane_d": -1906.1060791015625,
      "bbox_min": [
        -1652.9609375,
        -3881.71875,
        935.0
      ],
      "bbox_max": [
        -1645.145263671875,
        -3873.09375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15978914499282837,
        -0.16391967236995697,
        -0.9734463095664978
      ],
      "plane_d": 22.3712158203125,
      "bbox_min": [
        -1652.9609375,
        -3881.71875,
        936.5
      ],
      "bbox_max": [
        -1645.145263671875,
        -3865.27783203125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14323239028453827,
        -0.1967095136642456,
        -0.9699432849884033
      ],
      "plane_d": -80.67277526855469,
      "bbox_min": [
        -1652.9609375,
        -3881.71875,
        945.5
      ],
      "bbox_max": [
        -1645.145263671875,
        -3873.09375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6815035939216614,
        -0.6081943511962891,
        -0.40700429677963257
      ],
      "plane_d": -3093.56005859375,
      "bbox_min": [
        -1652.09375,
        -3873.09375,
        936.5
      ],
      "bbox_max": [
        -1646.832763671875,
        -3865.27783203125,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546027660369873,
        -0.6715241074562073,
        -0.34720391035079956
      ],
      "plane_d": -3350.61572265625,
      "bbox_min": [
        -1652.09375,
        -3873.09375,
        941.0
      ],
      "bbox_max": [
        -1646.832763671875,
        -3867.96533203125,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6546027064323425,
        -0.6715240478515625,
        0.34720394015312195
      ],
      "plane_d": -4004.05322265625,
      "bbox_min": [
        -1652.09375,
        -3873.09375,
        936.5
      ],
      "bbox_max": [
        -1646.832763671875,
        -3865.27783203125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6815035939216614,
        -0.6081942915916443,
        0.40700435638427734
      ],
      "plane_d": -3859.5419921875,
      "bbox_min": [
        -1652.09375,
        -3870.21875,
        936.5
      ],
      "bbox_max": [
        -1647.395263671875,
        -3865.27783203125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10289715975522995,
        0.15085679292678833,
        0.9831858277320862
      ],
      "plane_d": -502.97589111328125,
      "bbox_min": [
        -1647.395263671875,
        -3893.21875,
        935.0
      ],
      "bbox_max": [
        -1633.803466796875,
        -3866.951171875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46636632084846497,
        0.704620361328125,
        0.5348014235496521
      ],
      "plane_d": 1473.802001953125,
      "bbox_min": [
        -1647.395263671875,
        -3893.21875,
        935.0
      ],
      "bbox_max": [
        -1633.803466796875,
        -3866.951171875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4835618734359741,
        0.708946704864502,
        0.5133833885192871
      ],
      "plane_d": 1482.54931640625,
      "bbox_min": [
        -1643.457763671875,
        -3893.21875,
        936.5
      ],
      "bbox_max": [
        -1635.139404296875,
        -3884.669921875,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10289714485406876,
        0.15085679292678833,
        -0.9831858277320862
      ],
      "plane_d": 1347.3798828125,
      "bbox_min": [
        -1647.395263671875,
        -3893.21875,
        935.0
      ],
      "bbox_max": [
        -1633.803466796875,
        -3866.951171875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46636638045310974,
        0.7046204209327698,
        -0.5348014831542969
      ],
      "plane_d": 2480.298583984375,
      "bbox_min": [
        -1647.395263671875,
        -3893.21875,
        935.0
      ],
      "bbox_max": [
        -1633.803466796875,
        -3866.951171875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4835619330406189,
        0.7089466452598572,
        -0.5133833885192871
      ],
      "plane_d": 2448.736572265625,
      "bbox_min": [
        -1643.457763671875,
        -3893.21875,
        941.0
      ],
      "bbox_max": [
        -1635.139404296875,
        -3884.669921875,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10688108205795288,
        0.13808657228946686,
        0.9846362471580505
      ],
      "plane_d": -560.45654296875,
      "bbox_min": [
        -1647.395263671875,
        -3884.669921875,
        935.0
      ],
      "bbox_max": [
        -1635.139404296875,
        -3866.951171875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10688110440969467,
        0.13808660209178925,
        -0.9846363067626953
      ],
      "plane_d": 1292.6290283203125,
      "bbox_min": [
        -1647.395263671875,
        -3884.669921875,
        935.0
      ],
      "bbox_max": [
        -1635.139404296875,
        -3866.951171875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12568296492099762,
        -0.12799406051635742,
        0.9837790727615356
      ],
      "plane_d": -1210.063232421875,
      "bbox_min": [
        -1647.395263671875,
        -3881.71875,
        935.0
      ],
      "bbox_max": [
        -1639.147216796875,
        -3866.951171875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1148313656449318,
        -0.1483580619096756,
        0.9822441935539246
      ],
      "plane_d": -1305.3682861328125,
      "bbox_min": [
        -1646.832763671875,
        -3881.71875,
        935.0
      ],
      "bbox_max": [
        -1639.147216796875,
        -3873.09375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12568296492099762,
        -0.12799406051635742,
        -0.9837790727615356
      ],
      "plane_d": 641.408935546875,
      "bbox_min": [
        -1647.395263671875,
        -3881.71875,
        936.5
      ],
      "bbox_max": [
        -1639.147216796875,
        -3866.951171875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1148313656449318,
        -0.1483580619096756,
        -0.9822441935539246
      ],
      "plane_d": 543.21533203125,
      "bbox_min": [
        -1646.832763671875,
        -3881.71875,
        945.5
      ],
      "bbox_max": [
        -1639.147216796875,
        -3873.09375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5983065366744995,
        -0.6093084216117859,
        -0.5203582048416138
      ],
      "plane_d": -882.5992431640625,
      "bbox_min": [
        -1647.395263671875,
        -3873.09375,
        936.5
      ],
      "bbox_max": [
        -1643.155029296875,
        -3866.951171875,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5983065366744995,
        -0.6093084216117859,
        0.5203582048416138
      ],
      "plane_d": -1861.913330078125,
      "bbox_min": [
        -1647.395263671875,
        -3873.09375,
        936.5
      ],
      "bbox_max": [
        -1643.155029296875,
        -3866.951171875,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6637147665023804,
        -0.5899245738983154,
        -0.45986059308052063
      ],
      "plane_d": -757.0078125,
      "bbox_min": [
        -1647.395263671875,
        -3873.09375,
        936.5
      ],
      "bbox_max": [
        -1644.490966796875,
        -3866.951171875,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6637147665023804,
        -0.5899245738983154,
        0.45986059308052063
      ],
      "plane_d": -1622.4654541015625,
      "bbox_min": [
        -1647.395263671875,
        -3873.09375,
        936.5
      ],
      "bbox_max": [
        -1644.490966796875,
        -3866.951171875,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9358931183815002,
        0.10427482426166534,
        -0.33649787306785583
      ],
      "plane_d": -807.0836181640625,
      "bbox_min": [
        -1644.490966796875,
        -3887.201171875,
        935.0
      ],
      "bbox_max": [
        -1612.0,
        -3813.0,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547726154327393,
        0.6288760304450989,
        -0.5447404384613037
      ],
      "plane_d": 3811.828125,
      "bbox_min": [
        -1624.6712646484375,
        -3822.512939453125,
        935.9661254882812
      ],
      "bbox_max": [
        -1612.0,
        -3813.0,
        946.0338745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547725558280945,
        0.6288760304450989,
        0.544740617275238
      ],
      "plane_d": 2786.62646484375,
      "bbox_min": [
        -1624.6712646484375,
        -3822.512939453125,
        935.9661254882812
      ],
      "bbox_max": [
        -1612.0,
        -3813.0,
        946.0338745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4012720584869385,
        0.580380380153656,
        0.7086179852485657
      ],
      "plane_d": 2198.984130859375,
      "bbox_min": [
        -1621.9622802734375,
        -3822.512939453125,
        935.9661254882812
      ],
      "bbox_max": [
        -1612.0,
        -3813.0,
        946.0338745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4012720286846161,
        0.5803803205490112,
        -0.7086178660392761
      ],
      "plane_d": 3532.6025390625,
      "bbox_min": [
        -1621.9622802734375,
        -3822.512939453125,
        935.9661254882812
      ],
      "bbox_max": [
        -1612.0,
        -3813.0,
        946.0338745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037743739783763885,
        0.09482476115226746,
        0.9947782158851624
      ],
      "plane_d": -508.6690368652344,
      "bbox_min": [
        -1618.371826171875,
        -3822.512939453125,
        935.9661254882812
      ],
      "bbox_max": [
        -1612.0,
        -3813.0,
        946.0338745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3808179199695587,
        0.6312364339828491,
        -0.6756613850593567
      ],
      "plane_d": 3662.785888671875,
      "bbox_min": [
        -1616.83203125,
        -3822.512939453125,
        941.0
      ],
      "bbox_max": [
        -1612.0,
        -3819.80419921875,
        943.8273315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9358931183815002,
        0.10427482426166534,
        0.33649787306785583
      ],
      "plane_d": -1440.372802734375,
      "bbox_min": [
        -1644.490966796875,
        -3887.201171875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9263719320297241,
        0.10018934309482574,
        0.3630387783050537
      ],
      "plane_d": -1465.530517578125,
      "bbox_min": [
        -1644.490966796875,
        -3884.669921875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9263719320297241,
        0.10018934309482574,
        -0.3630387783050537
      ],
      "plane_d": -782.29150390625,
      "bbox_min": [
        -1644.490966796875,
        -3884.669921875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29648396372795105,
        0.03206544741988182,
        0.954499363899231
      ],
      "plane_d": -1254.11767578125,
      "bbox_min": [
        -1644.490966796875,
        -3884.669921875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29648396372795105,
        0.03206544741988182,
        -0.954499363899231
      ],
      "plane_d": 542.250244140625,
      "bbox_min": [
        -1644.490966796875,
        -3884.669921875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27289947867393494,
        0.026155296713113785,
        0.961686909198761
      ],
      "plane_d": -1245.0936279296875,
      "bbox_min": [
        -1644.490966796875,
        -3877.076171875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27289947867393494,
        0.026155296713113785,
        -0.961686909198761
      ],
      "plane_d": 564.8011474609375,
      "bbox_min": [
        -1644.490966796875,
        -3877.076171875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30183640122413635,
        -0.02892867662012577,
        -0.95292067527771
      ],
      "plane_d": 1285.011474609375,
      "bbox_min": [
        -1644.490966796875,
        -3877.076171875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2732575833797455,
        -0.021221237257122993,
        -0.9617068767547607
      ],
      "plane_d": 1276.1832275390625,
      "bbox_min": [
        -1643.155029296875,
        -3869.482421875,
        945.3009643554688
      ],
      "bbox_max": [
        -1635.554443359375,
        -3838.919677734375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9440637826919556,
        -0.07331617921590805,
        -0.3215092718601227
      ],
      "plane_d": 1571.5345458984375,
      "bbox_min": [
        -1643.155029296875,
        -3869.482421875,
        945.3009643554688
      ],
      "bbox_max": [
        -1635.554443359375,
        -3838.919677734375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7561629414558411,
        -0.5762584805488586,
        -0.31007054448127747
      ],
      "plane_d": -678.4927978515625,
      "bbox_min": [
        -1640.8818359375,
        -3839.21484375,
        945.3009643554688
      ],
      "bbox_max": [
        -1640.804443359375,
        -3839.195068359375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20691068470478058,
        -0.49014851450920105,
        -0.8467245101928711
      ],
      "plane_d": -741.7073974609375,
      "bbox_min": [
        -1640.86962890625,
        -3839.58984375,
        945.3043823242188
      ],
      "bbox_max": [
        -1635.554443359375,
        -3838.919677734375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7561629414558411,
        -0.5762584805488586,
        -0.31007054448127747
      ],
      "plane_d": -678.4927978515625,
      "bbox_min": [
        -1640.86962890625,
        -3839.21484375,
        945.3043823242188
      ],
      "bbox_max": [
        -1640.63232421875,
        -3838.919677734375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30183640122413635,
        -0.02892867662012577,
        0.95292067527771
      ],
      "plane_d": -508.38519287109375,
      "bbox_min": [
        -1644.490966796875,
        -3877.076171875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2732575833797455,
        -0.021221237257122993,
        0.9617068767547607
      ],
      "plane_d": -533.7490844726562,
      "bbox_min": [
        -1643.155029296875,
        -3869.482421875,
        935.0
      ],
      "bbox_max": [
        -1635.554443359375,
        -3838.919921875,
        936.698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9440637826919556,
        -0.07331617921590805,
        0.3215092718601227
      ],
      "plane_d": 966.4540405273438,
      "bbox_min": [
        -1643.155029296875,
        -3869.482421875,
        935.0
      ],
      "bbox_max": [
        -1635.554443359375,
        -3838.919921875,
        936.698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7561630010604858,
        -0.5762585401535034,
        0.31007054448127747
      ],
      "plane_d": -1262.0457763671875,
      "bbox_min": [
        -1640.8818359375,
        -3839.21484375,
        936.5
      ],
      "bbox_max": [
        -1640.804443359375,
        -3839.19482421875,
        936.698974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20691071450710297,
        -0.49014854431152344,
        0.8467245697975159
      ],
      "plane_d": -2335.242919921875,
      "bbox_min": [
        -1640.8695068359375,
        -3839.58984375,
        935.0
      ],
      "bbox_max": [
        -1635.554443359375,
        -3838.919921875,
        936.6954956054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7561630010604858,
        -0.5762585401535034,
        0.31007054448127747
      ],
      "plane_d": -1262.0457763671875,
      "bbox_min": [
        -1640.8695068359375,
        -3839.21484375,
        936.5
      ],
      "bbox_max": [
        -1640.6324462890625,
        -3838.919921875,
        936.6954956054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9294503927230835,
        -0.06460217386484146,
        0.36324742436408997
      ],
      "plane_d": 936.843505859375,
      "bbox_min": [
        -1644.490966796875,
        -3869.482421875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9294503927230835,
        -0.06460217386484146,
        -0.36324742436408997
      ],
      "plane_d": 1620.4752197265625,
      "bbox_min": [
        -1644.490966796875,
        -3869.482421875,
        935.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9440637826919556,
        -0.07331617921590805,
        -0.3215092718601227
      ],
      "plane_d": 1571.5345458984375,
      "bbox_min": [
        -1644.490966796875,
        -3869.482421875,
        941.0
      ],
      "bbox_max": [
        -1640.9583740234375,
        -3840.373291015625,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8304018974304199,
        -0.4629102945327759,
        0.31007540225982666
      ],
      "plane_d": -3421.752685546875,
      "bbox_min": [
        -1631.467529296875,
        -3839.984619140625,
        936.5
      ],
      "bbox_max": [
        -1630.0281982421875,
        -3837.096923828125,
        937.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8304018974304199,
        -0.4629102945327759,
        0.31007540225982666
      ],
      "plane_d": -3421.752685546875,
      "bbox_min": [
        -1631.467529296875,
        -3840.08984375,
        937.2103271484375
      ],
      "bbox_max": [
        -1628.554443359375,
        -3837.096923828125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8304018378257751,
        -0.4629102945327759,
        -0.31007543206214905
      ],
      "plane_d": -2838.19091796875,
      "bbox_min": [
        -1631.467529296875,
        -3839.984619140625,
        944.3333129882812
      ],
      "bbox_max": [
        -1630.0281982421875,
        -3837.096923828125,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8304018378257751,
        -0.4629102945327759,
        -0.31007543206214905
      ],
      "plane_d": -2838.19091796875,
      "bbox_min": [
        -1631.467529296875,
        -3840.08984375,
        941.0
      ],
      "bbox_max": [
        -1628.554443359375,
        -3837.096923828125,
        944.78955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2803981900215149,
        -0.8922681212425232,
        -0.35388487577438354
      ],
      "plane_d": -3546.994384765625,
      "bbox_min": [
        -1635.1981201171875,
        -3836.40966796875,
        941.0
      ],
      "bbox_max": [
        -1630.0372314453125,
        -3834.6025390625,
        941.7083129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2803981900215149,
        -0.8922681212425232,
        -0.35388487577438354
      ],
      "plane_d": -3546.994384765625,
      "bbox_min": [
        -1635.1981201171875,
        -3837.096923828125,
        941.0
      ],
      "bbox_max": [
        -1630.3411865234375,
        -3834.6025390625,
        944.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32168135046958923,
        -0.37212902307510376,
        0.8706555962562561
      ],
      "plane_d": -1716.758544921875,
      "bbox_min": [
        -1639.245361328125,
        -3839.58984375,
        935.0
      ],
      "bbox_max": [
        -1635.329345703125,
        -3836.439697265625,
        937.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7828254103660583,
        -0.4367678165435791,
        0.44319087266921997
      ],
      "plane_d": -808.000244140625,
      "bbox_min": [
        -1642.554443359375,
        -3839.58984375,
        936.6287231445312
      ],
      "bbox_max": [
        -1635.1981201171875,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7561630010604858,
        -0.5762585401535034,
        0.31007054448127747
      ],
      "plane_d": -1262.0457763671875,
      "bbox_min": [
        -1642.554443359375,
        -3839.209228515625,
        936.6287231445312
      ],
      "bbox_max": [
        -1639.245361328125,
        -3836.541259765625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15072879195213318,
        -0.9230712652206421,
        -0.3538646996021271
      ],
      "plane_d": -2960.153076171875,
      "bbox_min": [
        -1642.554443359375,
        -3839.58984375,
        941.0
      ],
      "bbox_max": [
        -1635.1981201171875,
        -3834.6025390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23891796171665192,
        -0.9369913339614868,
        -0.2548833191394806
      ],
      "plane_d": -2962.4658203125,
      "bbox_min": [
        -1639.245361328125,
        -3836.541259765625,
        941.0
      ],
      "bbox_max": [
        -1635.1981201171875,
        -3834.6025390625,
        945.7367553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32168132066726685,
        -0.37212902307510376,
        -0.8706555962562561
      ],
      "plane_d": -78.18463134765625,
      "bbox_min": [
        -1639.245361328125,
        -3839.58984375,
        944.3333129882812
      ],
      "bbox_max": [
        -1635.329345703125,
        -3836.439697265625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7828254103660583,
        -0.4367678165435791,
        -0.44319090247154236
      ],
      "plane_d": 26.0850830078125,
      "bbox_min": [
        -1642.554443359375,
        -3839.209228515625,
        941.0
      ],
      "bbox_max": [
        -1639.245361328125,
        -3835.474365234375,
        945.3712158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7561629414558411,
        -0.5762584805488586,
        -0.31007054448127747
      ],
      "plane_d": -678.4927978515625,
      "bbox_min": [
        -1642.554443359375,
        -3839.209228515625,
        941.0
      ],
      "bbox_max": [
        -1639.245361328125,
        -3836.541259765625,
        945.3712158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.25008928775787354,
        0.9682227969169617
      ],
      "plane_d": 67.357177734375,
      "bbox_min": [
        -1732.764892578125,
        -3915.0,
        932.8438110351562
      ],
      "bbox_max": [
        -1689.2894287109375,
        -3895.0,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9846713542938232,
        0.17441987991333008
      ],
      "plane_d": -4017.887939453125,
      "bbox_min": [
        -1705.0,
        -3915.0,
        932.8438110351562
      ],
      "bbox_max": [
        -1692.0,
        -3904.803955078125,
        941.328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8309906721115112,
        -0.519740104675293,
        0.19830459356307983
      ],
      "plane_d": -811.1348876953125,
      "bbox_min": [
        -1705.0,
        -3915.0,
        932.8438110351562
      ],
      "bbox_max": [
        -1692.0,
        -3904.803955078125,
        941.328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.835360586643219,
        -0.522473156452179,
        0.17086340487003326
      ],
      "plane_d": -3626.54833984375,
      "bbox_min": [
        -1705.0,
        -3915.0,
        932.8438110351562
      ],
      "bbox_max": [
        -1692.0,
        -3904.803955078125,
        941.328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8309916853904724,
        0.5197407007217407,
        0.1982990950345993
      ],
      "plane_d": 3253.2421875,
      "bbox_min": [
        -1705.0,
        -3910.0,
        932.8438110351562
      ],
      "bbox_max": [
        -1692.0,
        -3904.803955078125,
        940.3744506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8353597521781921,
        0.5224726796150208,
        0.17086905241012573
      ],
      "plane_d": 459.185546875,
      "bbox_min": [
        -1705.0,
        -3910.0,
        932.8438110351562
      ],
      "bbox_max": [
        -1695.25,
        -3904.803955078125,
        940.3744506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9846713542938232,
        0.17441989481449127
      ],
      "plane_d": 3682.2421875,
      "bbox_min": [
        -1701.75,
        -3905.95263671875,
        932.8438110351562
      ],
      "bbox_max": [
        -1695.25,
        -3904.803955078125,
        939.3290405273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.338542640209198,
        -0.9409511089324951
      ],
      "plane_d": -413.951416015625,
      "bbox_min": [
        -1732.764892578125,
        -3915.0,
        936.5
      ],
      "bbox_max": [
        -1689.2894287109375,
        -3895.0,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9832141995429993,
        -0.1824551820755005
      ],
      "plane_d": 4017.306640625,
      "bbox_min": [
        -1705.0,
        -3915.0,
        965.6521606445312
      ],
      "bbox_max": [
        -1692.0,
        -3904.803955078125,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8293917775154114,
        0.5187644362449646,
        -0.20734645426273346
      ],
      "plane_d": 3634.03759765625,
      "bbox_min": [
        -1705.0,
        -3915.0,
        965.6521606445312
      ],
      "bbox_max": [
        -1692.0,
        -3904.803955078125,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8341626524925232,
        0.5217485427856445,
        -0.17874912917613983
      ],
      "plane_d": 792.2208251953125,
      "bbox_min": [
        -1705.0,
        -3915.0,
        965.6521606445312
      ],
      "bbox_max": [
        -1692.0,
        -3904.803955078125,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829391598701477,
        -0.518764317035675,
        -0.20734789967536926
      ],
      "plane_d": -422.69873046875,
      "bbox_min": [
        -1705.0,
        -3915.0,
        966.8412475585938
      ],
      "bbox_max": [
        -1692.0,
        -3910.0,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8341628313064575,
        -0.5217486619949341,
        -0.17874766886234283
      ],
      "plane_d": -3287.85498046875,
      "bbox_min": [
        -1705.0,
        -3915.0,
        966.8412475585938
      ],
      "bbox_max": [
        -1695.3914794921875,
        -3910.0,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9832141995429993,
        -0.18245519697666168
      ],
      "plane_d": -3671.428466796875,
      "bbox_min": [
        -1701.646240234375,
        -3915.0,
        968.2003173828125
      ],
      "bbox_max": [
        -1695.3914794921875,
        -3913.777587890625,
        974.787353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.978027880191803,
        -0.19976262748241425,
        -0.05963584780693054
      ],
      "plane_d": 969.0894775390625,
      "bbox_min": [
        -1732.764892578125,
        -3915.0,
        936.5
      ],
      "bbox_max": [
        -1689.2894287109375,
        -3895.0,
        968.6401977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9737920761108398,
        -0.22737257182598114,
        0.005545672960579395
      ],
      "plane_d": 791.8502197265625,
      "bbox_min": [
        -1732.764892578125,
        -3915.0,
        948.2280883789062
      ],
      "bbox_max": [
        -1728.0625,
        -3895.0,
        964.1701049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7620426416397095,
        -0.3324712812900543,
        -0.5556560754776001
      ],
      "plane_d": 553.7591552734375,
      "bbox_min": [
        -1732.61767578125,
        -3915.0,
        962.5885620117188
      ],
      "bbox_max": [
        -1730.8765869140625,
        -3910.445556640625,
        964.1701049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7092720866203308,
        0.06432174891233444,
        0.7019942998886108
      ],
      "plane_d": 815.8492431640625,
      "bbox_min": [
        -1732.74267578125,
        -3915.0,
        936.5
      ],
      "bbox_max": [
        -1689.2894287109375,
        -3895.0,
        968.6401977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9142935872077942,
        0.071955606341362,
        0.3986096978187561
      ],
      "plane_d": 1485.7398681640625,
      "bbox_min": [
        -1729.0,
        -3915.0,
        936.5
      ],
      "bbox_max": [
        -1726.765625,
        -3895.0,
        942.0579223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7620426416397095,
        -0.3324712812900543,
        -0.5556560754776001
      ],
      "plane_d": 553.7591552734375,
      "bbox_min": [
        -1731.71044921875,
        -3915.0,
        936.5
      ],
      "bbox_max": [
        -1689.2894287109375,
        -3895.0,
        968.6401977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9200292825698853,
        -0.2912231981754303,
        -0.2621738910675049
      ],
      "plane_d": -2446.0263671875,
      "bbox_min": [
        -1698.4375,
        -3915.0,
        948.2280883789062
      ],
      "bbox_max": [
        -1689.6070556640625,
        -3895.0,
        968.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829391598701477,
        -0.518764317035675,
        -0.20734789967536926
      ],
      "plane_d": -422.69873046875,
      "bbox_min": [
        -1697.201171875,
        -3912.992919921875,
        962.647705078125
      ],
      "bbox_max": [
        -1694.2506103515625,
        -3906.6953125,
        967.9180297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9832141995429993,
        -0.1824551820755005
      ],
      "plane_d": 4017.306640625,
      "bbox_min": [
        -1697.201171875,
        -3906.923095703125,
        964.4246215820312
      ],
      "bbox_max": [
        -1696.614990234375,
        -3906.6953125,
        965.6521606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9832141995429993,
        -0.1824551820755005
      ],
      "plane_d": 4017.306640625,
      "bbox_min": [
        -1697.699462890625,
        -3913.777587890625,
        963.5293579101562
      ],
      "bbox_max": [
        -1696.273681640625,
        -3906.6953125,
        968.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9832141995429993,
        -0.18245519697666168
      ],
      "plane_d": -3671.428466796875,
      "bbox_min": [
        -1696.388427734375,
        -3913.777587890625,
        967.9130859375
      ],
      "bbox_max": [
        -1696.273681640625,
        -3913.724365234375,
        968.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7095091342926025,
        0.04798009991645813,
        0.7030609250068665
      ],
      "plane_d": -1676.69091796875,
      "bbox_min": [
        -1694.8375244140625,
        -3915.0,
        939.8978271484375
      ],
      "bbox_max": [
        -1689.2894287109375,
        -3895.0,
        947.239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8309916853904724,
        0.5197407007217407,
        0.1982990950345993
      ],
      "plane_d": 3253.2421875,
      "bbox_min": [
        -1694.8375244140625,
        -3911.33056640625,
        939.8978271484375
      ],
      "bbox_max": [
        -1693.797119140625,
        -3908.15478515625,
        941.9656372070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8309906721115112,
        -0.519740104675293,
        0.19830459356307983
      ],
      "plane_d": -811.1348876953125,
      "bbox_min": [
        -1694.71142578125,
        -3911.33056640625,
        940.3744506835938
      ],
      "bbox_max": [
        -1693.797119140625,
        -3910.0,
        941.9656372070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8309906721115112,
        -0.519740104675293,
        0.19830459356307983
      ],
      "plane_d": -811.1348876953125,
      "bbox_min": [
        -1694.1943359375,
        -3910.033935546875,
        941.9489135742188
      ],
      "bbox_max": [
        -1694.1767578125,
        -3909.97021484375,
        941.982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5741609930992126,
        -0.346888929605484,
        -0.741624653339386
      ],
      "plane_d": -1616.5740966796875,
      "bbox_min": [
        -1704.02783203125,
        -3915.0,
        939.3289794921875
      ],
      "bbox_max": [
        -1694.1807861328125,
        -3895.0,
        968.6401977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5847918391227722,
        -0.3420015573501587,
        -0.735563337802887
      ],
      "plane_d": -1621.394287109375,
      "bbox_min": [
        -1704.02783203125,
        -3915.0,
        957.0
      ],
      "bbox_max": [
        -1695.492431640625,
        -3895.0,
        968.6401977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829391598701477,
        -0.518764317035675,
        -0.20734789967536926
      ],
      "plane_d": -422.69873046875,
      "bbox_min": [
        -1702.206298828125,
        -3913.777587890625,
        961.7584838867188
      ],
      "bbox_max": [
        -1695.492431640625,
        -3906.6953125,
        968.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9832141995429993,
        -0.18245519697666168
      ],
      "plane_d": -3671.428466796875,
      "bbox_min": [
        -1702.206298828125,
        -3913.777587890625,
        961.7584838867188
      ],
      "bbox_max": [
        -1695.492431640625,
        -3906.6953125,
        968.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8293917775154114,
        0.5187644362449646,
        -0.20734645426273346
      ],
      "plane_d": 3634.03759765625,
      "bbox_min": [
        -1702.206298828125,
        -3913.777587890625,
        961.7584838867188
      ],
      "bbox_max": [
        -1695.492431640625,
        -3906.6953125,
        968.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8341626524925232,
        0.5217485427856445,
        -0.17874912917613983
      ],
      "plane_d": 792.2208251953125,
      "bbox_min": [
        -1702.206298828125,
        -3913.777587890625,
        964.2869873046875
      ],
      "bbox_max": [
        -1700.614990234375,
        -3906.6953125,
        968.2003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8341628313064575,
        -0.5217486619949341,
        -0.17874766886234283
      ],
      "plane_d": -3287.85498046875,
      "bbox_min": [
        -1701.7509765625,
        -3913.681396484375,
        963.8726806640625
      ],
      "bbox_max": [
        -1700.049072265625,
        -3906.94873046875,
        967.7295532226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8353597521781921,
        0.5224726796150208,
        0.17086905241012573
      ],
      "plane_d": 459.185546875,
      "bbox_min": [
        -1703.4595947265625,
        -3913.693115234375,
        939.3289794921875
      ],
      "bbox_max": [
        -1694.1807861328125,
        -3905.95263671875,
        967.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8309916853904724,
        0.5197407007217407,
        0.1982990950345993
      ],
      "plane_d": 3253.2421875,
      "bbox_min": [
        -1703.4595947265625,
        -3913.693115234375,
        939.3289794921875
      ],
      "bbox_max": [
        -1694.1807861328125,
        -3905.95263671875,
        967.0733642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9846713542938232,
        0.17441987991333008
      ],
      "plane_d": -4017.887939453125,
      "bbox_min": [
        -1700.95458984375,
        -3913.693115234375,
        940.7181396484375
      ],
      "bbox_max": [
        -1694.1807861328125,
        -3910.0,
        962.1761474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8309906721115112,
        -0.519740104675293,
        0.19830459356307983
      ],
      "plane_d": -811.1348876953125,
      "bbox_min": [
        -1698.0625,
        -3913.693115234375,
        940.7181396484375
      ],
      "bbox_max": [
        -1694.1807861328125,
        -3910.0,
        957.1318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829391598701477,
        -0.518764317035675,
        -0.20734789967536926
      ],
      "plane_d": -422.69873046875,
      "bbox_min": [
        -1698.0625,
        -3912.474609375,
        954.8438110351562
      ],
      "bbox_max": [
        -1697.214111328125,
        -3910.893798828125,
        961.1782836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9832141995429993,
        -0.18245519697666168
      ],
      "plane_d": -3671.428466796875,
      "bbox_min": [
        -1700.5423583984375,
        -3913.568359375,
        954.8438110351562
      ],
      "bbox_max": [
        -1697.33642578125,
        -3910.0,
        967.0733642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8341628313064575,
        -0.5217486619949341,
        -0.17874766886234283
      ],
      "plane_d": -3287.85498046875,
      "bbox_min": [
        -1700.5423583984375,
        -3912.914306640625,
        954.8438110351562
      ],
      "bbox_max": [
        -1699.6875,
        -3910.0,
        963.5484008789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8293917775154114,
        0.5187644362449646,
        -0.20734645426273346
      ],
      "plane_d": 3634.03759765625,
      "bbox_min": [
        -1698.0625,
        -3913.165771484375,
        954.8438110351562
      ],
      "bbox_max": [
        -1695.521240234375,
        -3908.700927734375,
        964.9033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8341626524925232,
        0.5217485427856445,
        -0.17874912917613983
      ],
      "plane_d": 792.2208251953125,
      "bbox_min": [
        -1702.0714111328125,
        -3913.681396484375,
        954.8438110351562
      ],
      "bbox_max": [
        -1699.6875,
        -3908.700927734375,
        967.681884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9832141995429993,
        -0.1824551820755005
      ],
      "plane_d": 4017.306640625,
      "bbox_min": [
        -1703.0709228515625,
        -3910.88232421875,
        954.8438110351562
      ],
      "bbox_max": [
        -1695.5672607421875,
        -3906.950927734375,
        967.15869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8293917775154114,
        0.5187644362449646,
        -0.20734645426273346
      ],
      "plane_d": 3634.03759765625,
      "bbox_min": [
        -1703.0709228515625,
        -3910.88232421875,
        954.8438110351562
      ],
      "bbox_max": [
        -1695.5672607421875,
        -3907.4111328125,
        967.15869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8341628313064575,
        -0.5217486619949341,
        -0.17874766886234283
      ],
      "plane_d": -3287.85498046875,
      "bbox_min": [
        -1703.0709228515625,
        -3910.88232421875,
        962.1771850585938
      ],
      "bbox_max": [
        -1702.0714111328125,
        -3910.0,
        967.15869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9789685606956482,
        0.20401129126548767
      ],
      "plane_d": -4035.42724609375,
      "bbox_min": [
        -1722.0,
        -3926.196044921875,
        932.8438110351562
      ],
      "bbox_max": [
        -1695.1273193359375,
        -3915.0,
        944.55322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8247852921485901,
        -0.5158589482307434,
        0.2315572053194046
      ],
      "plane_d": -830.827392578125,
      "bbox_min": [
        -1722.0,
        -3926.196044921875,
        932.8438110351562
      ],
      "bbox_max": [
        -1695.1273193359375,
        -3915.0,
        944.55322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8307161927223206,
        -0.5195683836936951,
        0.19989803433418274
      ],
      "plane_d": -3655.658203125,
      "bbox_min": [
        -1722.0,
        -3926.196044921875,
        940.167236328125
      ],
      "bbox_max": [
        -1709.0,
        -3915.803955078125,
        944.55322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9789685606956482,
        0.20401130616664886
      ],
      "plane_d": 3641.64404296875,
      "bbox_min": [
        -1722.0,
        -3921.0,
        940.167236328125
      ],
      "bbox_max": [
        -1709.0,
        -3915.803955078125,
        943.332275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8307151198387146,
        0.5195677280426025,
        0.19990456104278564
      ],
      "plane_d": 418.7899169921875,
      "bbox_min": [
        -1722.0,
        -3921.0,
        940.167236328125
      ],
      "bbox_max": [
        -1709.0,
        -3915.803955078125,
        943.332275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8247865438461304,
        0.5158597826957703,
        0.23155084252357483
      ],
      "plane_d": 3214.550048828125,
      "bbox_min": [
        -1712.5191650390625,
        -3921.0,
        940.167236328125
      ],
      "bbox_max": [
        -1709.0,
        -3915.803955078125,
        943.332275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9846713542938232,
        0.17441987991333008
      ],
      "plane_d": -4017.887939453125,
      "bbox_min": [
        -1701.8726806640625,
        -3915.196044921875,
        932.8438110351562
      ],
      "bbox_max": [
        -1695.1273193359375,
        -3915.0,
        933.9505615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8309906721115112,
        -0.519740104675293,
        0.19830459356307983
      ],
      "plane_d": -811.1348876953125,
      "bbox_min": [
        -1701.8726806640625,
        -3915.196044921875,
        932.8438110351562
      ],
      "bbox_max": [
        -1695.1273193359375,
        -3915.0,
        933.9505615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.835360586643219,
        -0.522473156452179,
        0.17086340487003326
      ],
      "plane_d": -3626.54833984375,
      "bbox_min": [
        -1701.8726806640625,
        -3915.196044921875,
        932.8438110351562
      ],
      "bbox_max": [
        -1701.646240234375,
        -3915.0,
        933.9505615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.25008928775787354,
        0.9682227969169617
      ],
      "plane_d": 67.357177734375,
      "bbox_min": [
        -1733.0,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1681.58935546875,
        -3915.0,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9789685606956482,
        0.20401130616664886
      ],
      "plane_d": 3641.64404296875,
      "bbox_min": [
        -1718.8193359375,
        -3916.656005859375,
        941.95703125
      ],
      "bbox_max": [
        -1712.2579345703125,
        -3916.177001953125,
        942.0936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8247865438461304,
        0.5158597826957703,
        0.23155084252357483
      ],
      "plane_d": 3214.550048828125,
      "bbox_min": [
        -1712.521240234375,
        -3916.656005859375,
        941.95703125
      ],
      "bbox_max": [
        -1712.2579345703125,
        -3916.177001953125,
        942.0936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8226276636123657,
        0.5145336389541626,
        -0.24194790422916412
      ],
      "plane_d": 3659.671875,
      "bbox_min": [
        -1722.0,
        -3940.0,
        969.4464721679688
      ],
      "bbox_max": [
        -1686.152587890625,
        -3915.803955078125,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8290908336639404,
        0.5185762047767639,
        -0.20901477336883545
      ],
      "plane_d": 809.7911376953125,
      "bbox_min": [
        -1722.0,
        -3926.196044921875,
        969.4464721679688
      ],
      "bbox_max": [
        -1709.0,
        -3915.803955078125,
        976.7172241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8226273059844971,
        -0.5145334601402283,
        -0.24194954335689545
      ],
      "plane_d": -375.29931640625,
      "bbox_min": [
        -1722.0,
        -3926.196044921875,
        970.6046752929688
      ],
      "bbox_max": [
        -1709.0,
        -3921.0,
        976.7172241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8290910124778748,
        -0.5185763835906982,
        -0.20901307463645935
      ],
      "plane_d": -3256.88623046875,
      "bbox_min": [
        -1722.0,
        -3926.196044921875,
        970.6046752929688
      ],
      "bbox_max": [
        -1712.25,
        -3921.0,
        976.7172241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9769880175590515,
        -0.2132941633462906
      ],
      "plane_d": -3627.518310546875,
      "bbox_min": [
        -1718.75,
        -3926.196044921875,
        971.9374389648438
      ],
      "bbox_max": [
        -1712.25,
        -3925.152587890625,
        976.7172241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08101704716682434,
        -0.9752894043922424,
        -0.20554053783416748
      ],
      "plane_d": -3501.814697265625,
      "bbox_min": [
        -1693.4010009765625,
        -3940.0,
        975.4791259765625
      ],
      "bbox_max": [
        -1686.152587890625,
        -3936.187744140625,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.520645797252655,
        -0.45860591530799866,
        -0.7201448082923889
      ],
      "plane_d": -221.804443359375,
      "bbox_min": [
        -1693.4010009765625,
        -3940.0,
        975.6493530273438
      ],
      "bbox_max": [
        -1688.58935546875,
        -3936.71826171875,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5394985675811768,
        -0.43720877170562744,
        -0.7195762395858765
      ],
      "plane_d": -106.20318603515625,
      "bbox_min": [
        -1693.4010009765625,
        -3940.0,
        975.872802734375
      ],
      "bbox_max": [
        -1689.58935546875,
        -3937.41455078125,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9832141995429993,
        -0.18245519697666168
      ],
      "plane_d": -3671.428466796875,
      "bbox_min": [
        -1701.8726806640625,
        -3915.196044921875,
        974.787353515625
      ],
      "bbox_max": [
        -1695.1273193359375,
        -3915.0,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829391598701477,
        -0.518764317035675,
        -0.20734789967536926
      ],
      "plane_d": -422.69873046875,
      "bbox_min": [
        -1701.8726806640625,
        -3915.196044921875,
        974.787353515625
      ],
      "bbox_max": [
        -1695.1273193359375,
        -3915.0,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8341628313064575,
        -0.5217486619949341,
        -0.17874766886234283
      ],
      "plane_d": -3287.85498046875,
      "bbox_min": [
        -1701.8726806640625,
        -3915.196044921875,
        974.787353515625
      ],
      "bbox_max": [
        -1701.646240234375,
        -3915.0,
        975.8438110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.061969973146915436,
        -0.24206946790218353,
        -0.9682778716087341
      ],
      "plane_d": 97.44004821777344,
      "bbox_min": [
        -1733.0,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1681.58935546875,
        -3915.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1733.0,
      "bbox_min": [
        -1733.0,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1681.58935546875,
        -3915.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.338542640209198,
        -0.9409511089324951
      ],
      "plane_d": -413.951416015625,
      "bbox_min": [
        -1733.0,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1681.58935546875,
        -3915.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7993826270103455,
        -0.14572079479694366,
        -0.5828831791877747
      ],
      "plane_d": 1376.00390625,
      "bbox_min": [
        -1733.0,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1681.58935546875,
        -3915.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7003492712974548,
        0.19573189318180084,
        0.6864400506019592
      ],
      "plane_d": 1329.777099609375,
      "bbox_min": [
        -1733.0,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1681.58935546875,
        -3915.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6776865720748901,
        0.1915758103132248,
        0.7099574208259583
      ],
      "plane_d": 1251.940185546875,
      "bbox_min": [
        -1733.0,
        -3940.0,
        947.625
      ],
      "bbox_max": [
        -1727.5,
        -3916.375,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6776866316795349,
        0.191575825214386,
        0.709957480430603
      ],
      "plane_d": -1067.103271484375,
      "bbox_min": [
        -1733.0,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1681.58935546875,
        -3915.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7003492712974548,
        0.19573189318180084,
        0.6864400506019592
      ],
      "plane_d": -1066.818115234375,
      "bbox_min": [
        -1694.565673828125,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1689.0,
        -3915.0,
        948.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7095091342926025,
        0.04798009991645813,
        0.7030609250068665
      ],
      "plane_d": -1676.69091796875,
      "bbox_min": [
        -1694.565673828125,
        -3916.65625,
        941.6659545898438
      ],
      "bbox_max": [
        -1689.0,
        -3915.0,
        947.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9388341307640076,
        0.05072424188256264,
        0.34061360359191895
      ],
      "plane_d": -1713.0750732421875,
      "bbox_min": [
        -1694.565673828125,
        -3916.65625,
        941.6659545898438
      ],
      "bbox_max": [
        -1694.4234619140625,
        -3915.0,
        942.09375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9575175642967224,
        -0.07512829452753067,
        -0.27841663360595703
      ],
      "plane_d": -1647.6431884765625,
      "bbox_min": [
        -1733.0,
        -3940.0,
        941.6659545898438
      ],
      "bbox_max": [
        -1681.58935546875,
        -3915.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9840825200080872,
        -0.17638441920280457,
        -0.02168283611536026
      ],
      "plane_d": -2336.384521484375,
      "bbox_min": [
        -1695.390380859375,
        -3940.0,
        954.0
      ],
      "bbox_max": [
        -1681.58935546875,
        -3916.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08097396045923233,
        -0.9742723107337952,
        -0.21032491326332092
      ],
      "plane_d": -3493.22021484375,
      "bbox_min": [
        -1690.171142578125,
        -3940.0,
        954.0
      ],
      "bbox_max": [
        -1681.58935546875,
        -3935.5,
        975.5918579101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5977080464363098,
        -0.45933178067207336,
        0.657084047794342
      ],
      "plane_d": -3452.27783203125,
      "bbox_min": [
        -1690.0523681640625,
        -3940.0,
        954.0
      ],
      "bbox_max": [
        -1681.58935546875,
        -3935.5,
        971.247802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9797075390815735,
        -0.20015542209148407,
        -0.010534179396927357
      ],
      "plane_d": -2433.288818359375,
      "bbox_min": [
        -1690.0523681640625,
        -3940.0,
        954.0
      ],
      "bbox_max": [
        -1687.259033203125,
        -3935.5,
        966.3091430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7620094418525696,
        -0.36048412322998047,
        0.5379523634910583
      ],
      "plane_d": -3225.086669921875,
      "bbox_min": [
        -1690.03662109375,
        -3940.0,
        962.310302734375
      ],
      "bbox_max": [
        -1687.259033203125,
        -3935.5,
        966.3091430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7935213446617126,
        -0.39494895935058594,
        0.46296781301498413
      ],
      "plane_d": -3341.69384765625,
      "bbox_min": [
        -1690.03662109375,
        -3940.0,
        963.997802734375
      ],
      "bbox_max": [
        -1687.259033203125,
        -3935.5,
        966.3091430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49310117959976196,
        -0.869820773601532,
        -0.016220420598983765
      ],
      "plane_d": -4240.8974609375,
      "bbox_min": [
        -1690.0523681640625,
        -3935.517333984375,
        963.997802734375
      ],
      "bbox_max": [
        -1690.02685546875,
        -3935.5,
        965.2359008789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19223570823669434,
        -0.9710968136787415,
        0.1414797157049179
      ],
      "plane_d": -4284.07373046875,
      "bbox_min": [
        -1690.171142578125,
        -3937.0,
        965.2271118164062
      ],
      "bbox_max": [
        -1682.58935546875,
        -3935.50830078125,
        974.810302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5258613228797913,
        -0.8451367020606995,
        -0.09598855674266815
      ],
      "plane_d": -4121.94775390625,
      "bbox_min": [
        -1690.102783203125,
        -3936.625,
        965.2271118164062
      ],
      "bbox_max": [
        -1688.118408203125,
        -3935.50830078125,
        969.5563354492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49310117959976196,
        -0.869820773601532,
        -0.016220420598983765
      ],
      "plane_d": -4240.8974609375,
      "bbox_min": [
        -1690.098876953125,
        -3936.625,
        965.2271118164062
      ],
      "bbox_max": [
        -1688.118408203125,
        -3935.50830078125,
        967.4632568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1904810220003128,
        -0.9751290082931519,
        0.11331535875797272
      ],
      "plane_d": -4269.6416015625,
      "bbox_min": [
        -1690.171142578125,
        -3937.0,
        970.576171875
      ],
      "bbox_max": [
        -1682.58935546875,
        -3935.551513671875,
        974.810302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5881543755531311,
        -0.27736496925354004,
        -0.7596994042396545
      ],
      "plane_d": -1350.610107421875,
      "bbox_min": [
        -1695.390380859375,
        -3940.0,
        963.0
      ],
      "bbox_max": [
        -1690.02685546875,
        -3916.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05337664484977722,
        -0.3956316113471985,
        -0.9168569445610046
      ],
      "plane_d": -573.3687744140625,
      "bbox_min": [
        -1695.2987060546875,
        -3940.0,
        967.4964599609375
      ],
      "bbox_max": [
        -1690.095947265625,
        -3934.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5394985675811768,
        -0.43720877170562744,
        -0.7195762395858765
      ],
      "plane_d": -106.20318603515625,
      "bbox_min": [
        -1694.134033203125,
        -3940.0,
        974.7466430664062
      ],
      "bbox_max": [
        -1690.095947265625,
        -3936.378173828125,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08101704716682434,
        -0.9752894043922424,
        -0.20554053783416748
      ],
      "plane_d": -3501.814697265625,
      "bbox_min": [
        -1693.274658203125,
        -3937.41455078125,
        974.7466430664062
      ],
      "bbox_max": [
        -1690.095947265625,
        -3936.378173828125,
        975.872802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.520645797252655,
        -0.45860591530799866,
        -0.7201448082923889
      ],
      "plane_d": -221.804443359375,
      "bbox_min": [
        -1693.274658203125,
        -3937.41455078125,
        974.7466430664062
      ],
      "bbox_max": [
        -1692.1082763671875,
        -3936.625,
        975.872802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1283208578824997,
        -0.37154722213745117,
        -0.9195033311843872
      ],
      "plane_d": -348.9274597167969,
      "bbox_min": [
        -1695.2987060546875,
        -3940.0,
        967.4964599609375
      ],
      "bbox_max": [
        -1690.0989990234375,
        -3934.0,
        976.1529541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08097396045923233,
        -0.9742723107337952,
        -0.21032491326332092
      ],
      "plane_d": -3493.22021484375,
      "bbox_min": [
        -1693.274658203125,
        -3936.625,
        970.3831176757812
      ],
      "bbox_max": [
        -1690.10791015625,
        -3935.5,
        974.8245849609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1904810220003128,
        -0.9751290082931519,
        0.11331535875797272
      ],
      "plane_d": -4269.6416015625,
      "bbox_min": [
        -1690.696533203125,
        -3935.63037109375,
        970.3831176757812
      ],
      "bbox_max": [
        -1690.144287109375,
        -3935.5,
        970.968505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19223570823669434,
        -0.9710968136787415,
        0.1414797157049179
      ],
      "plane_d": -4284.07373046875,
      "bbox_min": [
        -1690.696533203125,
        -3935.63037109375,
        970.3831176757812
      ],
      "bbox_max": [
        -1690.144287109375,
        -3935.5,
        970.5761108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29626861214637756,
        -0.8583329916000366,
        -0.4189145863056183
      ],
      "plane_d": -3472.263427734375,
      "bbox_min": [
        -1695.2210693359375,
        -3936.625,
        967.4964599609375
      ],
      "bbox_max": [
        -1690.0989990234375,
        -3934.0,
        974.7466430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5258613228797913,
        -0.8451367020606995,
        -0.09598855674266815
      ],
      "plane_d": -4121.94775390625,
      "bbox_min": [
        -1692.83935546875,
        -3935.759033203125,
        967.4964599609375
      ],
      "bbox_max": [
        -1690.0989990234375,
        -3934.0,
        970.5279541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19223570823669434,
        -0.9710968136787415,
        0.1414797157049179
      ],
      "plane_d": -4284.07373046875,
      "bbox_min": [
        -1690.696533203125,
        -3935.759033203125,
        969.5567016601562
      ],
      "bbox_max": [
        -1690.10302734375,
        -3935.5,
        970.5279541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1283208578824997,
        -0.37154722213745117,
        -0.9195033311843872
      ],
      "plane_d": -348.9274597167969,
      "bbox_min": [
        -1695.390380859375,
        -3940.0,
        975.0013427734375
      ],
      "bbox_max": [
        -1694.8770751953125,
        -3937.55224609375,
        976.0492553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49310117959976196,
        -0.869820773601532,
        -0.016220420598983765
      ],
      "plane_d": -4240.8974609375,
      "bbox_min": [
        -1692.83935546875,
        -3935.52734375,
        963.997802734375
      ],
      "bbox_max": [
        -1690.02685546875,
        -3934.0,
        969.060302734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1283208578824997,
        -0.37154722213745117,
        -0.9195033311843872
      ],
      "plane_d": -348.9274597167969,
      "bbox_min": [
        -1702.0223388671875,
        -3940.0,
        974.081787109375
      ],
      "bbox_max": [
        -1695.1810302734375,
        -3935.5,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15360873937606812,
        -0.31874024868011475,
        -0.9353122115135193
      ],
      "plane_d": -603.7601928710938,
      "bbox_min": [
        -1702.0223388671875,
        -3940.0,
        974.122802734375
      ],
      "bbox_max": [
        -1695.65185546875,
        -3935.5,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05337664484977722,
        -0.3956316113471985,
        -0.9168569445610046
      ],
      "plane_d": -573.3687744140625,
      "bbox_min": [
        -1695.65185546875,
        -3936.647705078125,
        974.081787109375
      ],
      "bbox_max": [
        -1695.1810302734375,
        -3935.5,
        974.6405639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29626861214637756,
        -0.8583329916000366,
        -0.4189145863056183
      ],
      "plane_d": -3472.263427734375,
      "bbox_min": [
        -1695.65185546875,
        -3935.703857421875,
        974.081787109375
      ],
      "bbox_max": [
        -1695.1810302734375,
        -3935.5,
        974.23583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7662650346755981,
        -0.35982680320739746,
        -0.532318115234375
      ],
      "plane_d": -2196.8740234375,
      "bbox_min": [
        -1733.0,
        -3935.642578125,
        941.6659545898438
      ],
      "bbox_max": [
        -1689.0,
        -3915.0,
        974.122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5881543755531311,
        -0.27736496925354004,
        -0.7596994042396545
      ],
      "plane_d": -1350.610107421875,
      "bbox_min": [
        -1701.38232421875,
        -3935.642578125,
        953.8836669921875
      ],
      "bbox_max": [
        -1690.96435546875,
        -3915.0,
        974.122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29626861214637756,
        -0.8583329916000366,
        -0.4189145863056183
      ],
      "plane_d": -3472.263427734375,
      "bbox_min": [
        -1695.65185546875,
        -3935.642578125,
        972.5686645507812
      ],
      "bbox_max": [
        -1694.7884521484375,
        -3935.03955078125,
        974.122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5741609930992126,
        -0.346888929605484,
        -0.741624653339386
      ],
      "plane_d": -1616.5740966796875,
      "bbox_min": [
        -1701.38232421875,
        -3916.211181640625,
        953.8836669921875
      ],
      "bbox_max": [
        -1690.96435546875,
        -3915.0,
        969.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9200292825698853,
        -0.2912231981754303,
        -0.2621738910675049
      ],
      "plane_d": -2446.0263671875,
      "bbox_min": [
        -1693.735107421875,
        -3916.211181640625,
        953.8836669921875
      ],
      "bbox_max": [
        -1690.96435546875,
        -3915.0,
        963.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7092720866203308,
        0.06432174891233444,
        0.7019942998886108
      ],
      "plane_d": 815.8492431640625,
      "bbox_min": [
        -1733.0,
        -3916.375,
        947.1720581054688
      ],
      "bbox_max": [
        -1732.6763916015625,
        -3915.0,
        947.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8247865438461304,
        0.5158597826957703,
        0.23155084252357483
      ],
      "plane_d": 3214.550048828125,
      "bbox_min": [
        -1733.0,
        -3925.281982421875,
        941.6659545898438
      ],
      "bbox_max": [
        -1689.0,
        -3915.0,
        971.9374389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9789685606956482,
        0.20401130616664886
      ],
      "plane_d": 3641.64404296875,
      "bbox_min": [
        -1721.2384033203125,
        -3925.281982421875,
        941.9706420898438
      ],
      "bbox_max": [
        -1709.8885498046875,
        -3916.179931640625,
        965.1004028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8307151198387146,
        0.5195677280426025,
        0.19990456104278564
      ],
      "plane_d": 418.7899169921875,
      "bbox_min": [
        -1721.2384033203125,
        -3925.281982421875,
        941.9706420898438
      ],
      "bbox_max": [
        -1709.8885498046875,
        -3916.179931640625,
        965.1004028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9789685606956482,
        0.20401129126548767
      ],
      "plane_d": -4035.42724609375,
      "bbox_min": [
        -1718.2662353515625,
        -3925.281982421875,
        944.55322265625
      ],
      "bbox_max": [
        -1712.90966796875,
        -3922.299072265625,
        960.9126586914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8226273059844971,
        -0.5145334601402283,
        -0.24194954335689545
      ],
      "plane_d": -375.29931640625,
      "bbox_min": [
        -1715.916015625,
        -3923.659912109375,
        958.8672485351562
      ],
      "bbox_max": [
        -1714.214111328125,
        -3921.0,
        965.1004028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9769880175590515,
        -0.2132941633462906
      ],
      "plane_d": -3627.518310546875,
      "bbox_min": [
        -1715.916015625,
        -3923.659912109375,
        958.8672485351562
      ],
      "bbox_max": [
        -1714.214111328125,
        -3922.299072265625,
        965.1004028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8290910124778748,
        -0.5185763835906982,
        -0.20901307463645935
      ],
      "plane_d": -3256.88623046875,
      "bbox_min": [
        -1733.0,
        -3925.152587890625,
        941.6659545898438
      ],
      "bbox_max": [
        -1714.33642578125,
        -3915.0,
        971.9374389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9769880175590515,
        -0.2132941633462906
      ],
      "plane_d": -3627.518310546875,
      "bbox_min": [
        -1720.458984375,
        -3925.152587890625,
        958.8672485351562
      ],
      "bbox_max": [
        -1714.33642578125,
        -3918.544677734375,
        971.9374389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9142935872077942,
        0.071955606341362,
        0.3986096978187561
      ],
      "plane_d": 1485.7398681640625,
      "bbox_min": [
        -1727.61474609375,
        -3916.65625,
        941.6659545898438
      ],
      "bbox_max": [
        -1727.44384765625,
        -3915.0,
        942.09375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7620426416397095,
        -0.3324712812900543,
        -0.5556560754776001
      ],
      "plane_d": 553.7591552734375,
      "bbox_min": [
        -1733.0,
        -3916.0,
        962.7142944335938
      ],
      "bbox_max": [
        -1728.4510498046875,
        -3915.0,
        969.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.773443341255188,
        -0.33550629019737244,
        -0.5377926826477051
      ],
      "plane_d": 544.4290161132812,
      "bbox_min": [
        -1733.0,
        -3916.0,
        962.7142944335938
      ],
      "bbox_max": [
        -1732.61767578125,
        -3915.0,
        963.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8226276636123657,
        0.5145336389541626,
        -0.24194790422916412
      ],
      "plane_d": 3659.671875,
      "bbox_min": [
        -1718.801513671875,
        -3925.152587890625,
        942.4073486328125
      ],
      "bbox_max": [
        -1689.0,
        -3915.0,
        971.9374389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9769880771636963,
        -0.21329417824745178
      ],
      "plane_d": 4034.02197265625,
      "bbox_min": [
        -1718.801513671875,
        -3925.152587890625,
        958.8672485351562
      ],
      "bbox_max": [
        -1713.003173828125,
        -3917.391357421875,
        971.9374389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9200292825698853,
        -0.2912231981754303,
        -0.2621738910675049
      ],
      "plane_d": -2446.0263671875,
      "bbox_min": [
        -1691.21875,
        -3916.375,
        947.239013671875
      ],
      "bbox_max": [
        -1689.0,
        -3915.0,
        954.3366088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9153409600257874,
        -0.27521592378616333,
        -0.29395097494125366
      ],
      "plane_d": -2345.30419921875,
      "bbox_min": [
        -1689.6070556640625,
        -3916.375,
        947.239013671875
      ],
      "bbox_max": [
        -1689.0,
        -3915.0,
        948.2280883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9230769872665405,
        -0.38461539149284363,
        0.0
      ],
      "plane_d": -3060.615478515625,
      "bbox_min": [
        -1689.58935546875,
        -3940.0,
        970.060302734375
      ],
      "bbox_max": [
        -1630.8995361328125,
        -3930.1005859375,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        0.3826828598976135,
        0.0
      ],
      "plane_d": -2.7730712890625,
      "bbox_min": [
        -1635.0,
        -3940.0,
        1032.0
      ],
      "bbox_max": [
        -1630.8995361328125,
        -3930.1005859375,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25766265392303467,
        -0.9662349820137024,
        0.0
      ],
      "plane_d": -4235.71630859375,
      "bbox_min": [
        -1689.58935546875,
        -3940.0,
        970.060302734375
      ],
      "bbox_max": [
        -1674.0,
        -3936.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766265392303467,
        -0.9662349820137024,
        0.0
      ],
      "plane_d": -3370.4853515625,
      "bbox_min": [
        -1689.58935546875,
        -3940.0,
        970.060302734375
      ],
      "bbox_max": [
        -1674.0,
        -3936.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2440335899591446,
        -0.9690989851951599,
        0.03598198667168617
      ],
      "plane_d": -4259.85400390625,
      "bbox_min": [
        -1689.1590576171875,
        -3938.708984375,
        971.3323364257812
      ],
      "bbox_max": [
        -1679.0,
        -3936.0,
        995.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1821102648973465,
        -0.9758580923080444,
        0.12056906521320343
      ],
      "plane_d": -4265.47265625,
      "bbox_min": [
        -1689.1590576171875,
        -3938.708984375,
        971.3323364257812
      ],
      "bbox_max": [
        -1679.0,
        -3936.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24408484995365143,
        -0.9690858721733093,
        -0.03598954156041145
      ],
      "plane_d": -3368.747802734375,
      "bbox_min": [
        -1689.1590576171875,
        -3938.708984375,
        974.810302734375
      ],
      "bbox_max": [
        -1679.0,
        -3936.0,
        995.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.181951642036438,
        -0.9761321544647217,
        -0.11857336759567261
      ],
      "plane_d": -3419.781494140625,
      "bbox_min": [
        -1688.905029296875,
        -3937.94677734375,
        974.810302734375
      ],
      "bbox_max": [
        -1680.6473388671875,
        -3936.0,
        985.0932006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18266600370407104,
        -0.9758133888244629,
        -0.12008854001760483
      ],
      "plane_d": -3415.838134765625,
      "bbox_min": [
        -1688.58935546875,
        -3937.0,
        974.810302734375
      ],
      "bbox_max": [
        -1680.6473388671875,
        -3936.0,
        982.3275756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507342100143433,
        -0.4439001977443695,
        -0.4892348647117615
      ],
      "plane_d": -1.29931640625,
      "bbox_min": [
        -1688.905029296875,
        -3937.94677734375,
        978.372802734375
      ],
      "bbox_max": [
        -1684.2098388671875,
        -3937.0,
        985.0932006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9067347049713135,
        -0.3999742865562439,
        -0.1336139589548111
      ],
      "plane_d": 84.0550537109375,
      "bbox_min": [
        -1689.1590576171875,
        -3938.708984375,
        978.7476196289062
      ],
      "bbox_max": [
        -1682.75,
        -3937.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507342100143433,
        -0.4439001977443695,
        -0.4892348647117615
      ],
      "plane_d": -1.29931640625,
      "bbox_min": [
        -1689.1590576171875,
        -3938.708984375,
        978.7476196289062
      ],
      "bbox_max": [
        -1684.2098388671875,
        -3937.0,
        985.2269897460938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9067347049713135,
        -0.3999742865562439,
        -0.1336139589548111
      ],
      "plane_d": 84.0550537109375,
      "bbox_min": [
        -1689.58935546875,
        -3940.0,
        979.04931640625
      ],
      "bbox_max": [
        -1682.75,
        -3937.0,
        995.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7503157258033752,
        -0.44673967361450195,
        -0.48728838562965393
      ],
      "plane_d": -15.1004638671875,
      "bbox_min": [
        -1689.58935546875,
        -3940.0,
        979.04931640625
      ],
      "bbox_max": [
        -1684.3822021484375,
        -3937.435302734375,
        986.0150756835938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9066964387893677,
        -0.4000079929828644,
        0.13377298414707184
      ],
      "plane_d": -3226.47705078125,
      "bbox_min": [
        -1682.6605224609375,
        -3940.0,
        970.060302734375
      ],
      "bbox_max": [
        -1674.0,
        -3936.0,
        993.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2440733164548874,
        -0.9690881967544556,
        0.036005258560180664
      ],
      "plane_d": -4259.9013671875,
      "bbox_min": [
        -1682.6605224609375,
        -3940.0,
        970.060302734375
      ],
      "bbox_max": [
        -1675.25,
        -3936.0,
        993.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7458806037902832,
        -0.446991890668869,
        0.4938223361968994
      ],
      "plane_d": -3494.441650390625,
      "bbox_min": [
        -1682.6605224609375,
        -3940.0,
        971.247802734375
      ],
      "bbox_max": [
        -1675.8973388671875,
        -3936.225341796875,
        981.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1821102648973465,
        -0.9758580923080444,
        0.12056906521320343
      ],
      "plane_d": -4265.47265625,
      "bbox_min": [
        -1682.6605224609375,
        -3937.0,
        971.247802734375
      ],
      "bbox_max": [
        -1677.0848388671875,
        -3936.225341796875,
        981.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -948.75,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3958.5,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7592566013336182,
        0.650791347026825
      ],
      "plane_d": 2384.662353515625,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 3748.199951171875,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.12072310596704483,
        -0.9926862716674805
      ],
      "plane_d": 1445.208251953125,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.539498507976532,
        0.43720877170562744,
        -0.7195761203765869
      ],
      "plane_d": 3339.00146484375,
      "bbox_min": [
        -1693.40087890625,
        -3943.591552734375,
        976.2658081054688
      ],
      "bbox_max": [
        -1686.8150634765625,
        -3940.0,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5206458568572998,
        0.45860594511032104,
        -0.7201448678970337
      ],
      "plane_d": 3392.010498046875,
      "bbox_min": [
        -1691.981201171875,
        -3943.591552734375,
        976.2658081054688
      ],
      "bbox_max": [
        -1686.8150634765625,
        -3940.0,
        979.560302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08101704716682434,
        0.9752894043922424,
        -0.20554055273532867
      ],
      "plane_d": 4183.4658203125,
      "bbox_min": [
        -1691.2523193359375,
        -3943.591552734375,
        976.2658081054688
      ],
      "bbox_max": [
        -1686.8150634765625,
        -3943.0,
        978.372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06386952847242355,
        0.0,
        -0.9979583024978638
      ],
      "plane_d": 1083.415771484375,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1733.0,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330593228340149,
        0.7737390995025635,
        0.023739725351333618
      ],
      "plane_d": 4133.80859375,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6736035943031311,
        0.7390928268432617,
        1.6312183603872654e-08
      ],
      "plane_d": 4089.72802734375,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6904757618904114,
        0.0,
        0.7233555912971497
      ],
      "plane_d": 506.51324462890625,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6904757618904114,
        0.0,
        0.7233555912971497
      ],
      "plane_d": -1856.294921875,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8080075979232788,
        0.0,
        -0.5891721844673157
      ],
      "plane_d": 1971.18505859375,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6221115589141846,
        0.7603585124015808,
        -0.18663348257541656
      ],
      "plane_d": 2133.75927734375,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6633139848709106,
        0.7278028130531311,
        -0.17411990463733673
      ],
      "plane_d": 1923.132080078125,
      "bbox_min": [
        -1698.6805419921875,
        -3958.5,
        954.0
      ],
      "bbox_max": [
        -1693.5,
        -3954.0,
        969.5184936523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.508177638053894,
        0.557583749294281,
        -0.6563961505889893
      ],
      "plane_d": 1980.13525390625,
      "bbox_min": [
        -1698.6805419921875,
        -3958.5,
        969.0
      ],
      "bbox_max": [
        -1693.5,
        -3954.0,
        969.5184936523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8662608861923218,
        0.3147071301937103,
        -0.3880094885826111
      ],
      "plane_d": 151.3984375,
      "bbox_min": [
        -1694.445068359375,
        -3954.0,
        954.0
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6171047687530518,
        0.4313398003578186,
        0.6581244468688965
      ],
      "plane_d": 23.237060546875,
      "bbox_min": [
        -1694.3253173828125,
        -3946.0,
        963.5697021484375
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5977080464363098,
        0.45933178067207336,
        0.657084047794342
      ],
      "plane_d": 167.256591796875,
      "bbox_min": [
        -1690.5540771484375,
        -3944.78125,
        963.5697021484375
      ],
      "bbox_max": [
        -1681.58935546875,
        -3940.0,
        971.247802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7620094418525696,
        0.36048412322998047,
        0.5379523634910583
      ],
      "plane_d": -384.47174072265625,
      "bbox_min": [
        -1690.5540771484375,
        -3944.78125,
        963.5697021484375
      ],
      "bbox_max": [
        -1687.259033203125,
        -3940.0,
        966.3091430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931010901927948,
        0.869820773601532,
        -0.016220416873693466
      ],
      "plane_d": 2613.290283203125,
      "bbox_min": [
        -1690.5540771484375,
        -3944.78125,
        963.997802734375
      ],
      "bbox_max": [
        -1688.118408203125,
        -3943.375,
        966.3091430664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.525861382484436,
        0.8451367020606995,
        -0.09598853439092636
      ],
      "plane_d": 2537.729248046875,
      "bbox_min": [
        -1693.417236328125,
        -3946.0,
        964.9468383789062
      ],
      "bbox_max": [
        -1688.118408203125,
        -3943.375,
        971.2294311523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4931010901927948,
        0.869820773601532,
        -0.016220416873693466
      ],
      "plane_d": 2613.290283203125,
      "bbox_min": [
        -1693.417236328125,
        -3946.0,
        964.9468383789062
      ],
      "bbox_max": [
        -1688.118408203125,
        -3943.375,
        971.2294311523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.311288982629776,
        0.8535249829292297,
        -0.41784486174583435
      ],
      "plane_d": 3245.96435546875,
      "bbox_min": [
        -1693.417236328125,
        -3946.0,
        969.060302734375
      ],
      "bbox_max": [
        -1690.696533203125,
        -3944.5,
        971.2294311523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29626861214637756,
        0.8583329916000366,
        -0.4189145267009735
      ],
      "plane_d": 3291.400146484375,
      "bbox_min": [
        -1693.417236328125,
        -3946.0,
        969.060302734375
      ],
      "bbox_max": [
        -1692.83935546875,
        -3945.043701171875,
        971.2294311523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.311288982629776,
        0.8535249829292297,
        -0.41784486174583435
      ],
      "plane_d": 3245.96435546875,
      "bbox_min": [
        -1694.3253173828125,
        -3945.140869140625,
        970.5279541015625
      ],
      "bbox_max": [
        -1682.58935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08101704716682434,
        0.9752894043922424,
        -0.20554055273532867
      ],
      "plane_d": 4183.4658203125,
      "bbox_min": [
        -1693.274658203125,
        -3944.5,
        970.5279541015625
      ],
      "bbox_max": [
        -1685.58935546875,
        -3942.093505859375,
        976.4479370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08097397536039352,
        0.9742723703384399,
        -0.2103249430656433
      ],
      "plane_d": 4184.0458984375,
      "bbox_min": [
        -1693.274658203125,
        -3944.5,
        970.5279541015625
      ],
      "bbox_max": [
        -1685.58935546875,
        -3943.375,
        974.810302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5206458568572998,
        0.45860594511032104,
        -0.7201448678970337
      ],
      "plane_d": 3392.010498046875,
      "bbox_min": [
        -1693.274658203125,
        -3943.375,
        974.7466430664062
      ],
      "bbox_max": [
        -1691.2523193359375,
        -3942.093505859375,
        976.4479370117188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29626861214637756,
        0.8583329916000366,
        -0.4189145267009735
      ],
      "plane_d": 3291.400146484375,
      "bbox_min": [
        -1694.3253173828125,
        -3945.140869140625,
        971.132080078125
      ],
      "bbox_max": [
        -1692.0440673828125,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05337664484977722,
        0.3956316113471985,
        -0.9168569445610046
      ],
      "plane_d": 2544.20849609375,
      "bbox_min": [
        -1694.3253173828125,
        -3943.8525390625,
        974.4818725585938
      ],
      "bbox_max": [
        -1693.274658203125,
        -3940.68994140625,
        975.8654174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7620094418525696,
        0.36048412322998047,
        0.5379523634910583
      ],
      "plane_d": -384.47174072265625,
      "bbox_min": [
        -1690.02685546875,
        -3944.5,
        962.310302734375
      ],
      "bbox_max": [
        -1688.2001953125,
        -3940.0,
        963.997802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05337664484977722,
        0.3956316113471985,
        -0.9168569445610046
      ],
      "plane_d": 2544.20849609375,
      "bbox_min": [
        -1694.445068359375,
        -3942.904052734375,
        974.8887329101562
      ],
      "bbox_max": [
        -1693.9112548828125,
        -3940.0,
        976.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.539498507976532,
        0.43720877170562744,
        -0.7195761203765869
      ],
      "plane_d": 3339.00146484375,
      "bbox_min": [
        -1694.134033203125,
        -3940.690185546875,
        975.8654174804688
      ],
      "bbox_max": [
        -1693.9112548828125,
        -3940.0,
        976.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1283208578824997,
        0.37154722213745117,
        -0.9195033311843872
      ],
      "plane_d": 2578.86474609375,
      "bbox_min": [
        -1694.445068359375,
        -3940.835693359375,
        975.7759399414062
      ],
      "bbox_max": [
        -1694.134033203125,
        -3940.0,
        976.1529541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999423027038574,
        -0.0,
        -0.010751751251518726
      ],
      "plane_d": -1678.6453857421875,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1689.0,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.313576340675354,
        0.09756845980882645,
        -0.9445371031761169
      ],
      "plane_d": 773.2376098632812,
      "bbox_min": [
        -1702.0223388671875,
        -3954.0,
        969.060302734375
      ],
      "bbox_max": [
        -1692.83935546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1283208578824997,
        0.37154722213745117,
        -0.9195033311843872
      ],
      "plane_d": 2578.86474609375,
      "bbox_min": [
        -1702.0223388671875,
        -3944.5,
        973.62451171875
      ],
      "bbox_max": [
        -1694.0552978515625,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15360873937606812,
        0.31874024868011475,
        -0.9353122115135193
      ],
      "plane_d": 1907.9129638671875,
      "bbox_min": [
        -1702.0223388671875,
        -3944.5,
        974.122802734375
      ],
      "bbox_max": [
        -1695.65185546875,
        -3940.0,
        976.7025756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05337664484977722,
        0.3956316113471985,
        -0.9168569445610046
      ],
      "plane_d": 2544.20849609375,
      "bbox_min": [
        -1695.65185546875,
        -3944.5,
        973.62451171875
      ],
      "bbox_max": [
        -1694.0552978515625,
        -3940.835693359375,
        975.7759399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29626861214637756,
        0.8583329916000366,
        -0.4189145267009735
      ],
      "plane_d": 3291.400146484375,
      "bbox_min": [
        -1695.65185546875,
        -3944.5,
        973.62451171875
      ],
      "bbox_max": [
        -1694.0552978515625,
        -3943.8525390625,
        974.4818725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7496738433837891,
        0.39256951212882996,
        -0.5328023433685303
      ],
      "plane_d": 796.319580078125,
      "bbox_min": [
        -1701.25,
        -3954.0,
        969.060302734375
      ],
      "bbox_max": [
        -1692.83935546875,
        -3944.192138671875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29626861214637756,
        0.8583329916000366,
        -0.4189145267009735
      ],
      "plane_d": 3291.400146484375,
      "bbox_min": [
        -1695.65185546875,
        -3946.0,
        969.060302734375
      ],
      "bbox_max": [
        -1692.83935546875,
        -3944.192138671875,
        974.122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6046099066734314,
        0.6633914709091187,
        -0.44086143374443054
      ],
      "plane_d": 4098.033203125,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1689.0,
        -3954.0,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5276818871498108,
        0.6449444890022278,
        0.5528095960617065
      ],
      "plane_d": 1131.4755859375,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1689.0,
        -3954.0,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5276818871498108,
        0.6449444890022278,
        0.5528095960617065
      ],
      "plane_d": 2937.20263671875,
      "bbox_min": [
        -1733.0,
        -3958.5,
        948.75
      ],
      "bbox_max": [
        -1727.5,
        -3954.0,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9230769872665405,
        0.38461539149284363,
        0.0
      ],
      "plane_d": -29.84619140625,
      "bbox_min": [
        -1689.58935546875,
        -3949.8994140625,
        970.060302734375
      ],
      "bbox_max": [
        -1630.8995361328125,
        -3940.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        -0.3826828598976135,
        0.0
      ],
      "plane_d": -3018.31396484375,
      "bbox_min": [
        -1635.0,
        -3949.8994140625,
        1032.0
      ],
      "bbox_max": [
        -1630.8995361328125,
        -3940.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25766268372535706,
        0.9662350416183472,
        0.0
      ],
      "plane_d": 3378.21533203125,
      "bbox_min": [
        -1689.58935546875,
        -3944.0,
        970.060302734375
      ],
      "bbox_max": [
        -1674.0,
        -3940.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25766268372535706,
        0.9662350416183472,
        0.0
      ],
      "plane_d": 4243.44677734375,
      "bbox_min": [
        -1689.58935546875,
        -3944.0,
        970.060302734375
      ],
      "bbox_max": [
        -1674.0,
        -3940.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2440335899591446,
        0.9690989851951599,
        0.03598198667168617
      ],
      "plane_d": 3376.64599609375,
      "bbox_min": [
        -1689.158935546875,
        -3944.0,
        971.3328247070312
      ],
      "bbox_max": [
        -1679.0,
        -3941.291259765625,
        995.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.18266600370407104,
        0.9758133888244629,
        -0.12008854001760483
      ],
      "plane_d": 4273.5712890625,
      "bbox_min": [
        -1689.158935546875,
        -3944.0,
        971.3328247070312
      ],
      "bbox_max": [
        -1679.0,
        -3941.291259765625,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24408484995365143,
        0.9690858125686646,
        -0.03598954528570175
      ],
      "plane_d": 4267.64892578125,
      "bbox_min": [
        -1688.58935546875,
        -3944.0,
        978.372802734375
      ],
      "bbox_max": [
        -1679.0,
        -3942.688720703125,
        995.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.181951642036438,
        0.9761321544647217,
        -0.11857336759567261
      ],
      "plane_d": 4272.1396484375,
      "bbox_min": [
        -1688.58935546875,
        -3944.0,
        978.372802734375
      ],
      "bbox_max": [
        -1680.6473388671875,
        -3942.9921875,
        985.0932006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7507342100143433,
        0.4439001977443695,
        -0.4892348647117615
      ],
      "plane_d": 3496.63427734375,
      "bbox_min": [
        -1688.58935546875,
        -3943.0,
        978.372802734375
      ],
      "bbox_max": [
        -1684.2098388671875,
        -3942.9921875,
        985.0932006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7503157258033752,
        0.44673967361450195,
        -0.48728838562965393
      ],
      "plane_d": 3505.2080078125,
      "bbox_min": [
        -1684.2239990234375,
        -3943.0,
        985.0786743164062
      ],
      "bbox_max": [
        -1684.2098388671875,
        -3942.9921875,
        985.0956420898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1821102499961853,
        0.9758579730987549,
        0.12056905031204224
      ],
      "plane_d": 3424.2890625,
      "bbox_min": [
        -1685.58935546875,
        -3944.0,
        971.3328247070312
      ],
      "bbox_max": [
        -1681.016845703125,
        -3943.02392578125,
        977.3650512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9230769872665405,
        0.38461539149284363,
        0.0
      ],
      "plane_d": 3069.84619140625,
      "bbox_min": [
        -1689.58935546875,
        -3944.0,
        970.060302734375
      ],
      "bbox_max": [
        -1674.0,
        -3940.0,
        1035.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9067347049713135,
        0.3999742865562439,
        -0.1336139589548111
      ],
      "plane_d": 3235.852294921875,
      "bbox_min": [
        -1689.58935546875,
        -3943.0,
        979.0491943359375
      ],
      "bbox_max": [
        -1682.75,
        -3940.0,
        995.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7507342100143433,
        0.4439001977443695,
        -0.4892348647117615
      ],
      "plane_d": 3496.63427734375,
      "bbox_min": [
        -1689.58935546875,
        -3942.25439453125,
        979.0491943359375
      ],
      "bbox_max": [
        -1685.546875,
        -3940.0,
        983.718017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9066964387893677,
        0.40000802278518677,
        0.13377296924591064
      ],
      "plane_d": -74.4140625,
      "bbox_min": [
        -1682.660888671875,
        -3944.0,
        970.060302734375
      ],
      "bbox_max": [
        -1674.0,
        -3940.0,
        993.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2440733164548874,
        0.9690881967544556,
        0.036005258560180664
      ],
      "plane_d": 3376.513671875,
      "bbox_min": [
        -1682.660888671875,
        -3944.0,
        970.060302734375
      ],
      "bbox_max": [
        -1675.25,
        -3940.0,
        993.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7458806037902832,
        0.446991890668869,
        0.4938223361968994
      ],
      "plane_d": 27.8544921875,
      "bbox_min": [
        -1682.660888671875,
        -3943.77490234375,
        971.247802734375
      ],
      "bbox_max": [
        -1675.8973388671875,
        -3940.0,
        981.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1821102499961853,
        0.9758579730987549,
        0.12056905031204224
      ],
      "plane_d": 3424.2890625,
      "bbox_min": [
        -1682.660888671875,
        -3943.77490234375,
        971.247802734375
      ],
      "bbox_max": [
        -1677.0848388671875,
        -3943.0,
        981.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18141700327396393,
        0.9761470556259155,
        0.11926742643117905
      ],
      "plane_d": 3427.8662109375,
      "bbox_min": [
        -1681.016845703125,
        -3943.77490234375,
        977.3650512695312
      ],
      "bbox_max": [
        -1677.0848388671875,
        -3943.0,
        981.7047729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7261701822280884,
        -0.3190624415874481,
        -0.6089958548545837
      ],
      "plane_d": -1905.5399169921875,
      "bbox_min": [
        -1854.0667724609375,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7711217999458313,
        -0.42644163966178894,
        -0.47277751564979553
      ],
      "plane_d": -2510.69482421875,
      "bbox_min": [
        -1815.1942138671875,
        -3679.57470703125,
        948.8031616210938
      ],
      "bbox_max": [
        -1804.336669921875,
        -3664.117431640625,
        955.1499633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21827691793441772,
        0.0049761561676859856,
        -0.9758742451667786
      ],
      "plane_d": 554.12451171875,
      "bbox_min": [
        -1815.1942138671875,
        -3679.57470703125,
        953.0
      ],
      "bbox_max": [
        -1805.9105224609375,
        -3664.117431640625,
        955.1499633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2352815866470337,
        -0.045620810240507126,
        -0.9708560109138489
      ],
      "plane_d": 332.51116943359375,
      "bbox_min": [
        -1807.6737060546875,
        -3679.57470703125,
        953.0
      ],
      "bbox_max": [
        -1805.9105224609375,
        -3677.889404296875,
        953.3975830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.712002158164978,
        -0.3079468607902527,
        -0.6310482025146484
      ],
      "plane_d": -1818.2164306640625,
      "bbox_min": [
        -1854.0667724609375,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7711217999458313,
        -0.42644163966178894,
        -0.47277751564979553
      ],
      "plane_d": -2510.69482421875,
      "bbox_min": [
        -1817.310302734375,
        -3679.83349609375,
        948.6624145507812
      ],
      "bbox_max": [
        -1804.283935546875,
        -3660.83447265625,
        955.6400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21827691793441772,
        0.0049761561676859856,
        -0.9758742451667786
      ],
      "plane_d": 554.12451171875,
      "bbox_min": [
        -1817.310302734375,
        -3679.83349609375,
        953.2717895507812
      ],
      "bbox_max": [
        -1806.8277587890625,
        -3660.83447265625,
        955.6400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2352815866470337,
        -0.045620810240507126,
        -0.9708560109138489
      ],
      "plane_d": 332.51116943359375,
      "bbox_min": [
        -1808.0965576171875,
        -3679.83349609375,
        953.2717895507812
      ],
      "bbox_max": [
        -1806.8277587890625,
        -3677.73779296875,
        953.492919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.678015947341919,
        -0.3143327832221985,
        0.6644466519355774
      ],
      "plane_d": -3011.15966796875,
      "bbox_min": [
        -1854.0667724609375,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7149882316589355,
        -0.5036027431488037,
        0.48494958877563477
      ],
      "plane_d": -3601.5107421875,
      "bbox_min": [
        -1817.310302734375,
        -3682.892822265625,
        942.8718872070312
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3659.154296875,
        950.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6339929103851318,
        -0.4036944806575775,
        0.6596087217330933
      ],
      "plane_d": -3253.72021484375,
      "bbox_min": [
        -1817.310302734375,
        -3676.583984375,
        945.5599975585938
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3659.154296875,
        950.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7127566933631897,
        -0.3061889708042145,
        -0.6310515999794006
      ],
      "plane_d": -1813.14892578125,
      "bbox_min": [
        -1813.37060546875,
        -3676.583984375,
        948.5
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3659.154296875,
        950.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.008492524735629559,
        -0.09328603744506836,
        0.9956030249595642
      ],
      "plane_d": -1298.3406982421875,
      "bbox_min": [
        -1817.310302734375,
        -3682.892822265625,
        942.8718872070312
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3660.83447265625,
        950.2374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.050205618143081665,
        -0.20834136009216309,
        0.9767667055130005
      ],
      "plane_d": -1779.122802734375,
      "bbox_min": [
        -1811.4193115234375,
        -3682.892822265625,
        942.8718872070312
      ],
      "bbox_max": [
        -1805.9105224609375,
        -3676.546875,
        944.1380004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7127566933631897,
        -0.3061889708042145,
        -0.6310515999794006
      ],
      "plane_d": -1813.14892578125,
      "bbox_min": [
        -1810.0089111328125,
        -3676.654052734375,
        948.5
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3666.6962890625,
        950.2374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7711217999458313,
        -0.42644163966178894,
        -0.47277751564979553
      ],
      "plane_d": -2510.69482421875,
      "bbox_min": [
        -1807.1966552734375,
        -3676.654052734375,
        948.5
      ],
      "bbox_max": [
        -1804.2230224609375,
        -3673.005615234375,
        950.1390380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6996594667434692,
        -0.23998118937015533,
        0.6729679107666016
      ],
      "plane_d": -220.2861328125,
      "bbox_min": [
        -1854.0667724609375,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5481629967689514,
        -0.5071733593940735,
        0.6650506854057312
      ],
      "plane_d": -1471.241943359375,
      "bbox_min": [
        -1851.213623046875,
        -3660.77880859375,
        946.2000122070312
      ],
      "bbox_max": [
        -1850.797607421875,
        -3660.28271484375,
        946.7112426757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20821693539619446,
        -0.061841581016778946,
        0.9761255979537964
      ],
      "plane_d": -764.6138916015625,
      "bbox_min": [
        -1850.9775390625,
        -3660.77880859375,
        946.2000122070312
      ],
      "bbox_max": [
        -1850.797607421875,
        -3660.50341796875,
        946.2284545898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7326282262802124,
        -0.2623337507247925,
        0.6280419826507568
      ],
      "plane_d": -198.1591796875,
      "bbox_min": [
        -1854.0667724609375,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09405817836523056,
        -0.0814281553030014,
        -0.9922310709953308
      ],
      "plane_d": 479.18780517578125,
      "bbox_min": [
        -1854.0667724609375,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19323499500751495,
        -0.038269639015197754,
        -0.980405867099762
      ],
      "plane_d": 1152.676025390625,
      "bbox_min": [
        -1838.2537841796875,
        -3657.98291015625,
        954.3333129882812
      ],
      "bbox_max": [
        -1828.758056640625,
        -3627.812744140625,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3622669279575348,
        -0.5614168047904968,
        -0.7440254092216492
      ],
      "plane_d": -1991.34130859375,
      "bbox_min": [
        -1838.2537841796875,
        -3631.6884765625,
        954.3333129882812
      ],
      "bbox_max": [
        -1828.758056640625,
        -3627.812744140625,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30971452593803406,
        -0.6826200485229492,
        -0.6618965268135071
      ],
      "plane_d": -2413.13330078125,
      "bbox_min": [
        -1837.0777587890625,
        -3628.69287109375,
        954.5902099609375
      ],
      "bbox_max": [
        -1834.2305908203125,
        -3627.812744140625,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3997192084789276,
        -0.6348176002502441,
        -0.6612344980239868
      ],
      "plane_d": -937.845947265625,
      "bbox_min": [
        -1837.0777587890625,
        -3628.69287109375,
        954.6991577148438
      ],
      "bbox_max": [
        -1835.9195556640625,
        -3627.812744140625,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7219261527061462,
        -0.2746710181236267,
        -0.6351208090782166
      ],
      "plane_d": 938.596923828125,
      "bbox_min": [
        -1854.0667724609375,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6770437955856323,
        -0.24634476006031036,
        -0.693488359451294
      ],
      "plane_d": 1014.4943237304688,
      "bbox_min": [
        -1853.904541015625,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0519728921353817,
        -0.1179526224732399,
        -0.9916582107543945
      ],
      "plane_d": 420.3456115722656,
      "bbox_min": [
        -1851.213623046875,
        -3660.828857421875,
        955.7954711914062
      ],
      "bbox_max": [
        -1850.797607421875,
        -3660.28271484375,
        956.3226928710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46660611033439636,
        -0.5822109580039978,
        -0.6658146381378174
      ],
      "plane_d": -630.886474609375,
      "bbox_min": [
        -1851.213623046875,
        -3660.77880859375,
        955.7954711914062
      ],
      "bbox_max": [
        -1850.797607421875,
        -3660.28271484375,
        956.318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08636977523565292,
        -0.1698460578918457,
        -0.9816784858703613
      ],
      "plane_d": 476.89044189453125,
      "bbox_min": [
        -1850.9775390625,
        -3660.77880859375,
        956.280029296875
      ],
      "bbox_max": [
        -1850.797607421875,
        -3660.50341796875,
        956.318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055899061262607574,
        -0.08559808135032654,
        -0.9947603940963745
      ],
      "plane_d": 741.395263671875,
      "bbox_min": [
        -1850.9036865234375,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19323499500751495,
        -0.038269639015197754,
        -0.980405867099762
      ],
      "plane_d": 1152.676025390625,
      "bbox_min": [
        -1850.8724365234375,
        -3661.367919921875,
        954.2557983398438
      ],
      "bbox_max": [
        -1833.3609619140625,
        -3627.37451171875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0519728921353817,
        -0.1179526224732399,
        -0.9916582107543945
      ],
      "plane_d": 420.3456115722656,
      "bbox_min": [
        -1850.8724365234375,
        -3661.367919921875,
        956.280029296875
      ],
      "bbox_max": [
        -1850.53564453125,
        -3660.50341796875,
        956.369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43263134360313416,
        -0.5192100405693054,
        -0.7370555996894836
      ],
      "plane_d": -385.4794921875,
      "bbox_min": [
        -1842.615966796875,
        -3632.537109375,
        954.2557983398438
      ],
      "bbox_max": [
        -1833.3609619140625,
        -3627.37451171875,
        955.0933227539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30971452593803406,
        -0.6826200485229492,
        -0.6618965268135071
      ],
      "plane_d": -2413.13330078125,
      "bbox_min": [
        -1836.001953125,
        -3629.004638671875,
        954.2607421875
      ],
      "bbox_max": [
        -1833.3609619140625,
        -3627.37451171875,
        954.6991577148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3622669279575348,
        -0.5614168047904968,
        -0.7440254092216492
      ],
      "plane_d": -1991.34130859375,
      "bbox_min": [
        -1834.2305908203125,
        -3629.004638671875,
        954.46826171875
      ],
      "bbox_max": [
        -1833.3609619140625,
        -3628.48193359375,
        954.5902099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07872018963098526,
        -0.04659454524517059,
        0.9958072900772095
      ],
      "plane_d": -967.0972290039062,
      "bbox_min": [
        -1850.9036865234375,
        -3674.24609375,
        945.0
      ],
      "bbox_max": [
        -1834.1256103515625,
        -3657.98291015625,
        946.2052001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.028696101158857346,
        0.000738015107344836,
        0.999587893486023
      ],
      "plane_d": -889.2786254882812,
      "bbox_min": [
        -1850.9036865234375,
        -3674.24609375,
        945.0
      ],
      "bbox_max": [
        -1834.1256103515625,
        -3657.98291015625,
        946.2052001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.002867229515686631,
        0.21853896975517273,
        0.9758239984512329
      ],
      "plane_d": -125.45957946777344,
      "bbox_min": [
        -1850.9036865234375,
        -3674.24609375,
        945.0907592773438
      ],
      "bbox_max": [
        -1836.976318359375,
        -3660.50341796875,
        946.2052001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1250888556241989,
        -0.02953234314918518,
        0.9917059540748596
      ],
      "plane_d": -814.9412841796875,
      "bbox_min": [
        -1850.9036865234375,
        -3661.55859375,
        946.1204833984375
      ],
      "bbox_max": [
        -1850.4163818359375,
        -3660.50341796875,
        946.2052001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0485512912273407,
        -0.09096493571996689,
        0.9946697950363159
      ],
      "plane_d": -1361.76025390625,
      "bbox_min": [
        -1850.797607421875,
        -3692.083984375,
        942.5
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18613652884960175,
        -0.06145239248871803,
        0.9806001782417297
      ],
      "plane_d": -1492.856689453125,
      "bbox_min": [
        -1839.8900146484375,
        -3687.446533203125,
        942.5
      ],
      "bbox_max": [
        -1809.7178955078125,
        -3627.4091796875,
        947.723388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.008492524735629559,
        -0.09328603744506836,
        0.9956030249595642
      ],
      "plane_d": -1298.3406982421875,
      "bbox_min": [
        -1820.0167236328125,
        -3687.446533203125,
        942.5
      ],
      "bbox_max": [
        -1809.7178955078125,
        -3660.83447265625,
        945.5599975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.050205618143081665,
        -0.20834136009216309,
        0.9767667055130005
      ],
      "plane_d": -1779.122802734375,
      "bbox_min": [
        -1820.0167236328125,
        -3686.873779296875,
        942.5
      ],
      "bbox_max": [
        -1809.7178955078125,
        -3674.127685546875,
        944.30419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27436336874961853,
        0.08239280432462692,
        0.9580898284912109
      ],
      "plane_d": -102.57244873046875,
      "bbox_min": [
        -1820.0167236328125,
        -3686.873779296875,
        942.5
      ],
      "bbox_max": [
        -1810.9730224609375,
        -3674.127685546875,
        944.2120971679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25783196091651917,
        0.02469453029334545,
        0.9658740758895874
      ],
      "plane_d": -352.42669677734375,
      "bbox_min": [
        -1814.81982421875,
        -3686.873779296875,
        942.5
      ],
      "bbox_max": [
        -1810.9730224609375,
        -3683.097412109375,
        943.4953002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27436336874961853,
        0.08239280432462692,
        0.9580898284912109
      ],
      "plane_d": -102.57244873046875,
      "bbox_min": [
        -1818.236083984375,
        -3687.446533203125,
        943.1553955078125
      ],
      "bbox_max": [
        -1813.18505859375,
        -3677.4912109375,
        943.991455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25783196091651917,
        0.02469453029334545,
        0.9658740758895874
      ],
      "plane_d": -352.42669677734375,
      "bbox_min": [
        -1815.360107421875,
        -3687.446533203125,
        943.1553955078125
      ],
      "bbox_max": [
        -1813.18505859375,
        -3682.923828125,
        943.6350708007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3622669279575348,
        -0.5614168047904968,
        0.7440254092216492
      ],
      "plane_d": -3406.4775390625,
      "bbox_min": [
        -1839.8900146484375,
        -3631.6884765625,
        946.5
      ],
      "bbox_max": [
        -1828.758056640625,
        -3627.4091796875,
        947.723388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30971452593803406,
        -0.6826200485229492,
        0.6618965268135071
      ],
      "plane_d": -3672.060546875,
      "bbox_min": [
        -1837.7694091796875,
        -3628.740478515625,
        946.5
      ],
      "bbox_max": [
        -1833.6483154296875,
        -3627.4091796875,
        947.723388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3997192084789276,
        -0.6348176002502441,
        0.6612344980239868
      ],
      "plane_d": -2195.513916015625,
      "bbox_min": [
        -1837.7694091796875,
        -3628.740478515625,
        946.5
      ],
      "bbox_max": [
        -1835.9195556640625,
        -3627.4091796875,
        947.70458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05502452328801155,
        -0.07965857535600662,
        -0.9953023791313171
      ],
      "plane_d": 762.0365600585938,
      "bbox_min": [
        -1850.797607421875,
        -3692.083984375,
        943.30322265625
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0519728921353817,
        -0.1179526224732399,
        -0.9916582107543945
      ],
      "plane_d": 420.3456115722656,
      "bbox_min": [
        -1850.797607421875,
        -3661.55859375,
        956.280029296875
      ],
      "bbox_max": [
        -1850.4163818359375,
        -3660.50341796875,
        956.3855590820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05970484018325806,
        -0.04220467433333397,
        -0.9973234534263611
      ],
      "plane_d": 690.07568359375,
      "bbox_min": [
        -1845.272705078125,
        -3692.083984375,
        943.30322265625
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08096522837877274,
        -0.002082288498058915,
        -0.9967147707939148
      ],
      "plane_d": 797.7386474609375,
      "bbox_min": [
        -1840.4287109375,
        -3669.60693359375,
        955.6400146484375
      ],
      "bbox_max": [
        -1817.310302734375,
        -3657.98291015625,
        957.1859130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028696101158857346,
        -0.000738015107344836,
        -0.999587893486023
      ],
      "plane_d": 901.2737426757812,
      "bbox_min": [
        -1840.4287109375,
        -3669.60693359375,
        957.0
      ],
      "bbox_max": [
        -1833.82666015625,
        -3657.98291015625,
        957.1859130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03449896350502968,
        0.19499902427196503,
        -0.980196475982666
      ],
      "plane_d": 1716.5157470703125,
      "bbox_min": [
        -1820.877197265625,
        -3685.22119140625,
        954.2710571289062
      ],
      "bbox_max": [
        -1810.9730224609375,
        -3673.15673828125,
        956.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04131109640002251,
        0.2157788723707199,
        -0.9755679965019226
      ],
      "plane_d": 1800.9942626953125,
      "bbox_min": [
        -1812.994140625,
        -3685.22119140625,
        954.2710571289062
      ],
      "bbox_max": [
        -1810.9730224609375,
        -3683.684326171875,
        954.55810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7127566933631897,
        -0.3061889708042145,
        -0.6310515999794006
      ],
      "plane_d": -1813.14892578125,
      "bbox_min": [
        -1845.272705078125,
        -3692.083984375,
        943.30322265625
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7711217999458313,
        -0.42644163966178894,
        -0.47277751564979553
      ],
      "plane_d": -2510.69482421875,
      "bbox_min": [
        -1817.310302734375,
        -3673.306396484375,
        950.122314453125
      ],
      "bbox_max": [
        -1807.0406494140625,
        -3660.83447265625,
        955.6400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028696101158857346,
        -0.000738015107344836,
        -0.999587893486023
      ],
      "plane_d": 901.2737426757812,
      "bbox_min": [
        -1845.272705078125,
        -3692.083984375,
        943.30322265625
      ],
      "bbox_max": [
        -1811.7457275390625,
        -3624.114501953125,
        957.3287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020183326676487923,
        -0.10149332135915756,
        0.9946314692497253
      ],
      "plane_d": -1275.3546142578125,
      "bbox_min": [
        -1833.82666015625,
        -3690.81689453125,
        943.30322265625
      ],
      "bbox_max": [
        -1813.6839599609375,
        -3660.83447265625,
        945.5599975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27436336874961853,
        0.08239280432462692,
        0.9580898284912109
      ],
      "plane_d": -102.57244873046875,
      "bbox_min": [
        -1820.877197265625,
        -3675.11083984375,
        944.1475830078125
      ],
      "bbox_max": [
        -1819.34765625,
        -3673.15673828125,
        944.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.050205618143081665,
        -0.20834136009216309,
        0.9767667055130005
      ],
      "plane_d": -1779.122802734375,
      "bbox_min": [
        -1820.877197265625,
        -3674.141845703125,
        944.2120971679688
      ],
      "bbox_max": [
        -1819.34765625,
        -3673.15673828125,
        944.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.008492524735629559,
        -0.09328603744506836,
        0.9956030249595642
      ],
      "plane_d": -1298.3406982421875,
      "bbox_min": [
        -1833.82666015625,
        -3690.81689453125,
        943.30322265625
      ],
      "bbox_max": [
        -1813.6839599609375,
        -3660.83447265625,
        945.5599975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.050205618143081665,
        -0.20834136009216309,
        0.9767667055130005
      ],
      "plane_d": -1779.122802734375,
      "bbox_min": [
        -1820.877197265625,
        -3674.16943359375,
        944.2434692382812
      ],
      "bbox_max": [
        -1818.0521240234375,
        -3673.15673828125,
        944.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10314925760030746,
        0.20491160452365875,
        0.9733300805091858
      ],
      "plane_d": 21.305984497070312,
      "bbox_min": [
        -1833.82666015625,
        -3690.81689453125,
        943.30322265625
      ],
      "bbox_max": [
        -1813.6839599609375,
        -3669.60693359375,
        945.5573120117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27436336874961853,
        0.08239280432462692,
        0.9580898284912109
      ],
      "plane_d": -102.57244873046875,
      "bbox_min": [
        -1826.211669921875,
        -3682.923828125,
        943.6350708007812
      ],
      "bbox_max": [
        -1815.360107421875,
        -3673.15673828125,
        945.3822021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11732440441846848,
        0.15781500935554504,
        0.9804741144180298
      ],
      "plane_d": -132.62265014648438,
      "bbox_min": [
        -1826.211669921875,
        -3677.730712890625,
        944.375
      ],
      "bbox_max": [
        -1820.877197265625,
        -3673.15673828125,
        945.3573608398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7414790987968445,
        0.5098005533218384,
        0.436247855424881
      ],
      "plane_d": 2815.97314453125,
      "bbox_min": [
        -1821.9376220703125,
        -3690.81689453125,
        944.0
      ],
      "bbox_max": [
        -1816.0355224609375,
        -3682.74853515625,
        945.5573120117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7397749423980713,
        0.4712161719799042,
        0.48030033707618713
      ],
      "plane_d": 2628.91064453125,
      "bbox_min": [
        -1818.1707763671875,
        -3690.81689453125,
        944.0
      ],
      "bbox_max": [
        -1816.0355224609375,
        -3688.3310546875,
        945.5573120117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.028696101158857346,
        0.000738015107344836,
        0.999587893486023
      ],
      "plane_d": -889.2786254882812,
      "bbox_min": [
        -1844.4464111328125,
        -3692.083984375,
        945.0
      ],
      "bbox_max": [
        -1811.7457275390625,
        -3624.114501953125,
        957.3059692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30971452593803406,
        -0.6826200485229492,
        -0.6618965268135071
      ],
      "plane_d": -2413.13330078125,
      "bbox_min": [
        -1844.4464111328125,
        -3692.083984375,
        945.0
      ],
      "bbox_max": [
        -1811.7457275390625,
        -3624.114501953125,
        957.3059692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30971452593803406,
        -0.6826200485229492,
        0.6618965268135071
      ],
      "plane_d": -3672.060546875,
      "bbox_min": [
        -1844.4464111328125,
        -3692.083984375,
        945.0
      ],
      "bbox_max": [
        -1811.7457275390625,
        -3624.114501953125,
        957.3059692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3997192084789276,
        -0.6348176002502441,
        -0.6612344980239868
      ],
      "plane_d": -937.845947265625,
      "bbox_min": [
        -1844.4464111328125,
        -3692.083984375,
        945.0
      ],
      "bbox_max": [
        -1811.7457275390625,
        -3624.114501953125,
        957.3059692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.009241362102329731,
        0.20599421858787537,
        -0.9785096645355225
      ],
      "plane_d": 1709.298583984375,
      "bbox_min": [
        -1844.4464111328125,
        -3692.083984375,
        945.0
      ],
      "bbox_max": [
        -1811.7457275390625,
        -3628.04052734375,
        957.3059692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03449896350502968,
        0.19499902427196503,
        -0.980196475982666
      ],
      "plane_d": 1716.5157470703125,
      "bbox_min": [
        -1844.4464111328125,
        -3690.220703125,
        952.8278198242188
      ],
      "bbox_max": [
        -1811.7457275390625,
        -3669.60693359375,
        957.3059692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06604354083538055,
        0.20556071400642395,
        -0.976413369178772
      ],
      "plane_d": 1567.64208984375,
      "bbox_min": [
        -1841.3310546875,
        -3677.9169921875,
        955.1904907226562
      ],
      "bbox_max": [
        -1833.82666015625,
        -3669.60693359375,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14017903804779053,
        0.8745019435882568,
        -0.4643232822418213
      ],
      "plane_d": 3401.90625,
      "bbox_min": [
        -1840.36328125,
        -3677.9169921875,
        955.1904907226562
      ],
      "bbox_max": [
        -1833.82666015625,
        -3676.73193359375,
        955.7494506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04131109640002251,
        0.2157788723707199,
        -0.9755679965019226
      ],
      "plane_d": 1800.9942626953125,
      "bbox_min": [
        -1824.017822265625,
        -3690.220703125,
        952.8278198242188
      ],
      "bbox_max": [
        -1811.7457275390625,
        -3680.14111328125,
        954.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6483544111251831,
        0.6040927171707153,
        -0.4633665382862091
      ],
      "plane_d": 3848.2138671875,
      "bbox_min": [
        -1824.017822265625,
        -3690.220703125,
        952.8278198242188
      ],
      "bbox_max": [
        -1816.0355224609375,
        -3680.14111328125,
        954.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6422198414802551,
        0.5866087675094604,
        -0.49340012669563293
      ],
      "plane_d": 3801.176513671875,
      "bbox_min": [
        -1816.374267578125,
        -3690.220703125,
        952.8278198242188
      ],
      "bbox_max": [
        -1816.0355224609375,
        -3689.8583984375,
        953.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3622669279575348,
        -0.5614168047904968,
        -0.7440254092216492
      ],
      "plane_d": -1991.34130859375,
      "bbox_min": [
        -1844.273681640625,
        -3692.083984375,
        945.0
      ],
      "bbox_max": [
        -1816.10009765625,
        -3628.04052734375,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3622669279575348,
        -0.5614168047904968,
        0.7440254092216492
      ],
      "plane_d": -3406.4775390625,
      "bbox_min": [
        -1844.273681640625,
        -3692.083984375,
        945.0
      ],
      "bbox_max": [
        -1816.10009765625,
        -3628.04052734375,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11732440441846848,
        0.15781500935554504,
        0.9804741144180298
      ],
      "plane_d": -132.62265014648438,
      "bbox_min": [
        -1842.4884033203125,
        -3692.083984375,
        945.0
      ],
      "bbox_max": [
        -1816.10009765625,
        -3669.60693359375,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.008490041829645634,
        0.20600305497646332,
        0.9785144925117493
      ],
      "plane_d": -153.1766357421875,
      "bbox_min": [
        -1842.4884033203125,
        -3691.376220703125,
        945.0
      ],
      "bbox_max": [
        -1816.6195068359375,
        -3669.60693359375,
        947.459228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10314925760030746,
        0.20491160452365875,
        0.9733300805091858
      ],
      "plane_d": 21.305984497070312,
      "bbox_min": [
        -1842.4884033203125,
        -3691.376220703125,
        945.0
      ],
      "bbox_max": [
        -1816.6195068359375,
        -3669.60693359375,
        946.8563842773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.002867229515686631,
        0.21853896975517273,
        0.9758239984512329
      ],
      "plane_d": -125.45957946777344,
      "bbox_min": [
        -1842.4884033203125,
        -3691.376220703125,
        945.0
      ],
      "bbox_max": [
        -1816.6195068359375,
        -3669.60693359375,
        946.8563842773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7414790987968445,
        0.5098005533218384,
        0.436247855424881
      ],
      "plane_d": 2815.97314453125,
      "bbox_min": [
        -1824.017822265625,
        -3691.376220703125,
        945.3573608398438
      ],
      "bbox_max": [
        -1816.6195068359375,
        -3677.730712890625,
        946.8563842773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7397749423980713,
        0.4712161719799042,
        0.48030033707618713
      ],
      "plane_d": 2628.91064453125,
      "bbox_min": [
        -1819.5340576171875,
        -3691.376220703125,
        945.507568359375
      ],
      "bbox_max": [
        -1816.6195068359375,
        -3687.171875,
        946.8563842773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27436336874961853,
        0.08239280432462692,
        0.9580898284912109
      ],
      "plane_d": -102.57244873046875,
      "bbox_min": [
        -1824.017822265625,
        -3682.74853515625,
        945.3573608398438
      ],
      "bbox_max": [
        -1821.9376220703125,
        -3677.730712890625,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25783196091651917,
        0.02469453029334545,
        0.9658740758895874
      ],
      "plane_d": -352.42669677734375,
      "bbox_min": [
        -1824.017822265625,
        -3682.74853515625,
        945.3822021484375
      ],
      "bbox_max": [
        -1821.9376220703125,
        -3680.14111328125,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10592427849769592,
        0.8816924095153809,
        0.45978105068206787
      ],
      "plane_d": 2612.31689453125,
      "bbox_min": [
        -1840.36328125,
        -3677.991455078125,
        946.5
      ],
      "bbox_max": [
        -1833.82666015625,
        -3676.73193359375,
        947.459228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6422198414802551,
        0.5866087675094604,
        -0.49340012669563293
      ],
      "plane_d": 3801.176513671875,
      "bbox_min": [
        -1840.1947021484375,
        -3692.083984375,
        945.875
      ],
      "bbox_max": [
        -1816.10009765625,
        -3676.73193359375,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6483544111251831,
        0.6040927171707153,
        -0.4633665382862091
      ],
      "plane_d": 3848.2138671875,
      "bbox_min": [
        -1840.1947021484375,
        -3689.8583984375,
        946.4525756835938
      ],
      "bbox_max": [
        -1816.374267578125,
        -3676.73193359375,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14164398610591888,
        0.8754680752754211,
        -0.4620526134967804
      ],
      "plane_d": 3400.602294921875,
      "bbox_min": [
        -1840.1947021484375,
        -3679.8271484375,
        948.3361206054688
      ],
      "bbox_max": [
        -1833.82666015625,
        -3676.73193359375,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14017903804779053,
        0.8745019435882568,
        -0.4643232822418213
      ],
      "plane_d": 3401.90625,
      "bbox_min": [
        -1840.1947021484375,
        -3679.8271484375,
        948.3361206054688
      ],
      "bbox_max": [
        -1833.82666015625,
        -3676.73193359375,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10260345786809921,
        0.8797172904014587,
        0.46429523825645447
      ],
      "plane_d": 2606.872314453125,
      "bbox_min": [
        -1839.88232421875,
        -3679.8271484375,
        948.3361206054688
      ],
      "bbox_max": [
        -1833.82666015625,
        -3678.416748046875,
        951.2213745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34920617938041687,
        0.8287091851234436,
        0.4373742640018463
      ],
      "plane_d": 3273.35009765625,
      "bbox_min": [
        -1840.148193359375,
        -3682.46923828125,
        946.4525756835938
      ],
      "bbox_max": [
        -1825.064697265625,
        -3676.73193359375,
        951.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7397749423980713,
        0.4712161719799042,
        0.48030033707618713
      ],
      "plane_d": 2628.91064453125,
      "bbox_min": [
        -1833.0823974609375,
        -3692.083984375,
        945.875
      ],
      "bbox_max": [
        -1817.106689453125,
        -3676.990478515625,
        950.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7486400008201599,
        -0.4590180516242981,
        -0.4783727824687958
      ],
      "plane_d": -2584.59521484375,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1785.3544921875,
        -3676.583984375,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.737348198890686,
        -0.43309497833251953,
        -0.5184075236320496
      ],
      "plane_d": -2430.691650390625,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1785.3544921875,
        -3676.583984375,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2736406624317169,
        -0.009869424626231194,
        -0.9617813229560852
      ],
      "plane_d": 386.1021423339844,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1785.3544921875,
        -3676.583984375,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6512948274612427,
        -0.5771052241325378,
        0.49271145462989807
      ],
      "plane_d": -3764.19384765625,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1785.3544921875,
        -3676.583984375,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.037867866456508636,
        -0.21864888072013855,
        0.9750685095787048
      ],
      "plane_d": -1793.1552734375,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1785.3544921875,
        -3678.521484375,
        954.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6358077526092529,
        -0.5643464922904968,
        0.5265563130378723
      ],
      "plane_d": -3721.24169921875,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1785.3544921875,
        -3678.521484375,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25148606300354004,
        0.018586046993732452,
        -0.967682421207428
      ],
      "plane_d": 536.6956787109375,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1787.4169921875,
        -3684.333984375,
        954.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.037908848375082016,
        0.21861477196216583,
        -0.9750745892524719
      ],
      "plane_d": 1804.8104248046875,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1793.6044921875,
        -3684.333984375,
        954.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2575441002845764,
        -0.025718724355101585,
        0.9659242033958435
      ],
      "plane_d": -539.0291137695312,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        937.5
      ],
      "bbox_max": [
        -1793.6044921875,
        -3684.333984375,
        953.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28081193566322327,
        0.0031012617982923985,
        0.9597576856613159
      ],
      "plane_d": -384.6026916503906,
      "bbox_min": [
        -1816.0355224609375,
        -3709.64697265625,
        937.5
      ],
      "bbox_max": [
        -1793.6044921875,
        -3684.333984375,
        944.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7681731581687927,
        0.3841913640499115,
        0.5121591091156006
      ],
      "plane_d": 2329.009765625,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        939.0
      ],
      "bbox_max": [
        -1799.7919921875,
        -3690.146484375,
        953.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7809627056121826,
        0.4113636314868927,
        0.46997591853141785
      ],
      "plane_d": 2492.5908203125,
      "bbox_min": [
        -1817.7230224609375,
        -3715.27197265625,
        939.0
      ],
      "bbox_max": [
        -1799.7919921875,
        -3690.146484375,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6847602128982544,
        0.5400689840316772,
        -0.48931482434272766
      ],
      "plane_d": 3702.79931640625,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        943.5
      ],
      "bbox_max": [
        -1799.7919921875,
        -3690.146484375,
        953.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6674284338951111,
        0.5274506211280823,
        -0.5256757736206055
      ],
      "plane_d": 3659.1953125,
      "bbox_min": [
        -1817.7230224609375,
        -3717.14697265625,
        943.5
      ],
      "bbox_max": [
        -1799.7919921875,
        -3692.083984375,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03434140980243683,
        -0.02573409117758274,
        0.9990788698196411
      ],
      "plane_d": -969.1722412109375,
      "bbox_min": [
        -1801.8544921875,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3700.1103515625,
        949.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.03434140607714653,
        0.02573408931493759,
        -0.9990787506103516
      ],
      "plane_d": 981.1610107421875,
      "bbox_min": [
        -1801.8544921875,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3700.1103515625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2214372754096985,
        -0.01642865315079689,
        -0.9750362634658813
      ],
      "plane_d": 467.6814880371094,
      "bbox_min": [
        -1798.8731689453125,
        -3735.731201171875,
        946.6685180664062
      ],
      "bbox_max": [
        -1755.0,
        -3704.404052734375,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05678233876824379,
        0.18588665127754211,
        -0.9809290766716003
      ],
      "plane_d": 1519.7591552734375,
      "bbox_min": [
        -1779.1064453125,
        -3735.731201171875,
        946.6685180664062
      ],
      "bbox_max": [
        -1755.0,
        -3714.480712890625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22038012742996216,
        -0.09131436049938202,
        -0.97113037109375
      ],
      "plane_d": 186.47308349609375,
      "bbox_min": [
        -1779.1064453125,
        -3735.731201171875,
        946.9905395507812
      ],
      "bbox_max": [
        -1778.9820556640625,
        -3735.53173828125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1923946589231491,
        0.07971859723329544,
        -0.9780742526054382
      ],
      "plane_d": 1566.3182373046875,
      "bbox_min": [
        -1779.1064453125,
        -3735.719970703125,
        946.99267578125
      ],
      "bbox_max": [
        -1779.0284423828125,
        -3735.53173828125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.027785949409008026,
        0.22891536355018616,
        -0.9730496406555176
      ],
      "plane_d": 1822.94287109375,
      "bbox_min": [
        -1798.8731689453125,
        -3718.70068359375,
        947.625
      ],
      "bbox_max": [
        -1784.6767578125,
        -3709.64697265625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2214372754096985,
        0.01642865315079689,
        0.9750362634658813
      ],
      "plane_d": -455.9810485839844,
      "bbox_min": [
        -1799.7919921875,
        -3718.70068359375,
        935.625
      ],
      "bbox_max": [
        -1784.6767578125,
        -3708.806640625,
        939.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027785949409008026,
        -0.22891536355018616,
        0.9730496406555176
      ],
      "plane_d": -1811.2662353515625,
      "bbox_min": [
        -1793.6044921875,
        -3718.70068359375,
        935.625
      ],
      "bbox_max": [
        -1784.6767578125,
        -3708.806640625,
        937.72412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027785949409008026,
        -0.22891536355018616,
        0.9730496406555176
      ],
      "plane_d": -1811.2662353515625,
      "bbox_min": [
        -1792.6800537109375,
        -3718.70068359375,
        935.625
      ],
      "bbox_max": [
        -1784.6767578125,
        -3704.02197265625,
        939.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7599560022354126,
        0.3977682590484619,
        0.5140498876571655
      ],
      "plane_d": 2362.88720703125,
      "bbox_min": [
        -1801.8544921875,
        -3733.377685546875,
        936.3569946289062
      ],
      "bbox_max": [
        -1788.693115234375,
        -3715.27197265625,
        943.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7488711476325989,
        0.3345642387866974,
        0.5720653533935547
      ],
      "plane_d": 2052.95458984375,
      "bbox_min": [
        -1793.2906494140625,
        -3733.377685546875,
        936.3569946289062
      ],
      "bbox_max": [
        -1788.693115234375,
        -3730.2275390625,
        941.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15572531521320343,
        0.07247110456228256,
        0.9851384162902832
      ],
      "plane_d": -373.3344421386719,
      "bbox_min": [
        -1790.1783447265625,
        -3733.377685546875,
        936.3569946289062
      ],
      "bbox_max": [
        -1788.693115234375,
        -3730.2275390625,
        936.3704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1658772975206375,
        0.12430189549922943,
        0.9782810211181641
      ],
      "plane_d": -745.472412109375,
      "bbox_min": [
        -1801.8544921875,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3700.1103515625,
        948.2227783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04134446382522583,
        -0.1353481262922287,
        0.9899351000785828
      ],
      "plane_d": -1355.77783203125,
      "bbox_min": [
        -1779.133056640625,
        -3737.5029296875,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3709.12548828125,
        937.346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05678233876824379,
        0.18588665127754211,
        0.9809290766716003
      ],
      "plane_d": -326.349365234375,
      "bbox_min": [
        -1779.133056640625,
        -3737.5029296875,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3714.480712890625,
        937.346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22038014233112335,
        -0.09131436794996262,
        0.9711304306983948
      ],
      "plane_d": -1641.1944580078125,
      "bbox_min": [
        -1779.133056640625,
        -3737.5029296875,
        935.0
      ],
      "bbox_max": [
        -1771.6722412109375,
        -3735.53173828125,
        936.509521484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1923946589231491,
        0.07971859723329544,
        0.9780742526054382
      ],
      "plane_d": -274.41754150390625,
      "bbox_min": [
        -1779.133056640625,
        -3737.5029296875,
        935.0
      ],
      "bbox_max": [
        -1771.6722412109375,
        -3735.53173828125,
        936.509521484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8050895929336548,
        -0.3663681745529175,
        0.466481477022171
      ],
      "plane_d": -3232.521484375,
      "bbox_min": [
        -1771.7001953125,
        -3737.5029296875,
        936.5
      ],
      "bbox_max": [
        -1771.6722412109375,
        -3737.45361328125,
        936.509521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05974610522389412,
        0.22343851625919342,
        0.972885251045227
      ],
      "plane_d": -184.45217895507812,
      "bbox_min": [
        -1765.804931640625,
        -3722.990966796875,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3716.8330078125,
        937.346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04134446382522583,
        -0.1353481262922287,
        0.9899351000785828
      ],
      "plane_d": -1355.77783203125,
      "bbox_min": [
        -1784.6767578125,
        -3718.70068359375,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3708.571044921875,
        936.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03946869447827339,
        -0.13732270896434784,
        0.989739716053009
      ],
      "plane_d": -1366.2484130859375,
      "bbox_min": [
        -1784.6767578125,
        -3718.70068359375,
        935.0
      ],
      "bbox_max": [
        -1765.804931640625,
        -3710.287353515625,
        936.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18056240677833557,
        0.12846297025680542,
        0.975138247013092
      ],
      "plane_d": -752.9949951171875,
      "bbox_min": [
        -1765.9560546875,
        -3718.28564453125,
        935.0
      ],
      "bbox_max": [
        -1765.6044921875,
        -3717.78125,
        935.0609741210938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.18056240677833557,
        0.12846297025680542,
        0.975138247013092
      ],
      "plane_d": -752.9949951171875,
      "bbox_min": [
        -1801.8544921875,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3700.1103515625,
        948.2227783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05974610522389412,
        0.22343851625919342,
        0.972885251045227
      ],
      "plane_d": -184.45217895507812,
      "bbox_min": [
        -1765.631591796875,
        -3723.171875,
        935.0608520507812
      ],
      "bbox_max": [
        -1755.0,
        -3717.992431640625,
        937.5471801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6537237763404846,
        0.44615718722343445,
        -0.6112192869186401
      ],
      "plane_d": 3413.0322265625,
      "bbox_min": [
        -1801.8544921875,
        -3733.60888671875,
        941.625
      ],
      "bbox_max": [
        -1787.739501953125,
        -3717.14697265625,
        946.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7209700345993042,
        0.33390212059020996,
        -0.6072161793708801
      ],
      "plane_d": 3110.8896484375,
      "bbox_min": [
        -1793.2906494140625,
        -3733.567138671875,
        941.625
      ],
      "bbox_max": [
        -1787.912109375,
        -3730.2275390625,
        946.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07756711542606354,
        0.05682527646422386,
        -0.9953663945198059
      ],
      "plane_d": 1292.884765625,
      "bbox_min": [
        -1790.1783447265625,
        -3733.567138671875,
        946.3697509765625
      ],
      "bbox_max": [
        -1787.912109375,
        -3730.2275390625,
        946.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07756711542606354,
        0.05682527646422386,
        -0.9953663945198059
      ],
      "plane_d": 1292.884765625,
      "bbox_min": [
        -1790.1783447265625,
        -3733.60888671875,
        946.4259643554688
      ],
      "bbox_max": [
        -1787.739501953125,
        -3730.2275390625,
        946.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08081882447004318,
        0.06368399411439896,
        -0.994692325592041
      ],
      "plane_d": 1323.6524658203125,
      "bbox_min": [
        -1799.7919921875,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3700.1103515625,
        948.2227783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0013370508095249534,
        0.1028955802321434,
        -0.9946911931037903
      ],
      "plane_d": 1322.845947265625,
      "bbox_min": [
        -1799.7919921875,
        -3735.7099609375,
        946.43701171875
      ],
      "bbox_max": [
        -1779.06982421875,
        -3714.436767578125,
        948.2227783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.027785949409008026,
        0.22891536355018616,
        -0.9730496406555176
      ],
      "plane_d": 1822.94287109375,
      "bbox_min": [
        -1799.7919921875,
        -3735.7099609375,
        946.43701171875
      ],
      "bbox_max": [
        -1779.06982421875,
        -3714.436767578125,
        948.2227783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07756711542606354,
        0.05682527646422386,
        -0.9953663945198059
      ],
      "plane_d": 1292.884765625,
      "bbox_min": [
        -1790.1783447265625,
        -3735.7099609375,
        946.43701171875
      ],
      "bbox_max": [
        -1779.06982421875,
        -3730.2275390625,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1658772975206375,
        0.12430188059806824,
        -0.9782810807228088
      ],
      "plane_d": 1095.65234375,
      "bbox_min": [
        -1790.1783447265625,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3700.1103515625,
        948.1018676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01716766692698002,
        -0.056201282888650894,
        -0.9982717633247375
      ],
      "plane_d": 766.7340698242188,
      "bbox_min": [
        -1779.1064453125,
        -3737.5029296875,
        944.6529541015625
      ],
      "bbox_max": [
        -1755.0,
        -3706.90771484375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22038012742996216,
        -0.09131436049938202,
        -0.97113037109375
      ],
      "plane_d": 186.47308349609375,
      "bbox_min": [
        -1779.1064453125,
        -3737.5029296875,
        945.4905395507812
      ],
      "bbox_max": [
        -1771.6722412109375,
        -3735.53173828125,
        947.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8050895929336548,
        -0.3663681745529175,
        -0.466481477022171
      ],
      "plane_d": -2354.603271484375,
      "bbox_min": [
        -1771.7001953125,
        -3737.5029296875,
        945.4905395507812
      ],
      "bbox_max": [
        -1771.6722412109375,
        -3737.45361328125,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2340203821659088,
        0.8751895427703857,
        -0.4234119653701782
      ],
      "plane_d": 3246.5810546875,
      "bbox_min": [
        -1760.86376953125,
        -3722.9912109375,
        944.6529541015625
      ],
      "bbox_max": [
        -1755.0,
        -3706.90771484375,
        946.6672973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11207671463489532,
        0.00446341885253787,
        -0.9936895966529846
      ],
      "plane_d": 758.2225341796875,
      "bbox_min": [
        -1787.837158203125,
        -3718.70068359375,
        945.6962280273438
      ],
      "bbox_max": [
        -1768.285400390625,
        -3703.06201171875,
        948.1018676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2214372754096985,
        -0.01642865315079689,
        -0.9750362634658813
      ],
      "plane_d": 467.6814880371094,
      "bbox_min": [
        -1787.837158203125,
        -3718.70068359375,
        947.625
      ],
      "bbox_max": [
        -1784.6767578125,
        -3704.02197265625,
        948.1018676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1308245062828064,
        -0.7518925070762634,
        0.6461755037307739
      ],
      "plane_d": -3626.85107421875,
      "bbox_min": [
        -1787.4169921875,
        -3710.287353515625,
        936.3599853515625
      ],
      "bbox_max": [
        -1771.6767578125,
        -3702.14697265625,
        946.048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28954747319221497,
        -0.8291540145874023,
        0.4781901240348816
      ],
      "plane_d": -4037.767333984375,
      "bbox_min": [
        -1787.4169921875,
        -3710.287353515625,
        936.3599853515625
      ],
      "bbox_max": [
        -1773.8353271484375,
        -3702.14697265625,
        943.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40881088376045227,
        -0.7606281638145447,
        -0.504300057888031
      ],
      "plane_d": -3070.0224609375,
      "bbox_min": [
        -1786.361083984375,
        -3706.594970703125,
        943.5
      ],
      "bbox_max": [
        -1779.0604248046875,
        -3702.14697265625,
        946.048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2874300181865692,
        -0.658076286315918,
        -0.6959306597709656
      ],
      "plane_d": -2292.84912109375,
      "bbox_min": [
        -1780.423095703125,
        -3710.287353515625,
        941.625
      ],
      "bbox_max": [
        -1771.6767578125,
        -3706.13818359375,
        946.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40881088376045227,
        -0.7606281638145447,
        -0.504300057888031
      ],
      "plane_d": -3070.0224609375,
      "bbox_min": [
        -1780.423095703125,
        -3710.287353515625,
        945.1064453125
      ],
      "bbox_max": [
        -1773.8353271484375,
        -3706.4873046875,
        946.4400024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2558348476886749,
        -0.7409781217575073,
        -0.620886504650116
      ],
      "plane_d": -1707.801025390625,
      "bbox_min": [
        -1790.1783447265625,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3702.145751953125,
        947.0821533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18056242167949677,
        0.12846297025680542,
        -0.9751381874084473
      ],
      "plane_d": 1082.215087890625,
      "bbox_min": [
        -1790.1783447265625,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3708.74755859375,
        947.0821533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01716766692698002,
        -0.056201282888650894,
        -0.9982717633247375
      ],
      "plane_d": 766.7340698242188,
      "bbox_min": [
        -1765.804931640625,
        -3723.171875,
        944.4528198242188
      ],
      "bbox_max": [
        -1755.0,
        -3708.74755859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05974610522389412,
        0.22343851625919342,
        -0.972885251045227
      ],
      "plane_d": 1646.517822265625,
      "bbox_min": [
        -1765.804931640625,
        -3723.171875,
        944.4528198242188
      ],
      "bbox_max": [
        -1755.0,
        -3717.78125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027851609513163567,
        -0.10413726419210434,
        -0.9941728711128235
      ],
      "plane_d": 505.1416320800781,
      "bbox_min": [
        -1773.8353271484375,
        -3717.902099609375,
        946.4400024414062
      ],
      "bbox_max": [
        -1765.804931640625,
        -3710.287353515625,
        947.0821533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21103280782699585,
        0.840233564376831,
        0.4994725286960602
      ],
      "plane_d": 2288.3974609375,
      "bbox_min": [
        -1771.7001953125,
        -3738.09423828125,
        936.5
      ],
      "bbox_max": [
        -1755.0,
        -3721.929931640625,
        944.5799560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23402035236358643,
        0.8751896023750305,
        0.4234119951725006
      ],
      "plane_d": 2449.719970703125,
      "bbox_min": [
        -1771.7001953125,
        -3738.09423828125,
        936.5
      ],
      "bbox_max": [
        -1755.0,
        -3721.929931640625,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8286907076835632,
        -0.392815500497818,
        0.3987073302268982
      ],
      "plane_d": -3309.710693359375,
      "bbox_min": [
        -1771.7001953125,
        -3738.09423828125,
        936.5
      ],
      "bbox_max": [
        -1769.2314453125,
        -3737.45361328125,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2340203821659088,
        0.8751895427703857,
        -0.4234119653701782
      ],
      "plane_d": 3246.5810546875,
      "bbox_min": [
        -1760.117431640625,
        -3724.96875,
        941.0
      ],
      "bbox_max": [
        -1755.0,
        -3721.929931640625,
        944.5799560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21103282272815704,
        0.8402336239814758,
        -0.499472439289093
      ],
      "plane_d": 3228.405029296875,
      "bbox_min": [
        -1760.117431640625,
        -3724.96875,
        941.0
      ],
      "bbox_max": [
        -1755.0,
        -3723.237060546875,
        941.7507934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320067286491394,
        0.520793616771698,
        -0.43924957513809204
      ],
      "plane_d": 1064.8560791015625,
      "bbox_min": [
        -1790.1783447265625,
        -3738.09423828125,
        935.0
      ],
      "bbox_max": [
        -1755.7940673828125,
        -3722.080810546875,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7252156734466553,
        0.5035718083381653,
        -0.4695504307746887
      ],
      "plane_d": 1041.17138671875,
      "bbox_min": [
        -1771.7001953125,
        -3738.09423828125,
        941.0
      ],
      "bbox_max": [
        -1755.7940673828125,
        -3722.080810546875,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15572531521320343,
        0.07247110456228256,
        0.9851384162902832
      ],
      "plane_d": -373.3344421386719,
      "bbox_min": [
        -1790.1783447265625,
        -3735.694580078125,
        935.0
      ],
      "bbox_max": [
        -1779.1064453125,
        -3730.2275390625,
        936.3599853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7999684810638428,
        0.37585699558258057,
        0.4677412509918213
      ],
      "plane_d": 2396.9365234375,
      "bbox_min": [
        -1793.2906494140625,
        -3773.6630859375,
        935.0
      ],
      "bbox_max": [
        -1758.47412109375,
        -3732.263671875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.793780505657196,
        0.38703927397727966,
        -0.46916210651397705
      ],
      "plane_d": 3309.78662109375,
      "bbox_min": [
        -1793.2906494140625,
        -3773.6630859375,
        935.0
      ],
      "bbox_max": [
        -1758.47412109375,
        -3732.263671875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7488711476325989,
        0.3345642387866974,
        0.5720653533935547
      ],
      "plane_d": 2052.95458984375,
      "bbox_min": [
        -1793.2906494140625,
        -3772.0537109375,
        935.0
      ],
      "bbox_max": [
        -1758.47412109375,
        -3732.263671875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1923946589231491,
        0.07971859723329544,
        0.9780742526054382
      ],
      "plane_d": -274.41754150390625,
      "bbox_min": [
        -1779.06982421875,
        -3772.0537109375,
        935.0
      ],
      "bbox_max": [
        -1765.4500732421875,
        -3735.7099609375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22038014233112335,
        -0.09131436794996262,
        0.9711304306983948
      ],
      "plane_d": -1641.1944580078125,
      "bbox_min": [
        -1779.0284423828125,
        -3767.2255859375,
        935.0
      ],
      "bbox_max": [
        -1765.4500732421875,
        -3735.719970703125,
        935.1397094726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18764466047286987,
        -0.08539054542779922,
        0.9785183072090149
      ],
      "plane_d": -1567.9757080078125,
      "bbox_min": [
        -1766.499755859375,
        -3767.2255859375,
        935.0
      ],
      "bbox_max": [
        -1765.4500732421875,
        -3764.492431640625,
        935.1397094726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07756711542606354,
        0.05682527646422386,
        -0.9953663945198059
      ],
      "plane_d": 1292.884765625,
      "bbox_min": [
        -1788.789306640625,
        -3772.0537109375,
        935.0
      ],
      "bbox_max": [
        -1758.47412109375,
        -3733.3544921875,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1923946589231491,
        0.07971859723329544,
        -0.9780742526054382
      ],
      "plane_d": 1566.3182373046875,
      "bbox_min": [
        -1779.06982421875,
        -3772.0537109375,
        945.5
      ],
      "bbox_max": [
        -1763.9769287109375,
        -3735.7099609375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22038012742996216,
        -0.09131436049938202,
        -0.97113037109375
      ],
      "plane_d": 186.47308349609375,
      "bbox_min": [
        -1779.0284423828125,
        -3767.2255859375,
        946.4674072265625
      ],
      "bbox_max": [
        -1763.9769287109375,
        -3735.719970703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18764464557170868,
        -0.08539053052663803,
        -0.9785182476043701
      ],
      "plane_d": 273.5958557128906,
      "bbox_min": [
        -1767.60888671875,
        -3767.2255859375,
        946.4674072265625
      ],
      "bbox_max": [
        -1763.9769287109375,
        -3758.725830078125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22038014233112335,
        -0.09131436794996262,
        0.9711304306983948
      ],
      "plane_d": -1641.1944580078125,
      "bbox_min": [
        -1779.0284423828125,
        -3766.77587890625,
        935.0
      ],
      "bbox_max": [
        -1758.47412109375,
        -3735.719970703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8050895929336548,
        -0.3663681745529175,
        0.466481477022171
      ],
      "plane_d": -3232.521484375,
      "bbox_min": [
        -1771.678466796875,
        -3762.3974609375,
        936.5
      ],
      "bbox_max": [
        -1760.2388916015625,
        -3737.501220703125,
        936.764404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8050895929336548,
        -0.3663681745529175,
        -0.466481477022171
      ],
      "plane_d": -2354.603271484375,
      "bbox_min": [
        -1779.0284423828125,
        -3765.511474609375,
        936.5
      ],
      "bbox_max": [
        -1758.47412109375,
        -3735.719970703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8286907076835632,
        -0.392815500497818,
        0.3987073302268982
      ],
      "plane_d": -3309.710693359375,
      "bbox_min": [
        -1779.0284423828125,
        -3765.511474609375,
        936.5094604492188
      ],
      "bbox_max": [
        -1758.47412109375,
        -3735.719970703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22038012742996216,
        -0.09131436049938202,
        -0.97113037109375
      ],
      "plane_d": 186.47308349609375,
      "bbox_min": [
        -1779.0284423828125,
        -3758.725830078125,
        945.5022583007812
      ],
      "bbox_max": [
        -1767.60888671875,
        -3735.719970703125,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46160078048706055,
        0.7566993236541748,
        0.4629588723182678
      ],
      "plane_d": 3238.52099609375,
      "bbox_min": [
        -1773.47412109375,
        -3784.9326171875,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4477357268333435,
        0.7458693385124207,
        -0.49316495656967163
      ],
      "plane_d": 4072.954833984375,
      "bbox_min": [
        -1771.59912109375,
        -3784.180908203125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4477357864379883,
        0.7458693385124207,
        0.49316495656967163
      ],
      "plane_d": 3144.818603515625,
      "bbox_min": [
        -1771.59912109375,
        -3784.180908203125,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10733222216367722,
        0.17880146205425262,
        0.9780131578445435
      ],
      "plane_d": -51.3109130859375,
      "bbox_min": [
        -1771.59912109375,
        -3782.01806640625,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10733222216367722,
        0.17880146205425262,
        -0.9780131578445435
      ],
      "plane_d": 1789.309814453125,
      "bbox_min": [
        -1771.59912109375,
        -3782.01806640625,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09504114836454391,
        0.16727665066719055,
        -0.9813183546066284
      ],
      "plane_d": 1727.3175048828125,
      "bbox_min": [
        -1765.97412109375,
        -3778.674560546875,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09504114836454391,
        0.16727665066719055,
        0.9813183546066284
      ],
      "plane_d": -119.5235595703125,
      "bbox_min": [
        -1765.97412109375,
        -3778.674560546875,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10383892804384232,
        -0.18276113271713257,
        -0.9776583909988403
      ],
      "plane_d": 53.96327209472656,
      "bbox_min": [
        -1765.97412109375,
        -3773.460693359375,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        947.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09030041098594666,
        -0.1701120138168335,
        -0.9812785983085632
      ],
      "plane_d": 128.8096466064453,
      "bbox_min": [
        -1760.34912109375,
        -3767.986328125,
        945.4580688476562
      ],
      "bbox_max": [
        -1755.0,
        -3762.3974609375,
        945.9766235351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4174700081348419,
        -0.7864490151405334,
        -0.4552105963230133
      ],
      "plane_d": -3263.4248046875,
      "bbox_min": [
        -1760.34912109375,
        -3765.23681640625,
        945.4580688476562
      ],
      "bbox_max": [
        -1755.0,
        -3762.3974609375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10383892059326172,
        -0.18276111781597137,
        0.9776583313941956
      ],
      "plane_d": -1785.98974609375,
      "bbox_min": [
        -1765.97412109375,
        -3773.460693359375,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09030041098594666,
        -0.1701120287179947,
        0.9812785983085632
      ],
      "plane_d": -1717.9566650390625,
      "bbox_min": [
        -1760.34912109375,
        -3767.986328125,
        936.0233764648438
      ],
      "bbox_max": [
        -1755.0,
        -3762.3974609375,
        936.5418701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4174700081348419,
        -0.7864490151405334,
        0.4552105963230133
      ],
      "plane_d": -4120.13134765625,
      "bbox_min": [
        -1760.34912109375,
        -3765.23681640625,
        936.5
      ],
      "bbox_max": [
        -1755.0,
        -3762.3974609375,
        936.5418701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.399713933467865,
        -0.7731451988220215,
        0.49241769313812256
      ],
      "plane_d": -4073.88671875,
      "bbox_min": [
        -1760.34912109375,
        -3765.212646484375,
        936.5
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4174700081348419,
        -0.7864490151405334,
        0.4552105963230133
      ],
      "plane_d": -4120.13134765625,
      "bbox_min": [
        -1760.34912109375,
        -3765.212646484375,
        936.5
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4174700081348419,
        -0.7864490151405334,
        -0.4552105963230133
      ],
      "plane_d": -3263.4248046875,
      "bbox_min": [
        -1760.34912109375,
        -3765.212646484375,
        941.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.399713933467865,
        -0.7731451988220215,
        -0.49241769313812256
      ],
      "plane_d": -3147.156982421875,
      "bbox_min": [
        -1758.47412109375,
        -3763.111083984375,
        941.0
      ],
      "bbox_max": [
        -1755.0,
        -3760.7880859375,
        941.8273315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08636977523565292,
        -0.1698460578918457,
        -0.9816784858703613
      ],
      "plane_d": 476.89044189453125,
      "bbox_min": [
        -1863.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3655.716796875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20821693539619446,
        -0.061841581016778946,
        0.9761255979537964
      ],
      "plane_d": -764.6138916015625,
      "bbox_min": [
        -1863.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3655.716796875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1250888556241989,
        -0.02953234314918518,
        0.9917059540748596
      ],
      "plane_d": -814.9412841796875,
      "bbox_min": [
        -1863.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3655.716796875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0519728921353817,
        -0.1179526224732399,
        -0.9916582107543945
      ],
      "plane_d": 420.3456115722656,
      "bbox_min": [
        -1863.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3655.716796875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05502452328801155,
        -0.07965857535600662,
        -0.9953023791313171
      ],
      "plane_d": 762.0365600585938,
      "bbox_min": [
        -1850.4163818359375,
        -3671.4521484375,
        956.3855590820312
      ],
      "bbox_max": [
        -1844.2569580078125,
        -3661.55859375,
        957.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028696101158857346,
        -0.000738015107344836,
        -0.999587893486023
      ],
      "plane_d": 901.2737426757812,
      "bbox_min": [
        -1846.841796875,
        -3671.4521484375,
        957.235107421875
      ],
      "bbox_max": [
        -1844.2569580078125,
        -3669.7900390625,
        957.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05572827160358429,
        0.1940326690673828,
        -0.9794108271598816
      ],
      "plane_d": 1547.123779296875,
      "bbox_min": [
        -1846.841796875,
        -3671.4521484375,
        957.235107421875
      ],
      "bbox_max": [
        -1844.2569580078125,
        -3671.112548828125,
        957.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46660611033439636,
        -0.5822109580039978,
        -0.6658146381378174
      ],
      "plane_d": -630.886474609375,
      "bbox_min": [
        -1863.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3655.716796875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6770437955856323,
        -0.24634476006031036,
        -0.693488359451294
      ],
      "plane_d": 1014.4943237304688,
      "bbox_min": [
        -1855.0087890625,
        -3660.28271484375,
        950.65380859375
      ],
      "bbox_max": [
        -1851.213623046875,
        -3655.716796875,
        955.7954711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7326282262802124,
        -0.2623337507247925,
        0.6280419826507568
      ],
      "plane_d": -198.1591796875,
      "bbox_min": [
        -1855.0087890625,
        -3658.26904296875,
        950.65380859375
      ],
      "bbox_max": [
        -1853.661865234375,
        -3655.716796875,
        951.6386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7219261527061462,
        -0.2746710181236267,
        -0.6351208090782166
      ],
      "plane_d": 938.596923828125,
      "bbox_min": [
        -1855.0087890625,
        -3658.26904296875,
        950.65380859375
      ],
      "bbox_max": [
        -1853.661865234375,
        -3655.716796875,
        951.6386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6996594667434692,
        -0.23998118937015533,
        0.6729679107666016
      ],
      "plane_d": -220.2861328125,
      "bbox_min": [
        -1855.0087890625,
        -3658.26904296875,
        950.65380859375
      ],
      "bbox_max": [
        -1853.661865234375,
        -3655.976318359375,
        951.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5481629967689514,
        -0.5071733593940735,
        0.6650506854057312
      ],
      "plane_d": -1471.241943359375,
      "bbox_min": [
        -1863.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3656.36474609375,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6996594667434692,
        -0.23998118937015533,
        0.6729679107666016
      ],
      "plane_d": -220.2861328125,
      "bbox_min": [
        -1855.0087890625,
        -3660.28271484375,
        946.7112426757812
      ],
      "bbox_max": [
        -1851.213623046875,
        -3656.36474609375,
        951.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6195074915885925,
        -0.5991314053535461,
        -0.5072001814842224
      ],
      "plane_d": -560.054443359375,
      "bbox_min": [
        -1863.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3658.26904296875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6769039034843445,
        -0.5380001068115234,
        0.5023515224456787
      ],
      "plane_d": -1190.4112548828125,
      "bbox_min": [
        -1863.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3658.26904296875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.013892820104956627,
        0.22615255415439606,
        0.9739928245544434
      ],
      "plane_d": -64.82232666015625,
      "bbox_min": [
        -1856.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3661.55859375,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.008510817773640156,
        0.23551158607006073,
        0.9718342423439026
      ],
      "plane_d": -69.79647064208984,
      "bbox_min": [
        -1856.9429931640625,
        -3682.45947265625,
        945.375
      ],
      "bbox_max": [
        -1846.841796875,
        -3671.4521484375,
        948.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07872018963098526,
        -0.04659454524517059,
        0.9958072900772095
      ],
      "plane_d": -967.0972290039062,
      "bbox_min": [
        -1856.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3661.55859375,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20212797820568085,
        0.1221870630979538,
        -0.9717071056365967
      ],
      "plane_d": 1005.5936279296875,
      "bbox_min": [
        -1856.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3669.7900390625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05572827160358429,
        0.1940326690673828,
        -0.9794108271598816
      ],
      "plane_d": 1547.123779296875,
      "bbox_min": [
        -1846.841796875,
        -3678.108154296875,
        955.1777954101562
      ],
      "bbox_max": [
        -1840.19091796875,
        -3671.415771484375,
        957.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06604354083538055,
        0.20556071400642395,
        -0.976413369178772
      ],
      "plane_d": 1567.64208984375,
      "bbox_min": [
        -1843.654296875,
        -3678.108154296875,
        955.1777954101562
      ],
      "bbox_max": [
        -1840.19091796875,
        -3676.098388671875,
        956.1409301757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14017903804779053,
        0.8745019435882568,
        -0.4643232822418213
      ],
      "plane_d": 3401.90625,
      "bbox_min": [
        -1843.654296875,
        -3678.108154296875,
        955.1777954101562
      ],
      "bbox_max": [
        -1840.19091796875,
        -3677.647216796875,
        955.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16106444597244263,
        0.10441973805427551,
        -0.9814044237136841
      ],
      "plane_d": 1025.4835205078125,
      "bbox_min": [
        -1856.9429931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3669.7900390625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4851413369178772,
        0.7334008812904358,
        -0.4761944115161896
      ],
      "plane_d": 2258.27734375,
      "bbox_min": [
        -1851.6929931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3669.7900390625,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14017903804779053,
        0.8745019435882568,
        -0.4643232822418213
      ],
      "plane_d": 3401.90625,
      "bbox_min": [
        -1843.654296875,
        -3680.3271484375,
        949.9010009765625
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3677.923095703125,
        955.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14164398610591888,
        0.8754680752754211,
        -0.4620526134967804
      ],
      "plane_d": 3400.602294921875,
      "bbox_min": [
        -1842.591796875,
        -3680.3271484375,
        949.9010009765625
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3679.052734375,
        952.837158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10260345786809921,
        0.8797172904014587,
        0.46429523825645447
      ],
      "plane_d": 2606.872314453125,
      "bbox_min": [
        -1842.591796875,
        -3680.3271484375,
        949.9010009765625
      ],
      "bbox_max": [
        -1839.0008544921875,
        -3679.177734375,
        951.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4646017253398895,
        0.7279523611068726,
        -0.5042128562927246
      ],
      "plane_d": 2302.88720703125,
      "bbox_min": [
        -1851.6929931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.4068603515625,
        -3669.7900390625,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37302693724632263,
        0.7941912412643433,
        0.4796992838382721
      ],
      "plane_d": 1779.17333984375,
      "bbox_min": [
        -1851.6929931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1839.4068603515625,
        -3669.7900390625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10592427849769592,
        0.8816924095153809,
        0.45978105068206787
      ],
      "plane_d": 2612.31689453125,
      "bbox_min": [
        -1843.654296875,
        -3680.3271484375,
        946.5458984375
      ],
      "bbox_max": [
        -1839.4068603515625,
        -3676.65478515625,
        951.375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.008490041829645634,
        0.20600305497646332,
        0.9785144925117493
      ],
      "plane_d": -153.1766357421875,
      "bbox_min": [
        -1843.654296875,
        -3678.108154296875,
        946.5458984375
      ],
      "bbox_max": [
        -1840.36328125,
        -3676.65478515625,
        946.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36008092761039734,
        0.7924860715866089,
        0.49224749207496643
      ],
      "plane_d": 1784.8876953125,
      "bbox_min": [
        -1851.6929931640625,
        -3684.45947265625,
        945.3059692382812
      ],
      "bbox_max": [
        -1840.9832763671875,
        -3669.7900390625,
        952.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.002867229515686631,
        0.21853896975517273,
        0.9758239984512329
      ],
      "plane_d": -125.45957946777344,
      "bbox_min": [
        -1846.841796875,
        -3678.108154296875,
        945.3059692382812
      ],
      "bbox_max": [
        -1840.9832763671875,
        -3669.7900390625,
        946.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.008490041829645634,
        0.20600305497646332,
        0.9785144925117493
      ],
      "plane_d": -153.1766357421875,
      "bbox_min": [
        -1843.654296875,
        -3678.108154296875,
        946.4317626953125
      ],
      "bbox_max": [
        -1840.9832763671875,
        -3676.098388671875,
        946.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.028696101158857346,
        0.000738015107344836,
        0.999587893486023
      ],
      "plane_d": -889.2786254882812,
      "bbox_min": [
        -1846.841796875,
        -3671.4521484375,
        945.3059692382812
      ],
      "bbox_max": [
        -1844.4464111328125,
        -3669.7900390625,
        945.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.831855297088623,
        -0.449511855840683,
        -0.32550859451293945
      ],
      "plane_d": 153.4979248046875,
      "bbox_min": [
        -1884.2122802734375,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3668.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7573050856590271,
        -0.5075263977050781,
        0.41098156571388245
      ],
      "plane_d": -842.2171630859375,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        946.5
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3668.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7341459393501282,
        -0.46688032150268555,
        0.49300357699394226
      ],
      "plane_d": -813.911376953125,
      "bbox_min": [
        -1880.5872802734375,
        -3693.0478515625,
        948.0
      ],
      "bbox_max": [
        -1862.1929931640625,
        -3668.45947265625,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7033767104148865,
        -0.5065484642982483,
        -0.49866804480552673
      ],
      "plane_d": -72.217041015625,
      "bbox_min": [
        -1880.5872802734375,
        -3693.0478515625,
        952.5
      ],
      "bbox_max": [
        -1863.738037109375,
        -3668.45947265625,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7033767104148865,
        -0.5065484642982483,
        -0.49866804480552673
      ],
      "plane_d": -72.217041015625,
      "bbox_min": [
        -1880.5872802734375,
        -3693.0478515625,
        953.0270385742188
      ],
      "bbox_max": [
        -1862.1929931640625,
        -3668.693603515625,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21941733360290527,
        -0.10816661268472672,
        0.9696165323257446
      ],
      "plane_d": -907.966796875,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        946.5
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3670.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19372406601905823,
        -0.07503696531057358,
        0.9781821370124817
      ],
      "plane_d": -841.9852294921875,
      "bbox_min": [
        -1879.0247802734375,
        -3694.3603515625,
        946.5
      ],
      "bbox_max": [
        -1856.9429931640625,
        -3670.45947265625,
        949.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15247976779937744,
        -0.18809275329113007,
        -0.9702427387237549
      ],
      "plane_d": 521.6085205078125,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        946.5
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3670.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11651720106601715,
        -0.14373081922531128,
        -0.9827335476875305
      ],
      "plane_d": 629.8953857421875,
      "bbox_min": [
        -1879.0247802734375,
        -3694.3603515625,
        957.0
      ],
      "bbox_max": [
        -1856.9429931640625,
        -3670.45947265625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18666328489780426,
        0.08143047988414764,
        -0.9790433645248413
      ],
      "plane_d": 891.1658935546875,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        946.5
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3676.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10658156126737595,
        0.15238070487976074,
        0.9825581908226013
      ],
      "plane_d": -567.6856689453125,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        946.5
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3676.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21120956540107727,
        0.11818646639585495,
        -0.9702692627906799
      ],
      "plane_d": 972.6693115234375,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        948.0
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3682.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14092786610126495,
        0.20148597657680511,
        0.9693002104759216
      ],
      "plane_d": -437.8878173828125,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        948.0
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3682.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6579570770263672,
        0.5591762661933899,
        -0.5043950080871582
      ],
      "plane_d": 1323.5155029296875,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        948.0
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3682.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6761533617973328,
        0.6102749705314636,
        -0.4127723276615143
      ],
      "plane_d": 1390.8538818359375,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        948.0
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3682.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.658704936504364,
        0.6293858289718628,
        0.4122878611087799
      ],
      "plane_d": 707.1195068359375,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        948.0
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3682.45947265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6040904521942139,
        0.6141218543052673,
        0.507867157459259
      ],
      "plane_d": 661.4307861328125,
      "bbox_min": [
        -1868.0872802734375,
        -3703.5478515625,
        948.0
      ],
      "bbox_max": [
        -1849.9429931640625,
        -3682.45947265625,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8856325149536133,
        -0.23562699556350708,
        0.4001688063144684
      ],
      "plane_d": 413.56640625,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        948.0
      ],
      "bbox_max": [
        -1868.0872802734375,
        -3693.0478515625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8964121341705322,
        -0.23059570789337158,
        0.3785112798213959
      ],
      "plane_d": 473.0804443359375,
      "bbox_min": [
        -1882.0594482421875,
        -3704.2421875,
        949.4639282226562
      ],
      "bbox_max": [
        -1878.9119873046875,
        -3693.0478515625,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3160931169986725,
        0.014925786294043064,
        0.9486107230186462
      ],
      "plane_d": -251.61785888671875,
      "bbox_min": [
        -1882.0594482421875,
        -3704.2421875,
        949.4639282226562
      ],
      "bbox_max": [
        -1878.9119873046875,
        -3694.3603515625,
        950.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3160931169986725,
        0.014925786294043064,
        0.9486107230186462
      ],
      "plane_d": -251.61785888671875,
      "bbox_min": [
        -1882.0594482421875,
        -3704.2421875,
        948.0
      ],
      "bbox_max": [
        -1874.3372802734375,
        -3694.455078125,
        950.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3160931169986725,
        0.014925775118172169,
        -0.948610782623291
      ],
      "plane_d": 1558.33154296875,
      "bbox_min": [
        -1882.0594482421875,
        -3704.2421875,
        957.3333129882812
      ],
      "bbox_max": [
        -1878.911865234375,
        -3694.3603515625,
        958.5361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3160931169986725,
        0.014925775118172169,
        -0.948610782623291
      ],
      "plane_d": 1558.33154296875,
      "bbox_min": [
        -1882.0594482421875,
        -3704.2421875,
        957.3333129882812
      ],
      "bbox_max": [
        -1874.3372802734375,
        -3694.455322265625,
        960.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.627183735370636,
        0.6617406010627747,
        -0.41077977418899536
      ],
      "plane_d": 1671.0379638671875,
      "bbox_min": [
        -1876.3372802734375,
        -3709.2978515625,
        957.2877807617188
      ],
      "bbox_max": [
        -1869.2288818359375,
        -3702.2353515625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.627183735370636,
        0.6617406010627747,
        -0.41077977418899536
      ],
      "plane_d": 1671.0379638671875,
      "bbox_min": [
        -1876.3372802734375,
        -3709.2978515625,
        954.0
      ],
      "bbox_max": [
        -1868.0872802734375,
        -3702.5888671875,
        957.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6271836757659912,
        0.6617405414581299,
        0.41077980399131775
      ],
      "plane_d": 887.27001953125,
      "bbox_min": [
        -1876.3372802734375,
        -3709.2978515625,
        949.5
      ],
      "bbox_max": [
        -1869.2288818359375,
        -3702.2353515625,
        950.7120361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6271836757659912,
        0.6617405414581299,
        0.41077980399131775
      ],
      "plane_d": 887.27001953125,
      "bbox_min": [
        -1876.3372802734375,
        -3709.2978515625,
        950.6666870117188
      ],
      "bbox_max": [
        -1868.0872802734375,
        -3702.5888671875,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10685895383358002,
        0.7836322784423828,
        -0.6119654178619385
      ],
      "plane_d": 3292.646240234375,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        949.5
      ],
      "bbox_max": [
        -1876.3372802734375,
        -3704.2421875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10685895383358002,
        0.7836322784423828,
        0.6119654178619385
      ],
      "plane_d": 2125.016357421875,
      "bbox_min": [
        -1884.2122802734375,
        -3713.5478515625,
        949.5
      ],
      "bbox_max": [
        -1876.3372802734375,
        -3704.2421875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209666013717651,
        0.05256105959415436,
        -0.5685518980026245
      ],
      "plane_d": 2284.1005859375,
      "bbox_min": [
        -1884.2122802734375,
        -3712.7978515625,
        949.5
      ],
      "bbox_max": [
        -1876.3372802734375,
        -3704.2421875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209666013717651,
        0.05256105959415436,
        0.5685518980026245
      ],
      "plane_d": 1199.303466796875,
      "bbox_min": [
        -1884.2122802734375,
        -3712.7978515625,
        949.5
      ],
      "bbox_max": [
        -1876.3372802734375,
        -3704.2421875,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23709455132484436,
        0.7130553722381592,
        -0.659801721572876
      ],
      "plane_d": 2831.715576171875,
      "bbox_min": [
        -1880.8997802734375,
        -3712.7978515625,
        949.5
      ],
      "bbox_max": [
        -1876.3372802734375,
        -3709.2978515625,
        958.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23709455132484436,
        0.7130553722381592,
        0.659801721572876
      ],
      "plane_d": 1572.8140869140625,
      "bbox_min": [
        -1880.8997802734375,
        -3712.7978515625,
        949.5
      ],
      "bbox_max": [
        -1876.3372802734375,
        -3709.2978515625,
        954.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314961194992065,
        -0.4493333399295807,
        -0.32667070627212524
      ],
      "plane_d": 154.5902099609375,
      "bbox_min": [
        -1850.0635986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        944.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9055700302124023,
        -0.290523886680603,
        0.3090933561325073
      ],
      "plane_d": 294.33154296875,
      "bbox_min": [
        -1850.0635986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        944.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958713412284851,
        -0.2870465815067291,
        0.3391439914703369
      ],
      "plane_d": 261.64306640625,
      "bbox_min": [
        -1850.0635986328125,
        -3759.229736328125,
        926.25
      ],
      "bbox_max": [
        -1838.0635986328125,
        -3730.729736328125,
        934.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4396478235721588,
        0.08157564699649811,
        0.8944581151008606
      ],
      "plane_d": 290.05767822265625,
      "bbox_min": [
        -1847.3135986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        944.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3228292763233185,
        0.19248870015144348,
        0.9266764521598816
      ],
      "plane_d": 461.35247802734375,
      "bbox_min": [
        -1847.3135986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        944.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1107582375407219,
        -0.3274669647216797,
        -0.9383485913276672
      ],
      "plane_d": -142.55264282226562,
      "bbox_min": [
        -1847.3135986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        944.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20640511810779572,
        -0.3944646120071411,
        -0.8954298496246338
      ],
      "plane_d": -258.14910888671875,
      "bbox_min": [
        -1847.3135986328125,
        -3761.123291015625,
        936.5
      ],
      "bbox_max": [
        -1829.8135986328125,
        -3737.729736328125,
        944.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4641743004322052,
        -0.1186302974820137,
        -0.8777636885643005
      ],
      "plane_d": -470.7347412109375,
      "bbox_min": [
        -1839.0635986328125,
        -3761.123291015625,
        936.5
      ],
      "bbox_max": [
        -1829.8135986328125,
        -3737.729736328125,
        944.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3288135826587677,
        -0.25511324405670166,
        -0.909284770488739
      ],
      "plane_d": -705.3016357421875,
      "bbox_min": [
        -1839.0635986328125,
        -3761.123291015625,
        942.6824340820312
      ],
      "bbox_max": [
        -1836.4071044921875,
        -3757.67529296875,
        944.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08256905525922775,
        0.35685989260673523,
        0.9305016994476318
      ],
      "plane_d": 330.4202880859375,
      "bbox_min": [
        -1839.0635986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        943.82763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19332484900951385,
        0.4372062385082245,
        0.8783372044563293
      ],
      "plane_d": 477.09423828125,
      "bbox_min": [
        -1839.0635986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        943.82763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4641743004322052,
        -0.1186302974820137,
        -0.8777636885643005
      ],
      "plane_d": -470.7347412109375,
      "bbox_min": [
        -1838.0635986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        943.82763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181568622589111,
        0.20089106261730194,
        -0.34151241183280945
      ],
      "plane_d": -603.492431640625,
      "bbox_min": [
        -1830.8135986328125,
        -3762.3564453125,
        933.9375
      ],
      "bbox_max": [
        -1823.6260986328125,
        -3742.979736328125,
        941.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.833058774471283,
        0.44617074728012085,
        0.3270239531993866
      ],
      "plane_d": -149.586669921875,
      "bbox_min": [
        -1838.0635986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3727.729736328125,
        939.988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8336049318313599,
        0.4464282691478729,
        0.32527607679367065
      ],
      "plane_d": -147.998291015625,
      "bbox_min": [
        -1830.8135986328125,
        -3762.229736328125,
        917.91845703125
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3736.9794921875,
        926.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7331662178039551,
        0.593595564365387,
        0.33183059096336365
      ],
      "plane_d": 579.988037109375,
      "bbox_min": [
        -1823.6260986328125,
        -3744.729736328125,
        917.9323120117188
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3736.988037109375,
        926.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7487927079200745,
        0.4994327425956726,
        0.43574824929237366
      ],
      "plane_d": 103.586669921875,
      "bbox_min": [
        -1823.6260986328125,
        -3744.729736328125,
        917.9323120117188
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3736.988037109375,
        926.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.870718777179718,
        0.32211777567863464,
        -0.3716030716896057
      ],
      "plane_d": -35.628173828125,
      "bbox_min": [
        -1823.6260986328125,
        -3744.729736328125,
        917.9323120117188
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3736.988037109375,
        926.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9134572148323059,
        -0.19181375205516815,
        0.358892023563385
      ],
      "plane_d": -2709.7919921875,
      "bbox_min": [
        -1823.6260986328125,
        -3742.979736328125,
        917.9323120117188
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3736.988037109375,
        923.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8612866401672363,
        -0.24392488598823547,
        0.445742130279541
      ],
      "plane_d": -2889.37451171875,
      "bbox_min": [
        -1820.7025146484375,
        -3738.729736328125,
        918.3333129882812
      ],
      "bbox_max": [
        -1818.0635986328125,
        -3736.988037109375,
        923.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22998371720314026,
        0.19438722729682922,
        0.953583300113678
      ],
      "plane_d": -567.7427368164062,
      "bbox_min": [
        -1823.6260986328125,
        -3742.979736328125,
        917.9323120117188
      ],
      "bbox_max": [
        -1820.7025146484375,
        -3737.648681640625,
        918.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20047497749328613,
        0.3961786925792694,
        0.8960203528404236
      ],
      "plane_d": 293.22235107421875,
      "bbox_min": [
        -1821.29736328125,
        -3738.396484375,
        917.9323120117188
      ],
      "bbox_max": [
        -1820.7025146484375,
        -3737.648681640625,
        918.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.87058025598526,
        -0.3589896261692047,
        -0.33647671341896057
      ],
      "plane_d": -2614.283203125,
      "bbox_min": [
        -1823.64013671875,
        -3742.979736328125,
        917.91845703125
      ],
      "bbox_max": [
        -1818.685546875,
        -3736.9794921875,
        925.0186767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8612866401672363,
        -0.24392488598823547,
        0.445742130279541
      ],
      "plane_d": -2889.37451171875,
      "bbox_min": [
        -1820.6868896484375,
        -3737.645751953125,
        918.7744750976562
      ],
      "bbox_max": [
        -1818.685546875,
        -3736.9794921875,
        923.001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22998371720314026,
        0.19438722729682922,
        0.953583300113678
      ],
      "plane_d": -567.7427368164062,
      "bbox_min": [
        -1823.64013671875,
        -3742.979736328125,
        917.91845703125
      ],
      "bbox_max": [
        -1821.01708984375,
        -3737.622802734375,
        918.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20047497749328613,
        0.3961786925792694,
        0.8960203528404236
      ],
      "plane_d": 293.22235107421875,
      "bbox_min": [
        -1821.317138671875,
        -3738.35302734375,
        917.91845703125
      ],
      "bbox_max": [
        -1821.01708984375,
        -3737.622802734375,
        918.1809692382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9326850175857544,
        0.20486170053482056,
        -0.2968677580356598
      ],
      "plane_d": -656.819580078125,
      "bbox_min": [
        -1838.0635986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.6885986328125,
        -3727.729736328125,
        939.988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.904798686504364,
        0.2926294803619385,
        -0.30936571955680847
      ],
      "plane_d": -265.7801513671875,
      "bbox_min": [
        -1823.6260986328125,
        -3744.729736328125,
        922.8179321289062
      ],
      "bbox_max": [
        -1818.6885986328125,
        -3736.75732421875,
        933.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.870718777179718,
        0.32211777567863464,
        -0.3716030716896057
      ],
      "plane_d": -35.628173828125,
      "bbox_min": [
        -1821.5635986328125,
        -3744.729736328125,
        924.3258666992188
      ],
      "bbox_max": [
        -1818.7518310546875,
        -3738.0693359375,
        929.7222290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.87058025598526,
        -0.3589896261692047,
        -0.33647671341896057
      ],
      "plane_d": -2614.283203125,
      "bbox_min": [
        -1820.7025146484375,
        -3738.638671875,
        924.3258666992188
      ],
      "bbox_max": [
        -1818.7518310546875,
        -3738.0693359375,
        929.7222290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.903721034526825,
        -0.31097275018692017,
        -0.2942519783973694
      ],
      "plane_d": -2534.3740234375,
      "bbox_min": [
        -1823.6260986328125,
        -3742.979736328125,
        922.8179321289062
      ],
      "bbox_max": [
        -1818.6885986328125,
        -3736.75732421875,
        933.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.87058025598526,
        -0.3589896261692047,
        -0.33647671341896057
      ],
      "plane_d": -2614.283203125,
      "bbox_min": [
        -1820.7025146484375,
        -3738.396484375,
        922.8179321289062
      ],
      "bbox_max": [
        -1818.6885986328125,
        -3736.75732421875,
        929.7222290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8612866401672363,
        -0.24392488598823547,
        0.445742130279541
      ],
      "plane_d": -2889.37451171875,
      "bbox_min": [
        -1818.77490234375,
        -3737.00732421875,
        922.8179321289062
      ],
      "bbox_max": [
        -1818.6885986328125,
        -3736.75732421875,
        923.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5806518197059631,
        -0.3186589181423187,
        -0.7491995096206665
      ],
      "plane_d": -1551.920166015625,
      "bbox_min": [
        -1823.6260986328125,
        -3742.979736328125,
        929.7222290039062
      ],
      "bbox_max": [
        -1820.7025146484375,
        -3737.37939453125,
        933.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5986526608467102,
        -0.06404326856136322,
        -0.7984445095062256
      ],
      "plane_d": -587.055908203125,
      "bbox_min": [
        -1821.4404296875,
        -3738.396484375,
        929.7222290039062
      ],
      "bbox_max": [
        -1820.7025146484375,
        -3737.37939453125,
        930.2711791992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181568622589111,
        0.20089106261730194,
        -0.34151241183280945
      ],
      "plane_d": -603.492431640625,
      "bbox_min": [
        -1838.0635986328125,
        -3762.729736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3727.729736328125,
        939.988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5986526608467102,
        -0.06404326856136322,
        -0.7984445095062256
      ],
      "plane_d": -587.055908203125,
      "bbox_min": [
        -1838.0635986328125,
        -3742.979736328125,
        915.5625
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3727.729736328125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5806518197059631,
        -0.3186589181423187,
        -0.7491995096206665
      ],
      "plane_d": -1551.920166015625,
      "bbox_min": [
        -1829.8135986328125,
        -3742.979736328125,
        930.2711791992188
      ],
      "bbox_max": [
        -1821.4404296875,
        -3737.729736328125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27155154943466187,
        -0.3307728171348572,
        0.9037970304489136
      ],
      "plane_d": -1567.3287353515625,
      "bbox_min": [
        -1838.0635986328125,
        -3742.9677734375,
        915.5625
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3727.729736328125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11945869028568268,
        -0.318240225315094,
        0.9404534697532654
      ],
      "plane_d": -1832.3642578125,
      "bbox_min": [
        -1836.0010986328125,
        -3737.729736328125,
        916.0
      ],
      "bbox_max": [
        -1828.64697265625,
        -3730.396484375,
        918.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16348996758460999,
        -0.9204438924789429,
        -0.35504111647605896
      ],
      "plane_d": -2804.565673828125,
      "bbox_min": [
        -1838.0635986328125,
        -3742.9677734375,
        915.5625
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3727.729736328125,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12703198194503784,
        -0.9592365026473999,
        -0.2524445354938507
      ],
      "plane_d": -3111.33251953125,
      "bbox_min": [
        -1838.0635986328125,
        -3733.311279296875,
        926.25
      ],
      "bbox_max": [
        -1828.64697265625,
        -3730.396484375,
        934.3433837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23860684037208557,
        -0.6383978128433228,
        -0.7317888736724854
      ],
      "plane_d": -2137.4443359375,
      "bbox_min": [
        -1836.0010986328125,
        -3733.311279296875,
        929.7222290039062
      ],
      "bbox_max": [
        -1828.64697265625,
        -3730.396484375,
        934.3433837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23860684037208557,
        -0.6383978128433228,
        -0.7317888736724854
      ],
      "plane_d": -2137.4443359375,
      "bbox_min": [
        -1835.0211181640625,
        -3737.729736328125,
        929.7222290039062
      ],
      "bbox_max": [
        -1828.64697265625,
        -3730.396484375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.297308087348938,
        -0.9045224785804749,
        0.30569103360176086
      ],
      "plane_d": -4198.62548828125,
      "bbox_min": [
        -1829.8135986328125,
        -3742.9677734375,
        915.5625
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3727.729736328125,
        930.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3704715967178345,
        -0.7843051552772522,
        0.4976103901863098
      ],
      "plane_d": -4060.203125,
      "bbox_min": [
        -1828.64697265625,
        -3731.729736328125,
        918.3333129882812
      ],
      "bbox_max": [
        -1820.5635986328125,
        -3727.729736328125,
        923.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20047497749328613,
        0.3961786925792694,
        0.8960203528404236
      ],
      "plane_d": 293.22235107421875,
      "bbox_min": [
        -1829.8135986328125,
        -3742.9677734375,
        915.5625
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3731.729736328125,
        930.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22998371720314026,
        0.19438722729682922,
        0.953583300113678
      ],
      "plane_d": -567.7427368164062,
      "bbox_min": [
        -1829.8135986328125,
        -3742.9677734375,
        916.0
      ],
      "bbox_max": [
        -1821.317138671875,
        -3737.729736328125,
        918.5567016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.87058025598526,
        -0.3589896261692047,
        -0.33647671341896057
      ],
      "plane_d": -2614.283203125,
      "bbox_min": [
        -1822.8760986328125,
        -3737.622802734375,
        915.5625
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3731.729736328125,
        930.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.903721034526825,
        -0.31097275018692017,
        -0.2942519783973694
      ],
      "plane_d": -2534.3740234375,
      "bbox_min": [
        -1822.8760986328125,
        -3737.37939453125,
        922.25
      ],
      "bbox_max": [
        -1820.5635986328125,
        -3731.729736328125,
        930.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9134572148323059,
        -0.19181375205516815,
        0.358892023563385
      ],
      "plane_d": -2709.7919921875,
      "bbox_min": [
        -1822.8760986328125,
        -3737.622802734375,
        915.5625
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3731.729736328125,
        922.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8612866401672363,
        -0.24392488598823547,
        0.445742130279541
      ],
      "plane_d": -2889.37451171875,
      "bbox_min": [
        -1820.6864013671875,
        -3737.62255859375,
        918.7880249023438
      ],
      "bbox_max": [
        -1818.7679443359375,
        -3731.729736328125,
        922.96826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027478098869324,
        0.3052692115306854,
        0.3030792772769928
      ],
      "plane_d": 2534.41357421875,
      "bbox_min": [
        -1850.0635986328125,
        -3786.161376953125,
        926.5597534179688
      ],
      "bbox_max": [
        -1840.7244873046875,
        -3758.729736328125,
        934.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33408603072166443,
        0.3278310000896454,
        0.8836929798126221
      ],
      "plane_d": 1030.7568359375,
      "bbox_min": [
        -1847.3135986328125,
        -3786.161376953125,
        926.5597534179688
      ],
      "bbox_max": [
        -1840.7244873046875,
        -3759.229736328125,
        934.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9342950582504272,
        0.14731967449188232,
        -0.32463762164115906
      ],
      "plane_d": 2585.53271484375,
      "bbox_min": [
        -1850.0635986328125,
        -3787.161376953125,
        934.25
      ],
      "bbox_max": [
        -1842.9744873046875,
        -3758.729736328125,
        941.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33408603072166443,
        0.3278310000896454,
        0.8836929798126221
      ],
      "plane_d": 1030.7568359375,
      "bbox_min": [
        -1847.3135986328125,
        -3786.161376953125,
        924.0
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3759.229736328125,
        952.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2572098970413208,
        -0.20033776760101318,
        -0.9453612565994263
      ],
      "plane_d": 612.5028076171875,
      "bbox_min": [
        -1847.3135986328125,
        -3786.161376953125,
        924.0
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3759.229736328125,
        952.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4239461123943329,
        -0.19921784102916718,
        -0.8835054636001587
      ],
      "plane_d": 864.9302978515625,
      "bbox_min": [
        -1840.7244873046875,
        -3786.161376953125,
        944.5
      ],
      "bbox_max": [
        -1831.531982421875,
        -3760.729736328125,
        952.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3361071050167084,
        -0.3663517236709595,
        -0.867651104927063
      ],
      "plane_d": -1176.375732421875,
      "bbox_min": [
        -1839.0635986328125,
        -3783.161376953125,
        944.5
      ],
      "bbox_max": [
        -1831.531982421875,
        -3760.729736328125,
        952.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15992137789726257,
        -0.40797024965286255,
        -0.8988800048828125
      ],
      "plane_d": -980.9752197265625,
      "bbox_min": [
        -1833.9744873046875,
        -3783.161376953125,
        949.8875732421875
      ],
      "bbox_max": [
        -1831.531982421875,
        -3778.767333984375,
        952.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24365054070949554,
        0.2573694586753845,
        0.9350911378860474
      ],
      "plane_d": -344.21612548828125,
      "bbox_min": [
        -1839.0635986328125,
        -3783.161376953125,
        924.0
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3760.729736328125,
        951.07275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4439326822757721,
        0.26868146657943726,
        0.8548297882080078
      ],
      "plane_d": -593.9697875976562,
      "bbox_min": [
        -1839.0635986328125,
        -3783.161376953125,
        926.5625
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3760.729736328125,
        951.07275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9016774892807007,
        -0.30759042501449585,
        -0.30391737818717957
      ],
      "plane_d": -2521.758056640625,
      "bbox_min": [
        -1839.0635986328125,
        -3782.07568359375,
        926.5625
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3760.729736328125,
        951.07275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3361071050167084,
        -0.3663517236709595,
        -0.867651104927063
      ],
      "plane_d": -1176.375732421875,
      "bbox_min": [
        -1839.0635986328125,
        -3782.07568359375,
        926.5625
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3760.729736328125,
        951.07275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15992137789726257,
        -0.40797024965286255,
        -0.8988800048828125
      ],
      "plane_d": -980.9752197265625,
      "bbox_min": [
        -1833.3109130859375,
        -3782.07568359375,
        941.9375
      ],
      "bbox_max": [
        -1827.2244873046875,
        -3762.229736328125,
        951.07275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9414464235305786,
        -0.04890691488981247,
        0.3335966467857361
      ],
      "plane_d": -2216.710205078125,
      "bbox_min": [
        -1830.8135986328125,
        -3780.161376953125,
        926.5625
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3762.229736328125,
        941.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9020489454269409,
        -0.30773234367370605,
        -0.3026690185070038
      ],
      "plane_d": -2524.14794921875,
      "bbox_min": [
        -1830.8135986328125,
        -3780.161376953125,
        934.0625
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3762.229736328125,
        941.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9568365812301636,
        -0.04914053529500961,
        0.28644198179244995
      ],
      "plane_d": -2201.6689453125,
      "bbox_min": [
        -1828.0635986328125,
        -3780.161376953125,
        934.0625
      ],
      "bbox_max": [
        -1824.9744873046875,
        -3762.729736328125,
        941.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.586943507194519,
        -0.809627890586853,
        0.0
      ],
      "plane_d": -2030.0614013671875,
      "bbox_min": [
        -1835.29150390625,
        -3836.97802734375,
        799.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3782.575927734375,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1835.29150390625,
        -3818.11865234375,
        816.0
      ],
      "bbox_max": [
        -1799.21533203125,
        -3782.575927734375,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1808.0,
        -3818.11865234375,
        816.0
      ],
      "bbox_max": [
        -1799.21533203125,
        -3811.75,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36573904752731323,
        0.02829245664179325,
        0.9302873015403748
      ],
      "plane_d": -1430.28369140625,
      "bbox_min": [
        -1835.29150390625,
        -3784.4990234375,
        931.5
      ],
      "bbox_max": [
        -1832.657470703125,
        -3782.575927734375,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13020363450050354,
        0.45811501145362854,
        0.8793051838874817
      ],
      "plane_d": 1152.84033203125,
      "bbox_min": [
        -1835.29150390625,
        -3784.4990234375,
        931.5
      ],
      "bbox_max": [
        -1832.80615234375,
        -3783.161376953125,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15324726700782776,
        0.46064797043800354,
        0.8742532730102539
      ],
      "plane_d": 1209.39013671875,
      "bbox_min": [
        -1833.9744873046875,
        -3784.4990234375,
        931.5
      ],
      "bbox_max": [
        -1832.80615234375,
        -3783.161376953125,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8258160948753357,
        -0.5639395713806152,
        0.0
      ],
      "plane_d": -661.0687255859375,
      "bbox_min": [
        -1815.8687744140625,
        -3836.97802734375,
        799.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3805.336669921875,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1808.0,
        -3819.813720703125,
        816.0
      ],
      "bbox_max": [
        -1805.7073974609375,
        -3816.45654296875,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9923036098480225,
        -0.12382844090461731,
        0.0
      ],
      "plane_d": -2240.543212890625,
      "bbox_min": [
        -1815.8687744140625,
        -3836.97802734375,
        799.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3805.336669921875,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.575560986995697,
        -0.8177589178085327,
        0.0
      ],
      "plane_d": -4142.314453125,
      "bbox_min": [
        -1815.8687744140625,
        -3836.97802734375,
        799.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3805.336669921875,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6003345847129822,
        0.799748957157135,
        -0.0
      ],
      "plane_d": 4154.236328125,
      "bbox_min": [
        -1815.8687744140625,
        -3836.97802734375,
        799.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3805.336669921875,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44340404868125916,
        0.8963219523429871,
        0.0
      ],
      "plane_d": 2642.78125,
      "bbox_min": [
        -1815.8687744140625,
        -3836.97802734375,
        799.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3805.336669921875,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1790.053466796875,
        -3834.0,
        816.0
      ],
      "bbox_max": [
        -1784.0,
        -3831.00537109375,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1790.053466796875,
        -3834.0,
        817.5
      ],
      "bbox_max": [
        -1784.0,
        -3831.00537109375,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.895645022392273,
        0.4447697103023529,
        0.0
      ],
      "plane_d": 105.4088134765625,
      "bbox_min": [
        -1815.8687744140625,
        -3836.97802734375,
        799.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3805.336669921875,
        932.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1785.0,
        -3831.5,
        816.0
      ],
      "bbox_max": [
        -1784.0,
        -3829.486328125,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1808.0,
        -3834.0,
        816.0
      ],
      "bbox_max": [
        -1791.05419921875,
        -3811.75,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1806.6060791015625,
        -3834.0,
        816.0
      ],
      "bbox_max": [
        -1789.9801025390625,
        -3825.902587890625,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1806.6060791015625,
        -3834.0,
        817.5
      ],
      "bbox_max": [
        -1790.6312255859375,
        -3826.072021484375,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1798.3004150390625,
        -3822.01025390625,
        816.0
      ],
      "bbox_max": [
        -1784.0,
        -3811.75,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1794.0501708984375,
        -3826.17626953125,
        816.0
      ],
      "bbox_max": [
        -1784.0,
        -3811.75,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1791.953369140625,
        -3833.963623046875,
        816.0
      ],
      "bbox_max": [
        -1784.0,
        -3820.278076171875,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1791.953369140625,
        -3833.963623046875,
        816.0
      ],
      "bbox_max": [
        -1784.0,
        -3820.57861328125,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0600874088704586,
        0.9810517430305481,
        0.18419286608695984
      ],
      "plane_d": 3496.47216796875,
      "bbox_min": [
        -1808.353515625,
        -3836.97802734375,
        799.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3818.672607421875,
        864.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1799.0528564453125,
        -3834.0,
        816.0
      ],
      "bbox_max": [
        -1789.94775390625,
        -3826.9130859375,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1793.187744140625,
        -3827.30712890625,
        816.0
      ],
      "bbox_max": [
        -1790.7933349609375,
        -3823.73388671875,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -817.5,
      "bbox_min": [
        -1795.08740234375,
        -3827.433837890625,
        816.0
      ],
      "bbox_max": [
        -1792.40673828125,
        -3825.945556640625,
        817.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -816.0,
      "bbox_min": [
        -1800.718994140625,
        -3827.3779296875,
        816.0
      ],
      "bbox_max": [
        -1791.5572509765625,
        -3819.102783203125,
        816.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6480280160903931,
        0.7261329889297485,
        0.22976233065128326
      ],
      "plane_d": 3727.9033203125,
      "bbox_min": [
        -1842.9744873046875,
        -3798.024658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        959.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6487107872962952,
        0.7069293856620789,
        0.28182485699653625
      ],
      "plane_d": 3607.404541015625,
      "bbox_min": [
        -1842.9744873046875,
        -3798.024658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        959.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7893454432487488,
        0.5680246949195862,
        -0.23298463225364685
      ],
      "plane_d": 3824.80517578125,
      "bbox_min": [
        -1842.9744873046875,
        -3798.024658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        959.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7687095403671265,
        0.565635621547699,
        -0.2985667586326599
      ],
      "plane_d": 3840.04052734375,
      "bbox_min": [
        -1842.9744873046875,
        -3798.024658203125,
        941.75
      ],
      "bbox_max": [
        -1832.7962646484375,
        -3786.161376953125,
        949.4375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5857881307601929,
        -0.14790843427181244,
        -0.7968534231185913
      ],
      "plane_d": 1273.363525390625,
      "bbox_min": [
        -1840.7244873046875,
        -3796.649658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        959.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4274039566516876,
        -0.2107067108154297,
        -0.8791635036468506
      ],
      "plane_d": 823.6741333007812,
      "bbox_min": [
        -1840.7244873046875,
        -3796.649658203125,
        949.4375
      ],
      "bbox_max": [
        -1831.0462646484375,
        -3783.161376953125,
        956.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04664308577775955,
        -0.6366621851921082,
        -0.7697309851646423
      ],
      "plane_d": -1590.6470947265625,
      "bbox_min": [
        -1840.7244873046875,
        -3796.649658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        959.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006503463722765446,
        -0.6409716606140137,
        -0.7675369381904602
      ],
      "plane_d": -1706.13134765625,
      "bbox_min": [
        -1833.9744873046875,
        -3792.524658203125,
        949.4375
      ],
      "bbox_max": [
        -1825.7962646484375,
        -3780.161376953125,
        959.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15324726700782776,
        0.46064797043800354,
        0.8742532730102539
      ],
      "plane_d": 1209.39013671875,
      "bbox_min": [
        -1840.7244873046875,
        -3796.649658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        956.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13020363450050354,
        0.45811501145362854,
        0.8793051838874817
      ],
      "plane_d": 1152.84033203125,
      "bbox_min": [
        -1840.7244873046875,
        -3796.649658203125,
        932.0
      ],
      "bbox_max": [
        -1831.0462646484375,
        -3783.746826171875,
        938.09375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8384984731674194,
        -0.4934234619140625,
        0.23120050132274628
      ],
      "plane_d": -3612.6982421875,
      "bbox_min": [
        -1832.80615234375,
        -3792.524658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        956.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.511241614818573,
        0.0061096069402992725,
        0.8594152927398682
      ],
      "plane_d": -1713.8055419921875,
      "bbox_min": [
        -1832.80615234375,
        -3792.524658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        956.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36573904752731323,
        0.02829245664179325,
        0.9302873015403748
      ],
      "plane_d": -1430.28369140625,
      "bbox_min": [
        -1832.80615234375,
        -3792.524658203125,
        932.0
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        956.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6463914513587952,
        -0.7092027068138123,
        -0.2814417779445648
      ],
      "plane_d": -3594.79150390625,
      "bbox_min": [
        -1827.2244873046875,
        -3788.399658203125,
        934.0625
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3779.161376953125,
        956.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6477405428886414,
        -0.7263942956924438,
        -0.22974686324596405
      ],
      "plane_d": -3711.32470703125,
      "bbox_min": [
        -1827.2244873046875,
        -3788.399658203125,
        947.375
      ],
      "bbox_max": [
        -1818.7962646484375,
        -3780.161376953125,
        956.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8074427247047424,
        -0.5066489577293396,
        0.30223023891448975
      ],
      "plane_d": -3672.89599609375,
      "bbox_min": [
        -1827.2244873046875,
        -3788.399658203125,
        934.0625
      ],
      "bbox_max": [
        -1820.5462646484375,
        -3779.161376953125,
        941.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9033649563789368,
        0.4222138822078705,
        -0.07528041303157806
      ],
      "plane_d": 48.6595458984375,
      "bbox_min": [
        -1832.7962646484375,
        -3830.73193359375,
        932.0
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.996049702167511,
        -0.08879745006561279
      ],
      "plane_d": 3881.429931640625,
      "bbox_min": [
        -1817.084716796875,
        -3829.927001953125,
        932.0
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3795.009765625,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9033649563789368,
        -0.4222138822078705,
        -0.07528041303157806
      ],
      "plane_d": 93.2440185546875,
      "bbox_min": [
        -1817.084716796875,
        -3829.927001953125,
        932.0
      ],
      "bbox_max": [
        -1794.38916015625,
        -3808.25341796875,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9033650159835815,
        0.4222138822078705,
        -0.07528042048215866
      ],
      "plane_d": 3312.87841796875,
      "bbox_min": [
        -1817.084716796875,
        -3829.927001953125,
        942.5
      ],
      "bbox_max": [
        -1802.231689453125,
        -3808.25341796875,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.996049702167511,
        -0.08879745006561279
      ],
      "plane_d": -3714.046630859375,
      "bbox_min": [
        -1817.084716796875,
        -3829.927001953125,
        942.5
      ],
      "bbox_max": [
        -1803.7322998046875,
        -3808.986083984375,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9033650159835815,
        -0.4222138822078705,
        -0.07528042048215866
      ],
      "plane_d": -3170.974853515625,
      "bbox_min": [
        -1811.56982421875,
        -3817.3466796875,
        942.5
      ],
      "bbox_max": [
        -1803.7322998046875,
        -3808.986083984375,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6849338412284851,
        0.3491114377975464,
        -0.6395208239555359
      ],
      "plane_d": 721.17822265625,
      "bbox_min": [
        -1810.1939697265625,
        -3816.117431640625,
        977.980712890625
      ],
      "bbox_max": [
        -1803.7322998046875,
        -3808.986083984375,
        985.281982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36472880840301514,
        0.6842003464698792,
        -0.6315399408340454
      ],
      "plane_d": 2570.195068359375,
      "bbox_min": [
        -1810.1939697265625,
        -3816.117431640625,
        978.26171875
      ],
      "bbox_max": [
        -1805.4967041015625,
        -3811.975341796875,
        985.1331787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36472880840301514,
        0.6842003464698792,
        -0.6315399408340454
      ],
      "plane_d": 2570.195068359375,
      "bbox_min": [
        -1811.56982421875,
        -3816.273193359375,
        979.712158203125
      ],
      "bbox_max": [
        -1808.2506103515625,
        -3812.800048828125,
        984.4282836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36472880840301514,
        0.6842003464698792,
        -0.6315399408340454
      ],
      "plane_d": 2570.195068359375,
      "bbox_min": [
        -1817.084716796875,
        -3829.927001953125,
        971.059814453125
      ],
      "bbox_max": [
        -1805.221435546875,
        -3815.963134765625,
        981.4603271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21571679413318634,
        0.5579977631568909,
        -0.8013144135475159
      ],
      "plane_d": 2523.2392578125,
      "bbox_min": [
        -1817.084716796875,
        -3829.927001953125,
        971.059814453125
      ],
      "bbox_max": [
        -1806.4892578125,
        -3818.368408203125,
        976.25634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6849338412284851,
        0.3491114377975464,
        -0.6395208239555359
      ],
      "plane_d": 721.17822265625,
      "bbox_min": [
        -1805.4967041015625,
        -3816.156982421875,
        977.97265625
      ],
      "bbox_max": [
        -1805.221435546875,
        -3815.963134765625,
        978.2617797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6849338412284851,
        0.3491114377975464,
        -0.6395208239555359
      ],
      "plane_d": 721.17822265625,
      "bbox_min": [
        -1805.0771484375,
        -3812.80029296875,
        978.1123046875
      ],
      "bbox_max": [
        -1802.231689453125,
        -3809.327880859375,
        981.4482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7210636138916016,
        -0.49240541458129883,
        0.4874465763568878
      ],
      "plane_d": -1031.5142822265625,
      "bbox_min": [
        -1811.4947509765625,
        -3824.931396484375,
        932.0
      ],
      "bbox_max": [
        -1805.7071533203125,
        -3816.456298828125,
        933.7120361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6849338412284851,
        0.3491114377975464,
        -0.6395208239555359
      ],
      "plane_d": 721.17822265625,
      "bbox_min": [
        -1808.6702880859375,
        -3822.6123046875,
        932.0
      ],
      "bbox_max": [
        -1794.38916015625,
        -3809.61328125,
        978.244873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1804.5697021484375,
        -3817.9013671875,
        975.7308349609375
      ],
      "bbox_max": [
        -1803.2261962890625,
        -3816.839111328125,
        976.804443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1804.5697021484375,
        -3818.743896484375,
        975.3904418945312
      ],
      "bbox_max": [
        -1803.2513427734375,
        -3816.839111328125,
        976.804443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21571679413318634,
        0.5579977631568909,
        -0.8013144135475159
      ],
      "plane_d": 2523.2392578125,
      "bbox_min": [
        -1808.6702880859375,
        -3822.6123046875,
        932.0
      ],
      "bbox_max": [
        -1801.954833984375,
        -3813.55029296875,
        977.9725952148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1804.6414794921875,
        -3819.110107421875,
        975.242431640625
      ],
      "bbox_max": [
        -1804.2200927734375,
        -3816.839111328125,
        976.804443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4949774742126465,
        -0.682770311832428,
        0.5374215841293335
      ],
      "plane_d": -2212.855712890625,
      "bbox_min": [
        -1806.9569091796875,
        -3816.456298828125,
        932.0
      ],
      "bbox_max": [
        -1801.954833984375,
        -3813.55029296875,
        934.0848388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2361481636762619,
        -0.5314380526542664,
        0.8135156035423279
      ],
      "plane_d": -2359.9921875,
      "bbox_min": [
        -1806.9569091796875,
        -3816.456298828125,
        932.0
      ],
      "bbox_max": [
        -1802.954833984375,
        -3813.55029296875,
        934.0848388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6849338412284851,
        0.3491114377975464,
        -0.6395208239555359
      ],
      "plane_d": 721.17822265625,
      "bbox_min": [
        -1808.4825439453125,
        -3810.19775390625,
        965.967041015625
      ],
      "bbox_max": [
        -1789.7308349609375,
        -3801.03759765625,
        985.2825927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5316759943962097,
        0.17712247371673584,
        -0.8282198905944824
      ],
      "plane_d": 525.6104736328125,
      "bbox_min": [
        -1799.21240234375,
        -3810.19775390625,
        966.9677734375
      ],
      "bbox_max": [
        -1789.7308349609375,
        -3801.03759765625,
        974.8458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319893479347229,
        -0.5238977074623108,
        0.18255063891410828
      ],
      "plane_d": -3660.06396484375,
      "bbox_min": [
        -1792.3414306640625,
        -3806.468505859375,
        966.9677734375
      ],
      "bbox_max": [
        -1789.7308349609375,
        -3801.03759765625,
        972.3338012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319893479347229,
        -0.5238977074623108,
        0.18255063891410828
      ],
      "plane_d": -3660.06396484375,
      "bbox_min": [
        -1792.3414306640625,
        -3806.591796875,
        965.967041015625
      ],
      "bbox_max": [
        -1790.09912109375,
        -3801.03759765625,
        972.3338012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5810175538063049,
        -0.8133273124694824,
        -0.030286790803074837
      ],
      "plane_d": -4103.4208984375,
      "bbox_min": [
        -1806.3492431640625,
        -3813.736083984375,
        932.0
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3795.009765625,
        987.1534423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03150865063071251,
        -0.2929813861846924,
        0.9555988907814026
      ],
      "plane_d": -1953.22412109375,
      "bbox_min": [
        -1806.3492431640625,
        -3813.736083984375,
        932.0
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3795.009765625,
        987.1534423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2361481636762619,
        -0.5314380526542664,
        0.8135156035423279
      ],
      "plane_d": -2359.9921875,
      "bbox_min": [
        -1806.3492431640625,
        -3813.736083984375,
        932.0
      ],
      "bbox_max": [
        -1788.5474853515625,
        -3801.559814453125,
        937.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7088854908943176,
        -0.6234127283096313,
        0.32990580797195435
      ],
      "plane_d": -3948.93408203125,
      "bbox_min": [
        -1791.130615234375,
        -3805.947998046875,
        932.0
      ],
      "bbox_max": [
        -1789.087890625,
        -3801.559814453125,
        937.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.575560986995697,
        -0.8177589178085327,
        0.0
      ],
      "plane_d": -4142.314453125,
      "bbox_min": [
        -1790.3687744140625,
        -3805.947998046875,
        932.0
      ],
      "bbox_max": [
        -1789.500244140625,
        -3805.336669921875,
        932.711181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7088854908943176,
        -0.6234127283096313,
        0.32990580797195435
      ],
      "plane_d": -3948.93408203125,
      "bbox_min": [
        -1791.130615234375,
        -3805.589599609375,
        934.2744140625
      ],
      "bbox_max": [
        -1788.5474853515625,
        -3801.559814453125,
        937.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319893479347229,
        -0.5238977074623108,
        0.18255063891410828
      ],
      "plane_d": -3660.06396484375,
      "bbox_min": [
        -1804.7509765625,
        -3807.23779296875,
        936.3233642578125
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3795.009765625,
        987.1534423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6682409048080444,
        -0.7401582598686218,
        -0.07496613264083862
      ],
      "plane_d": -3940.3818359375,
      "bbox_min": [
        -1799.7705078125,
        -3807.23779296875,
        936.3233642578125
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3795.490478515625,
        960.7262573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6315538287162781,
        -0.6995227932929993,
        -0.334376722574234
      ],
      "plane_d": -3473.10791015625,
      "bbox_min": [
        -1799.7705078125,
        -3807.23779296875,
        936.3233642578125
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3795.490478515625,
        960.7262573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26929882168769836,
        -0.9185101389884949,
        0.2895122468471527
      ],
      "plane_d": -4245.5380859375,
      "bbox_min": [
        -1799.7705078125,
        -3805.119873046875,
        936.3233642578125
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3795.490478515625,
        949.2740478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7315678000450134,
        -0.6817687749862671,
        0.0
      ],
      "plane_d": -3902.1181640625,
      "bbox_min": [
        -1791.130615234375,
        -3805.119873046875,
        936.3233642578125
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3801.559814453125,
        942.5228271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7088854908943176,
        -0.6234127283096313,
        0.32990580797195435
      ],
      "plane_d": -3948.93408203125,
      "bbox_min": [
        -1791.130615234375,
        -3805.119873046875,
        936.3233642578125
      ],
      "bbox_max": [
        -1788.1417236328125,
        -3801.559814453125,
        937.86181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.638627290725708,
        -0.7106617093086243,
        -0.2951529026031494
      ],
      "plane_d": -3558.903076171875,
      "bbox_min": [
        -1804.7509765625,
        -3801.03759765625,
        969.3895263671875
      ],
      "bbox_max": [
        -1792.3414306640625,
        -3795.009765625,
        987.1534423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5633212327957153,
        -0.8207308053970337,
        -0.09523717314004898
      ],
      "plane_d": -4036.6904296875,
      "bbox_min": [
        -1804.7509765625,
        -3801.03759765625,
        969.3895263671875
      ],
      "bbox_max": [
        -1792.3414306640625,
        -3795.009765625,
        987.1534423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5852543115615845,
        0.34085002541542053,
        -0.7357300519943237
      ],
      "plane_d": 965.29638671875,
      "bbox_min": [
        -1804.7509765625,
        -3800.721923828125,
        986.3063354492188
      ],
      "bbox_max": [
        -1802.64990234375,
        -3797.20654296875,
        987.1534423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46141356229782104,
        -0.7024359703063965,
        -0.5419235825538635
      ],
      "plane_d": -2964.74951171875,
      "bbox_min": [
        -1803.3499755859375,
        -3797.693359375,
        986.3063354492188
      ],
      "bbox_max": [
        -1802.64990234375,
        -3797.20654296875,
        987.1534423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.423296183347702,
        0.6822999715805054,
        -0.5960597395896912
      ],
      "plane_d": 2421.813720703125,
      "bbox_min": [
        -1832.7962646484375,
        -3830.73193359375,
        932.0
      ],
      "bbox_max": [
        -1799.174072265625,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36472880840301514,
        0.6842003464698792,
        -0.6315399408340454
      ],
      "plane_d": 2570.195068359375,
      "bbox_min": [
        -1820.2176513671875,
        -3830.588623046875,
        969.1823120117188
      ],
      "bbox_max": [
        -1809.67919921875,
        -3810.466064453125,
        987.7176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21571679413318634,
        0.5579977631568909,
        -0.8013144135475159
      ],
      "plane_d": 2523.2392578125,
      "bbox_min": [
        -1820.2176513671875,
        -3830.480712890625,
        969.6207885742188
      ],
      "bbox_max": [
        -1815.1253662109375,
        -3825.248046875,
        973.7904663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14758671820163727,
        0.9498504996299744,
        -0.2756847143173218
      ],
      "plane_d": 4173.96533203125,
      "bbox_min": [
        -1820.2176513671875,
        -3830.480712890625,
        969.6207885742188
      ],
      "bbox_max": [
        -1817.3382568359375,
        -3829.3046875,
        972.3364868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14758671820163727,
        0.9498504996299744,
        -0.2756847143173218
      ],
      "plane_d": 4173.96533203125,
      "bbox_min": [
        -1820.2176513671875,
        -3830.588623046875,
        969.1823120117188
      ],
      "bbox_max": [
        -1809.67919921875,
        -3810.466064453125,
        987.7176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6849338412284851,
        0.3491114377975464,
        -0.6395208239555359
      ],
      "plane_d": 721.17822265625,
      "bbox_min": [
        -1811.510986328125,
        -3811.975341796875,
        985.1331787109375
      ],
      "bbox_max": [
        -1809.67919921875,
        -3810.466064453125,
        987.7176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9013466238975525,
        0.310899943113327,
        0.30152183771133423
      ],
      "plane_d": 2547.135986328125,
      "bbox_min": [
        -1832.7962646484375,
        -3830.73193359375,
        932.0
      ],
      "bbox_max": [
        -1799.174072265625,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9095819592475891,
        0.35035619139671326,
        0.2234082967042923
      ],
      "plane_d": 2786.08837890625,
      "bbox_min": [
        -1832.7962646484375,
        -3815.831298828125,
        937.6104125976562
      ],
      "bbox_max": [
        -1823.9571533203125,
        -3796.005126953125,
        947.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26730549335479736,
        0.15917444229125977,
        0.9503743052482605
      ],
      "plane_d": 202.23812866210938,
      "bbox_min": [
        -1831.0462646484375,
        -3815.831298828125,
        937.6104125976562
      ],
      "bbox_max": [
        -1823.9571533203125,
        -3796.005126953125,
        939.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32331761717796326,
        0.2689535617828369,
        0.9072649478912354
      ],
      "plane_d": 762.0324096679688,
      "bbox_min": [
        -1831.0462646484375,
        -3797.344970703125,
        937.6104125976562
      ],
      "bbox_max": [
        -1829.8521728515625,
        -3796.005126953125,
        938.09375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.690223753452301,
        0.7220855355262756,
        -0.04672892019152641
      ],
      "plane_d": 4063.29248046875,
      "bbox_min": [
        -1832.7962646484375,
        -3830.73193359375,
        932.0
      ],
      "bbox_max": [
        -1799.174072265625,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8561754822731018,
        0.49833184480667114,
        -0.1364879161119461
      ],
      "plane_d": 3599.40234375,
      "bbox_min": [
        -1827.75244140625,
        -3830.73193359375,
        958.8253784179688
      ],
      "bbox_max": [
        -1816.1422119140625,
        -3817.375244140625,
        984.6117553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14758671820163727,
        0.9498504996299744,
        -0.2756847143173218
      ],
      "plane_d": 4173.96533203125,
      "bbox_min": [
        -1820.2176513671875,
        -3830.73193359375,
        968.6002197265625
      ],
      "bbox_max": [
        -1817.845947265625,
        -3829.3046875,
        972.3364868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7843647599220276,
        0.6104368567466736,
        -0.11017642170190811
      ],
      "plane_d": 3870.611328125,
      "bbox_min": [
        -1832.7962646484375,
        -3829.765869140625,
        932.0
      ],
      "bbox_max": [
        -1799.174072265625,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8561754822731018,
        0.49833184480667114,
        -0.1364879161119461
      ],
      "plane_d": 3599.40234375,
      "bbox_min": [
        -1827.75244140625,
        -3820.533935546875,
        968.6271362304688
      ],
      "bbox_max": [
        -1823.36572265625,
        -3817.375244140625,
        986.6029052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6716129183769226,
        0.7266879677772522,
        -0.14443247020244598
      ],
      "plane_d": 4138.35791015625,
      "bbox_min": [
        -1817.6905517578125,
        -3829.765869140625,
        935.1113891601562
      ],
      "bbox_max": [
        -1816.65673828125,
        -3828.559814453125,
        937.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8694509863853455,
        0.38375425338745117,
        0.3111070990562439
      ],
      "plane_d": 2757.9560546875,
      "bbox_min": [
        -1832.7962646484375,
        -3829.5927734375,
        932.0
      ],
      "bbox_max": [
        -1799.174072265625,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7210636138916016,
        -0.49240541458129883,
        0.4874465763568878
      ],
      "plane_d": -1031.5142822265625,
      "bbox_min": [
        -1817.6905517578125,
        -3829.5927734375,
        934.804931640625
      ],
      "bbox_max": [
        -1816.3896484375,
        -3828.559814453125,
        937.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42189931869506836,
        -0.8514009714126587,
        0.3116367757320404
      ],
      "plane_d": -4286.8623046875,
      "bbox_min": [
        -1832.7962646484375,
        -3829.5546875,
        932.0
      ],
      "bbox_max": [
        -1799.174072265625,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47628259658813477,
        -0.8523299694061279,
        0.21607521176338196
      ],
      "plane_d": -4298.759765625,
      "bbox_min": [
        -1821.6302490234375,
        -3799.53759765625,
        937.4549560546875
      ],
      "bbox_max": [
        -1799.174072265625,
        -3787.024658203125,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26929882168769836,
        -0.9185101389884949,
        0.2895122468471527
      ],
      "plane_d": -4245.5380859375,
      "bbox_min": [
        -1804.4571533203125,
        -3799.53759765625,
        938.4177856445312
      ],
      "bbox_max": [
        -1799.174072265625,
        -3793.956298828125,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03150865063071251,
        -0.2929813861846924,
        0.9555988907814026
      ],
      "plane_d": -1953.22412109375,
      "bbox_min": [
        -1804.4571533203125,
        -3799.53759765625,
        938.4177856445312
      ],
      "bbox_max": [
        -1799.174072265625,
        -3793.956298828125,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6682409048080444,
        -0.7401582598686218,
        -0.07496613264083862
      ],
      "plane_d": -3940.3818359375,
      "bbox_min": [
        -1801.2071533203125,
        -3795.514404296875,
        949.2740478515625
      ],
      "bbox_max": [
        -1799.174072265625,
        -3793.956298828125,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19761410355567932,
        -0.23253905773162842,
        0.9522994160652161
      ],
      "plane_d": -2134.062744140625,
      "bbox_min": [
        -1821.6302490234375,
        -3797.081298828125,
        937.4549560546875
      ],
      "bbox_max": [
        -1804.4571533203125,
        -3788.399658203125,
        939.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32331761717796326,
        -0.2689535617828369,
        0.9072649478912354
      ],
      "plane_d": -2458.617919921875,
      "bbox_min": [
        -1821.6302490234375,
        -3789.912841796875,
        937.4549560546875
      ],
      "bbox_max": [
        -1820.0150146484375,
        -3788.399658203125,
        938.09375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26730549335479736,
        0.15917444229125977,
        0.9503743052482605
      ],
      "plane_d": 202.23812866210938,
      "bbox_min": [
        -1832.7962646484375,
        -3829.5546875,
        932.0
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2983568608760834,
        0.0109871132299304,
        0.9543911218643188
      ],
      "plane_d": -310.35638427734375,
      "bbox_min": [
        -1823.9571533203125,
        -3829.5546875,
        932.0
      ],
      "bbox_max": [
        -1806.404541015625,
        -3806.456298828125,
        939.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2811243236064911,
        0.14407622814178467,
        0.9487946033477783
      ],
      "plane_d": 171.31463623046875,
      "bbox_min": [
        -1823.9571533203125,
        -3829.32275390625,
        932.0
      ],
      "bbox_max": [
        -1806.5394287109375,
        -3806.456298828125,
        939.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5788326263427734,
        -0.21574242413043976,
        0.7863891124725342
      ],
      "plane_d": -511.0841064453125,
      "bbox_min": [
        -1817.6905517578125,
        -3829.32275390625,
        932.0
      ],
      "bbox_max": [
        -1806.5394287109375,
        -3813.956298828125,
        937.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7210636138916016,
        -0.49240541458129883,
        0.4874465763568878
      ],
      "plane_d": -1031.5142822265625,
      "bbox_min": [
        -1817.6905517578125,
        -3829.32275390625,
        932.0
      ],
      "bbox_max": [
        -1809.437255859375,
        -3820.223876953125,
        937.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2361481636762619,
        -0.5314380526542664,
        0.8135156035423279
      ],
      "plane_d": -2359.9921875,
      "bbox_min": [
        -1807.8321533203125,
        -3814.986083984375,
        933.3231811523438
      ],
      "bbox_max": [
        -1806.5394287109375,
        -3813.956298828125,
        934.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18121078610420227,
        -0.24916483461856842,
        0.9513566493988037
      ],
      "plane_d": -2166.707275390625,
      "bbox_min": [
        -1814.2071533203125,
        -3813.956298828125,
        934.25
      ],
      "bbox_max": [
        -1807.8321533203125,
        -3806.456298828125,
        935.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6716129183769226,
        0.7266879677772522,
        -0.14443247020244598
      ],
      "plane_d": 4138.35791015625,
      "bbox_min": [
        -1817.6905517578125,
        -3829.5546875,
        937.3016357421875
      ],
      "bbox_max": [
        -1816.6212158203125,
        -3828.559814453125,
        937.6217041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18121078610420227,
        -0.24916483461856842,
        0.9513566493988037
      ],
      "plane_d": -2166.707275390625,
      "bbox_min": [
        -1808.5015869140625,
        -3813.999755859375,
        933.8463745117188
      ],
      "bbox_max": [
        -1806.404541015625,
        -3812.724365234375,
        934.4451293945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2361481636762619,
        -0.5314380526542664,
        0.8135156035423279
      ],
      "plane_d": -2359.9921875,
      "bbox_min": [
        -1807.8321533203125,
        -3813.999755859375,
        933.8463745117188
      ],
      "bbox_max": [
        -1806.404541015625,
        -3813.549560546875,
        934.3720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03150865063071251,
        -0.2929813861846924,
        0.9555988907814026
      ],
      "plane_d": -1953.22412109375,
      "bbox_min": [
        -1807.8321533203125,
        -3813.956298828125,
        934.25
      ],
      "bbox_max": [
        -1807.4771728515625,
        -3813.549560546875,
        934.3720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32331761717796326,
        -0.2689535617828369,
        0.9072649478912354
      ],
      "plane_d": -2458.617919921875,
      "bbox_min": [
        -1824.8719482421875,
        -3813.69287109375,
        934.0154418945312
      ],
      "bbox_max": [
        -1800.1610107421875,
        -3789.25146484375,
        939.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2361481636762619,
        -0.5314380526542664,
        0.8135156035423279
      ],
      "plane_d": -2359.9921875,
      "bbox_min": [
        -1807.47705078125,
        -3813.692626953125,
        934.0154418945312
      ],
      "bbox_max": [
        -1805.920654296875,
        -3812.53759765625,
        934.6219482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9751908183097839,
        0.19020585715770721,
        -0.11324544250965118
      ],
      "plane_d": 2616.1015625,
      "bbox_min": [
        -1832.7962646484375,
        -3818.956298828125,
        947.375
      ],
      "bbox_max": [
        -1827.2071533203125,
        -3793.932373046875,
        979.897705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9555795788764954,
        0.20608240365982056,
        -0.21070735156536102
      ],
      "plane_d": 2733.70751953125,
      "bbox_min": [
        -1832.7962646484375,
        -3818.956298828125,
        947.375
      ],
      "bbox_max": [
        -1827.2071533203125,
        -3796.649658203125,
        979.897705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9954152703285217,
        0.09253215044736862,
        0.024209951981902122
      ],
      "plane_d": 2149.15234375,
      "bbox_min": [
        -1829.466064453125,
        -3818.956298828125,
        952.25
      ],
      "bbox_max": [
        -1827.2071533203125,
        -3800.87890625,
        979.897705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9956793785095215,
        0.0909339115023613,
        0.01880642957985401
      ],
      "plane_d": 2148.767822265625,
      "bbox_min": [
        -1829.466064453125,
        -3817.375244140625,
        964.1786499023438
      ],
      "bbox_max": [
        -1827.75244140625,
        -3800.87890625,
        979.897705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8324105739593506,
        -0.5484451651573181,
        0.07937666773796082
      ],
      "plane_d": -639.5228271484375,
      "bbox_min": [
        -1829.466064453125,
        -3802.545166015625,
        964.1786499023438
      ],
      "bbox_max": [
        -1828.5665283203125,
        -3800.87890625,
        979.897705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8324105739593506,
        -0.5484451651573181,
        0.07937666773796082
      ],
      "plane_d": -639.5228271484375,
      "bbox_min": [
        -1829.0228271484375,
        -3802.545166015625,
        962.4985961914062
      ],
      "bbox_max": [
        -1827.798828125,
        -3798.74365234375,
        970.9074096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.841090202331543,
        -0.42094534635543823,
        -0.3396646976470947
      ],
      "plane_d": 265.2069091796875,
      "bbox_min": [
        -1829.0228271484375,
        -3802.545166015625,
        962.4985961914062
      ],
      "bbox_max": [
        -1827.798828125,
        -3798.74365234375,
        964.7213745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5810175538063049,
        -0.8133273124694824,
        -0.030286790803074837
      ],
      "plane_d": -4103.4208984375,
      "bbox_min": [
        -1829.466064453125,
        -3819.111328125,
        947.375
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5633212327957153,
        -0.8207308053970337,
        -0.09523717314004898
      ],
      "plane_d": -4036.6904296875,
      "bbox_min": [
        -1829.466064453125,
        -3819.111328125,
        947.375
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3036706745624542,
        0.6720419526100159,
        -0.6753842234611511
      ],
      "plane_d": 2677.779296875,
      "bbox_min": [
        -1829.466064453125,
        -3819.111328125,
        947.375
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33363839983940125,
        0.573661744594574,
        -0.7480624914169312
      ],
      "plane_d": 2320.403564453125,
      "bbox_min": [
        -1824.742431640625,
        -3819.111328125,
        986.0774536132812
      ],
      "bbox_max": [
        -1811.510986328125,
        -3810.466064453125,
        993.1408081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7702163457870483,
        0.39804983139038086,
        -0.49832025170326233
      ],
      "plane_d": 3416.6201171875,
      "bbox_min": [
        -1824.742431640625,
        -3819.111328125,
        986.0774536132812
      ],
      "bbox_max": [
        -1823.8763427734375,
        -3810.66455078125,
        993.1408081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7702163457870483,
        0.39804983139038086,
        -0.49832025170326233
      ],
      "plane_d": 3416.6201171875,
      "bbox_min": [
        -1829.388427734375,
        -3818.09326171875,
        983.2586059570312
      ],
      "bbox_max": [
        -1824.01171875,
        -3810.66455078125,
        993.1408081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5852543115615845,
        0.34085002541542053,
        -0.7357300519943237
      ],
      "plane_d": 965.29638671875,
      "bbox_min": [
        -1829.466064453125,
        -3812.63232421875,
        947.375
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6713981032371521,
        0.31869369745254517,
        -0.6690731644630432
      ],
      "plane_d": 658.9818115234375,
      "bbox_min": [
        -1818.2830810546875,
        -3810.466064453125,
        987.7176513671875
      ],
      "bbox_max": [
        -1810.6942138671875,
        -3797.4375,
        996.4900512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2908751964569092,
        -0.17130647599697113,
        -0.9412999153137207
      ],
      "plane_d": -242.40313720703125,
      "bbox_min": [
        -1818.2830810546875,
        -3804.345947265625,
        993.1038208007812
      ],
      "bbox_max": [
        -1810.6942138671875,
        -3797.4375,
        996.4900512695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46141356229782104,
        -0.7024359703063965,
        -0.5419235825538635
      ],
      "plane_d": -2964.74951171875,
      "bbox_min": [
        -1810.6942138671875,
        -3797.671142578125,
        978.9132690429688
      ],
      "bbox_max": [
        -1801.6177978515625,
        -3791.7900390625,
        993.1038208007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.638627290725708,
        -0.7106617093086243,
        -0.2951529026031494
      ],
      "plane_d": -3558.903076171875,
      "bbox_min": [
        -1807.650390625,
        -3797.20654296875,
        978.9132690429688
      ],
      "bbox_max": [
        -1801.6177978515625,
        -3791.7900390625,
        986.3063354492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1625807136297226,
        -0.9865548014640808,
        0.01664571277797222
      ],
      "plane_d": -4051.63818359375,
      "bbox_min": [
        -1829.466064453125,
        -3812.63232421875,
        947.375
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3787.024658203125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3078475892543793,
        -0.9359785914421082,
        -0.17080356180667877
      ],
      "plane_d": -3942.911376953125,
      "bbox_min": [
        -1822.935791015625,
        -3793.956298828125,
        947.375
      ],
      "bbox_max": [
        -1801.2071533203125,
        -3787.024658203125,
        986.5371704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3118681311607361,
        -0.9295797348022461,
        -0.1965189278125763
      ],
      "plane_d": -3901.388671875,
      "bbox_min": [
        -1820.5462646484375,
        -3793.956298828125,
        947.375
      ],
      "bbox_max": [
        -1801.2071533203125,
        -3787.024658203125,
        986.5371704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09184753894805908,
        -0.9925417304039001,
        0.08015573024749756
      ],
      "plane_d": -4008.346435546875,
      "bbox_min": [
        -1813.9156494140625,
        -3793.414794921875,
        968.6104736328125
      ],
      "bbox_max": [
        -1802.8179931640625,
        -3791.3740234375,
        986.5371704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.047714341431856155,
        -0.995876669883728,
        -0.07715587317943573
      ],
      "plane_d": -3786.547119140625,
      "bbox_min": [
        -1811.34130859375,
        -3791.93994140625,
        983.1920166015625
      ],
      "bbox_max": [
        -1807.650390625,
        -3791.737060546875,
        986.5371704101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3173261880874634,
        -0.7934240102767944,
        -0.519405722618103
      ],
      "plane_d": -1931.20751953125,
      "bbox_min": [
        -1822.935791015625,
        -3791.369873046875,
        956.65625
      ],
      "bbox_max": [
        -1815.681884765625,
        -3788.399658203125,
        964.165283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09184753894805908,
        -0.9925417304039001,
        0.08015573024749756
      ],
      "plane_d": -4008.346435546875,
      "bbox_min": [
        -1818.08544921875,
        -3793.414794921875,
        968.6104736328125
      ],
      "bbox_max": [
        -1802.8179931640625,
        -3791.09716796875,
        989.8412475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04399305209517479,
        -0.9966779351234436,
        -0.0685403048992157
      ],
      "plane_d": -3791.329345703125,
      "bbox_min": [
        -1818.08544921875,
        -3792.087890625,
        979.814453125
      ],
      "bbox_max": [
        -1809.9324951171875,
        -3791.09716796875,
        989.8412475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.047714341431856155,
        -0.995876669883728,
        -0.07715587317943573
      ],
      "plane_d": -3786.547119140625,
      "bbox_min": [
        -1814.565185546875,
        -3792.087890625,
        984.7911376953125
      ],
      "bbox_max": [
        -1809.9324951171875,
        -3791.69091796875,
        989.8412475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9982712268829346,
        -0.010021140798926353,
        -0.057914283126592636
      ],
      "plane_d": 1844.963623046875,
      "bbox_min": [
        -1829.466064453125,
        -3812.63232421875,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3790.277099609375,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9989708662033081,
        -0.016533521935343742,
        -0.04223504662513733
      ],
      "plane_d": 1805.99755859375,
      "bbox_min": [
        -1829.388427734375,
        -3812.63232421875,
        983.2586059570312
      ],
      "bbox_max": [
        -1828.716552734375,
        -3799.6962890625,
        993.6304931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7804040312767029,
        -0.3852560520172119,
        -0.4924909770488739
      ],
      "plane_d": 450.3448486328125,
      "bbox_min": [
        -1828.947998046875,
        -3805.8037109375,
        988.6119384765625
      ],
      "bbox_max": [
        -1828.716552734375,
        -3799.6962890625,
        993.6304931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8727903366088867,
        -0.47007137537002563,
        0.13141511380672455
      ],
      "plane_d": -318.7474365234375,
      "bbox_min": [
        -1829.466064453125,
        -3811.5693359375,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3790.277099609375,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8324105739593506,
        -0.5484451651573181,
        0.07937666773796082
      ],
      "plane_d": -639.5228271484375,
      "bbox_min": [
        -1829.466064453125,
        -3800.94287109375,
        958.0643310546875
      ],
      "bbox_max": [
        -1820.8646240234375,
        -3790.277099609375,
        979.897705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6915217638015747,
        -0.46643930673599243,
        -0.551572322845459
      ],
      "plane_d": 22.966796875,
      "bbox_min": [
        -1827.798828125,
        -3798.74365234375,
        958.6942138671875
      ],
      "bbox_max": [
        -1825.7962646484375,
        -3792.524658203125,
        962.4985961914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26084235310554504,
        -0.8942757248878479,
        -0.36363741755485535
      ],
      "plane_d": -2566.316650390625,
      "bbox_min": [
        -1825.7962646484375,
        -3794.848388671875,
        958.0643310546875
      ],
      "bbox_max": [
        -1820.8646240234375,
        -3790.277099609375,
        966.6207275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39645400643348694,
        -0.9148337244987488,
        0.07683363556861877
      ],
      "plane_d": -2822.71923828125,
      "bbox_min": [
        -1824.1845703125,
        -3794.848388671875,
        959.8062744140625
      ],
      "bbox_max": [
        -1815.681884765625,
        -3790.589111328125,
        979.814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26084235310554504,
        -0.8942757248878479,
        -0.36363741755485535
      ],
      "plane_d": -2566.316650390625,
      "bbox_min": [
        -1824.1845703125,
        -3794.848388671875,
        959.8062744140625
      ],
      "bbox_max": [
        -1815.681884765625,
        -3790.589111328125,
        966.6207275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3173261880874634,
        -0.7934240102767944,
        -0.519405722618103
      ],
      "plane_d": -1931.20751953125,
      "bbox_min": [
        -1821.9150390625,
        -3792.08154296875,
        959.8062744140625
      ],
      "bbox_max": [
        -1815.681884765625,
        -3790.589111328125,
        964.165283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9022069573402405,
        -0.42644211649894714,
        0.06457395851612091
      ],
      "plane_d": -34.099609375,
      "bbox_min": [
        -1829.466064453125,
        -3811.5693359375,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3791.09716796875,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8722758889198303,
        -0.48868075013160706,
        0.018049053847789764
      ],
      "plane_d": -279.3345947265625,
      "bbox_min": [
        -1829.466064453125,
        -3800.94287109375,
        978.7329711914062
      ],
      "bbox_max": [
        -1825.52783203125,
        -3793.956298828125,
        988.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6845497488975525,
        0.4222728908061981,
        -0.594202995300293
      ],
      "plane_d": 955.8919677734375,
      "bbox_min": [
        -1828.947998046875,
        -3811.5693359375,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3791.09716796875,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6849338412284851,
        0.3491114377975464,
        -0.6395208239555359
      ],
      "plane_d": 721.17822265625,
      "bbox_min": [
        -1811.510986328125,
        -3811.5693359375,
        985.1533813476562
      ],
      "bbox_max": [
        -1808.4766845703125,
        -3808.9736328125,
        987.7176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8109626770019531,
        -0.17289447784423828,
        -0.5589695572853088
      ],
      "plane_d": 1378.8660888671875,
      "bbox_min": [
        -1828.947998046875,
        -3805.642822265625,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3791.09716796875,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7804040312767029,
        -0.3852560520172119,
        -0.4924909770488739
      ],
      "plane_d": 450.3448486328125,
      "bbox_min": [
        -1828.947998046875,
        -3805.642822265625,
        988.6119384765625
      ],
      "bbox_max": [
        -1822.83154296875,
        -3797.966064453125,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04399305209517479,
        -0.9966779351234436,
        -0.0685403048992157
      ],
      "plane_d": -3791.329345703125,
      "bbox_min": [
        -1820.00634765625,
        -3791.61279296875,
        979.814453125
      ],
      "bbox_max": [
        -1817.7244873046875,
        -3791.09716796875,
        988.5453491210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07305890321731567,
        -0.8072749376296997,
        -0.5856360793113708
      ],
      "plane_d": -2348.978515625,
      "bbox_min": [
        -1826.2640380859375,
        -3797.966064453125,
        988.5453491210938
      ],
      "bbox_max": [
        -1820.00634765625,
        -3791.61279296875,
        996.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04399305209517479,
        -0.9966779351234436,
        -0.0685403048992157
      ],
      "plane_d": -3791.329345703125,
      "bbox_min": [
        -1820.00634765625,
        -3795.8955078125,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3791.157958984375,
        993.4776611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.047714341431856155,
        -0.995876669883728,
        -0.07715587317943573
      ],
      "plane_d": -3786.547119140625,
      "bbox_min": [
        -1820.00634765625,
        -3795.8955078125,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3791.61279296875,
        993.4776611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319893479347229,
        -0.5238977074623108,
        0.18255063891410828
      ],
      "plane_d": -3660.06396484375,
      "bbox_min": [
        -1801.2071533203125,
        -3795.8955078125,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3793.956298828125,
        955.87841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6682409048080444,
        -0.7401582598686218,
        -0.07496613264083862
      ],
      "plane_d": -3940.3818359375,
      "bbox_min": [
        -1801.2071533203125,
        -3795.8955078125,
        950.5826416015625
      ],
      "bbox_max": [
        -1799.2943115234375,
        -3793.956298828125,
        953.487548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6315538287162781,
        -0.6995227932929993,
        -0.334376722574234
      ],
      "plane_d": -3473.10791015625,
      "bbox_min": [
        -1801.2071533203125,
        -3795.8955078125,
        952.25
      ],
      "bbox_max": [
        -1799.4476318359375,
        -3793.956298828125,
        953.487548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904165506362915,
        0.4225879907608032,
        -0.06248297914862633
      ],
      "plane_d": 3303.765625,
      "bbox_min": [
        -1818.0108642578125,
        -3838.0,
        932.0
      ],
      "bbox_max": [
        -1765.0,
        -3804.76708984375,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9972783327102661,
        -0.07372774928808212
      ],
      "plane_d": 3884.6005859375,
      "bbox_min": [
        -1818.0108642578125,
        -3837.358642578125,
        932.0
      ],
      "bbox_max": [
        -1794.812255859375,
        -3817.20703125,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9972783327102661,
        -0.07372774928808212
      ],
      "plane_d": -3747.171875,
      "bbox_min": [
        -1818.0108642578125,
        -3837.358642578125,
        932.0
      ],
      "bbox_max": [
        -1794.812255859375,
        -3821.75341796875,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.904165506362915,
        0.4225880205631256,
        -0.062482982873916626
      ],
      "plane_d": 46.599853515625,
      "bbox_min": [
        -1816.2578125,
        -3830.8466796875,
        932.0
      ],
      "bbox_max": [
        -1796.949951171875,
        -3821.75341796875,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.904165506362915,
        -0.4225879907608032,
        -0.06248297914862633
      ],
      "plane_d": -3187.29736328125,
      "bbox_min": [
        -1805.449951171875,
        -3830.8466796875,
        932.0
      ],
      "bbox_max": [
        -1796.949951171875,
        -3823.36083984375,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904165506362915,
        -0.4225880205631256,
        -0.062482982873916626
      ],
      "plane_d": 69.868408203125,
      "bbox_min": [
        -1803.828369140625,
        -3830.8466796875,
        932.0
      ],
      "bbox_max": [
        -1796.949951171875,
        -3823.36083984375,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1803.828369140625,
        -3828.949462890625,
        967.23095703125
      ],
      "bbox_max": [
        -1798.6622314453125,
        -3823.36083984375,
        971.7603149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1804.9781494140625,
        -3828.99462890625,
        967.8370361328125
      ],
      "bbox_max": [
        -1802.4384765625,
        -3826.300537109375,
        970.03271484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.21571679413318634,
        0.5579977631568909,
        -0.8013144135475159
      ],
      "plane_d": 2523.2392578125,
      "bbox_min": [
        -1816.2578125,
        -3829.208251953125,
        932.0
      ],
      "bbox_max": [
        -1802.57373046875,
        -3823.220947265625,
        973.6528930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1804.951904296875,
        -3828.933349609375,
        968.4855346679688
      ],
      "bbox_max": [
        -1802.57373046875,
        -3823.3173828125,
        972.3485107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7210636138916016,
        -0.49240541458129883,
        0.4874465763568878
      ],
      "plane_d": -1031.5142822265625,
      "bbox_min": [
        -1812.9766845703125,
        -3826.355712890625,
        932.0
      ],
      "bbox_max": [
        -1812.429443359375,
        -3826.25,
        932.7532348632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.010137375444173813,
        0.9999485611915588,
        0.0
      ],
      "plane_d": 3818.44873046875,
      "bbox_min": [
        -1818.0108642578125,
        -3837.358642578125,
        932.0
      ],
      "bbox_max": [
        -1794.812255859375,
        -3826.30029296875,
        971.3377075195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03899751976132393,
        0.9976190328598022,
        0.056879643350839615
      ],
      "plane_d": 3844.199951171875,
      "bbox_min": [
        -1808.353515625,
        -3837.358642578125,
        941.2639770507812
      ],
      "bbox_max": [
        -1794.812255859375,
        -3836.841552734375,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.012056472711265087,
        0.9785863757133484,
        -0.20548337697982788
      ],
      "plane_d": 3928.683837890625,
      "bbox_min": [
        -1808.353515625,
        -3837.358642578125,
        949.642578125
      ],
      "bbox_max": [
        -1794.812255859375,
        -3836.841552734375,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7836125493049622,
        0.5710275769233704,
        0.24470172822475433
      ],
      "plane_d": 3375.0517578125,
      "bbox_min": [
        -1818.0108642578125,
        -3836.97802734375,
        932.0
      ],
      "bbox_max": [
        -1794.8834228515625,
        -3826.30029296875,
        971.3377075195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6696184277534485,
        0.7427052855491638,
        0.0
      ],
      "plane_d": 4060.65087890625,
      "bbox_min": [
        -1816.8994140625,
        -3836.97802734375,
        932.0
      ],
      "bbox_max": [
        -1802.30029296875,
        -3826.30029296875,
        958.8253784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6716129183769226,
        0.7266879677772522,
        -0.14443247020244598
      ],
      "plane_d": 4138.35791015625,
      "bbox_min": [
        -1816.8994140625,
        -3836.97802734375,
        932.0
      ],
      "bbox_max": [
        -1808.353515625,
        -3829.52392578125,
        938.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6003345847129822,
        0.799748957157135,
        -0.0
      ],
      "plane_d": 4154.236328125,
      "bbox_min": [
        -1816.8994140625,
        -3836.97802734375,
        932.0
      ],
      "bbox_max": [
        -1808.353515625,
        -3829.524169921875,
        938.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7210636138916016,
        -0.49240541458129883,
        0.4874465763568878
      ],
      "plane_d": -1031.5142822265625,
      "bbox_min": [
        -1816.8994140625,
        -3831.336669921875,
        932.0
      ],
      "bbox_max": [
        -1815.389404296875,
        -3829.524169921875,
        935.1113891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06113339960575104,
        0.998129665851593,
        0.0
      ],
      "plane_d": 3719.250732421875,
      "bbox_min": [
        -1816.621337890625,
        -3836.97802734375,
        932.0
      ],
      "bbox_max": [
        -1802.30029296875,
        -3826.30029296875,
        938.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0036161455791443586,
        0.9905247688293457,
        0.1372869610786438
      ],
      "plane_d": 3678.30859375,
      "bbox_min": [
        -1808.353515625,
        -3836.97802734375,
        936.3349609375
      ],
      "bbox_max": [
        -1803.5963134765625,
        -3836.6865234375,
        938.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7210636138916016,
        -0.49240541458129883,
        0.4874465763568878
      ],
      "plane_d": -1031.5142822265625,
      "bbox_min": [
        -1816.621337890625,
        -3830.634765625,
        932.0
      ],
      "bbox_max": [
        -1812.429443359375,
        -3826.30029296875,
        934.9442138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.012056472711265087,
        0.9785863757133484,
        -0.20548337697982788
      ],
      "plane_d": 3928.683837890625,
      "bbox_min": [
        -1817.3382568359375,
        -3836.97802734375,
        932.0
      ],
      "bbox_max": [
        -1794.8834228515625,
        -3828.8544921875,
        971.3377075195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21571679413318634,
        0.5579977631568909,
        -0.8013144135475159
      ],
      "plane_d": 2523.2392578125,
      "bbox_min": [
        -1817.3382568359375,
        -3836.93359375,
        932.0
      ],
      "bbox_max": [
        -1795.322509765625,
        -3828.8544921875,
        971.3377075195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1805.103515625,
        -3833.72802734375,
        965.1875
      ],
      "bbox_max": [
        -1800.2864990234375,
        -3828.9111328125,
        968.4436645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23576459288597107,
        0.5804930925369263,
        -0.7793861627578735
      ],
      "plane_d": 2552.126953125,
      "bbox_min": [
        -1805.103515625,
        -3836.93359375,
        932.0
      ],
      "bbox_max": [
        -1795.322509765625,
        -3828.8544921875,
        966.671630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06113339960575104,
        0.998129665851593,
        0.0
      ],
      "plane_d": 3719.250732421875,
      "bbox_min": [
        -1803.5963134765625,
        -3836.6865234375,
        932.0
      ],
      "bbox_max": [
        -1796.47998046875,
        -3836.250732421875,
        936.3349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1812.85498046875,
        -3826.30029296875,
        932.0
      ],
      "bbox_max": [
        -1799.8514404296875,
        -3817.20703125,
        975.7396850585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7210636138916016,
        -0.49240541458129883,
        0.4874465763568878
      ],
      "plane_d": -1031.5142822265625,
      "bbox_min": [
        -1812.85498046875,
        -3826.30029296875,
        932.0
      ],
      "bbox_max": [
        -1811.7235107421875,
        -3825.266357421875,
        932.6801147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9972783327102661,
        -0.07372774928808212
      ],
      "plane_d": -3739.692138671875,
      "bbox_min": [
        -1798.95263671875,
        -3838.0,
        932.0
      ],
      "bbox_max": [
        -1765.0,
        -3805.280029296875,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.904165506362915,
        -0.4225879907608032,
        -0.06248297914862633
      ],
      "plane_d": -3176.89453125,
      "bbox_min": [
        -1797.449951171875,
        -3823.3466796875,
        932.0
      ],
      "bbox_max": [
        -1771.2308349609375,
        -3805.280029296875,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904165506362915,
        0.4225879907608032,
        -0.06248297914862633
      ],
      "plane_d": 3293.36279296875,
      "bbox_min": [
        -1795.8853759765625,
        -3823.3466796875,
        932.0
      ],
      "bbox_max": [
        -1771.2308349609375,
        -3805.280029296875,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9972783327102661,
        -0.07372774928808212
      ],
      "plane_d": 3877.120849609375,
      "bbox_min": [
        -1795.8853759765625,
        -3823.3466796875,
        932.0
      ],
      "bbox_max": [
        -1788.949951171875,
        -3813.1376953125,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904165506362915,
        -0.4225880205631256,
        -0.062482982873916626
      ],
      "plane_d": 65.804443359375,
      "bbox_min": [
        -1795.8853759765625,
        -3823.3466796875,
        932.0
      ],
      "bbox_max": [
        -1788.949951171875,
        -3815.949462890625,
        993.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5315654873847961,
        0.1640140563249588,
        -0.8309858441352844
      ],
      "plane_d": 478.47900390625,
      "bbox_min": [
        -1795.8853759765625,
        -3821.56689453125,
        967.5718383789062
      ],
      "bbox_max": [
        -1790.74169921875,
        -3815.949462890625,
        970.8622436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5315654873847961,
        0.1640140563249588,
        -0.8309858441352844
      ],
      "plane_d": 478.47900390625,
      "bbox_min": [
        -1791.22509765625,
        -3819.849609375,
        967.3843383789062
      ],
      "bbox_max": [
        -1790.5703125,
        -3818.80029296875,
        967.6739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5315654873847961,
        0.1640140563249588,
        -0.8309858441352844
      ],
      "plane_d": 478.47900390625,
      "bbox_min": [
        -1794.5322265625,
        -3816.074462890625,
        968.867431640625
      ],
      "bbox_max": [
        -1791.926025390625,
        -3815.153564453125,
        970.5592651367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.411079078912735,
        -0.7600318193435669,
        0.5033543109893799
      ],
      "plane_d": -4108.47216796875,
      "bbox_min": [
        -1793.199951171875,
        -3821.36962890625,
        932.0
      ],
      "bbox_max": [
        -1771.2308349609375,
        -3805.280029296875,
        970.2972412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9375241994857788,
        -0.3479200005531311,
        0.0
      ],
      "plane_d": -2996.9150390625,
      "bbox_min": [
        -1788.81640625,
        -3819.533447265625,
        932.0
      ],
      "bbox_max": [
        -1779.178466796875,
        -3805.280029296875,
        954.3013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7315678000450134,
        -0.6817687749862671,
        0.0
      ],
      "plane_d": -3902.1181640625,
      "bbox_min": [
        -1788.81640625,
        -3819.200439453125,
        932.0
      ],
      "bbox_max": [
        -1779.3021240234375,
        -3805.280029296875,
        954.3013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6682409048080444,
        -0.7401582598686218,
        -0.07496613264083862
      ],
      "plane_d": -3940.3818359375,
      "bbox_min": [
        -1788.81640625,
        -3819.200439453125,
        932.0
      ],
      "bbox_max": [
        -1779.3021240234375,
        -3805.280029296875,
        954.3013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9923036098480225,
        -0.12382844090461731,
        0.0
      ],
      "plane_d": -2240.543212890625,
      "bbox_min": [
        -1788.81640625,
        -3819.200439453125,
        932.0
      ],
      "bbox_max": [
        -1779.3021240234375,
        -3805.524169921875,
        954.3013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7943500280380249,
        -0.362562894821167,
        0.48739734292030334
      ],
      "plane_d": -3254.98486328125,
      "bbox_min": [
        -1782.353515625,
        -3819.200439453125,
        934.2450561523438
      ],
      "bbox_max": [
        -1779.3021240234375,
        -3810.97802734375,
        938.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.575560986995697,
        -0.8177589178085327,
        0.0
      ],
      "plane_d": -4142.314453125,
      "bbox_min": [
        -1788.81640625,
        -3810.97802734375,
        932.0
      ],
      "bbox_max": [
        -1782.353515625,
        -3805.524169921875,
        954.3013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6315538287162781,
        -0.6995227932929993,
        -0.334376722574234
      ],
      "plane_d": -3473.10791015625,
      "bbox_min": [
        -1788.81640625,
        -3810.97802734375,
        934.0454711914062
      ],
      "bbox_max": [
        -1782.353515625,
        -3805.524169921875,
        954.3013916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7088854908943176,
        -0.6234127283096313,
        0.32990580797195435
      ],
      "plane_d": -3948.93408203125,
      "bbox_min": [
        -1787.8704833984375,
        -3810.97802734375,
        934.0454711914062
      ],
      "bbox_max": [
        -1782.353515625,
        -3805.545654296875,
        938.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6415151357650757,
        -0.6903079152107239,
        -0.3345642387866974
      ],
      "plane_d": -3455.56640625,
      "bbox_min": [
        -1793.199951171875,
        -3821.36962890625,
        947.7633666992188
      ],
      "bbox_max": [
        -1771.2308349609375,
        -3806.123779296875,
        970.2972412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319893479347229,
        -0.5238977074623108,
        0.18255063891410828
      ],
      "plane_d": -3660.06396484375,
      "bbox_min": [
        -1792.015380859375,
        -3814.22802734375,
        961.5117797851562
      ],
      "bbox_max": [
        -1785.603515625,
        -3806.148193359375,
        970.0717163085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4494231641292572,
        0.05505229905247688,
        -0.8916210532188416
      ],
      "plane_d": 268.0718994140625,
      "bbox_min": [
        -1793.199951171875,
        -3821.36962890625,
        952.25
      ],
      "bbox_max": [
        -1775.184326171875,
        -3806.123779296875,
        970.2972412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5316759943962097,
        0.17712247371673584,
        -0.8282198905944824
      ],
      "plane_d": 525.6104736328125,
      "bbox_min": [
        -1793.199951171875,
        -3819.19482421875,
        965.1875
      ],
      "bbox_max": [
        -1785.603515625,
        -3810.63671875,
        970.2972412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5315654873847961,
        0.1640140563249588,
        -0.8309858441352844
      ],
      "plane_d": 478.47900390625,
      "bbox_min": [
        -1792.326171875,
        -3819.19482421875,
        965.1875
      ],
      "bbox_max": [
        -1785.603515625,
        -3814.22802734375,
        969.30517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6315538287162781,
        -0.6995227932929993,
        -0.334376722574234
      ],
      "plane_d": -3473.10791015625,
      "bbox_min": [
        -1790.2613525390625,
        -3820.9736328125,
        952.25
      ],
      "bbox_max": [
        -1775.184326171875,
        -3806.123779296875,
        965.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319893479347229,
        -0.5238977074623108,
        0.18255063891410828
      ],
      "plane_d": -3660.06396484375,
      "bbox_min": [
        -1790.2613525390625,
        -3814.22802734375,
        961.3255615234375
      ],
      "bbox_max": [
        -1785.603515625,
        -3808.127685546875,
        965.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5754331946372986,
        -0.11572109907865524,
        -0.8096204400062561
      ],
      "plane_d": -687.4466552734375,
      "bbox_min": [
        -1785.603515625,
        -3820.9736328125,
        958.7178955078125
      ],
      "bbox_max": [
        -1775.184326171875,
        -3814.22802734375,
        965.1875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5315654873847961,
        0.1640140563249588,
        -0.8309858441352844
      ],
      "plane_d": 478.47900390625,
      "bbox_min": [
        -1797.260009765625,
        -3821.69580078125,
        969.4256591796875
      ],
      "bbox_max": [
        -1794.4932861328125,
        -3818.800048828125,
        971.1700439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23576459288597107,
        0.5804930925369263,
        -0.7793861627578735
      ],
      "plane_d": 2552.126953125,
      "bbox_min": [
        -1798.95263671875,
        -3838.0,
        932.0
      ],
      "bbox_max": [
        -1765.0,
        -3818.800048828125,
        971.232666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4494231641292572,
        0.05505229905247688,
        -0.8916210532188416
      ],
      "plane_d": 268.0718994140625,
      "bbox_min": [
        -1798.95263671875,
        -3838.0,
        932.0
      ],
      "bbox_max": [
        -1765.0,
        -3818.800048828125,
        971.232666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5315654873847961,
        0.1640140563249588,
        -0.8309858441352844
      ],
      "plane_d": 478.47900390625,
      "bbox_min": [
        -1797.8427734375,
        -3823.97802734375,
        968.3999633789062
      ],
      "bbox_max": [
        -1792.866455078125,
        -3821.490966796875,
        971.232666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1797.8427734375,
        -3823.97802734375,
        969.5
      ],
      "bbox_max": [
        -1795.353515625,
        -3822.28466796875,
        971.232666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011269882321357727,
        0.9704700112342834,
        -0.24095848202705383
      ],
      "plane_d": 3932.744873046875,
      "bbox_min": [
        -1798.95263671875,
        -3838.0,
        932.0
      ],
      "bbox_max": [
        -1765.0,
        -3818.800048828125,
        970.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.012056472711265087,
        0.9785863757133484,
        -0.20548337697982788
      ],
      "plane_d": 3928.683837890625,
      "bbox_min": [
        -1798.95263671875,
        -3838.0,
        932.0
      ],
      "bbox_max": [
        -1765.0,
        -3818.800048828125,
        970.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03899751976132393,
        0.9976190328598022,
        0.056879643350839615
      ],
      "plane_d": 3844.199951171875,
      "bbox_min": [
        -1798.95263671875,
        -3838.0,
        932.0
      ],
      "bbox_max": [
        -1765.0,
        -3818.800048828125,
        970.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.010137375444173813,
        0.9999485611915588,
        0.0
      ],
      "plane_d": 3818.44873046875,
      "bbox_min": [
        -1796.31591796875,
        -3836.851806640625,
        934.2263793945312
      ],
      "bbox_max": [
        -1790.4365234375,
        -3836.4208984375,
        941.2637939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0036161455791443586,
        0.9905247688293457,
        0.1372869610786438
      ],
      "plane_d": 3678.30859375,
      "bbox_min": [
        -1796.31591796875,
        -3836.851806640625,
        934.2263793945312
      ],
      "bbox_max": [
        -1790.4365234375,
        -3836.4208984375,
        937.3236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.029599439352750778,
        0.978628396987915,
        0.20349550247192383
      ],
      "plane_d": 3511.17138671875,
      "bbox_min": [
        -1798.95263671875,
        -3838.0,
        932.0
      ],
      "bbox_max": [
        -1765.0,
        -3818.800048828125,
        970.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0036161455791443586,
        0.9905247688293457,
        0.1372869610786438
      ],
      "plane_d": 3678.30859375,
      "bbox_min": [
        -1796.54736328125,
        -3836.79638671875,
        932.0
      ],
      "bbox_max": [
        -1790.4365234375,
        -3835.9072265625,
        936.780029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06113339960575104,
        0.998129665851593,
        0.0
      ],
      "plane_d": 3719.250732421875,
      "bbox_min": [
        -1796.54736328125,
        -3836.2548828125,
        932.0
      ],
      "bbox_max": [
        -1794.33837890625,
        -3836.11962890625,
        933.0028076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3983542025089264,
        0.805255651473999,
        0.4391779601573944
      ],
      "plane_d": 1964.9610595703125,
      "bbox_min": [
        -1794.33837890625,
        -3836.79638671875,
        932.0
      ],
      "bbox_max": [
        -1790.4365234375,
        -3835.9072265625,
        936.780029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29425543546676636,
        0.7889154553413391,
        0.5394683480262756
      ],
      "plane_d": 1994.698974609375,
      "bbox_min": [
        -1796.36181640625,
        -3836.79638671875,
        932.0
      ],
      "bbox_max": [
        -1780.875,
        -3827.787109375,
        936.780029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0036161455791443586,
        0.9905247688293457,
        0.1372869610786438
      ],
      "plane_d": 3678.30859375,
      "bbox_min": [
        -1796.36181640625,
        -3836.79638671875,
        932.0
      ],
      "bbox_max": [
        -1780.875,
        -3827.787109375,
        936.780029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46586188673973083,
        0.23134306073188782,
        0.8540802001953125
      ],
      "plane_d": -741.17529296875,
      "bbox_min": [
        -1785.0,
        -3831.5,
        932.0
      ],
      "bbox_max": [
        -1780.875,
        -3827.787109375,
        934.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8070030808448792,
        0.15641659498214722,
        0.5694558620452881
      ],
      "plane_d": -1369.8756103515625,
      "bbox_min": [
        -1783.15625,
        -3831.5,
        932.0
      ],
      "bbox_max": [
        -1777.5965576171875,
        -3818.800048828125,
        938.054443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46586188673973083,
        0.23134306073188782,
        0.8540802001953125
      ],
      "plane_d": -741.17529296875,
      "bbox_min": [
        -1783.15625,
        -3831.5,
        932.0
      ],
      "bbox_max": [
        -1777.5965576171875,
        -3818.800048828125,
        938.054443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9923036098480225,
        -0.12382844090461731,
        0.0
      ],
      "plane_d": -2240.543212890625,
      "bbox_min": [
        -1781.37744140625,
        -3823.11962890625,
        932.0
      ],
      "bbox_max": [
        -1780.83837890625,
        -3818.800048828125,
        934.2450561523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9375241994857788,
        -0.3479200005531311,
        0.0
      ],
      "plane_d": -2996.9150390625,
      "bbox_min": [
        -1779.3021240234375,
        -3823.79638671875,
        936.780029296875
      ],
      "bbox_max": [
        -1777.5965576171875,
        -3819.200439453125,
        938.054443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.411079078912735,
        -0.7600318193435669,
        0.5033543109893799
      ],
      "plane_d": -4108.47216796875,
      "bbox_min": [
        -1798.95263671875,
        -3836.375,
        934.25
      ],
      "bbox_max": [
        -1765.0,
        -3819.247314453125,
        970.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24275289475917816,
        -0.9431560635566711,
        0.22699673473834991
      ],
      "plane_d": -4250.599609375,
      "bbox_min": [
        -1779.28466796875,
        -3829.798583984375,
        935.8944091796875
      ],
      "bbox_max": [
        -1765.0,
        -3819.247314453125,
        945.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9375241994857788,
        -0.3479200005531311,
        0.0
      ],
      "plane_d": -2996.9150390625,
      "bbox_min": [
        -1779.28466796875,
        -3823.79638671875,
        936.780029296875
      ],
      "bbox_max": [
        -1777.5965576171875,
        -3819.247314453125,
        941.9246826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15530145168304443,
        -0.3928207457065582,
        0.9064068794250488
      ],
      "plane_d": -2627.233642578125,
      "bbox_min": [
        -1777.5965576171875,
        -3829.798583984375,
        935.8944091796875
      ],
      "bbox_max": [
        -1765.875,
        -3823.79638671875,
        937.5625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15530145168304443,
        -0.3928207457065582,
        0.9064068794250488
      ],
      "plane_d": -2627.233642578125,
      "bbox_min": [
        -1798.95263671875,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1765.0,
        -3819.96533203125,
        970.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6657670140266418,
        -0.7110824584960938,
        -0.22608844935894012
      ],
      "plane_d": -3681.259033203125,
      "bbox_min": [
        -1798.95263671875,
        -3826.9990234375,
        945.25
      ],
      "bbox_max": [
        -1765.0,
        -3819.96533203125,
        970.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1798.95263671875,
        -3826.9990234375,
        968.163818359375
      ],
      "bbox_max": [
        -1795.353515625,
        -3822.994873046875,
        970.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5315654873847961,
        0.1640140563249588,
        -0.8309858441352844
      ],
      "plane_d": 478.47900390625,
      "bbox_min": [
        -1802.452392578125,
        -3822.447998046875,
        970.5032958984375
      ],
      "bbox_max": [
        -1794.2822265625,
        -3815.4228515625,
        975.37744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20375491678714752,
        0.5591962933540344,
        -0.8036065101623535
      ],
      "plane_d": 2551.638671875,
      "bbox_min": [
        -1801.619140625,
        -3822.447998046875,
        971.13671875
      ],
      "bbox_max": [
        -1797.5396728515625,
        -3819.12451171875,
        974.4660034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6315538287162781,
        -0.6995227932929993,
        -0.334376722574234
      ],
      "plane_d": -3473.10791015625,
      "bbox_min": [
        -1801.562255859375,
        -3825.595703125,
        932.0
      ],
      "bbox_max": [
        -1787.4161376953125,
        -3804.76708984375,
        974.3555297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8319893479347229,
        -0.5238977074623108,
        0.18255063891410828
      ],
      "plane_d": -3660.06396484375,
      "bbox_min": [
        -1790.984130859375,
        -3808.1767578125,
        960.7262573242188
      ],
      "bbox_max": [
        -1789.8712158203125,
        -3806.270263671875,
        968.5748901367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.575560986995697,
        -0.8177589178085327,
        0.0
      ],
      "plane_d": -4142.314453125,
      "bbox_min": [
        -1789.500244140625,
        -3807.169921875,
        932.0
      ],
      "bbox_max": [
        -1787.76416015625,
        -3805.947998046875,
        934.0454711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7315678000450134,
        -0.6817687749862671,
        0.0
      ],
      "plane_d": -3902.1181640625,
      "bbox_min": [
        -1788.1417236328125,
        -3805.545654296875,
        937.86181640625
      ],
      "bbox_max": [
        -1787.4161376953125,
        -3804.76708984375,
        943.3262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02404947206377983,
        0.9775403141975403,
        0.2093718945980072
      ],
      "plane_d": 3596.506591796875,
      "bbox_min": [
        -1772.0,
        -3838.0,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.041608307510614395,
        0.978481113910675,
        -0.20209749042987823
      ],
      "plane_d": 3872.713134765625,
      "bbox_min": [
        -1772.0,
        -3838.0,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038983557373285294,
        0.9398388862609863,
        -0.3393862545490265
      ],
      "plane_d": 3858.82763671875,
      "bbox_min": [
        -1772.0,
        -3838.0,
        943.2973022460938
      ],
      "bbox_max": [
        -1755.0,
        -3837.25341796875,
        945.3648681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00998904462903738,
        0.9405069947242737,
        0.33962753415107727
      ],
      "plane_d": 3307.4072265625,
      "bbox_min": [
        -1771.125,
        -3837.100341796875,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17112234234809875,
        0.5290375351905823,
        -0.8311656713485718
      ],
      "plane_d": 2518.55615234375,
      "bbox_min": [
        -1771.125,
        -3836.375,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02619413286447525,
        0.4540315568447113,
        0.8906004428863525
      ],
      "plane_d": 953.23486328125,
      "bbox_min": [
        -1771.125,
        -3836.375,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2356797605752945,
        0.2858017086982727,
        -0.9288554787635803
      ],
      "plane_d": 1565.7708740234375,
      "bbox_min": [
        -1768.5,
        -3833.464599609375,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.29408586025238037,
        0.9557790160179138
      ],
      "plane_d": 233.13653564453125,
      "bbox_min": [
        -1768.5,
        -3833.464599609375,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.028840895742177963,
        -0.9786328673362732,
        0.2035827785730362
      ],
      "plane_d": -3884.80322265625,
      "bbox_min": [
        -1768.5,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05109425261616707,
        -0.9759101271629333,
        -0.21210555732250214
      ],
      "plane_d": -3622.544921875,
      "bbox_min": [
        -1768.5,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04806070029735565,
        -0.9394670724868774,
        -0.3392519950866699
      ],
      "plane_d": -3357.61083984375,
      "bbox_min": [
        -1765.0,
        -3825.541748046875,
        943.8333129882812
      ],
      "bbox_max": [
        -1755.0,
        -3825.0,
        945.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23012220859527588,
        -0.3528193235397339,
        -0.9069522619247437
      ],
      "plane_d": -892.2055053710938,
      "bbox_min": [
        -1768.5,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3826.052734375,
        955.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22436819970607758,
        -0.2865879535675049,
        -0.9314108490943909
      ],
      "plane_d": -605.2945556640625,
      "bbox_min": [
        -1765.875,
        -3828.342041015625,
        950.3178100585938
      ],
      "bbox_max": [
        -1755.0,
        -3826.625,
        952.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.46527862548828125,
        0.8851642608642578
      ],
      "plane_d": -2610.34375,
      "bbox_min": [
        -1768.5,
        -3831.5,
        935.0
      ],
      "bbox_max": [
        -1755.0,
        -3826.052734375,
        938.7732543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.032873403280973434,
        -0.2939269244670868,
        0.9552623629570007
      ],
      "plane_d": -1962.31591796875,
      "bbox_min": [
        -1765.875,
        -3828.342041015625,
        936.659912109375
      ],
      "bbox_max": [
        -1755.0,
        -3826.4580078125,
        937.6505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01168737094849348,
        -0.9404897093772888,
        0.33962127566337585
      ],
      "plane_d": -3896.67919921875,
      "bbox_min": [
        -1765.875,
        -3826.625,
        937.188232421875
      ],
      "bbox_max": [
        -1755.0,
        -3826.4580078125,
        937.6505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01168737094849348,
        -0.9404897093772888,
        0.33962127566337585
      ],
      "plane_d": -3896.67919921875,
      "bbox_min": [
        -1765.875,
        -3826.625,
        937.5625
      ],
      "bbox_max": [
        -1755.0,
        -3826.052734375,
        938.7732543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        0.3826828598976135,
        0.0
      ],
      "plane_d": -2.7730712890625,
      "bbox_min": [
        -1705.0,
        -3954.5,
        1035.5
      ],
      "bbox_max": [
        -1630.8995361328125,
        -3930.1005859375,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923879861831665,
        -0.3826828598976135,
        0.0
      ],
      "plane_d": -3018.31396484375,
      "bbox_min": [
        -1635.0,
        -3949.8994140625,
        1035.5
      ],
      "bbox_max": [
        -1630.8995361328125,
        -3940.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3944.5,
      "bbox_min": [
        -1705.0,
        -3954.5,
        1035.5
      ],
      "bbox_max": [
        -1640.0,
        -3935.5,
        1044.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        -1705.0,
        -3954.5,
        1035.5
      ],
      "bbox_max": [
        -1695.0,
        -3944.5,
        1040.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1695.0,
      "bbox_min": [
        -1705.0,
        -3954.5,
        1035.5
      ],
      "bbox_max": [
        -1695.0,
        -3944.5,
        1040.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        -1705.0,
        -3954.5,
        1035.5
      ],
      "bbox_max": [
        -1695.0,
        -3944.5,
        1040.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3954.5,
      "bbox_min": [
        -1705.0,
        -3954.5,
        1035.5
      ],
      "bbox_max": [
        -1695.0,
        -3954.5,
        1040.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3935.5,
      "bbox_min": [
        -1705.0,
        -3944.5,
        1035.5
      ],
      "bbox_max": [
        -1640.0,
        -3935.5,
        1044.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1044.5,
      "bbox_min": [
        -1705.0,
        -3944.5,
        1035.5
      ],
      "bbox_max": [
        -1640.0,
        -3935.5,
        1044.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        -1705.0,
        -3944.5,
        1035.5
      ],
      "bbox_max": [
        -1653.0,
        -3935.5,
        1044.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.41036465764045715,
        0.0,
        -0.911921501159668
      ],
      "plane_d": 1630.834716796875,
      "bbox_min": [
        -1663.0,
        -3944.5,
        1040.0
      ],
      "bbox_max": [
        -1653.0,
        -3935.5,
        1044.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        -1705.0,
        -3944.5,
        1035.5
      ],
      "bbox_max": [
        -1705.0,
        -3935.5,
        1040.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt02c",
      "entity_class": "CGameArea",
      "piece_name": "mt02c",
      "offset": 54,
      "centroid": [
        -1607.2750244140625,
        -3809.6500244140625,
        1001.0250091552734
      ],
      "bbox_min": [
        -1666.0,
        -3944.5,
        958.2000122070312
      ],
      "bbox_max": [
        -1541.300048828125,
        -3679.300048828125,
        1040.0
      ],
      "dimensions_source": {
        "span_x": 124.699951171875,
        "span_y": 265.199951171875,
        "height_z": 81.79998779296875,
        "door_width": 265.199951171875,
        "door_depth": 124.699951171875,
        "leaf_depth": 124.699951171875,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -1666.0,
          -3944.5,
          1035.5
        ],
        [
          -1666.0,
          -3935.5,
          1035.5
        ],
        [
          -1666.0,
          -3935.5,
          1040.0
        ],
        [
          -1666.0,
          -3944.5,
          1040.0
        ],
        [
          -1555.800048828125,
          -3679.300048828125,
          958.2000122070312
        ],
        [
          -1555.800048828125,
          -3679.300048828125,
          970.4000244140625
        ],
        [
          -1541.300048828125,
          -3679.300048828125,
          970.4000244140625
        ],
        [
          -1541.300048828125,
          -3679.300048828125,
          958.2000122070312
        ]
      ],
      "plane_distance": -1666.0
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 9106,
      "centroid": [
        -1679.0,
        -3940.0,
        1035.5
      ],
      "bbox_min": [
        -1684.0,
        -3944.0,
        1035.5
      ],
      "bbox_max": [
        -1674.0,
        -3936.0,
        1035.5
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 8.0,
        "height_z": 0.0,
        "door_width": 10.0,
        "door_depth": 8.0,
        "leaf_depth": 8.0,
        "clearance_margin": 0.0,
        "slide_axis": "x"
      },
      "vertices": [
        [
          -1679.0,
          -3944.0,
          1035.5
        ],
        [
          -1674.0,
          -3940.0,
          1035.5
        ],
        [
          -1675.25,
          -3943.0,
          1035.5
        ],
        [
          -1684.0,
          -3940.0,
          1035.5
        ],
        [
          -1682.75,
          -3943.0,
          1035.5
        ],
        [
          -1679.0,
          -3936.0,
          1035.5
        ],
        [
          -1675.25,
          -3937.0,
          1035.5
        ],
        [
          -1682.75,
          -3937.0,
          1035.5
        ]
      ]
    }
  ],
  "tutorial_messages": []
}